
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("e4JJO", function(module, exports) {

var $1A9t2 = parcelRequire("1A9t2");


var $ij2FZ = parcelRequire("ij2FZ");

const $8d8bfd1ce8e7d438$var$createSegmenter = ()=>{
    try {
        return Intl?.Segmenter ? new Intl.Segmenter(undefined, {
            granularity: 'word'
        }) : null;
    } catch  {
        return null;
    }
};
const $8d8bfd1ce8e7d438$var$segmenter = $8d8bfd1ce8e7d438$var$createSegmenter();
const $8d8bfd1ce8e7d438$var$wordCount = (text)=>{
    if (!text) return 0;
    // We use Intl here since it is locale-aware and accurately handles word counts across all languages. The regex will undercount non-English languages.
    if ($8d8bfd1ce8e7d438$var$segmenter) return [
        ...$8d8bfd1ce8e7d438$var$segmenter.segment(text)
    ].filter((s)=>s.isWordLike).length;
    return text.match(/\S+/g)?.length ?? 0;
};
const $8d8bfd1ce8e7d438$var$processADFNode = (currentValue, node)=>{
    switch(node.type){
        case 'text':
            const linkCount = node.marks?.some((mark)=>mark.type === 'link') ? currentValue.linkCount + 1 : currentValue.linkCount;
            return {
                ...currentValue,
                textLength: currentValue.textLength + (node.text ? node.text.length : 0),
                wordCount: currentValue.wordCount + $8d8bfd1ce8e7d438$var$wordCount(node.text),
                linkCount: linkCount
            };
        case 'mention':
            return {
                ...currentValue,
                mentionCount: currentValue.mentionCount + 1
            };
        case 'inlineCard':
        case 'embedCard':
            return {
                ...currentValue,
                linkCount: currentValue.linkCount + 1
            };
        case 'inlineExtension':
            if (node.attrs?.extensionKey === (0, $ij2FZ.ROVO_SKILL_COMBINED_EXTENSION_KEY) && node.attrs?.parameters?.slug) return {
                ...currentValue,
                explicitSkills: [
                    ...currentValue.explicitSkills,
                    node.attrs.parameters.slug
                ]
            };
            return currentValue;
    }
    return currentValue;
};
const $8d8bfd1ce8e7d438$export$a148305df2eb5487 = (adf)=>{
    const initialFeatures = {
        adfLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        linkCount: 0,
        mentionCount: 0,
        explicitSkills: []
    };
    return (0, $1A9t2.reduce)(adf, (currentValue, node)=>$8d8bfd1ce8e7d438$var$processADFNode(currentValue, node), initialFeatures);
};
const $8d8bfd1ce8e7d438$export$c5df045f791f45da = (adf)=>(0, $1A9t2.reduce)(adf, (currentValue, node)=>node.type === 'text' && node.text ? currentValue + node.text : currentValue, '');
/**
 * Backtick-wrapped placeholders in prompt cards (e.g. `document`, `person`) are meant to be replaced by the user.
 * When comparing sent text to the card prompt, we treat these as variable and only require fixed segments to match.
 */ const $8d8bfd1ce8e7d438$var$BACKTICK_PLACEHOLDER_REGEX = /`[^`]*`/g;
const $8d8bfd1ce8e7d438$export$2def72d3ef808307 = (normalizedSentText, normalizedOriginalPrompt)=>{
    if (normalizedSentText === normalizedOriginalPrompt) return 'asIs';
    if (normalizedOriginalPrompt.length === 0) return null;
    const fixedSegments = normalizedOriginalPrompt.split($8d8bfd1ce8e7d438$var$BACKTICK_PLACEHOLDER_REGEX);
    const hasPlaceholders = fixedSegments.length > 1;
    if (hasPlaceholders) {
        let searchFrom = 0;
        let firstSegmentMatchedAtStart = true;
        for (const segment of fixedSegments){
            const trimmed = segment.trim();
            if (trimmed.length === 0) continue;
            const idx = normalizedSentText.indexOf(trimmed, searchFrom);
            if (idx === -1) {
                // User truncated or edited after matching some of the card — if we matched at least one
                // fixed segment, they started from the card so treat as tweaked
                if (searchFrom > 0) return 'tweaked';
                // No segment matched yet; check containment (strip placeholders so "on `x`" vs "on x" match)
                const originalWithoutPlaceholders = normalizedOriginalPrompt.replace($8d8bfd1ce8e7d438$var$BACKTICK_PLACEHOLDER_REGEX, ' ').replace(/\s+/g, ' ').trim();
                if (normalizedOriginalPrompt.includes(normalizedSentText) || normalizedSentText.includes(normalizedOriginalPrompt) || originalWithoutPlaceholders.includes(normalizedSentText) || normalizedSentText.includes(originalWithoutPlaceholders) || originalWithoutPlaceholders.startsWith(normalizedSentText) || normalizedSentText.startsWith(originalWithoutPlaceholders)) return 'tweaked';
                return null;
            }
            if (searchFrom === 0 && idx !== 0) firstSegmentMatchedAtStart = false;
            searchFrom = idx + trimmed.length;
        }
        // Trailing content after the last fixed segment
        if (normalizedSentText.length > searchFrom) return 'tweaked';
        return firstSegmentMatchedAtStart ? 'placeholdersFilled' : 'tweaked';
    }
    if (normalizedSentText.includes(normalizedOriginalPrompt) || normalizedOriginalPrompt.includes(normalizedSentText)) return 'tweaked';
    return null;
};
/**
 * Checks whether a top-level adf block has a given localId anywhere in its subtree.
 */ const $8d8bfd1ce8e7d438$var$containsLocalId = (node, localId)=>{
    if (node.attrs?.localId === localId) return true;
    return (node.content ?? []).some((child)=>$8d8bfd1ce8e7d438$var$containsLocalId(child, localId));
};
const $8d8bfd1ce8e7d438$export$1e86d752377e082a = (fullAdf, startLocalId, endLocalId)=>{
    if (!startLocalId || !endLocalId) return [];
    try {
        const topLevelNodes = fullAdf?.content ?? [];
        // A selection anchor can be anywhere in the doc tree, not just at the top level. We need to know which top-level ADF component the selection belongs to.
        let startNodeIndex;
        let endNodeIndex;
        for(let i = 0; i < topLevelNodes.length; i++){
            if (startNodeIndex === undefined && $8d8bfd1ce8e7d438$var$containsLocalId(topLevelNodes[i], startLocalId)) startNodeIndex = i;
            if (endNodeIndex === undefined && $8d8bfd1ce8e7d438$var$containsLocalId(topLevelNodes[i], endLocalId)) endNodeIndex = i;
            if (startNodeIndex !== undefined && endNodeIndex !== undefined) break;
        }
        if (startNodeIndex === undefined || endNodeIndex === undefined) return [];
        // The editor gives IDs in selection direction (can be right-to-left), so we use
        // min/max to get everything between the two anchors regardless of order.
        const from = Math.min(startNodeIndex, endNodeIndex);
        const to = Math.max(startNodeIndex, endNodeIndex);
        return [
            ...new Set(topLevelNodes.slice(from, to + 1).map((n)=>n.type).filter(Boolean))
        ];
    } catch  {
        // swallow the error and return nothing since this is just for analytics.
        return [];
    }
};
const $8d8bfd1ce8e7d438$export$d6a1a695ea643f8e = (fragmentNodes)=>fragmentNodes.reduce((total, node)=>(0, $1A9t2.reduce)(node, (count, n)=>n.type === 'text' ? count + $8d8bfd1ce8e7d438$var$wordCount(n.text) : count, total), 0);
const $8d8bfd1ce8e7d438$export$89d0962bb7c449e3 = (normalizedSentText, normalizedOriginalPrompt)=>$8d8bfd1ce8e7d438$export$2def72d3ef808307(normalizedSentText, normalizedOriginalPrompt) !== null;
module.exports["extractContentFeatures"] = $8d8bfd1ce8e7d438$export$a148305df2eb5487;
module.exports["extractPlainTextFromAdf"] = $8d8bfd1ce8e7d438$export$c5df045f791f45da;
module.exports["getPromptCardSendType"] = $8d8bfd1ce8e7d438$export$2def72d3ef808307;
module.exports["getTopLevelNodeTypes"] = $8d8bfd1ce8e7d438$export$1e86d752377e082a;
module.exports["countFragmentWords"] = $8d8bfd1ce8e7d438$export$d6a1a695ea643f8e;

});

parcelRegister("3vCSA", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $fgOJ7 = parcelRequire("fgOJ7");


var $l30d8 = parcelRequire("l30d8");


var $eL1ct = parcelRequire("eL1ct");


var $6nGJw = parcelRequire("6nGJw");

function $0c322a09d1b57883$export$a4068a52445901dc(data, props) {
    return data !== null && typeof data === 'object' && props.every((prop)=>data.hasOwnProperty(prop));
}
const $0c322a09d1b57883$export$740b9b28cb05ebd6 = 'dynamic-ui-create';
function $0c322a09d1b57883$export$6da360af78d7e3dd(data) {
    return $0c322a09d1b57883$export$a4068a52445901dc(data, [
        'id'
    ]);
}
function $0c322a09d1b57883$export$da7aa926fc604bd7(data) {
    return $0c322a09d1b57883$export$a4068a52445901dc(data, [
        'id',
        'previousMauiId',
        'contentType'
    ]) && data.previousMauiId != null;
}
function $0c322a09d1b57883$export$3147e11228ebc102(action) {
    return $0c322a09d1b57883$export$6da360af78d7e3dd(action.data);
}
const $0c322a09d1b57883$export$440c8d4309cb1c9 = (data)=>{
    if (data?.id) return `${window.location.origin}/remix/ui/${encodeURIComponent(data.id)}`;
    return null;
};
const $0c322a09d1b57883$export$4a9884303bce30ff = 'image-create';
function $0c322a09d1b57883$export$ce86c52462376ef2(data) {
    return $0c322a09d1b57883$export$a4068a52445901dc(data, [
        'mediaFileId'
    ]);
}
function $0c322a09d1b57883$export$3b2fa4f5aa307773(data) {
    return $0c322a09d1b57883$export$a4068a52445901dc(data, [
        'mediaFileId',
        'previousMediaFileId',
        'mediaCollection'
    ]) && data.previousMediaFileId != null;
}
function $0c322a09d1b57883$export$ef033f677befc7d4(action) {
    return action.key === $0c322a09d1b57883$export$4a9884303bce30ff && $0c322a09d1b57883$export$ce86c52462376ef2(action.data);
}
function $0c322a09d1b57883$export$3bb9ace6cd5cc74a(data) {
    return $0c322a09d1b57883$export$a4068a52445901dc(data, [
        'previousMediaFileId'
    ]);
}
const $0c322a09d1b57883$var$MEDIA_BASE_URL_STAGING = 'https://media.staging.atl-paas.net';
const $0c322a09d1b57883$var$MEDIA_BASE_URL_PROD = 'https://media-cdn.atlassian.com';
const $0c322a09d1b57883$export$4e8e610ccc58ae5b = ({ fileId: fileId, token: token, collection: collection, clientId: clientId, isStaging: isStaging })=>{
    const baseUrl = isStaging ? $0c322a09d1b57883$var$MEDIA_BASE_URL_STAGING : $0c322a09d1b57883$var$MEDIA_BASE_URL_PROD;
    const url = new URL(`${baseUrl}/file/${fileId}/image`);
    url.searchParams.set('token', token);
    url.searchParams.set('issuer', 'micros/convo-ai');
    url.searchParams.set('collection', collection);
    url.searchParams.set('client', clientId);
    return url.toString();
};
const $0c322a09d1b57883$export$7afb9b8acd50eb4e = 'aifc-confluence-page-create';
function $0c322a09d1b57883$export$77c5629325e9aaaf(data) {
    return typeof data === 'object' && data !== null && 'title' in data && 'adf' in data && 'contentId' in data;
}
const $0c322a09d1b57883$export$b632d4bc1af2f7d3 = 'aifc-deep-research-confluence-page-create';
function $0c322a09d1b57883$export$3bd74956949aecbc(data) {
    return typeof data === 'object' && data !== null && 'title' in data && 'content' in data && 'contentId' in data;
}
function $0c322a09d1b57883$export$d6ad19367a51fe7a(data) {
    return typeof data === 'object' && data !== null && 'contentId' in data;
}
const $0c322a09d1b57883$export$88028308fe524b8a = 'aifc-confluence-page-update';
const $0c322a09d1b57883$export$bb3d6eff667f4678 = 'aifc-adf-update';
const $0c322a09d1b57883$export$7cca3e34118747ef = 'aifc-action-classification-metadata';
function $0c322a09d1b57883$export$4f41f9d38097cf0a(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data;
}
function $0c322a09d1b57883$export$1cf42b66f457bc6c(data) {
    return typeof data === 'object' && data !== null && 'toolCalls' in data && 'contentId' in data && typeof data.toolCalls === 'string' && typeof data.contentId === 'string';
}
function $0c322a09d1b57883$export$fbc8213fc156433a(data) {
    return typeof data === 'object' && data !== null && 'promptVersion' in data && typeof data.promptVersion === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$279c9cc61f7f510a = 'aifc-confluence-whiteboard-create';
function $0c322a09d1b57883$export$392158ed2444b56b(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'title' in data && typeof data.title === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$823e13f43093123d = 'aifc-confluence-slides-create';
function $0c322a09d1b57883$export$ae4ad515c9dd259d(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'title' in data && typeof data.title === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$49b21a7401bcc85 = 'aifc-confluence-slides-update';
function $0c322a09d1b57883$export$3d6de0a3c3e39cbf(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$d5d2204eeb3fde50 = 'aifc-confluence-whiteboard-update';
function $0c322a09d1b57883$export$35d2029c1a7b307c(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$771989b0afde4911 = 'aifc-confluence-whiteboard-to-page';
const $0c322a09d1b57883$export$325918e7af3a74aa = 'confluence-whiteboard-brainstorming';
function $0c322a09d1b57883$export$48e8bcda6802129c(data) {
    return typeof data === 'object' && data !== null && 'content' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$e3c19505945cf210 = 'confluence-whiteboard-diagramming';
const $0c322a09d1b57883$export$c8f288feec1641d9 = 'aifc-confluence-whiteboard-diagramming';
function $0c322a09d1b57883$export$f3a918f4f62365b2(data) {
    return typeof data === 'object' && data !== null && 'content' in data && 'diagramType' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$9f1bd612d6abcf5c = 'aifc-confluence-database-create';
function $0c322a09d1b57883$export$4dec930442f5ade2(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'title' in data && typeof data.title === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$ee0a705006a79cfe = 'aifc-confluence-database-update';
function $0c322a09d1b57883$export$dbed60ca289ab1f3(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data;
}
const $0c322a09d1b57883$export$691e9b05e574e32c = 'aifc-confluence-space-create';
function $0c322a09d1b57883$export$545244afe3ae2546(data) {
    return typeof data === 'object' && data !== null && 'jsonSpace' in data;
}
const $0c322a09d1b57883$export$af91dd9bf235f890 = 'aifc-confluence-space-update';
function $0c322a09d1b57883$export$38f648644a8b3072(data) {
    return typeof data === 'object' && data !== null && 'jsonSpace' in data;
}
const $0c322a09d1b57883$export$9f62c3ae716c44b2 = new Set([
    $0c322a09d1b57883$export$7afb9b8acd50eb4e,
    $0c322a09d1b57883$export$771989b0afde4911,
    $0c322a09d1b57883$export$b632d4bc1af2f7d3
]);
const $0c322a09d1b57883$export$aba0c096f5cdcaca = new Set([
    $0c322a09d1b57883$export$279c9cc61f7f510a
]);
const $0c322a09d1b57883$export$b9c5aef93dba02df = new Set([
    $0c322a09d1b57883$export$823e13f43093123d
]);
const $0c322a09d1b57883$export$45a7157715c10f20 = new Set([
    $0c322a09d1b57883$export$9f1bd612d6abcf5c
]);
const $0c322a09d1b57883$var$SPACE_CREATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$691e9b05e574e32c
]);
const $0c322a09d1b57883$var$CREATABLE_ACTION_KEYS = new Set([
    ...$0c322a09d1b57883$export$9f62c3ae716c44b2,
    ...$0c322a09d1b57883$export$aba0c096f5cdcaca,
    ...$0c322a09d1b57883$export$b9c5aef93dba02df,
    ...$0c322a09d1b57883$export$45a7157715c10f20,
    ...$0c322a09d1b57883$var$SPACE_CREATE_ACTIONS
]);
const $0c322a09d1b57883$var$PAGE_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$88028308fe524b8a,
    $0c322a09d1b57883$export$bb3d6eff667f4678,
    $0c322a09d1b57883$export$740b9b28cb05ebd6,
    $0c322a09d1b57883$export$4a9884303bce30ff
]);
const $0c322a09d1b57883$var$WHITEBOARD_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$d5d2204eeb3fde50,
    $0c322a09d1b57883$export$325918e7af3a74aa,
    $0c322a09d1b57883$export$e3c19505945cf210,
    $0c322a09d1b57883$export$c8f288feec1641d9
]);
const $0c322a09d1b57883$var$SLIDES_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$49b21a7401bcc85
]);
const $0c322a09d1b57883$var$DATABASE_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$ee0a705006a79cfe
]);
const $0c322a09d1b57883$var$SPACE_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$af91dd9bf235f890
]);
const $0c322a09d1b57883$var$UPDATABLE_ACTION_KEYS = new Set([
    ...$0c322a09d1b57883$var$PAGE_UPDATE_ACTIONS,
    ...$0c322a09d1b57883$var$WHITEBOARD_UPDATE_ACTIONS,
    ...$0c322a09d1b57883$var$SLIDES_UPDATE_ACTIONS,
    ...$0c322a09d1b57883$var$DATABASE_UPDATE_ACTIONS,
    ...$0c322a09d1b57883$var$SPACE_UPDATE_ACTIONS
]);
const $0c322a09d1b57883$export$6c0ed26dac146a75 = (action)=>$0c322a09d1b57883$export$9f62c3ae716c44b2.has(action.key);
const $0c322a09d1b57883$export$eac4577c3e50732a = (action)=>$0c322a09d1b57883$var$CREATABLE_ACTION_KEYS.has(action.key);
const $0c322a09d1b57883$export$a70db46a9e5e9e4a = (action)=>$0c322a09d1b57883$export$eac4577c3e50732a(action) && !!action.data?.metadata?.isExistingContent && (0, $dh538.fg)('confluence_aifc_create_on_existing');
const $0c322a09d1b57883$export$79fc6c76b9755410 = (action)=>$0c322a09d1b57883$export$eac4577c3e50732a(action) && !$0c322a09d1b57883$export$a70db46a9e5e9e4a(action);
const $0c322a09d1b57883$export$53f0114d9f187b14 = (action)=>action.key === $0c322a09d1b57883$export$740b9b28cb05ebd6;
const $0c322a09d1b57883$export$b3dfc475c0b1ff86 = (action)=>action.key === $0c322a09d1b57883$export$4a9884303bce30ff;
const $0c322a09d1b57883$export$dfda1ac7e19cab7b = (action)=>$0c322a09d1b57883$var$PAGE_UPDATE_ACTIONS.has(action.key);
const $0c322a09d1b57883$export$dcbfc8a9b613cd00 = (action)=>$0c322a09d1b57883$var$WHITEBOARD_UPDATE_ACTIONS.has(action.key);
const $0c322a09d1b57883$export$5d2d4e8984b13e00 = (action)=>$0c322a09d1b57883$var$SLIDES_UPDATE_ACTIONS.has(action.key);
const $0c322a09d1b57883$export$399c9116e9984ca3 = (action)=>$0c322a09d1b57883$var$DATABASE_UPDATE_ACTIONS.has(action.key);
const $0c322a09d1b57883$export$73dc9ed6ed2373f = (action)=>$0c322a09d1b57883$var$UPDATABLE_ACTION_KEYS.has(action.key);
const $0c322a09d1b57883$export$54716060fc6e52ee = (action)=>$0c322a09d1b57883$export$eac4577c3e50732a(action) || $0c322a09d1b57883$export$73dc9ed6ed2373f(action);
// ============================================================================
// CONFLUENCE PREVIEW CARDS
// ============================================================================
const $0c322a09d1b57883$var$PREVIEW_CARD_ACTION_KEYS = new Set([
    $0c322a09d1b57883$export$7afb9b8acd50eb4e,
    $0c322a09d1b57883$export$b632d4bc1af2f7d3,
    $0c322a09d1b57883$export$279c9cc61f7f510a,
    $0c322a09d1b57883$export$823e13f43093123d,
    $0c322a09d1b57883$export$771989b0afde4911,
    $0c322a09d1b57883$export$9f1bd612d6abcf5c
]);
const $0c322a09d1b57883$export$5cb5e5f4b4ce0a33 = (action)=>$0c322a09d1b57883$var$PREVIEW_CARD_ACTION_KEYS.has(action.key) && !$0c322a09d1b57883$export$a70db46a9e5e9e4a(action);
const $0c322a09d1b57883$export$681cf9ea58de88fd = (action, selectedPreviewContentId)=>{
    if (!action?.key) return;
    switch(action.key){
        case $0c322a09d1b57883$export$279c9cc61f7f510a:
            return (0, $6nGJw.getConfluenceWhiteboardClientId)(selectedPreviewContentId);
        case $0c322a09d1b57883$export$823e13f43093123d:
        case $0c322a09d1b57883$export$49b21a7401bcc85:
            return (0, $l30d8.getConfluenceSlidesClientId)(selectedPreviewContentId);
        case $0c322a09d1b57883$export$9f1bd612d6abcf5c:
            return (0, $fgOJ7.getConfluenceDatabaseClientId)(selectedPreviewContentId);
        default:
            return (0, $eL1ct.getConfluenceEditorClientId)(selectedPreviewContentId);
    }
};
const $0c322a09d1b57883$export$bb9f6b0763834612 = (action)=>{
    const actionKey = action.key;
    if ($0c322a09d1b57883$export$9f62c3ae716c44b2.has(actionKey) || $0c322a09d1b57883$var$PAGE_UPDATE_ACTIONS.has(actionKey)) return 'confluence-page';
    if ($0c322a09d1b57883$export$aba0c096f5cdcaca.has(actionKey) || $0c322a09d1b57883$var$WHITEBOARD_UPDATE_ACTIONS.has(actionKey)) return 'confluence-whiteboard';
    if ($0c322a09d1b57883$export$b9c5aef93dba02df.has(actionKey) || $0c322a09d1b57883$var$SLIDES_UPDATE_ACTIONS.has(actionKey)) return 'confluence-slide';
    if ($0c322a09d1b57883$export$45a7157715c10f20.has(actionKey) || $0c322a09d1b57883$var$DATABASE_UPDATE_ACTIONS.has(actionKey)) return 'confluence-database';
    if ($0c322a09d1b57883$var$SPACE_CREATE_ACTIONS.has(actionKey) || $0c322a09d1b57883$var$SPACE_UPDATE_ACTIONS.has(actionKey)) return 'confluence-space';
    return undefined;
};
// This mapping should contain the type guards of those actions that support data
// accumulation as defined below in `getPrimaryAccumulatedValue`.
const $0c322a09d1b57883$var$CONFLUENCE_AIFC_ACCUMULATED_DATA_TYPE_GUARDS = {
    [$0c322a09d1b57883$export$7afb9b8acd50eb4e]: $0c322a09d1b57883$export$77c5629325e9aaaf,
    [$0c322a09d1b57883$export$b632d4bc1af2f7d3]: $0c322a09d1b57883$export$3bd74956949aecbc,
    [$0c322a09d1b57883$export$9f1bd612d6abcf5c]: $0c322a09d1b57883$export$4dec930442f5ade2,
    [$0c322a09d1b57883$export$279c9cc61f7f510a]: $0c322a09d1b57883$export$392158ed2444b56b,
    [$0c322a09d1b57883$export$823e13f43093123d]: $0c322a09d1b57883$export$ae4ad515c9dd259d
};
const $0c322a09d1b57883$export$b95f9369e33f3b4a = (key)=>{
    return key in $0c322a09d1b57883$var$CONFLUENCE_AIFC_ACCUMULATED_DATA_TYPE_GUARDS;
};
const $0c322a09d1b57883$export$898d9c03b4eb5dd5 = (key)=>{
    return $0c322a09d1b57883$var$CONFLUENCE_AIFC_ACCUMULATED_DATA_TYPE_GUARDS[key];
};
const $0c322a09d1b57883$export$240debd921ff9f65 = (action)=>{
    if (!action.data) return undefined;
    if (action.key === $0c322a09d1b57883$export$7afb9b8acd50eb4e && $0c322a09d1b57883$export$77c5629325e9aaaf(action.data)) {
        const key = 'adf';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $0c322a09d1b57883$export$b632d4bc1af2f7d3 && $0c322a09d1b57883$export$3bd74956949aecbc(action.data)) {
        const key = 'content';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $0c322a09d1b57883$export$279c9cc61f7f510a && $0c322a09d1b57883$export$392158ed2444b56b(action.data)) {
        const key = 'document';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $0c322a09d1b57883$export$823e13f43093123d && $0c322a09d1b57883$export$ae4ad515c9dd259d(action.data)) {
        const key = 'document';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $0c322a09d1b57883$export$9f1bd612d6abcf5c && $0c322a09d1b57883$export$4dec930442f5ade2(action.data)) {
        const key = 'document';
        return {
            key: key,
            value: action.data[key]
        };
    }
    return undefined;
};
const $0c322a09d1b57883$var$getAccumulatedData = (prevAction, nextAction)=>{
    const prevPrimary = $0c322a09d1b57883$export$240debd921ff9f65(prevAction);
    const nextPrimary = $0c322a09d1b57883$export$240debd921ff9f65(nextAction);
    if (!prevPrimary || !nextPrimary || prevPrimary.key !== nextPrimary.key) return undefined;
    return {
        [nextPrimary.key]: String(prevPrimary.value ?? '') + String(nextPrimary.value ?? '')
    };
};
function $0c322a09d1b57883$export$5b30faa0f696991d(data) {
    return typeof data === 'object' && data !== null && 'isRemixGenerated' in data && data.isRemixGenerated === true;
}
const $0c322a09d1b57883$var$REMIX_GENERATED_ACTION_KEYS = new Set([
    $0c322a09d1b57883$export$740b9b28cb05ebd6,
    $0c322a09d1b57883$export$4a9884303bce30ff
]);
function $0c322a09d1b57883$export$8eb2b74d04c8d455(action) {
    if ($0c322a09d1b57883$var$REMIX_GENERATED_ACTION_KEYS.has(action.key)) return true;
    if (action.key === $0c322a09d1b57883$export$279c9cc61f7f510a || action.key === $0c322a09d1b57883$export$d5d2204eeb3fde50) return $0c322a09d1b57883$export$5b30faa0f696991d(action.data);
    return false;
}
function $0c322a09d1b57883$export$31b2392386905e76(action) {
    if (!action) return undefined;
    const { key: key, data: data } = action;
    if ($0c322a09d1b57883$export$da7aa926fc604bd7(data)) return 'edit';
    if ($0c322a09d1b57883$export$6da360af78d7e3dd(data)) return 'create';
    if ($0c322a09d1b57883$export$3b2fa4f5aa307773(data)) return 'edit';
    if ($0c322a09d1b57883$export$ce86c52462376ef2(data)) return 'create';
    if (key === $0c322a09d1b57883$export$d5d2204eeb3fde50) return 'edit';
    if (key === $0c322a09d1b57883$export$279c9cc61f7f510a) return 'create';
    return undefined;
}
function $0c322a09d1b57883$export$a549b965e1dff398(action) {
    if (action?.key === $0c322a09d1b57883$export$4a9884303bce30ff) return 'infographic';
    if (action?.data?.type === 'whiteboard') return 'diagram';
    return action?.data?.contentType;
}
function $0c322a09d1b57883$export$90cf5cf844c2f3b0(action) {
    return action?.data?.dynamicUiSubtype;
}
function $0c322a09d1b57883$export$ff1c2950f6d5486f({ action: action, selectedRemixMetadata: selectedRemixMetadata }) {
    return {
        metadataActionKey: action?.key,
        metadataActionType: $0c322a09d1b57883$export$31b2392386905e76(action),
        backendDynamicUiType: $0c322a09d1b57883$export$a549b965e1dff398(action),
        backendDynamicUiSubtype: $0c322a09d1b57883$export$90cf5cf844c2f3b0(action),
        ...selectedRemixMetadata
    };
}
const $0c322a09d1b57883$export$64e13fa6a74f5f86 = (prevAction, nextAction)=>{
    if (prevAction.data && nextAction.data) {
        const accumulatedData = $0c322a09d1b57883$var$getAccumulatedData(prevAction, nextAction);
        if (accumulatedData !== undefined) {
            const updatedData = {
                ...nextAction.data,
                ...accumulatedData
            };
            return {
                ...prevAction,
                data: updatedData,
                status: nextAction.status
            };
        }
    }
    return {
        ...prevAction,
        data: nextAction.data,
        status: nextAction.status
    };
};
module.exports["DYNAMIC_UI_CREATE_KEY"] = $0c322a09d1b57883$export$740b9b28cb05ebd6;
module.exports["isDynamicUiCreateData"] = $0c322a09d1b57883$export$6da360af78d7e3dd;
module.exports["isDynamicUiUpdateActionData"] = $0c322a09d1b57883$export$da7aa926fc604bd7;
module.exports["isDynamicUiCreateAction"] = $0c322a09d1b57883$export$3147e11228ebc102;
module.exports["buildDynamicUiPageUrl"] = $0c322a09d1b57883$export$440c8d4309cb1c9;
module.exports["IMAGE_CREATE_KEY"] = $0c322a09d1b57883$export$4a9884303bce30ff;
module.exports["isImageCreateData"] = $0c322a09d1b57883$export$ce86c52462376ef2;
module.exports["isImageUpdateActionData"] = $0c322a09d1b57883$export$3b2fa4f5aa307773;
module.exports["isImageCreateAction"] = $0c322a09d1b57883$export$ef033f677befc7d4;
module.exports["isImageUpdatePrepareData"] = $0c322a09d1b57883$export$3bb9ace6cd5cc74a;
module.exports["buildImageUrl"] = $0c322a09d1b57883$export$4e8e610ccc58ae5b;
module.exports["CONFLUENCE_AIFC_PAGE_CREATE_KEY"] = $0c322a09d1b57883$export$7afb9b8acd50eb4e;
module.exports["isConfluenceAIFCPageCreateActionData"] = $0c322a09d1b57883$export$77c5629325e9aaaf;
module.exports["CONFLUENCE_AIFC_DEEP_RESEARCH_PAGE_CREATE_KEY"] = $0c322a09d1b57883$export$b632d4bc1af2f7d3;
module.exports["isConfluenceAIFCDeepResearchPageCreateActionData"] = $0c322a09d1b57883$export$3bd74956949aecbc;
module.exports["isConfluenceAIFCDeepResearchPageCreateActionPrepare"] = $0c322a09d1b57883$export$d6ad19367a51fe7a;
module.exports["AIFC_ADF_UPDATE_KEY"] = $0c322a09d1b57883$export$bb3d6eff667f4678;
module.exports["AIFC_ACTION_CLASSIFICATION_METADATA"] = $0c322a09d1b57883$export$7cca3e34118747ef;
module.exports["isAIFCADFUpdateActionData"] = $0c322a09d1b57883$export$1cf42b66f457bc6c;
module.exports["isAIFCADFSetActionClassificationActionData"] = $0c322a09d1b57883$export$fbc8213fc156433a;
module.exports["CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY"] = $0c322a09d1b57883$export$279c9cc61f7f510a;
module.exports["isConfluenceAIFCWhiteboardCreateActionData"] = $0c322a09d1b57883$export$392158ed2444b56b;
module.exports["CONFLUENCE_AIFC_SLIDES_CREATE_KEY"] = $0c322a09d1b57883$export$823e13f43093123d;
module.exports["isConfluenceAIFCSlidesCreateActionData"] = $0c322a09d1b57883$export$ae4ad515c9dd259d;
module.exports["CONFLUENCE_AIFC_SLIDES_UPDATE_KEY"] = $0c322a09d1b57883$export$49b21a7401bcc85;
module.exports["isConfluenceAIFCSlidesUpdateActionData"] = $0c322a09d1b57883$export$3d6de0a3c3e39cbf;
module.exports["CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY"] = $0c322a09d1b57883$export$d5d2204eeb3fde50;
module.exports["isConfluenceAIFCWhiteboardUpdateActionData"] = $0c322a09d1b57883$export$35d2029c1a7b307c;
module.exports["CONFLUENCE_AIFC_WHITEBOARD_TO_PAGE_KEY"] = $0c322a09d1b57883$export$771989b0afde4911;
module.exports["CONFLUENCE_WHITEBOARD_BRAINSTORMING_KEY"] = $0c322a09d1b57883$export$325918e7af3a74aa;
module.exports["isConfluenceWhiteboardBrainstormingActionData"] = $0c322a09d1b57883$export$48e8bcda6802129c;
module.exports["LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY"] = $0c322a09d1b57883$export$e3c19505945cf210;
module.exports["AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY"] = $0c322a09d1b57883$export$c8f288feec1641d9;
module.exports["isConfluenceWhiteboardDiagrammingActionData"] = $0c322a09d1b57883$export$f3a918f4f62365b2;
module.exports["CONFLUENCE_AIFC_DATABASE_CREATE_KEY"] = $0c322a09d1b57883$export$9f1bd612d6abcf5c;
module.exports["isConfluenceAIFCDatabaseCreateActionData"] = $0c322a09d1b57883$export$4dec930442f5ade2;
module.exports["CONFLUENCE_AIFC_DATABASE_UPDATE_KEY"] = $0c322a09d1b57883$export$ee0a705006a79cfe;
module.exports["isConfluenceAIFCDatabaseUpdateActionData"] = $0c322a09d1b57883$export$dbed60ca289ab1f3;
module.exports["CONFLUENCE_AIFC_SPACE_CREATE_KEY"] = $0c322a09d1b57883$export$691e9b05e574e32c;
module.exports["isConfluenceAIFCSpaceCreateActionData"] = $0c322a09d1b57883$export$545244afe3ae2546;
module.exports["CONFLUENCE_AIFC_SPACE_UPDATE_KEY"] = $0c322a09d1b57883$export$af91dd9bf235f890;
module.exports["isConfluenceAIFCSpaceUpdateActionData"] = $0c322a09d1b57883$export$38f648644a8b3072;
module.exports["PAGE_CREATE_ACTIONS"] = $0c322a09d1b57883$export$9f62c3ae716c44b2;
module.exports["WHITEBOARD_CREATE_ACTIONS"] = $0c322a09d1b57883$export$aba0c096f5cdcaca;
module.exports["SLIDES_CREATE_ACTIONS"] = $0c322a09d1b57883$export$b9c5aef93dba02df;
module.exports["DATABASE_CREATE_ACTIONS"] = $0c322a09d1b57883$export$45a7157715c10f20;
module.exports["isConfluencePageCreateAction"] = $0c322a09d1b57883$export$6c0ed26dac146a75;
module.exports["isConfluenceCreatableAction"] = $0c322a09d1b57883$export$eac4577c3e50732a;
module.exports["isConfluenceCreateNewAction"] = $0c322a09d1b57883$export$79fc6c76b9755410;
module.exports["isDynamicUiCreatableAction"] = $0c322a09d1b57883$export$53f0114d9f187b14;
module.exports["isImageCreatableAction"] = $0c322a09d1b57883$export$b3dfc475c0b1ff86;
module.exports["isConfluencePageUpdateAction"] = $0c322a09d1b57883$export$dfda1ac7e19cab7b;
module.exports["isConfluenceWhiteboardUpdateAction"] = $0c322a09d1b57883$export$dcbfc8a9b613cd00;
module.exports["isConfluenceSlidesUpdateAction"] = $0c322a09d1b57883$export$5d2d4e8984b13e00;
module.exports["isConfluenceDatabaseUpdateAction"] = $0c322a09d1b57883$export$399c9116e9984ca3;
module.exports["isConfluenceUpdatableAction"] = $0c322a09d1b57883$export$73dc9ed6ed2373f;
module.exports["isConfluenceStreamAction"] = $0c322a09d1b57883$export$54716060fc6e52ee;
module.exports["isConfluencePreviewCardAction"] = $0c322a09d1b57883$export$5cb5e5f4b4ce0a33;
module.exports["generateRovoReceiverId"] = $0c322a09d1b57883$export$681cf9ea58de88fd;
module.exports["getConfluenceContentType"] = $0c322a09d1b57883$export$bb9f6b0763834612;
module.exports["isAccumulatedAction"] = $0c322a09d1b57883$export$b95f9369e33f3b4a;
module.exports["getAccumulatedActionTypeGuard"] = $0c322a09d1b57883$export$898d9c03b4eb5dd5;
module.exports["getPrimaryAccumulatedValue"] = $0c322a09d1b57883$export$240debd921ff9f65;
module.exports["isRemixGeneratedAction"] = $0c322a09d1b57883$export$5b30faa0f696991d;
module.exports["isRemixGeneratedFlow"] = $0c322a09d1b57883$export$8eb2b74d04c8d455;
module.exports["getDynamicUiType"] = $0c322a09d1b57883$export$a549b965e1dff398;
module.exports["getDynamicUiSubtype"] = $0c322a09d1b57883$export$90cf5cf844c2f3b0;
module.exports["getRemixMetadata"] = $0c322a09d1b57883$export$ff1c2950f6d5486f;
module.exports["customActionUpdater"] = $0c322a09d1b57883$export$64e13fa6a74f5f86;

});

parcelRegister("l30d8", function(module, exports) {

var $b9NdB = parcelRequire("b9NdB");

const $9036d8afa9b2002b$var$CONFLUENCE_SLIDE_CLIENT_ID_PREFIX = 'confluence-slide';
const $9036d8afa9b2002b$export$8ad4475ac322bb70 = (contentId)=>(0, $b9NdB.client)(`${$9036d8afa9b2002b$var$CONFLUENCE_SLIDE_CLIENT_ID_PREFIX}-${contentId}`);
module.exports["getConfluenceSlidesClientId"] = $9036d8afa9b2002b$export$8ad4475ac322bb70;

});

parcelRegister("hAuc5", function(module, exports) {

var $2Yzoe = parcelRequire("2Yzoe");


var $csam1 = parcelRequire("csam1");


var $42JDa = parcelRequire("42JDa");


var $5SAOw = parcelRequire("5SAOw");

function $fe15ff31308e86c4$export$a9d25ff08f358d72(schema, map) {
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $fe15ff31308e86c4$export$b535e2638dcce02 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $fe15ff31308e86c4$export$8f853a1c35ed8bbe = (extendMarkdownSupport)=>({
        blockquote: {
            block: 'blockquote'
        },
        paragraph: {
            block: 'paragraph'
        },
        em: {
            mark: 'em'
        },
        strong: {
            mark: 'strong'
        },
        link: {
            mark: 'link',
            attrs: (tok)=>{
                // @ts-expect-error
                if (tok.pmAttrs) // @ts-expect-error
                return tok.pmAttrs;
                else return {
                    href: tok.attrGet('href'),
                    title: tok.attrGet('title') || null
                };
            }
        },
        hr: {
            node: 'rule'
        },
        heading: {
            block: 'heading',
            attrs: (tok)=>({
                    level: +tok.tag.slice(1)
                })
        },
        softbreak: {
            node: 'hardBreak'
        },
        hardbreak: {
            node: 'hardBreak'
        },
        code_block: {
            block: 'codeBlock'
        },
        list_item: {
            block: 'listItem'
        },
        bullet_list: {
            block: 'bulletList'
        },
        ordered_list: {
            block: 'orderedList',
            attrs: (tok)=>({
                    order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
                })
        },
        code_inline: {
            mark: 'code'
        },
        code: {
            mark: 'code'
        },
        fence: {
            block: 'codeBlock',
            // we trim any whitespaces around language definition
            attrs: (tok)=>({
                    language: tok.info && tok.info.trim() || null
                })
        },
        mediaInline: {
            node: 'mediaInline',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {};
            }
        },
        media_single: {
            block: 'mediaSingle',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {};
            }
        },
        media: {
            node: 'media',
            attrs: (token)=>{
                // When token.pmAttrs is missing it means it's an external image.
                // @ts-expect-error
                if (token.pmAttrs) // @ts-expect-error
                return token.pmAttrs;
                return {
                    url: token.attrGet('url'),
                    type: 'external'
                };
            }
        },
        caption: {
            block: 'caption',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        alignment: {
            mark: 'alignment',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        breakout: {
            mark: 'breakout',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        border: {
            mark: 'border',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        textColor: {
            mark: 'textColor',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        underline: {
            mark: 'underline',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        subsup: {
            mark: 'subsup',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        emoji: {
            node: 'emoji',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {
                    shortName: `:${token.markup}:`,
                    text: token.content
                };
            }
        },
        inlineCard: {
            node: 'inlineCard',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        date: {
            node: 'date',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        status: {
            node: 'status',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        mention: {
            node: 'mention',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        placeholder: {
            node: 'placeholder',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        table: {
            block: 'table',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        tr: {
            block: 'tableRow',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        th: {
            block: 'tableHeader',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        td: {
            block: 'tableCell',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        s: {
            mark: 'strike'
        },
        strike: {
            mark: 'strike'
        },
        task_list: {
            block: 'taskList'
        },
        task_item: {
            block: 'taskItem',
            attrs: (tok)=>({
                    state: tok.meta
                })
        },
        layoutSection: {
            block: 'layoutSection',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        layoutColumn: {
            block: 'layoutColumn',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        panel: {
            block: 'panel',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        decisionList: {
            block: 'decisionList',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        decisionItem: {
            block: 'decisionItem',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        expand: {
            block: 'expand',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        extension: {
            node: 'extension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        bodiedExtension: {
            block: 'bodiedExtension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        nestedExpand: {
            block: 'nestedExpand',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        inlineExtension: {
            node: 'inlineExtension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        }
    });


const $0773845a48a88423$var$captionOpen = 'caption_open';
const $0773845a48a88423$var$paragraphOpen = 'paragraph_open';
const $0773845a48a88423$var$paragraphClose = 'paragraph_close';
function $0773845a48a88423$export$eee367902819022(index, tokens) {
    // make sure we have an opening and closing paragraph token
    if (tokens[index]?.type !== $0773845a48a88423$var$paragraphOpen && tokens[index + 2]?.type !== $0773845a48a88423$var$paragraphClose) return;
    // remove the closing paragraph token from state.tokens so we don't add it into the acc
    // when we loop through the tokens
    tokens[index + 2]?.type === $0773845a48a88423$var$paragraphClose && tokens.splice(index + 2, 1);
    // return empty to prevent adding the opening token to the acc
    return;
}
function $0773845a48a88423$export$2e2bcd8739ae039(md, idMap) {
    md.core.ruler.after('custom-block', 'caption', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            const isWithinCaption = acc[acc.length - 1]?.type === $0773845a48a88423$var$captionOpen;
            if (type === $0773845a48a88423$var$paragraphOpen && isWithinCaption) /**
				 * paragraph_open and paragraph_close tokens get automatically added by markdown-it
				 * around text content. caption nodes do not allow paragraph nodes as children
				 * so we need to prevent these tokens from being added to the acc
				 */ $0773845a48a88423$export$eee367902819022(index, state.tokens);
            else acc.push(token);
            return acc;
        }, []);
    });
}


function $e92fa7dc1daa52ee$export$2e2bcd8739ae039(md) {
    md.inline.ruler.before('text', 'citation', function(state, silent) {
        const str = state.src.slice(state.pos);
        /**
		 * Matches the following:
		 * [^00^]
		 */ // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const citationRegexp = /^\[\^[^\^]+\^]/;
        const match = citationRegexp.exec(str);
        if (!match) return false;
        if (silent) return true;
        // Just skip citation from parsing and don't render them in the output.
        state.pos += match[0].length;
        return true;
    });
}


function $6d1436b1813e587d$export$c255480b061bd6aa(state, type, level) {
    let nesting;
    if (type.includes('_open')) nesting = 1;
    else if (type.includes('_close')) nesting = -1;
    else nesting = 0;
    const token = new state.Token(type, '', nesting);
    if (level) token.level = level;
    return token;
}


function $bb6e978431b17277$export$e717b161ec14d433(tokens) {
    const openTokenIndexMap = new Map();
    const toRemove = new Set();
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // This attribute is set earlier in this file (customElementToken.attrPush(['isCustomBlock', 'true']))
        // So we can identify tokens added by this rule
        if (token.attrGet('isCustomBlock') === 'true') {
            // We split by the last underscore
            const type = token.type.substring(0, token.type.lastIndexOf('_'));
            const prevIndex = openTokenIndexMap.get(type);
            // Only check for removal if type exists
            if (type && token.nesting === 1) {
                if (prevIndex !== undefined) toRemove.add(prevIndex);
                openTokenIndexMap.set(type, i);
            } else if (type && token.nesting === -1) {
                if (prevIndex !== undefined) // If previous open token found, then we've found a match and we can close it
                openTokenIndexMap.delete(type);
                else toRemove.add(i);
            }
        }
    }
    // Anything left in the stack is an unmatched open token
    openTokenIndexMap.forEach((remainingIndex)=>toRemove.add(remainingIndex));
    return toRemove;
}


// Some nodes will be inline but it's content will be empty.
// That's why, don't remove paragraphs wrapping it.
// For example, inlineExtension is inline node, so there should be no content inside it.
//  So it's custom element is represented by <custom data-type="inlineExtension" ... />
const $4cab79ce214481e1$var$emptyInlineCustomNodes = [
    'inlineExtension'
];
function $4cab79ce214481e1$export$2e2bcd8739ae039(md, idMap, featureToggles, analyticsAttributes) {
    md.core.ruler.after('inline', 'custom-block', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const match = token.content.match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123" />
				 * <custom data-type="smartlink" />
				 * <custom data-type="panel_open" data-id="123" />
				 * <custom data-type="panel_close" />
				 */ // Ignored via go/ees005
            // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
            // eslint-disable-next-line require-unicode-regexp
            RegExp('<custom\\s+data-type="(?<dataType>.*?)"\\s*(data-id="(?<dataId>.*?)"\\s*)?\\/>'));
            const dataType = match?.groups?.dataType;
            if (match && dataType && !$4cab79ce214481e1$var$emptyInlineCustomNodes.includes(dataType)) {
                const dataId = match.groups?.dataId;
                if (dataType) {
                    analyticsAttributes.htmlConvertedToNodes++;
                    const customElementToken = (0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, dataType);
                    if (dataId && idMap[dataId]) // @ts-ignore
                    customElementToken.pmAttrs = idMap[dataId].attributes;
                    customElementToken.attrPush([
                        'isCustomBlock',
                        'true'
                    ]);
                    /**
					 * When the custom tag goes through the tokenizer it is transformed into this structure:
					 * paragraph_open
					 * inline
					 * paragraph_close
					 *
					 * so the following section removes the wrapping paragraph tokens
					 */ acc.splice(acc.length - 1, 1);
                    state.tokens.splice(index + 1, 1);
                    // We then push replace the inline token with our custom token
                    acc.push(customElementToken);
                } else {
                    analyticsAttributes.htmlConvertedToFallbackNodes++;
                    acc.push(token);
                }
            } else acc.push(token);
            return acc;
        }, []);
        const toRemove = (0, $bb6e978431b17277$export$e717b161ec14d433)(state.tokens);
        toRemove.forEach((index)=>{
            const tokenToBeRemoved = state.tokens[index];
            analyticsAttributes.unclosedTokens[tokenToBeRemoved.type] = (analyticsAttributes.unclosedTokens[tokenToBeRemoved.type] || 0) + 1;
        });
        // Remove all indices that have been set in `toRemove`
        if (featureToggles.markdownPlusRemoveUnclosedTokens) state.tokens = state.tokens.filter((_, index)=>!toRemove.has(index));
    });
}



var $a4TK8 = parcelRequire("a4TK8");

function $102908d0f0788df0$export$2e2bcd8739ae039(md, idMap, featureToggles, analyticsAttributes, markdownPlusAttributeStatus) {
    const rule = md.inline.ruler.before('text', 'custom', function(state, silent) {
        const start = state.pos;
        const origSrc = state.src;
        let match;
        if (featureToggles.markdownPlusAttributeTest) match = state.src.slice(start).match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123">content</custom>
				 * <custom data-id="123">content</custom>
				 * <custom data-type="emoji">content</custom>
				 * <custom>content</custom>
				 * <custom data-type="status" data-id="id-0" data-attrs='{"text":"test","color":"neutral"}'>test</custom>
				 */ // Ignored via go/ees005
        // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
        // eslint-disable-next-line require-unicode-regexp
        RegExp('<custom(?:\\s+data-type="(?<dataType>[^"]*)")?(?:\\s+data-id="(?<dataId>[^"]*)")?(?:\\s+data-attrs="(?<dataAttrs>\\{.*?\\})")?\\s*>(?<dataContent>.*?)<\\/custom>'));
        else match = state.src.slice(start).match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123">content</custom>
				 * <custom data-id="123">content</custom>
				 * <custom data-type="emoji">content</custom>
				 * <custom>content</custom>
				 */ // Ignored via go/ees005
        // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
        // eslint-disable-next-line require-unicode-regexp
        RegExp('<custom(\\sdata-(type|id)="(?<dataType>.*?)")?(\\sdata-(type|id)="(?<dataId>.*?)")?>(?<dataContent>.*?)<\\/custom>'));
        if (!match) return false;
        const tagLength = match[0].length;
        const beforeTag = state.src.slice(start, state.src.indexOf(match[0]));
        const dataType = match.groups?.dataType;
        const dataId = match.groups?.dataId;
        const dataAttrs = match.groups?.dataAttrs;
        const dataContent = match.groups?.dataContent;
        const afterTag = state.src.slice(start + beforeTag.length + tagLength);
        function mapCustomDataTypeToNodeType(customDataType) {
            switch(customDataType){
                case 'smartlink':
                    return 'inlineCard';
                case 'date':
                case 'emoji':
                case 'status':
                case 'mention':
                case 'placeholder':
                    return customDataType;
                // Just move below case alongside mention above to remove markdownPlusExtensions FF.
                case 'inlineExtension':
                    return featureToggles.markdownPlusExtensions ? 'inlineExtension' : false;
                case 'mediaInline':
                    return featureToggles.markdownPlusAddComplexNodes ? 'mediaInline' : false;
                default:
                    return false;
            }
        }
        const customDataType = mapCustomDataTypeToNodeType(dataType);
        if (!silent) {
            // tokenize beforeTag
            if (beforeTag) {
                state.src = beforeTag;
                // @ts-ignore
                state.md.inline.tokenize(state, beforeTag);
            }
            if (featureToggles.markdownPlusAttributeTest && featureToggles.markdownPlusMentions && !dataId && dataAttrs && customDataType) {
                const customDataToken = state.push(customDataType, '', 0);
                // @ts-ignore
                customDataToken.pmAttrs = dataAttrs;
            }
            if (dataId && idMap?.[dataId]?.attributes && customDataType) {
                analyticsAttributes.htmlConvertedToNodes++;
                const customDataToken = state.push(customDataType, '', 0);
                // @ts-ignore
                customDataToken.pmAttrs = idMap[dataId].attributes;
                if (featureToggles.markdownPlusAttributeTest && dataAttrs) try {
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(idMap[dataId].attributes, JSON.parse(dataAttrs))) markdownPlusAttributeStatus.push([
                        customDataType,
                        true
                    ]);
                    else // We need to check this because when you type it calls this function multiple times and the first time its called the current text is not the same
                    if (idMap[dataId].attributes.text === JSON.parse(dataAttrs).text) markdownPlusAttributeStatus.push([
                        customDataType,
                        false
                    ]);
                } catch (e) {
                    markdownPlusAttributeStatus.push([
                        customDataType,
                        false
                    ]);
                }
            } else {
                analyticsAttributes.htmlConvertedToFallbackNodes++;
                const textToken = state.push('text', '', 0);
                // If there is no data content we want to hide the custom tags as the AI has hallucinated something
                if (!dataContent) textToken.content = '';
                else textToken.content = dataContent || match[0];
            }
            if (afterTag) {
                state.src = afterTag;
                state.pos = 0;
                // @ts-ignore
                state.md.inline.tokenize(state, afterTag);
            }
        }
        state.src = origSrc;
        state.pos = start + state.src.length;
        return true;
    });
    return rule;
}


const $b85e013b8e2ab0fc$var$decisionItemOpen = 'decisionItem_open';
const $b85e013b8e2ab0fc$var$paragraphOpen = 'paragraph_open';
const $b85e013b8e2ab0fc$var$paragraphClose = 'paragraph_close';
const $b85e013b8e2ab0fc$var$inline = 'inline';
function $b85e013b8e2ab0fc$var$handleParagraphs(acc, token) {
    /**
	 * Traverse up the acc token array, and if a chain of one or more inline tokens are under
	 * a decisionItem_open token, then it is considered to be a paragraph_close token within
	 * a decision item.
	 *
	 * This also works for a paragraph_open token as inlineCount would be zero meaning that
	 * the conditional applies to when decisionItem_open is right above paragraph_open.
	 */ let inlineCount = 0;
    let inlineChainEnded = false;
    for(let i = acc.length - 1; i >= 0; i--){
        const type = acc[i]?.type;
        if (!inlineChainEnded) {
            if (type === $b85e013b8e2ab0fc$var$inline) inlineCount += 1;
            else inlineChainEnded = true;
        }
    }
    const isWithinDecisionItem = acc[acc.length - (inlineCount + 1)]?.type === $b85e013b8e2ab0fc$var$decisionItemOpen;
    if (!isWithinDecisionItem) acc.push(token);
}
function $b85e013b8e2ab0fc$export$2e2bcd8739ae039(md, idMap) {
    md.core.ruler.after('custom-block', 'decision-list', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === $b85e013b8e2ab0fc$var$paragraphOpen || type === $b85e013b8e2ab0fc$var$paragraphClose) $b85e013b8e2ab0fc$var$handleParagraphs(acc, token);
            else acc.push(token);
            return acc;
        }, []);
    });
}


const $e6de2bb5deb5f668$var$replaceBrWithLineBreak = (text)=>{
    // Matches <br> or <br /> or <br/> with optional trailing space
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/<br\s*\/?>\s?/gi, '\n');
};
const $e6de2bb5deb5f668$var$processInlineChildren = (children)=>{
    for (const child of children)if (child.type === 'text') {
        const newText = $e6de2bb5deb5f668$var$replaceBrWithLineBreak(child.content);
        if (child.content !== newText) child.content = newText;
    }
};
const $e6de2bb5deb5f668$var$brToLineBreak = (state)=>{
    for (const token of state.tokens)if (token.type === 'inline' && token.children) $e6de2bb5deb5f668$var$processInlineChildren(token.children);
};
var $e6de2bb5deb5f668$export$2e2bcd8739ae039 = (md)=>md.core.ruler.after('inline', 'lineBreak', $e6de2bb5deb5f668$var$brToLineBreak);


// File copied from packages/editor/editor-core/src/plugins/paste/linkify-md-plugin.ts

var $2Gb84 = parcelRequire("2Gb84");


var $81OAa = parcelRequire("81OAa");

// File copied from packages/editor/editor-core/src/plugins/hyperlink/utils.ts
// Regular expression for a windows filepath in the format <DRIVE LETTER>:\<folder name>\
// Ignored via go/ees005
const $7715b3c791c155be$export$893fccbed37586dd = // eslint-disable-next-line require-unicode-regexp
/([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
const $7715b3c791c155be$export$d37783fe63e2f0fe = (text, offset = 0)=>{
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const localRegExp = new RegExp($7715b3c791c155be$export$893fccbed37586dd);
    let match;
    const matchesList = [];
    const maxFilepathSize = 260;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while((match = localRegExp.exec(text)) !== null){
        const start = match.index + offset;
        let end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
const $7715b3c791c155be$export$5e652e74655163e5 = (linkStart, matchesList)=>{
    for(let i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $7715b3c791c155be$export$8acd10161c5f8b07(text) {
    return text.replace(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /(\[([^\]]+)\]\(|\!\[([^\]]*)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s]+)/g, (str)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return str.match(/^(https?|ftp|jamfselfservice):\/\/[^\s]+$/) ? `<${str}>` : str;
    });
}


// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $866d7fb158c265f1$var$arrayReplaceAt = (src, pos, newElements)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $866d7fb158c265f1$var$isLinkOpen = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<a[>\s]/i.test(str);
};
const $866d7fb158c265f1$var$isLinkClose = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<\/a\s*>/i.test(str);
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $866d7fb158c265f1$var$linkify = (state)=>{
    const blockTokens = state.tokens;
    const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($2Gb84)))();
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($866d7fb158c265f1$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($866d7fb158c265f1$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = (0, $81OAa.linkifyMatch)(text);
                if (!links.length) links = linkify.match(text) || [];
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                const filepaths = (0, $7715b3c791c155be$export$d37783fe63e2f0fe)(text);
                for(let ln = 0; ln < links.length; ln++){
                    if ((0, $7715b3c791c155be$export$5e652e74655163e5)(links[ln].index, filepaths)) continue;
                    const { url: url } = links[ln];
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    let token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $866d7fb158c265f1$var$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$866d7fb158c265f1$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $866d7fb158c265f1$var$linkify);


// File copied from packages/editor/editor-markdown-transformer/src/media.ts

var $bd943 = parcelRequire("bd943");

function $623b0b26b9c81375$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regx = /!\[[^\]]*\]\([^)]+\)/g;
    // Allow paragraph_close as a valid parent token for cases where a user has an image at the end of a paragraph
    // due to shift+enter
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'paragraph_close'
    ];
    /**
	 * This function looks for strings that matches ![description](url) inside Inline-tokens.
	 * It will then split the Inline-token with content before and after the image, example:
	 *
	 * Input (tokens):
	 *   paragraph_open
	 *   inline - content: Hello ![](image.jpg) World!
	 *   paragraph_close
	 * Output (tokens):
	 *   paragraph_open
	 *   inline - content: Hello
	 *   paragraph_close
	 *   media_single_open
	 *   media
	 *   media_single_close
	 *   paragraph_open
	 *   inline - content: World!
	 *   paragraph_close
	 *
	 * This is applied before the inline content is parsed, to ensure that the formatting of
	 * remaining inline content (bold, links, etc.) is kept intact!
	 */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            if (url.includes((0, $bd943.MEDIA_BASE_URL_STAGING))) try {
                const urlObject = new URL(getUrl(url));
                const params = urlObject.searchParams;
                if (params.toString()) {
                    const pmAttrs = {};
                    for (const [key, value] of params)pmAttrs[key] = value;
                    // @ts-expect-error - pmAttrs is not a standard markdown-it attribute
                    media.pmAttrs = pmAttrs;
                }
            } catch  {}
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && regx.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens// eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                .map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const matches = token.content.match(regx);
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + match.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $623b0b26b9c81375$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $623b0b26b9c81375$var$createRule());
};


// file copied from packages/editor/editor-core/src/plugins/paste/newline-md-plugin.ts
// ED-15363: modified version of the original newline plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_inline/newline.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $73825321bd2619ae$var$newline = (state, silent)=>{
    let pos = state.pos;
    // ED-15363: unread variables
    // max,
    // ws,
    if (state.src.charCodeAt(pos) !== 0x0a /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    // ED-15363: unread variable
    // max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) // ED-15363: We commented out this logic to preserve trailing whitespaces
            // for each line of text when pasting plain text
            // // Find whitespaces tail of pending chars.
            // ws = pmax - 1;
            // while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) {
            //   ws--;
            // }
            // state.pending = state.pending.slice(0, ws);
            state.push('hardbreak', 'br', 0);
            else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // ED-15363: We commented out this logic from the original library to
    // preserve leading whitespaces for each line of text when pasting plain
    // text (to preserve whitespace-based indentation).
    // // skip heading spaces for next line
    // while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    //   pos++;
    // }
    state.pos = pos;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$73825321bd2619ae$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $73825321bd2619ae$var$newline);






// eslint-disable-next-line require-unicode-regexp
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $3f17de48a6931d92$var$mediaRegex = /(!\[[^\]]*\]\([^)]+\))|(\[!\[[^\]]*\]\([^)]+\)\]\([^)]+\))/gu;
const $3f17de48a6931d92$var$getUrl = (state, str)=>{
    const res = state.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
    if (res.ok) {
        const href = state.md.normalizeLink(res.str);
        if (state.md.validateLink(href)) return href;
    }
    return '';
};
const $3f17de48a6931d92$var$checkPreviousToken = (type, acc)=>{
    return acc.length > 0 && acc[acc.length - 1].type === type;
};
const $3f17de48a6931d92$var$createMediaTokens = (url, state, acc)=>{
    const mediaSingleOpen = (0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, 'media_single_open');
    const media = (0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, 'media');
    media.attrs = [
        [
            'url',
            $3f17de48a6931d92$var$getUrl(state, url)
        ],
        [
            'type',
            'external'
        ]
    ];
    // This is a hack to get internal media to work
    // to recreate the image correctly we need to apply the pmAttrs from the image
    // We store the pmAttrs in the "fake" image url and apply them to the token
    if (url.includes((0, $bd943.MEDIA_BASE_URL_STAGING))) try {
        const urlObject = new URL($3f17de48a6931d92$var$getUrl(state, url));
        const params = urlObject.searchParams;
        if (params.toString()) {
            const pmAttrs = {};
            for (const [key, value] of params)pmAttrs[key] = value;
            // @ts-expect-error - pmAttrs is not a standard markdown-it attribute
            media.pmAttrs = pmAttrs;
        }
    } catch  {}
    const mediaSingleClose = (0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, 'media_single_close');
    acc.push(mediaSingleOpen, media, mediaSingleClose);
};
const $3f17de48a6931d92$var$createInlineTokens = (content, state, acc)=>{
    const paragraphOpen = (0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, 'paragraph_open');
    const inline = (0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, 'inline');
    inline.content = content;
    inline.children = [
        (0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, 'text')
    ];
    const paragraphClose = (0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, 'paragraph_close');
    acc.push(paragraphOpen, inline, paragraphClose);
};
/**
 * Splits the content of the inline token
 * Inline tokens can contain multiple media elements as well as regular text
 * We split the content into an array of strings which can then be converted into the correct tokens
 */ const $3f17de48a6931d92$var$findContent = (token)=>{
    let content = [];
    let lastIndex = 0;
    let match;
    $3f17de48a6931d92$var$mediaRegex.lastIndex = 0;
    // eslint-disable-next-line no-cond-assign
    while((match = $3f17de48a6931d92$var$mediaRegex.exec(token.content)) !== null){
        const matchedString = match[0];
        const matchIndex = match.index;
        if (lastIndex < matchIndex) content.push(token.content.substring(lastIndex, matchIndex));
        content.push(matchedString);
        lastIndex = matchIndex + matchedString.length;
    }
    if (lastIndex < token.content.length) content.push(token.content.substring(lastIndex));
    content = content.filter((item)=>item.length > 0);
    return content;
};
function $3f17de48a6931d92$export$2e2bcd8739ae039(md) {
    md.core.ruler.before('inline', 'media', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === 'inline' && $3f17de48a6931d92$var$mediaRegex.test(token.content)) {
                // If the previous token is a paragraph_open we want to remove it
                if ($3f17de48a6931d92$var$checkPreviousToken('paragraph_open', acc)) acc.pop();
                const content = $3f17de48a6931d92$var$findContent(token);
                content.forEach((item)=>{
                    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
                    const doesMatch = /!\[[^\]]*\]\([^)]+\)/u.test(item);
                    if (doesMatch) $3f17de48a6931d92$var$createMediaTokens(item, state, acc);
                    else $3f17de48a6931d92$var$createInlineTokens(item, state, acc);
                });
            // If the current token is paragraph close we want to make sure that the previous token isn't a media_single_close
            // or paragraph_close
            } else if (type === 'paragraph_close') {
                if (!$3f17de48a6931d92$var$checkPreviousToken('media_single_close', acc) && !$3f17de48a6931d92$var$checkPreviousToken('paragraph_close', acc)) acc.push(token);
            } else acc.push(token);
            return acc;
        }, []);
    });
}


// File copied from packages/editor/editor-core/src/plugins/paste/paragraph-md-plugin.ts
// ED-15363: modified version of the original paragraph plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/paragraph.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $811470bd95061a4c$var$paragraph = (state, startLine /*, endLine*/ )=>{
    let terminate, i, l, token, nextLine = startLine + 1;
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const endLine = state.lineMax;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$811470bd95061a4c$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $811470bd95061a4c$var$paragraph);



const $11bccb76849cfb3f$var$bulletListOpen = 'bullet_list_open';
const $11bccb76849cfb3f$var$bulletListClose = 'bullet_list_close';
const $11bccb76849cfb3f$var$listItemOpen = 'list_item_open';
const $11bccb76849cfb3f$var$listItemClose = 'list_item_close';
const $11bccb76849cfb3f$var$taskListOpen = 'task_list_open';
const $11bccb76849cfb3f$var$taskListClose = 'task_list_close';
const $11bccb76849cfb3f$var$taskItemOpen = 'task_item_open';
const $11bccb76849cfb3f$var$taskItemClose = 'task_item_close';
const $11bccb76849cfb3f$var$paragraphOpen = 'paragraph_open';
const $11bccb76849cfb3f$var$paragraphClose = 'paragraph_close';
function $11bccb76849cfb3f$var$checkTypeByIndex(acc, type, indexOffset = -1) {
    return acc[acc.length + indexOffset]?.type === type;
}
function $11bccb76849cfb3f$var$getTokenByIndex(acc, indexOffset = -1) {
    return acc[acc.length + indexOffset];
}
function $11bccb76849cfb3f$var$handleBulletListOpen(state, token, acc, index) {
    const isPreviousTokenInline = $11bccb76849cfb3f$var$checkTypeByIndex(acc, 'inline');
    const isStartOfTaskList = state.tokens[index + 3].type === 'inline' && $11bccb76849cfb3f$var$startsWithTodoMarkdown(state.tokens[index + 3]);
    // If the previous token is inline and our current token is a bullet_list_open that
    // means we have found the start of a nested list, due to current ADF limitations task items
    // cannot contain new task lists so first we must close the task item and then convert the
    // bullet_list_open to task_list_open
    if (isPreviousTokenInline) {
        acc.push((0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$taskItemClose, $11bccb76849cfb3f$var$getTokenByIndex(acc).level - 1));
        acc.push((0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$taskListOpen, $11bccb76849cfb3f$var$getTokenByIndex(acc).level));
    } else if (isStartOfTaskList) acc.push((0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$taskListOpen));
    else acc.push(token);
}
function $11bccb76849cfb3f$var$handleBulletListClose(state, token, acc) {
    const isPreviousTokenTaskItemClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemClose);
    const isPreviousTokenTaskListClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskListClose);
    if (isPreviousTokenTaskItemClose || isPreviousTokenTaskListClose) acc.push((0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$taskListClose, $11bccb76849cfb3f$var$getTokenByIndex(acc).level - 1));
    else acc.push(token);
}
function $11bccb76849cfb3f$var$handleListItemOpen(state, token, acc, index) {
    const newTaskItemOpen = (0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$taskItemOpen);
    const isTaskItem = state.tokens[index + 2].type === 'inline' && $11bccb76849cfb3f$var$startsWithTodoMarkdown(state.tokens[index + 2]);
    const isPreviousTokenTaskItemClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemClose);
    const isPreviousTokenListItemClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$listItemClose);
    const isPreviousTokenTaskListClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskListClose);
    if (isTaskItem) {
        // If the previous token is a list item close then we have run into some incorrect task list / list markdown
        // We need to complete the previous bullet list and then open a new task list
        if (isPreviousTokenListItemClose) {
            acc.push((0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$bulletListClose));
            acc.push((0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$taskListOpen));
        }
        newTaskItemOpen.meta = $11bccb76849cfb3f$var$isDone(state.tokens[index + 2]);
        newTaskItemOpen.level = $11bccb76849cfb3f$var$getTokenByIndex(acc).level + (isPreviousTokenTaskListClose ? 0 : 1);
        acc.push(newTaskItemOpen);
    } else {
        // If the previous token is a task item close but the current token is not a task item we need to
        // close the current task item list and then open a new bullet list
        if (isPreviousTokenTaskItemClose) {
            acc.push((0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$taskListClose));
            acc.push((0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$bulletListOpen));
        }
        acc.push(token);
    }
}
function $11bccb76849cfb3f$var$handleListItemClose(state, token, acc) {
    const isWithinTaskList = $11bccb76849cfb3f$var$checkTypeByIndex(acc, 'inline') && $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemOpen, -2);
    if (isWithinTaskList) acc.push((0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$taskItemClose, $11bccb76849cfb3f$var$getTokenByIndex(acc, -2).level));
    else if (!$11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskListClose)) acc.push(token);
}
function $11bccb76849cfb3f$var$handleInline(token, acc) {
    if (token.children?.[0]) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    token.children[0].content = $11bccb76849cfb3f$var$removeTodoMarkdown(token.children[0].content);
    token.content = $11bccb76849cfb3f$var$removeTodoMarkdown(token.content);
    token.level = $11bccb76849cfb3f$var$getTokenByIndex(acc).level + 1;
    acc.push(token);
}
function $11bccb76849cfb3f$var$handleParagraphs(token, acc) {
    const isWithinTaskItem = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemOpen) || $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemOpen, -2);
    if (!isWithinTaskItem) acc.push(token);
}
function $11bccb76849cfb3f$var$isInlineAfterTaskItemOpen(token, acc) {
    return token.type === 'inline' && acc[acc.length - 1].type === $11bccb76849cfb3f$var$taskItemOpen;
}
function $11bccb76849cfb3f$var$startsWithTodoMarkdown(token) {
    // leading whitespace in a list item is already trimmed off by markdown-it
    return token.content.indexOf('[ ] ') === 0 || token.content.indexOf('[x] ') === 0 || token.content.indexOf('[X] ') === 0;
}
function $11bccb76849cfb3f$var$removeTodoMarkdown(content) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regex = /(\[x\]\s)|(\[\s\]\s)/;
    return content.replace(regex, '');
}
function $11bccb76849cfb3f$var$isDone(token) {
    if (token.content.indexOf('[ ] ') === 0) return 'TODO';
    else return 'DONE';
}
function $11bccb76849cfb3f$export$2e2bcd8739ae039(md) {
    md.core.ruler.after('inline', 'github-task-lists', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === $11bccb76849cfb3f$var$bulletListOpen) $11bccb76849cfb3f$var$handleBulletListOpen(state, token, acc, index);
            else if (type === $11bccb76849cfb3f$var$bulletListClose) $11bccb76849cfb3f$var$handleBulletListClose(state, token, acc);
            else if (type === $11bccb76849cfb3f$var$listItemOpen) $11bccb76849cfb3f$var$handleListItemOpen(state, token, acc, index);
            else if ($11bccb76849cfb3f$var$isInlineAfterTaskItemOpen(token, acc)) $11bccb76849cfb3f$var$handleInline(token, acc);
            else if (type === $11bccb76849cfb3f$var$listItemClose) $11bccb76849cfb3f$var$handleListItemClose(state, token, acc);
            else if (type === $11bccb76849cfb3f$var$paragraphOpen || type === $11bccb76849cfb3f$var$paragraphClose) $11bccb76849cfb3f$var$handleParagraphs(token, acc);
            else acc.push(token);
            return acc;
        }, []);
    });
}



function $ce78ef6bb9d33c7d$var$getFragmentBackingArray(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fragment.content;
}
function $ce78ef6bb9d33c7d$var$mapFragment(content, callback, parent = null) {
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($ce78ef6bb9d33c7d$var$mapFragment(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $5SAOw.Fragment)) children.push(...$ce78ef6bb9d33c7d$var$getFragmentBackingArray(transformed));
            else if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return (0, $5SAOw.Fragment).fromArray(children);
}
function $ce78ef6bb9d33c7d$export$b2bf04f78f72b123({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
    const { markdownPlus: markdownPlus } = featureToggles;
    const tokenizer = new (0, (/*@__PURE__*/$parcel$interopDefault($2Yzoe)))('zero', {
        html: false
    });
    tokenizer.enable([
        // Process html entity - &#123;, &#xAF;, &quot;, ...
        'entity',
        // Process escaped chars and hardbreaks
        'escape',
        'newline'
    ]);
    [
        'nodes',
        'marks'
    ].forEach((key)=>{
        for(const idx in (0, $fe15ff31308e86c4$export$b535e2638dcce02)[key])if (schema[key][idx]) tokenizer.enable((0, $fe15ff31308e86c4$export$b535e2638dcce02)[key][idx]);
    });
    const analyticsAttributes = {
        htmlConvertedToNodes: 0,
        htmlConvertedToFallbackNodes: 0,
        unclosedTokens: {}
    };
    // Remove once markdownPlusAttributeTest is removed
    const markdownPlusAttributeStatus = [];
    if (markdownPlus) {
        tokenizer.use((0, $4cab79ce214481e1$export$2e2bcd8739ae039), idMap, featureToggles, analyticsAttributes);
        tokenizer.use((0, $b85e013b8e2ab0fc$export$2e2bcd8739ae039), idMap);
        tokenizer.use((0, $102908d0f0788df0$export$2e2bcd8739ae039), idMap, featureToggles, analyticsAttributes, markdownPlusAttributeStatus);
    }
    tokenizer.use((0, $e92fa7dc1daa52ee$export$2e2bcd8739ae039), idMap);
    tokenizer.use((0, $811470bd95061a4c$export$2e2bcd8739ae039));
    // enable modified version of linkify plugin
    // @see https://product-fabric.atlassian.net/browse/ED-3097
    tokenizer.use((0, $866d7fb158c265f1$export$2e2bcd8739ae039));
    tokenizer.use((0, $73825321bd2619ae$export$2e2bcd8739ae039));
    tokenizer.use((0, $e6de2bb5deb5f668$export$2e2bcd8739ae039));
    // Custom Table tokenizer
    if (schema.nodes.table) tokenizer.use((0, $csam1.markdownItTable));
    // Custom Media tokenizer
    if (schema.nodes.media && schema.nodes.mediaSingle) {
        if (featureToggles.markdownPlusUseNextMediaPlugin) tokenizer.use((0, $3f17de48a6931d92$export$2e2bcd8739ae039));
        else tokenizer.use((0, $623b0b26b9c81375$export$c8dcbd316b71f8cf));
        if (markdownPlus && featureToggles.markdownPlusAddComplexNodes) tokenizer.use((0, $0773845a48a88423$export$2e2bcd8739ae039));
    }
    // Custom TaskList tokenizer
    if (schema.nodes.taskList) tokenizer.use((0, $11bccb76849cfb3f$export$2e2bcd8739ae039));
    const markdownParser = new (0, $42JDa.MarkdownParser)(schema, tokenizer, (0, $fe15ff31308e86c4$export$a9d25ff08f358d72)(schema, (0, $fe15ff31308e86c4$export$8f853a1c35ed8bbe)(!!markdownPlus)));
    if (markdown === '') return {
        htmlConvertedToNodes: 0,
        htmlConvertedToFallbackNodes: 0,
        unclosedTokens: {},
        markdownPlusAttributeStatus: [],
        pmFragment: (0, $5SAOw.Fragment).empty
    };
    // normalize duplicated backticks (needed as a safeguard to avoid rendering malformed escape characters coming from backed)
    // the case with newline characters
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    markdown = markdown.replace(/\\n/g, '\n');
    // the case with custom field attributes (limit only to data- attributes inside custom fields)
    if (markdownPlus) // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    markdown = markdown.replace(/<custom[^>]*?>/g, function(match) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return match.replace(/(data-\w+=)\\\"(.*?)\\\"/g, '$1"$2"');
    });
    const prosemirrorNode = markdownPlus ? markdownParser.parse(markdown) : markdownParser.parse((0, $7715b3c791c155be$export$8acd10161c5f8b07)(markdown));
    if (!prosemirrorNode.content) throw new Error('Markdown conversion did not result in a valid document being created');
    // This logic is duplicated from editor-cores paste transformation.
    // The editor-plugin-ai package is avoiding sharing dependencies with editor-core to support
    // products using it with various versions of editor packages.
    // The duplication is from the following file:
    // packages/editor/editor-core/src/plugins/media/utils/media-single.ts
    // WARNING
    // If the `mapFragment` usage changes -- it means we have a breaking change for products
    // where currently it's expected they are using older versions of editor-common
    const mappedContent = $ce78ef6bb9d33c7d$var$mapFragment(prosemirrorNode.content, (node)=>{
        if (node.type.name === 'media') {
            const replacedAttrs = Object.fromEntries(Object.entries(node.attrs).map(([key, value])=>{
                // If value is the literal string 'null', convert it to JS null
                return [
                    key,
                    value === 'null' ? null : value
                ];
            }));
            return schema.nodes.media.createChecked({
                ...replacedAttrs,
                // Adding this attribute results in the media node being rendered
                // initially using the external url, but then triggering an upload
                // of the external url as an atlassian artifact, and this media
                // will then be replaced to use the atlassian artifact.
                //
                // This is done in the media nodeview by checking the attributes
                // when rendering.
                __external: replacedAttrs.type === 'external',
                __mediaTraceId: null
            }, node.content, node.marks);
        }
        return node;
    });
    return {
        ...analyticsAttributes,
        markdownPlusAttributeStatus: markdownPlusAttributeStatus,
        pmFragment: mappedContent
    };
}
function $ce78ef6bb9d33c7d$export$e661a057c2263d64({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
    const fragment = $ce78ef6bb9d33c7d$export$b2bf04f78f72b123({
        markdown: markdown,
        schema: schema,
        idMap: idMap,
        featureToggles: {
            markdownPlus: true,
            ...featureToggles
        }
    });
    try {
        const node = schema.nodes.doc.createChecked({}, fragment.pmFragment);
        return node;
    } catch  {
        throw new Error('Markdown conversion did not result in a valid ProseMirror node');
    }
}
module.exports["convertMarkdownToProsemirror"] = $ce78ef6bb9d33c7d$export$b2bf04f78f72b123;
module.exports["backendConvertMarkdownToProsemirrorNode"] = $ce78ef6bb9d33c7d$export$e661a057c2263d64;

});

parcelRegister("2O3ot", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $abb9e481ac8f38e8$var$initialState = {
    messageIdSelectedForPreview: null,
    invocationIdSelectedForPreview: null,
    stagingAreaMode: undefined,
    stagingAreaEntryPoint: '',
    prompt: '',
    dynamicUiType: undefined,
    dynamicUiSubtype: undefined,
    dynamicUiSource: undefined,
    isRemixUpdating: false,
    forceSkipAutoConversationSelection: false,
    currentDisplayMessageId: undefined
};
const $abb9e481ac8f38e8$var$actions = {
    setMessageIdSelectedForPreview: (messageId)=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: messageId
            });
        },
    getMessageIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().messageIdSelectedForPreview;
        },
    setStagingAreaMode: (mode, entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaMode: mode,
                stagingAreaEntryPoint: entryPoint ?? ''
            });
        },
    setStagingAreaEntryPoint: (entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaEntryPoint: entryPoint ?? ''
            });
        },
    setPrompt: (prompt)=>({ setState: setState })=>{
            setState({
                prompt: prompt
            });
        },
    setInvocationIdSelectedForPreview: (invocationId)=>({ setState: setState })=>{
            setState({
                invocationIdSelectedForPreview: invocationId
            });
        },
    getInvocationIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().invocationIdSelectedForPreview;
        },
    setIsRemixUpdating: (isUpdating)=>({ setState: setState })=>{
            setState({
                isRemixUpdating: isUpdating
            });
        },
    setDynamicUiContext: (dynamicUiType, dynamicUiSubtype, dynamicUiSource)=>({ setState: setState })=>{
            setState({
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                dynamicUiSource: dynamicUiSource
            });
        },
    resetStagingArea: ()=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: null,
                invocationIdSelectedForPreview: null,
                isRemixUpdating: false,
                stagingAreaMode: undefined,
                stagingAreaEntryPoint: '',
                dynamicUiType: undefined,
                dynamicUiSubtype: undefined,
                dynamicUiSource: undefined,
                forceSkipAutoConversationSelection: false,
                currentDisplayMessageId: undefined
            });
        },
    setForceSkipAutoConversationSelection: (forceSkip)=>({ setState: setState })=>{
            setState({
                forceSkipAutoConversationSelection: forceSkip
            });
        },
    setCurrentDisplayMessageId: (messageId)=>({ setState: setState })=>{
            setState({
                currentDisplayMessageId: messageId
            });
        }
};
const $abb9e481ac8f38e8$var$store = (0, $1P1Tu.createStore)({
    initialState: $abb9e481ac8f38e8$var$initialState,
    actions: $abb9e481ac8f38e8$var$actions
});
const $abb9e481ac8f38e8$export$a2795b51ce92008f = (0, $9zUhf.createHook)($abb9e481ac8f38e8$var$store, {
    selector: (state)=>state.messageIdSelectedForPreview
});
const $abb9e481ac8f38e8$export$916334da9df8d04 = (0, $9zUhf.createHook)($abb9e481ac8f38e8$var$store);
const $abb9e481ac8f38e8$export$8f9a13b17bec42d5 = (0, $9zUhf.createActionsHook)($abb9e481ac8f38e8$var$store);
const $abb9e481ac8f38e8$export$5a57f796673aabea = (0, $9zUhf.createStateHook)($abb9e481ac8f38e8$var$store);
module.exports["useMessageIdSelectedForPreview"] = $abb9e481ac8f38e8$export$a2795b51ce92008f;
module.exports["useStagingArea"] = $abb9e481ac8f38e8$export$916334da9df8d04;
module.exports["useStagingAreaActions"] = $abb9e481ac8f38e8$export$8f9a13b17bec42d5;
module.exports["useStagingAreaState"] = $abb9e481ac8f38e8$export$5a57f796673aabea;

});

parcelRegister("lpRYt", function(module, exports) {

var $2Yzoe = parcelRequire("2Yzoe");


var $csam1 = parcelRequire("csam1");


var $aRZzN = parcelRequire("aRZzN");


var $42JDa = parcelRequire("42JDa");


var $5SAOw = parcelRequire("5SAOw");


var $dh538 = parcelRequire("dh538");

const $eedc127a683be258$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ const $eedc127a683be258$var$citation = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $eedc127a683be258$var$CITATION_REGEX.test(childToken.content)) {
                /**
					 * Example content: `Hello [^1^][^1^].`
					 * `parts` will be ['Hello ', '1', '', '1', '.']
					 */ const parts = childToken.content.split($eedc127a683be258$var$CITATION_REGEX);
                const newChildren = [];
                /**
					 * we want to remove consecutive citation
					 * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
					 * should be transformed to `Hello 1. How are you 1 2`
					 */ let lastCitation = null;
                let isLastCitationDuplicate = false;
                // only want to add space in the next part after citation
                // if the last citation is valid
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        // this is a text part
                        /**
							 * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
							 * So it doesn't end up rendering empty space that will end up with multi empty spaces
							 * because previous valid citation already added 1 empty space
							 *
							 * Example: For `[^1^][^1^]`
							 * it will be split into parts: ['', '1', '', '1', ''],
							 * This code will skip any rendering for the last empty string (index=4)
							 * Because the empty string at index=2 already added 1 empty space from the code below
							 */ if (isLastCitationDuplicate && part.trim() === '') return;
                        if (part.trim() !== '') /**
								 * if the text part is not an empty string, we want to reset the last citation
								 * because the text part is a valid text, and not a space between citations
								 * so that we can render citation again, even if the next number is the same as the last number
								 *
								 * Example:
								 * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
								 */ lastCitation = null;
                        const textToken = new state.Token('text', '', 0);
                        if (index === parts.length - 1) textToken.content = part;
                        else textToken.content = part + ' ';
                        textToken.block = false;
                        textToken.level = childToken.level;
                        newChildren.push(textToken);
                    } else {
                        // this is a citation part
                        // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                        if (part === lastCitation) {
                            isLastCitationDuplicate = true;
                            return;
                        } else {
                            // always reset the duplicate flag
                            isLastCitationDuplicate = false;
                            lastCitation = part;
                        }
                        const citationToken = new state.Token('status', '', 0);
                        citationToken.content = '';
                        citationToken.block = false;
                        citationToken.level = childToken.level;
                        let citationText = part;
                        citationToken.attrs = [
                            [
                                'color',
                                'blue'
                            ],
                            [
                                'text',
                                citationText
                            ],
                            // localId is used to identify the citation token in the DOM
                            // this overrides the uuid that is normally used
                            [
                                'localId',
                                `citation-${citationText}`
                            ]
                        ];
                        citationToken.content = citationText;
                        newChildren.push(citationToken);
                    }
                });
                tokenChildren.push(...newChildren);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $eedc127a683be258$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('citation', $eedc127a683be258$var$citation);


const $85f34bd2edc9da4d$var$SCULPTOR_REGEX = /\[\^(sculptor)\^\]/;
const $85f34bd2edc9da4d$var$dataSculptor = (state)=>{
    const tokens = [];
    let sculptorCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $85f34bd2edc9da4d$var$SCULPTOR_REGEX.test(childToken.content)) {
                const citationToken = new state.Token('status', '', 0);
                citationToken.content = '';
                citationToken.block = false;
                citationToken.level = childToken.level;
                const parts = childToken.content.split($85f34bd2edc9da4d$var$SCULPTOR_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        citationToken.attrs = [
                            [
                                'localId',
                                'data-sculptor-' + sculptorCounter
                            ],
                            [
                                'text',
                                'data-sculptor-' + sculptorCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(citationToken);
                        sculptorCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $85f34bd2edc9da4d$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('data-sculptor', $85f34bd2edc9da4d$var$dataSculptor);


const $8d6eacbf9e066d7e$var$EXPAND_REGEX = /\[\^(expand)\^\]/;
const $8d6eacbf9e066d7e$var$expandable = (state)=>{
    const tokens = [];
    let expandCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children?.length === 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $8d6eacbf9e066d7e$var$EXPAND_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($8d6eacbf9e066d7e$var$EXPAND_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        const expandToken = new state.Token('status', '', 0);
                        expandToken.content = '';
                        expandToken.block = false;
                        expandToken.level = childToken.level;
                        expandToken.attrs = [
                            [
                                'localId',
                                'expandable-' + expandCounter
                            ],
                            [
                                'text',
                                'expandable-' + expandCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(expandToken);
                        expandCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
const $8d6eacbf9e066d7e$var$mdPluginExpandable = (md)=>{
    md.core.ruler.push('expandable', $8d6eacbf9e066d7e$var$expandable);
};
var $8d6eacbf9e066d7e$export$2e2bcd8739ae039 = $8d6eacbf9e066d7e$var$mdPluginExpandable;


const $cc4534e96af60336$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ const $cc4534e96af60336$var$groupedCitations = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $cc4534e96af60336$var$CITATION_REGEX.test(childToken.content)) {
                /**
					 * Example content: `Hello [^1^][^1^].`
					 * `parts` will be ['Hello ', '1', '', '1', '.']
					 */ const parts = childToken.content.split($cc4534e96af60336$var$CITATION_REGEX);
                const newChildren = [];
                /**
					 * we want to remove consecutive citation
					 * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
					 * should be transformed to `Hello 1. How are you 1 2`
					 */ let lastCitation = null;
                let isLastCitationDuplicate = false;
                let citationIndices = [];
                // only want to add space in the next part after citation
                // if the last citation is valid
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        // this is a text part
                        /**
							 * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
							 * So it doesn't end up rendering empty space that will end up with multi empty spaces
							 * because previous valid citation already added 1 empty space
							 *
							 * Example: For `[^1^][^1^]`
							 * it will be split into parts: ['', '1', '', '1', ''],
							 * This code will skip any rendering for the last empty string (index=4)
							 * Because the empty string at index=2 already added 1 empty space from the code below
							 */ if ((isLastCitationDuplicate || citationIndices.length > 0) && part.trim() === '') return;
                        if (part.trim() !== '') {
                            /**
								 * if the text part is not an empty string, we want to reset the last citation
								 * because the text part is a valid text, and not a space between citations
								 * so that we can render citation again, even if the next number is the same as the last number
								 *
								 * Example:
								 * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
								 */ lastCitation = null;
                            /**
								 * once we reach a text part, we need to capture the indices of the citations that have occurred up to this point
								 *
								 * Example
								 * `Hello [^1^][^2^] The example continues` -> parts = ['Hello ', '1', '', '2', 'The example continues']
								 * When 'The example continues' is reached, we need to create a status token for the citations prior
								 */ if (citationIndices.length > 0) {
                                const citationToken = new state.Token('status', '', 0);
                                citationToken.content = '';
                                citationToken.block = false;
                                citationToken.level = childToken.level;
                                // localId is used to identify the citation indices in the DOM
                                // this overrides the uuid that is normally used
                                // NOTE: ReactRenderer expects specific props for status nodes and
                                // therefore we cannot pass in custom attributes
                                citationToken.attrs = [
                                    [
                                        'color',
                                        'blue'
                                    ],
                                    [
                                        'text',
                                        'citation'
                                    ],
                                    // citationIndices is used to identify the citation token in the DOM
                                    // this overrides the uuid that is normally used
                                    [
                                        'localId',
                                        JSON.stringify(citationIndices)
                                    ]
                                ];
                                newChildren.push(citationToken);
                                citationIndices = [];
                            }
                        }
                        const textToken = new state.Token('text', '', 0);
                        // don't add trailing space if part already ends with one
                        textToken.content = index === parts.length - 1 ? part : part.endsWith(' ') ? part : part + ' ';
                        textToken.block = false;
                        textToken.level = childToken.level;
                        if (part !== '') newChildren.push(textToken);
                    } else {
                        // this is a citation part
                        // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                        if (part === lastCitation) {
                            isLastCitationDuplicate = true;
                            return;
                        } else {
                            // always reset the duplicate flag
                            isLastCitationDuplicate = false;
                            lastCitation = part;
                        }
                        citationIndices.push(parseInt(part));
                    }
                });
                /**
					 * Once we've reached the end of parts, we need to create a status token for any citations at the very end
					 *
					 * Example: `Hello [^1^][^2^]` -> parts = ['Hello ', '1', '', '2', '']
					 * When we've iterated through all of parts, 1 and 2 indices exist in citationIndices, and a status token needs to be created
					 */ if (citationIndices.length > 0) {
                    const citationToken = new state.Token('status', '', 0);
                    citationToken.content = '';
                    citationToken.block = false;
                    citationToken.level = childToken.level;
                    citationToken.attrs = [
                        [
                            'color',
                            'blue'
                        ],
                        [
                            'text',
                            'citation'
                        ],
                        [
                            'localId',
                            JSON.stringify(citationIndices)
                        ]
                    ];
                    newChildren.push(citationToken);
                    citationIndices = [];
                }
                tokenChildren.push(...newChildren);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $cc4534e96af60336$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('citation', $cc4534e96af60336$var$groupedCitations);



var $l8G7y = parcelRequire("l8G7y");

const $2e69c75627933db8$var$LUMINA_REGEX = /\[\^(lumina)\^\]/;
const $2e69c75627933db8$var$inlineLumina = (state)=>{
    const tokens = [];
    let luminaCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $2e69c75627933db8$var$LUMINA_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($2e69c75627933db8$var$LUMINA_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        const luminaToken = new state.Token('status', '', 0);
                        luminaToken.content = '';
                        luminaToken.block = false;
                        luminaToken.level = childToken.level;
                        luminaToken.attrs = [
                            [
                                'localId',
                                (0, $l8G7y.INLINE_LUMINA_STATUS_PREFIX) + luminaCounter
                            ],
                            [
                                'text',
                                (0, $l8G7y.INLINE_LUMINA_STATUS_PREFIX) + luminaCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(luminaToken);
                        luminaCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
function $2e69c75627933db8$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('inline-lumina', $2e69c75627933db8$var$inlineLumina);
}



var $2Gb84 = parcelRequire("2Gb84");


var $81OAa = parcelRequire("81OAa");

// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
const $146b6bae45423f24$var$arrayReplaceAt = (src, pos, newElements)=>[].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
const $146b6bae45423f24$var$isLinkOpen = (str)=>{
    return /^<a[>\s]/i.test(str);
};
const $146b6bae45423f24$var$isLinkClose = (str)=>{
    return /^<\/a\s*>/i.test(str);
};
const $146b6bae45423f24$export$8cd7d1ec2e6808da = ({ findFilepaths: findFilepaths, isLinkInMatches: isLinkInMatches })=>(state)=>{
        const blockTokens = state.tokens;
        const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($2Gb84)))();
        for(let j = 0, l = blockTokens.length; j < l; j++){
            if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
            let tokens = blockTokens[j].children ?? [];
            let htmlLinkLevel = 0;
            // We scan from the end, to keep position when new tags added.
            // Use reversed logic in links start/end match
            for(let i = tokens.length - 1; i >= 0; i--){
                const currentToken = tokens[i];
                // Skip content of markdown links
                if (currentToken.type === 'link_close') {
                    i--;
                    while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                    continue;
                }
                // Skip content of html tag links
                if (currentToken.type === 'html_inline') {
                    if ($146b6bae45423f24$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                    if ($146b6bae45423f24$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
                }
                if (htmlLinkLevel > 0) continue;
                if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                    const text = currentToken.content;
                    let links = (0, $81OAa.linkifyMatch)(text);
                    if (!links.length) links = linkify.match(text) || [];
                    // Now split string to nodes
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const nodes = [];
                    let level = currentToken.level;
                    let lastPos = 0;
                    const filepaths = findFilepaths(text);
                    for(let ln = 0; ln < links.length; ln++){
                        if (isLinkInMatches(links[ln].index, filepaths)) continue;
                        const { url: url } = links[ln];
                        const fullUrl = state.md.normalizeLink(url);
                        if (!state.md.validateLink(fullUrl)) continue;
                        let urlText = links[ln].text;
                        // Linkifier might send raw hostnames like "example.com", where url
                        // starts with domain name. So we prepend http:// in those cases,
                        // and remove it afterwards.
                        //
                        if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                        else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                        else urlText = state.md.normalizeLinkText(urlText);
                        const pos = links[ln].index;
                        if (pos > lastPos) {
                            const token = new state.Token('text', '', 0);
                            token.content = text.slice(lastPos, pos);
                            token.level = level;
                            nodes.push(token);
                        }
                        let token = new state.Token('link_open', 'a', 1);
                        token.attrs = [
                            [
                                'href',
                                fullUrl
                            ]
                        ];
                        token.level = level++;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        token = new state.Token('text', '', 0);
                        token.content = urlText;
                        token.level = level;
                        nodes.push(token);
                        token = new state.Token('link_close', 'a', -1);
                        token.level = --level;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        lastPos = links[ln].lastIndex;
                    }
                    if (lastPos < text.length) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos);
                        token.level = level;
                        nodes.push(token);
                    }
                    // replace current node
                    blockTokens[j].children = tokens = $146b6bae45423f24$var$arrayReplaceAt(tokens, i, nodes);
                }
            }
        }
    };


const $0c4919c13452ed71$export$763ac077c9998026 = (params)=>(md)=>md.core.ruler.push('custom-linkify', (0, $146b6bae45423f24$export$8cd7d1ec2e6808da)(params));


/**
 * This plugin handles blockquotes nested inside list items.
 * Since ADF doesn't support blockquotes as children of listItems,
 * we transform blockquote content into emphasized (italic) paragraphs.
 *
 * Before: 1. Item\n   > "Quote"
 * After:  1. Item\n   _"Quote"_
 *
 * This allows quotes within lists to render gracefully as italicized text
 * rather than failing due to ADF schema constraints.
 */ const $eebefa0fafefd79c$var$listBlockquoteFallback = (state)=>{
    const tokens = state.tokens;
    let listDepth = 0;
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // Track list nesting depth
        if (token.type === 'ordered_list_open' || token.type === 'bullet_list_open') listDepth++;
        else if (token.type === 'ordered_list_close' || token.type === 'bullet_list_close') listDepth--;
        // If we're inside a list and encounter a blockquote, transform it
        if (listDepth > 0 && token.type === 'blockquote_open') {
            // Find the matching blockquote_close
            let closeIndex = -1;
            let depth = 1;
            for(let j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'blockquote_open') depth++;
                else if (tokens[j].type === 'blockquote_close') {
                    depth--;
                    if (depth === 0) {
                        closeIndex = j;
                        break;
                    }
                }
            }
            if (closeIndex !== -1) {
                // Mark the blockquote tokens for removal
                token.type = 'blockquote_fallback_open';
                token.hidden = true;
                tokens[closeIndex].type = 'blockquote_fallback_close';
                tokens[closeIndex].hidden = true;
                // Process the content inside the blockquote
                // We need to wrap the inline content with emphasis marks
                for(let j = i + 1; j < closeIndex; j++){
                    const innerToken = tokens[j];
                    if (innerToken.type === 'inline' && innerToken.children) {
                        // Wrap all children with em marks
                        const emOpen = new state.Token('em_open', 'em', 1);
                        emOpen.block = false;
                        const emClose = new state.Token('em_close', 'em', -1);
                        emClose.block = false;
                        innerToken.children = [
                            emOpen,
                            ...innerToken.children,
                            emClose
                        ];
                    }
                }
            }
        }
    }
    // Filter out the hidden blockquote fallback tokens
    state.tokens = tokens.filter((t)=>t.type !== 'blockquote_fallback_open' && t.type !== 'blockquote_fallback_close');
};
const $eebefa0fafefd79c$var$mdPluginListBlockquoteFallback = (md)=>{
    md.core.ruler.push('list_blockquote_fallback', $eebefa0fafefd79c$var$listBlockquoteFallback);
};
var $eebefa0fafefd79c$export$2e2bcd8739ae039 = $eebefa0fafefd79c$var$mdPluginListBlockquoteFallback;


/**
Note: This implementation was built by referencing Editor AI
packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/md/media-md-plugin.ts

Aside from a refactor, the key differences in logic are:
- Our regex is more specific, and will only match images that are not inside single backticks otherwise we'll see AI Mate render images surrounded by single backticks
*/ function $536a5df99342df46$var$createRule() {
    // Match any images that aren't inside single backticks
    const mdImageRegex = RegExp("(?<!`)!\\[[^\\]]*\\]\\([^\\)]+\\)(?!`)", "g");
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open'
    ];
    return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        // Track the difference between original array indices and accumulated tokens indices
        // This is needed because when we skip processed tokens, the indices diverge
        let indexOffset = 0;
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && mdImageRegex.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                // Loop backwards through the tokens until a valid parent token is found
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                // If the previous token is not a valid parent token, add it to the start of the opening tokens array
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                // Create closing tokens for each opening token and reverse the array
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                const matches = token.content.match(mdImageRegex);
                // Process all images in the inline token
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substring(0, start);
                    inlineContentStack = inlineContentStack.substring(start + match.length);
                    // Add the inline tokens and media tokens to the subtree
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                // If there is any remaining content in the stack, add the inline tokens to the subtree
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                // Adjust cursor to account for previously skipped/modified tokens
                const adjustedCursor = cursor - indexOffset;
                tokens = [
                    ...tokens.slice(0, adjustedCursor),
                    ...subTree
                ];
                // Update offset: we consumed (i - cursor + 1) original tokens and added subTree.length
                indexOffset += i + 1 - cursor - subTree.length;
            } else if (processedTokens.indexOf(token.type) !== -1) {
                // Ignore token if it's already processed
                processedTokens.splice(processedTokens.indexOf(token.type), 1);
                // We skipped a token, so the offset increases
                indexOffset++;
            } else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
var $536a5df99342df46$export$2e2bcd8739ae039 = (md)=>{
    md.core.ruler.before('inline', 'media', $536a5df99342df46$var$createRule());
};


// Regex test is based on what's documented here:
// https://hello.atlassian.net/wiki/spaces/I/pages/1124693006/AAID+Format
const $ab169cc784e6afd4$var$isPeopleLink = (url)=>{
    return /^\/people\/[a-zA-Z0-9_\|\-\:]{1,128}$/g.test(url);
};
const $ab169cc784e6afd4$var$getAccountId = (url)=>{
    const match = url.match(/\/people\/([a-zA-Z0-9_\|\-\:]{1,128})/);
    return match ? match[1] : null;
};
const $ab169cc784e6afd4$var$mentionLinks = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        // We're only looking for inline children
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken, i)=>{
            const url = childToken.attrGet('href') ?? '';
            const discardedToken = [
                'link_close',
                'text'
            ].includes(childToken.type) && [
                tokenChildren[i - 1]?.type,
                tokenChildren[i - 2]?.type
            ].includes('mention');
            // Discarded tokens are preserved as `null` so index
            // cross-referencing between processed and raw tokens may
            // be preserved, however null are filtered out later.
            if (discardedToken) {
                tokenChildren.push(null);
                return;
            }
            if (childToken.type === 'link_open' && $ab169cc784e6afd4$var$isPeopleLink(url)) {
                const mentionText = token.children?.[i + 1]?.content ?? '';
                let mentionToken = new state.Token('mention', '', 0);
                mentionToken.content = '';
                mentionToken.block = false;
                mentionToken.level = childToken.level;
                mentionToken.attrSet('id', `${$ab169cc784e6afd4$var$getAccountId(url)}`);
                if (mentionText) mentionToken.attrSet('text', `@${mentionText}`);
                tokenChildren.push(mentionToken);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $ab169cc784e6afd4$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('mention', $ab169cc784e6afd4$var$mentionLinks);



var $gEMk1 = parcelRequire("gEMk1");

const $d5cccf701aceb868$var$linkPatternStart = '\\bhttps?:\\/\\/(?:www\\.)?';
const $d5cccf701aceb868$var$linkPatternEnd = '[^\\s\\]\\)]*';
const $d5cccf701aceb868$var$linkRegex = {
    youtube: `${$d5cccf701aceb868$var$linkPatternStart}youtube\\.com${$d5cccf701aceb868$var$linkPatternEnd}`,
    youtubeShortUrl: `${$d5cccf701aceb868$var$linkPatternStart}youtu\\.be${$d5cccf701aceb868$var$linkPatternEnd}`,
    loomVideo: `${$d5cccf701aceb868$var$linkPatternStart}loom\\.com\\/share\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    figmaFile: `${$d5cccf701aceb868$var$linkPatternStart}figma\\.com\\/(file|design)\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    confluenceWhiteboard: `${$d5cccf701aceb868$var$linkPatternStart}.*\\/wiki\\/spaces\\/.*\\/whiteboard\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    googlePresentationAndSpreadsheet: `${$d5cccf701aceb868$var$linkPatternStart}docs\\.google\\.com\\/(presentation|spreadsheets)\\/d\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    googleDoc: `${$d5cccf701aceb868$var$linkPatternStart}docs\\.google\\.com\\/(document)\\/d\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    googleForm: `${$d5cccf701aceb868$var$linkPatternStart}docs\\.google\\.com\\/forms\\/d\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    microsoftForm: `${$d5cccf701aceb868$var$linkPatternStart}forms\\.office\\.com\\/Pages\\/ResponsePage\\.aspx\\?id\\=${$d5cccf701aceb868$var$linkPatternEnd}`,
    analyticsChart: `\\bhttps://[^.]+\\.(atlassian\\.net|jira-dev\\.com)/analytics/[^/]+/chart-${$d5cccf701aceb868$var$linkPatternEnd}`
};
const $d5cccf701aceb868$var$newThirdPartyLinkRegex = {
    github: `${$d5cccf701aceb868$var$linkPatternStart}github\\.com${$d5cccf701aceb868$var$linkPatternEnd}`,
    canvaDesign: `${$d5cccf701aceb868$var$linkPatternStart}canva\\.com\\/design\\/[a-zA-Z0-9_\\-.]{1,255}\\/[a-zA-Z0-9_\\-.]{1,255}(?:\\/[^\\s\\]\\)]*)?`,
    canvaShortLink: `${$d5cccf701aceb868$var$linkPatternStart}canva\\.link\\/[a-zA-Z0-9]+(?:\\?${$d5cccf701aceb868$var$linkPatternEnd})?`,
    rovo: `${$d5cccf701aceb868$var$linkPatternStart}[^\\s\\]\\)]*\\.atlassian\\.net\\/rovo${$d5cccf701aceb868$var$linkPatternEnd}`,
    amplitude: `${$d5cccf701aceb868$var$linkPatternStart}app\\.amplitude\\.com${$d5cccf701aceb868$var$linkPatternEnd}`
};
const $d5cccf701aceb868$var$buildEmbedRegex = (includeNewThirdParties)=>{
    const patterns = [
        ...Object.values($d5cccf701aceb868$var$linkRegex),
        ...includeNewThirdParties ? Object.values($d5cccf701aceb868$var$newThirdPartyLinkRegex) : []
    ];
    return new RegExp(patterns.join('|'), 'g');
};
const $d5cccf701aceb868$var$embedInlineRegex = [
    // avpRovoSkillsChart
    `${$d5cccf701aceb868$var$linkPatternStart}avp-rovo-skills\\.[-\\w]+.frontend.public.atl-paas.net/v1/chart[^\\s\\)]+${$d5cccf701aceb868$var$linkPatternEnd}`
];
const $d5cccf701aceb868$var$avpChartsRegex = `${$d5cccf701aceb868$var$linkPatternStart}.*?\\/avpviz\\/c\\/[^\\/]+.*${$d5cccf701aceb868$var$linkPatternEnd}`;
/**
 * Checks if there is more than one link in the token stream.
 * Used to determine if all links should be rendered inline instead of as embeds.
 */ const $d5cccf701aceb868$var$hasMultipleLinks = (tokens)=>{
    let linkCount = 0;
    for (const token of tokens){
        if (token.type !== 'inline' || !token.children) continue;
        for (const childToken of token.children)if (childToken?.type === 'link_open') {
            linkCount++;
            if (linkCount > 1) return true; // Early exit once we find more than one
        }
    }
    return false;
};
const $d5cccf701aceb868$var$createSmartLinks = ({ regexStorage: regexStorage, isExperimentEnabled: isExperimentEnabled, shouldShowAsInline: shouldShowAsInline, xpcWrapUrl: xpcWrapUrl })=>(state)=>{
        const embedRegex = $d5cccf701aceb868$var$buildEmbedRegex(isExperimentEnabled?.('rovo_chat_smartlink_new_third_parties', false) ?? false);
        const tokens = [];
        const embedTokens = [];
        let embedMatches = [];
        let filteredTokens = [];
        const renderedInlineEmbeds = new Set();
        // If there are more than one link or the user opened the chat in mini modal, all links display inline
        const forceAllToInline = $d5cccf701aceb868$var$hasMultipleLinks(state.tokens) || shouldShowAsInline;
        // process each token to determine if the link should be converted to a smartlink
        for (const token of state.tokens){
            let processedTokenChildren = [];
            const regexMatchesRaw = token.content?.trim().match(embedRegex);
            const regexMatches = regexMatchesRaw ? Array.from(new Set(regexMatchesRaw)) : [];
            embedMatches = [
                ...embedMatches,
                ...regexMatches
            ];
            // Any block or embed Smart Card links will be in an "inline" token. If
            // the current token is anything other than "inline", or there's no child tokens
            // to process, then we add it to the list of tokens to keep and move forward
            if (token.type !== 'inline' || !token.children) {
                tokens.push(token);
                continue;
            }
            var outputToken = new state.Token('inline', '', 0);
            let tokensToAppend = [
                outputToken
            ];
            if (token.children) {
                let discardUntilIndex = -1;
                token.children.forEach((childToken, i)=>{
                    const discardedToken = i <= discardUntilIndex && [
                        'link_close',
                        'text'
                    ].includes(childToken.type);
                    if (discardedToken) return;
                    const url = childToken.attrGet('href') ?? '';
                    const isInlineLink = url === token.children?.[i + 1]?.content;
                    if (childToken?.type === 'link_open' && ((0, $gEMk1.isSupportedByLinkingPlatform)(url, regexStorage) || isInlineLink)) {
                        // Discard the next two tokens. We're now processing the opening node for a URL
                        // that will result in a new node that replaces it, therefore the subsequent link content and
                        // closing node are no longer needed
                        discardUntilIndex = i + 2;
                        // This link will be rendered as a smart link (embed or inline card) by the linking
                        // platform, so we only strip the `datasource` param without applying full XPC wrapping.
                        const smartLinkUrl = xpcWrapUrl ? xpcWrapUrl(url, true) : url;
                        // Check if this link should be rendered as an embed card inline (e.g., Loom, YouTube, Figma) at end of result
                        const matchesEmbedRegex = url.match(embedRegex);
                        if (matchesEmbedRegex && !embedMatches.includes(url)) embedMatches.push(url);
                        // handle condition for when link in the token content matches the linkRegex
                        const shouldRenderLinksAsEmbed = matchesEmbedRegex;
                        const shouldRenderAvpRovoSkillsEmbedInline = token.level <= 1 && $d5cccf701aceb868$var$embedInlineRegex.some((r)=>url.match(r));
                        const shouldRenderAvpChartsEmbedInline = token.level <= 1 && url.match($d5cccf701aceb868$var$avpChartsRegex);
                        const shouldRenderAvpEmbedInline = shouldRenderAvpRovoSkillsEmbedInline || shouldRenderAvpChartsEmbedInline;
                        // Render inline embed if either regex matches and token content is not part of a list
                        const shouldRenderEmbedInline = shouldRenderLinksAsEmbed && token.level <= 1;
                        if (shouldRenderAvpEmbedInline || shouldRenderLinksAsEmbed) {
                            // handle case if it is an analytic chart link or microsoft form link
                            // these should be rendered as inline cards, not embed cards
                            const isMicrosoftFormLink = new RegExp($d5cccf701aceb868$var$linkRegex.microsoftForm).test(url);
                            const isAnalyticsChartLink = new RegExp($d5cccf701aceb868$var$linkRegex.analyticsChart).test(url);
                            if (!forceAllToInline && shouldRenderEmbedInline && !isMicrosoftFormLink && !isAnalyticsChartLink || shouldRenderAvpEmbedInline) {
                                outputToken.children = processedTokenChildren;
                                tokensToAppend.push(new state.Token('paragraph_close', '', 0));
                                // Capture whether the URL was standalone on its own line
                                // (i.e. there was no preceding text in the same paragraph)
                                const isStandaloneUrl = processedTokenChildren.length === 0;
                                processedTokenChildren = [];
                                let embedToken = new state.Token('embedCard', '', 0);
                                embedToken.content = '';
                                embedToken.block = true;
                                embedToken.attrSet('url', smartLinkUrl);
                                embedToken.attrSet('layout', 'center');
                                // Mark whether this embed came from a standalone-line URL
                                if (isStandaloneUrl && isExperimentEnabled?.('rovo_chat_smartlink_new_third_parties', false)) embedToken.attrSet('isStandalone', 'true');
                                tokensToAppend.push(embedToken);
                                tokensToAppend.push(new state.Token('paragraph_open', '', 0));
                                outputToken = new state.Token('inline', '', 0);
                                tokensToAppend.push(outputToken);
                                // Track that we've rendered this URL as an inline embed
                                renderedInlineEmbeds.add(url);
                                return;
                            }
                        }
                        // create an inline card for the links that don't qualify
                        let cardToken = new state.Token('inlineCard', '', 0);
                        cardToken.content = '';
                        cardToken.block = false;
                        cardToken.level = childToken.level;
                        cardToken.attrSet('url', smartLinkUrl);
                        processedTokenChildren.push(cardToken);
                        return;
                    } else if (xpcWrapUrl && childToken?.type === 'link_open') // For plain links not supported by the linking platform, apply xpcWrapUrl (with full wrapping) to the href
                    childToken.attrSet('href', xpcWrapUrl(url, false));
                    // pushes non link tokens as is
                    processedTokenChildren.push(childToken);
                });
            }
            // set processed children to the output token
            outputToken.children = processedTokenChildren;
            // Keeps inline tokens that have children and all non-inline tokens.
            const blockTokensWithContent = tokensToAppend.filter((t)=>t.type !== 'inline' || t.children?.length);
            tokens.push(...blockTokensWithContent);
        }
        // Remove empty paragraphs otherwise add it to the filteredTokens
        for(let i = 0; i < tokens.length; i++)if (i < tokens.length - 1 && tokens[i].type === 'paragraph_open' && tokens[i + 1].type === 'paragraph_close') i = i + 1;
        else filteredTokens.push(tokens[i]);
        state.tokens = [
            ...filteredTokens,
            ...embedTokens
        ];
        return;
    };
const $d5cccf701aceb868$export$9625a798761643ac = (params, isExperimentEnabled, shouldShowAsInline, xpcWrapUrl)=>(md)=>md.core.ruler.push('inlineCard', $d5cccf701aceb868$var$createSmartLinks({
            ...params,
            isExperimentEnabled: isExperimentEnabled,
            shouldShowAsInline: shouldShowAsInline,
            xpcWrapUrl: xpcWrapUrl
        }));


const $9ff6b0f828ae5055$var$tableBreakTags = (state)=>{
    const tokens = state.tokens;
    // Find all table tokens
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // Check if we're inside a table
        if (token.type === 'table_open') {
            // Process all tokens until the matching table_close
            let j = i + 1;
            while(j < tokens.length && tokens[j].type !== 'table_close'){
                // If we're in a table cell content
                if (tokens && tokens[j]?.type === 'inline' && tokens[j]?.children && tokens[j]?.children?.length) {
                    // Process the content of the cell
                    const children = tokens[j]?.children;
                    if (!children) continue;
                    for(let k = 0; k < children.length; k++){
                        const child = children[k];
                        if (!child) continue;
                        // Replace <br>, <br/>, and <br /> tags with newlines
                        // Match different variations of <br> tags
                        const brRegex = /<br\s*\/?>/gi;
                        if (brRegex.test(child.content)) {
                            child.content = child.content.replace(brRegex, '\n');
                            // If the content is now just a newline, change the token type
                            if (child.content === '\n') child.type = 'hardbreak';
                        }
                    }
                }
                j++;
            }
            // Skip to the end of the table
            i = j;
        }
    }
    return;
};
var $9ff6b0f828ae5055$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('table-break-tags', $9ff6b0f828ae5055$var$tableBreakTags);


const $28815f35966a9eaf$var$CHART_REGEX = /\[\^(chart)\^\]/;
const $28815f35966a9eaf$var$visualizationChart = (state)=>{
    const tokens = [];
    let chartCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $28815f35966a9eaf$var$CHART_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($28815f35966a9eaf$var$CHART_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        // Create a new token for each chart match
                        const chartToken = new state.Token('status', '', 0);
                        chartToken.content = '';
                        chartToken.block = false;
                        chartToken.level = childToken.level;
                        chartToken.attrs = [
                            [
                                'localId',
                                'chart-' + chartCounter
                            ],
                            [
                                'text',
                                'loading chart-' + chartCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(chartToken);
                        chartCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
function $28815f35966a9eaf$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('chart', $28815f35966a9eaf$var$visualizationChart);
}





const $a1a032ec05100051$export$cd54a56af01ba875 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $a1a032ec05100051$export$eb83d753215c78a2 = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        attrs: (tok)=>({
                state: tok.meta
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    code_inline: {
        mark: 'code'
    },
    ordered_list: {
        block: 'orderedList',
        attrs: (tok)=>{
            const order = +(((0, $dh538.fg)('rovo_chat_fix_ordered_list_start_number') ? tok.attrGet('start') : tok.attrGet('order')) || 1);
            return {
                order: order
            };
        }
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        attrs: (tok)=>({
                language: tok.info?.trim() || null
            })
    },
    image: {
        node: 'image',
        attrs: (_tok)=>{
            return {};
        }
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                type: 'external'
            };
        }
    },
    // Enable ADF SmartLinks, produced by our SmartLink MD plugin
    inlineCard: {
        node: 'inlineCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    blockCard: {
        node: 'blockCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    embedCard: {
        node: 'embedCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    // Enable ADF Mentions, produced by our Mentions MD plugin which converts /people links
    mention: {
        node: 'mention',
        attrs: (tok)=>{
            return {
                id: tok.attrGet('id'),
                text: tok.attrGet('text'),
                type: 'mention'
            };
        }
    },
    status: {
        node: 'status',
        attrs: (token)=>({
                text: token.attrGet('text'),
                color: token.attrGet('color'),
                localId: token.attrGet('localId')
            })
    }
};


/**
 * Sanitizes raw markdown content before it reaches the markdown-it block tokenizer.
 *
 * Two constructs cause `ParserBlock.prototype.tokenize` to enter catastrophic
 * backtracking / exponential rule-matching, causing OOM browser crashes:
 *
 * ## 1. Tables indented 2+ spaces (inside a list item)
 *
 * The `markdown-it-table` plugin requires the table header row to start at
 * column 0 (or ≤1 space of indentation). When an AI response places a table
 * inside a list item — a common pattern — the table rows are indented with
 * 2+ spaces and are never recognized as a table block.
 *
 * Instead, each `|---` separator row triggers markdown-it's `lheading`
 * (setext heading) rule which checks whether the preceding paragraph can be
 * promoted to a heading. This check is O(n) against all prior paragraphs,
 * repeated for every `|` row in the table → O(n²) overall. For documents
 * with 200+ lines and multiple tables, this crashes the browser.
 *
 * ## 2. Code fences indented 4+ spaces (inside nested list items)
 *
 * markdown-it's `fence` block rule only recognizes fences with 0–3 spaces of
 * leading indentation. Fences indented with 4+ spaces (common inside nested
 * list items like "     ```jql") are treated as indented code continuation,
 * meaning the opening fence is never paired with its closing fence. The block
 * parser then tries every rule against the remaining content until EOF →
 * effectively infinite loop → OOM.
 *
 * ## Fix
 *
 * Strip excess leading whitespace from table rows and fence delimiters so
 * they are recognized by the parser as valid block-level constructs. A
 * fence-tracking state machine ensures that table rows and fence delimiters
 * *inside* a code fence are never modified.
 */ // Fast pre-check: matches a line starting with 2+ spaces followed by `|` or ` ``` `.
// Uses (^|\n) so it also catches indented constructs on the very first line.
// If the content has neither, skip the full line-by-line pass entirely.
const $603f9fbe0d7d63e0$var$NEEDS_SANITIZE_RE = /(?:^|\n) {2,}[|`]/;
function $603f9fbe0d7d63e0$export$20209a1e2cc01cc1(content) {
    if (!$603f9fbe0d7d63e0$var$NEEDS_SANITIZE_RE.test(content)) return content;
    const lines = content.split('\n');
    const result = [];
    let inFence = false;
    let fenceIndent = 0;
    for (const line of lines){
        const stripped = line.replace(/^\s+/, '');
        const indent = line.length - stripped.length;
        if (!inFence && stripped.startsWith('```')) {
            if (indent >= 4) {
                // Outdent deeply-indented opening fence to column 0 so the parser
                // recognizes it as a fenced code block
                result.push(stripped);
                inFence = true;
                fenceIndent = indent;
            } else {
                result.push(line);
                inFence = true;
                fenceIndent = indent;
            }
        } else if (inFence && stripped.startsWith('```')) {
            if (indent >= 4 && fenceIndent >= 4) // Outdent matching closing fence
            result.push(stripped);
            else result.push(line);
            inFence = false;
            fenceIndent = 0;
        } else if (!inFence && indent >= 2 && stripped.startsWith('|')) // Outdent table rows that are indented inside list items so
        // markdown-it-table recognizes them as a proper table block
        result.push(stripped);
        else result.push(line);
    }
    return result.join('\n');
}



const $8bba972fb5d34921$export$155749302793c60c = (schema, map)=>Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
const $8bba972fb5d34921$export$a1cf9d9b96e16789 = (md, schema)=>{
    for(const k in 0, $a1a032ec05100051$export$cd54a56af01ba875){
        const key = k;
        for(const i in (0, $a1a032ec05100051$export$cd54a56af01ba875)[key]){
            const idx = i;
            if (schema[key][idx]) md.enable((0, $a1a032ec05100051$export$cd54a56af01ba875)[key][idx]);
        }
    }
};


class $2d26328991932579$export$614853bf2169db97 extends (0, $aRZzN.MarkdownTransformer) {
    parse(content) {
        // Sanitize the raw markdown string before it reaches the markdown-it block
        // tokenizer (ParserBlock.tokenize). Indented tables and 4+ space-indented
        // fences can cause catastrophic backtracking / OOM; `sanitizeMarkdown`
        // outdents fences with 4+ spaces of indentation so the parser recognises
        // them as fenced code blocks rather than entering an infinite tokenization
        // loop.
        //
        // Note: md.core.ruler cannot be used here — core rules run AFTER block
        // tokenization, which is too late to prevent the crash. The sanitization
        // must happen on the raw string before parse() is called.
        const node = this.parser.parse((0, $603f9fbe0d7d63e0$export$20209a1e2cc01cc1)(content));
        if (!node) return new (0, $5SAOw.Node)();
        return node;
    }
    constructor(schema, pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, useGroupedCitations, xpcWrapUrl){
        super();
        this.parser = void 0;
        const md = (0, (/*@__PURE__*/$parcel$interopDefault($2Yzoe)))('zero', {
            html: false
        });
        md.enable([
            // Process html entity - &#123;, &#xAF;, &quot;, ...
            'entity',
            // Process escaped chars and hardbreaks
            'escape',
            'newline'
        ]);
        (0, $8bba972fb5d34921$export$a1cf9d9b96e16789)(md, schema);
        // Handle blockquotes inside list items - ADF doesn't support this nesting,
        // so we transform them into emphasized paragraphs
        md.use((0, $eebefa0fafefd79c$export$2e2bcd8739ae039));
        // enable modified version of linkify plugin
        // @see https://product-fabric.atlassian.net/browse/ED-3097
        md.use((0, $0c4919c13452ed71$export$763ac077c9998026)(pluginConfig.linkify));
        if (useGroupedCitations) md.use((0, $cc4534e96af60336$export$2e2bcd8739ae039));
        else md.use((0, $eedc127a683be258$export$2e2bcd8739ae039));
        if ((0, $dh538.fg)('rovo_enable_data_sculptor')) md.use((0, $85f34bd2edc9da4d$export$2e2bcd8739ae039));
        md.use((0, $8d6eacbf9e066d7e$export$2e2bcd8739ae039));
        md.use((0, $28815f35966a9eaf$export$2e2bcd8739ae039));
        if ((0, $dh538.fg)('rovo_chat_enable_inline_lumina')) md.use((0, $2e69c75627933db8$export$2e2bcd8739ae039));
        // Convert links with Linking Platform supported URLs to Smart Links
        if (!streaming && (schema.nodes.inlineCard || schema.nodes.blockCard || schema.nodes.embedCard)) // this is where we should separate it into its own plugin called createSmartLinksPluginRefresh
        md.use((0, $d5cccf701aceb868$export$9625a798761643ac)(pluginConfig.smartLinks, isExperimentEnabled, shouldShowAsInline, xpcWrapUrl));
        // Convert links matching people directory URLs to mentions
        if (schema.nodes.mention) md.use((0, $ab169cc784e6afd4$export$2e2bcd8739ae039));
        // Table support
        if (schema.nodes.table) {
            md.use((0, $csam1.markdownItTable));
            if ((0, $dh538.fg)('rovo_chat_enable_markdown_table_break_tags')) md.use((0, $9ff6b0f828ae5055$export$2e2bcd8739ae039));
        }
        // Image support
        if (schema.nodes.media && schema.nodes.mediaSingle) md.use((0, $536a5df99342df46$export$2e2bcd8739ae039));
        const filter = (0, $8bba972fb5d34921$export$155749302793c60c)(schema, (0, $a1a032ec05100051$export$eb83d753215c78a2));
        this.parser = new (0, $42JDa.MarkdownParser)(schema, md, filter);
    }
}
module.exports["AiMateMarkdownTransformer"] = $2d26328991932579$export$614853bf2169db97;

});

parcelRegister("l8G7y", function(module, exports) {
const $b441813f442be22d$export$8288860537fb7872 = 'inline-lumina-';
const $b441813f442be22d$export$5d9d37bd58628e00 = (localId)=>{
    return localId != null && localId.startsWith($b441813f442be22d$export$8288860537fb7872);
};
module.exports["INLINE_LUMINA_STATUS_PREFIX"] = $b441813f442be22d$export$8288860537fb7872;
module.exports["isInlineLuminaStatus"] = $b441813f442be22d$export$5d9d37bd58628e00;

});

parcelRegister("gEMk1", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

const $9088146284880a5b$export$57ad190cdc563df3 = `/gateway/api/object-resolver/providers`;
const $9088146284880a5b$export$1a30f994aeced995 = `/gateway/api/object-resolver/resolve/batch`;
const $9088146284880a5b$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $9088146284880a5b$export$b9858121ed269ff3 = 'aiMateSmartLinkProviderMapping';


const $bf5d74ffdabdc3d2$export$4b1056d02426889c = (url, regexStorage)=>{
    const cachedProviderRegex = $bf5d74ffdabdc3d2$export$90caa0c170ea581(regexStorage);
    if (!cachedProviderRegex.length || !url.length) return false;
    try {
        const regexPattern = new RegExp(cachedProviderRegex, 'g');
        return regexPattern.test(url);
    } catch  {
        // Malformed joined provider regex (e.g. duplicate named capture groups) — treat as unsupported.
        return false;
    }
};
const $bf5d74ffdabdc3d2$export$90caa0c170ea581 = (regexStorage)=>{
    if (regexStorage.getItem((0, $9088146284880a5b$export$56bec2f197c16818))) return JSON.parse(`${regexStorage.getItem((0, $9088146284880a5b$export$56bec2f197c16818))}`);
    return '';
};
const $bf5d74ffdabdc3d2$export$5af966b3aa3b1d83 = (regexStorage, providerRegex)=>{
    regexStorage?.setItem((0, $9088146284880a5b$export$56bec2f197c16818), JSON.stringify(providerRegex));
};
const $bf5d74ffdabdc3d2$export$d08c351b3b4e4934 = async (regexStorage, baseUrl)=>{
    const providerData = await $bf5d74ffdabdc3d2$export$dfebbb511ada4128(baseUrl);
    if (providerData) {
        const providerRegex = $bf5d74ffdabdc3d2$export$b7ac97ae80c7eb5a(providerData);
        $bf5d74ffdabdc3d2$export$5af966b3aa3b1d83(regexStorage, providerRegex);
        const providerMapping = $bf5d74ffdabdc3d2$export$8eafd18d19de7df5(providerData);
        $bf5d74ffdabdc3d2$export$b22dfe84603542b1(regexStorage, providerMapping);
    }
};
const $bf5d74ffdabdc3d2$export$b7ac97ae80c7eb5a = (data)=>{
    if (!data?.providers || !Array.isArray(data.providers)) return '';
    const sources = data.providers.reduce((acc, provider)=>{
        const providerSources = provider.patterns?.map((pattern)=>pattern.source) || [];
        return [
            ...acc,
            ...providerSources
        ];
    }, []);
    return sources.join('|');
};
const $bf5d74ffdabdc3d2$export$8eafd18d19de7df5 = (data)=>{
    if (!data?.providers || !Array.isArray(data.providers)) return {
        combinedRegex: '',
        patterns: []
    };
    const patterns = data.providers.flatMap((provider)=>(provider.patterns || []).map((pattern)=>({
                key: provider.key,
                regex: pattern.source
            })));
    const combinedRegex = patterns.map((p)=>p.regex).join('|');
    return {
        combinedRegex: combinedRegex,
        patterns: patterns
    };
};
const $bf5d74ffdabdc3d2$export$25b8a9cebf834f6e = (regexStorage)=>{
    const stored = regexStorage.getItem((0, $9088146284880a5b$export$b9858121ed269ff3));
    if (stored) try {
        return JSON.parse(stored);
    } catch  {
        return null;
    }
    return null;
};
const $bf5d74ffdabdc3d2$export$b22dfe84603542b1 = (regexStorage, providerMapping)=>{
    regexStorage?.setItem((0, $9088146284880a5b$export$b9858121ed269ff3), JSON.stringify(providerMapping));
};
const $bf5d74ffdabdc3d2$export$dfebbb511ada4128 = (0, $2XqLN.default)(async (baseUrl = '')=>{
    try {
        const response = await fetch(baseUrl + (0, $9088146284880a5b$export$57ad190cdc563df3), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                type: 'resolve'
            })
        });
        const data = await response.json();
        return data || null;
    } catch  {
        return null;
    }
});
const $bf5d74ffdabdc3d2$export$ab8eaff0f2d596bd = (0, $2XqLN.default)(async (baseUrl = '')=>{
    const data = await $bf5d74ffdabdc3d2$export$dfebbb511ada4128(baseUrl);
    return data ? $bf5d74ffdabdc3d2$export$b7ac97ae80c7eb5a(data) : '';
});
module.exports["isSupportedByLinkingPlatform"] = $bf5d74ffdabdc3d2$export$4b1056d02426889c;
module.exports["hydrateLinkingPlatformCache"] = $bf5d74ffdabdc3d2$export$d08c351b3b4e4934;

});

parcelRegister("6FQwA", function(module, exports) {
const $0075612de7c1f282$export$5a550907ffbc9119 = 'rovoChat';
const $0075612de7c1f282$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen',
    'insertPrompt',
    'promptLibraryOpen',
    'openChatMode'
];


const $fba4647064c9da0b$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $fba4647064c9da0b$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $fba4647064c9da0b$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $fba4647064c9da0b$export$9748efee331ec573 = (param)=>`${0, $0075612de7c1f282$export$5a550907ffbc9119}${$fba4647064c9da0b$export$fda91e425d265029(param)}`;
const $fba4647064c9da0b$export$f2888183a34644d4 = (param)=>{
    return $fba4647064c9da0b$export$858653b7ee3cbb17(param.replace((0, $0075612de7c1f282$export$5a550907ffbc9119), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $fba4647064c9da0b$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $fba4647064c9da0b$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $0075612de7c1f282$export$5a550907ffbc9119))) return;
        const paramKey = $fba4647064c9da0b$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $fba4647064c9da0b$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $fba4647064c9da0b$var$processParams(q).rovoParams;
    } catch  {
        return {};
    }
};
const $fba4647064c9da0b$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $fba4647064c9da0b$export$ef04687636c850fe(window.location.pathname, params));
};
const $fba4647064c9da0b$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $fba4647064c9da0b$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $fba4647064c9da0b$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $fba4647064c9da0b$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$fba4647064c9da0b$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).filter(([_, value])=>value !== undefined).map(([key, value])=>{
        return `${$fba4647064c9da0b$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $fba4647064c9da0b$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $fba4647064c9da0b$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
	For products using react-resource-router (e.g Atlas) to
	pass as the value of `query` on the route definition. It ensures that our parameters
	are not stripped from the URL when loading the page, or through redirect hops
	Any new parameters we want to maintain should be added here as well, which means
	only a version bump is needed in those products to support the latest param list
	The !=false simply means that the parameter is supported but is optional, and should
	not contain a value of 'false'
	*/ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $0075612de7c1f282$export$3cd6b610e7ede579).map((param)=>`${$fba4647064c9da0b$export$9748efee331ec573(param)}${suffix}`);
};
module.exports["getRovoParams"] = $fba4647064c9da0b$export$6405071f390601f7;
module.exports["updatePageRovoParams"] = $fba4647064c9da0b$export$4a302fc7d977f7b3;
module.exports["addRovoParamsToUrl"] = $fba4647064c9da0b$export$ef04687636c850fe;
module.exports["encodeRovoParams"] = $fba4647064c9da0b$export$eddc20a009406015;

});

parcelRegister("6eZqW", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8m4tT = parcelRequire("8m4tT");


var $8nxxM = parcelRequire("8nxxM");


var $42JDa = parcelRequire("42JDa");


var $5SAOw = parcelRequire("5SAOw");

const $92afea9a8f6a2cee$export$5be26e657c035da4 = (node, featureToggles, overrideDefaults = {})=>{
    if (!featureToggles.allowAttributesMatchDefault) return true;
    // @ts-expect-error - node.type.attrs does not exist in nodeType type, but it does exist.
    const nodeTypeAttrs = node.type.attrs;
    if (!nodeTypeAttrs || Object.keys(nodeTypeAttrs).length === 0 && Object.keys(node.attrs).length === 0) return true;
    const defaultAttrs = {};
    Object.keys(nodeTypeAttrs).forEach((key)=>{
        defaultAttrs[key] = nodeTypeAttrs[key].default;
    });
    // The actual node defaults don't match the node defaults when interacting with a page
    // So we override for a correct comparison
    Object.keys(overrideDefaults).forEach((key)=>{
        defaultAttrs[key] = overrideDefaults[key];
    });
    // Compare the node attributes to the default attributes
    for(const key in node.attrs){
        if (node.attrs[key] !== defaultAttrs[key]) return false;
    }
    return true;
};


const $deb7030063275628$var$isHeaderRow = (row)=>row.child(0).type.name === 'tableHeader';
const $deb7030063275628$var$isFirstRow = (row, parent)=>parent.content.child(0) === row;
const $deb7030063275628$var$isHeaderRowPresent = (table)=>{
    let headerRowPresent = false;
    table.content.forEach((row)=>{
        if ($deb7030063275628$var$isHeaderRow(row)) headerRowPresent = true;
    });
    return headerRowPresent;
};
const $deb7030063275628$var$renderNode = (state, node, index)=>{
    if (index > 0) state.write(' ');
    node.content.forEach((child, i)=>{
        if (child.isTextblock || child.type.name === 'mediaSingle') {
            if (i > 0) state.write(' ');
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            state.context.insideTable = true;
            state.renderInline(child);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            state.context.insideTable = false;
        } else $deb7030063275628$var$renderNode(state, child, i);
    });
};
const $deb7030063275628$var$renderInlineContent = ({ state: state, node: node })=>{
    state.write('| ');
    $deb7030063275628$var$renderNode(state, node, 0);
    state.write(' ');
};
const $deb7030063275628$var$tableNodes = {
    table: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="table_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>state.render(child, node, i));
                state.write(`<custom data-type="table_close" />\n\n`);
            } else {
                if (!(0, $92afea9a8f6a2cee$export$5be26e657c035da4)(node, state.featureToggles, {
                    layout: node.attrs.layout,
                    localId: node.attrs.localId,
                    width: 760
                })) state.updateNonErrorFallbackState(node);
                const headerRowPresent = $deb7030063275628$var$isHeaderRowPresent(node);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            headerRowPresent: headerRowPresent,
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.closeBlock(node);
            }
        },
        support: 'partial'
    },
    tableRow: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="tr_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="tr_close" />\n\n`);
            } else {
                if (!(0, $92afea9a8f6a2cee$export$5be26e657c035da4)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            ...options,
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write('|');
                state.ensureNewLine();
                if ($deb7030063275628$var$isHeaderRow(node) || $deb7030063275628$var$isFirstRow(node, parent)) {
                    for(let i = 0; i < node.childCount; i++)state.write('| --- ');
                    state.write('|');
                    state.ensureNewLine();
                }
            }
        },
        support: 'partial'
    },
    tableHeader: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="th_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="th_close" />\n\n`);
            } else {
                if (!(0, $92afea9a8f6a2cee$export$5be26e657c035da4)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                $deb7030063275628$var$renderInlineContent({
                    state: state,
                    node: node,
                    parent: parent,
                    index: index,
                    options: options
                });
            }
        },
        support: 'partial'
    },
    tableCell: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="td_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="td_close" />\n\n`);
            } else {
                if (!(0, $92afea9a8f6a2cee$export$5be26e657c035da4)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                $deb7030063275628$var$renderInlineContent({
                    state: state,
                    node: node,
                    parent: parent,
                    index: index,
                    options: options
                });
            }
        },
        support: 'partial'
    }
};
var $deb7030063275628$export$2e2bcd8739ae039 = $deb7030063275628$var$tableNodes;



var $bd943 = parcelRequire("bd943");




const $6ff1f24202635c31$export$8ef94ae42a3729bd = 1;
const $6ff1f24202635c31$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $6ff1f24202635c31$export$4ea3c6bbdf8f7944 = (maybeOrderedListNode)=>{
    if (!(maybeOrderedListNode instanceof (0, $5SAOw.Node))) return $6ff1f24202635c31$export$8ef94ae42a3729bd;
    const order = maybeOrderedListNode?.attrs?.order;
    return $6ff1f24202635c31$export$d445360e2a3c026b(order) ?? $6ff1f24202635c31$export$8ef94ae42a3729bd;
};


/**
 * A replacement for `String.repeat` until it becomes widely available.
 */ function $74c7a8487430b8e3$export$345d822805ab3239(text, length) {
    let result = '';
    for(let x = 0; x < length; x++)result += text;
    return result;
}
function $74c7a8487430b8e3$export$560888d6fe0cfe97(str, startOfLine, insideTable) {
    let strToEscape = str || '';
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    strToEscape = strToEscape.replace(/[`*\\~\[\]_]/g, (m, i)=>// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        m === '_' && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : '\\' + m);
    if (startOfLine) strToEscape = strToEscape// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/^(\+[ ]|[\-*>])/, '\\$&')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/^(\s*\d+)\.\s/, '$1\\. ');
    if (insideTable) // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    strToEscape = strToEscape.replace(/[|]/g, '\\$&');
    return strToEscape;
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $74c7a8487430b8e3$var$SPECIAL_CHARACTERS = /\u200c|↵/g;
function $74c7a8487430b8e3$var$removeSpecialCharacters(node) {
    if (node.nodeType === 3 && node.textContent) node.textContent = node.textContent.replace($74c7a8487430b8e3$var$SPECIAL_CHARACTERS, '');
    Array.from(node.childNodes).forEach((child)=>$74c7a8487430b8e3$var$removeSpecialCharacters(child));
}
function $74c7a8487430b8e3$export$9c95763b5a419f4c(html, options) {
    const el = document.createElement('div');
    el.innerHTML = html;
    // Remove zero-width-non-joiner
    Array.from(el.querySelectorAll('p')).forEach((p)=>{
        $74c7a8487430b8e3$var$removeSpecialCharacters(p);
    });
    // Convert mention containers, i.e.:
    //   <a href="/abodera/" rel="nofollow" title="@abodera" class="mention mention-me">Artur Bodera</a>
    Array.from(el.querySelectorAll('a.mention, a.ap-mention')).forEach((a)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = a.getAttribute('data-atlassian-id') || '';
        if (atlassianId) // Atlassian ID is wrapped in curlies so that it get serialized as @{aid-id} instead of @aid-id
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        else {
            const title = a.getAttribute('title') || '';
            if (title) {
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                const usernameMatch = title.match(/^@(.*?)$/);
                if (usernameMatch) {
                    const username = usernameMatch[1];
                    span.setAttribute('data-mention-id', username);
                }
            }
        }
        const text = a.textContent || '';
        if (text.indexOf('@') === 0) span.textContent = a.textContent;
        else span.textContent = `@${a.textContent}`;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.insertBefore(span, a);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.removeChild(a);
    });
    // Convert mention containers, i.e.:
    //   <span class="ap-mention" data-atlassian-id="5c09bf77ec71bd223bbe866f">@Scott Demo</span>
    Array.from(el.querySelectorAll('span.ap-mention')).forEach((s)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = s.getAttribute('data-atlassian-id') || '';
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        const text = s.textContent || '';
        span.textContent = text.indexOf('@') === 0 ? text : `@${text}`;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        s.parentNode.insertBefore(span, s);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        s.parentNode.removeChild(s);
    });
    // Parse emojis i.e.
    //     <img src="https://d301sr5gafysq2.cloudfront.net/207268dc597d/emoji/img/diamond_shape_with_a_dot_inside.svg" alt="diamond shape with a dot inside" title="diamond shape with a dot inside" class="emoji">
    Array.from(el.querySelectorAll('img.emoji')).forEach((img)=>{
        const span = document.createElement('span');
        let shortName = img.getAttribute('data-emoji-short-name') || '';
        if (!shortName) {
            // Fallback to parsing Bitbucket's src attributes to find the
            // short name
            const src = img.getAttribute('src');
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            const idMatch = !src ? false : src.match(/([^\/]+)\.[^\/]+$/);
            if (idMatch) shortName = `:${decodeURIComponent(idMatch[1])}:`;
        }
        if (shortName) span.setAttribute('data-emoji-short-name', shortName);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.insertBefore(span, img);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.removeChild(img);
    });
    if (!options.disableBitbucketLinkStripping) // Convert all automatic links to plain text, because they will be re-created on render by the server
    Array.from(el.querySelectorAll('a'))// Don't convert external links (i.e. not automatic links)
    .filter((a)=>a.getAttribute('data-is-external-link') !== 'true' && a.getAttribute('data-inline-card') === null).forEach((a)=>{
        Array.from(a.childNodes).forEach((child)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            a.parentNode.insertBefore(child, a);
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.removeChild(a);
    });
    // Parse images
    // Not using :pseudo because of IE11 bug:
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/16104908/
    Array.from(el.querySelectorAll('img')).filter((img)=>!img.classList.contains('emoji')).forEach((img)=>{
        const { parentNode: parentNode } = img;
        if (!parentNode) return;
        /**
     * Lift image node if parent isn't the root-element
     */ if (parentNode !== el) {
            const isValidPath = validateImageNodeParent(parentNode);
            if (!isValidPath) liftImageNode(parentNode, img);
        }
        /**
     * Replace image with media node
     */ const mediaSingle = document.createElement('div');
        mediaSingle.setAttribute('data-node-type', 'mediaSingle');
        const media = document.createElement('div');
        media.setAttribute('data-node-type', 'media');
        media.setAttribute('data-type', 'external');
        media.setAttribute('data-alt', img.getAttribute('alt') || '');
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        media.setAttribute('data-url', img.getAttribute('src'));
        mediaSingle.appendChild(media);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.insertBefore(mediaSingle, img);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.removeChild(img);
    });
    function validateImageNodeParent(node) {
        const ALLOWED_PARENTS = [
            'LI',
            'UL',
            'OL',
            'TD',
            'TH',
            'TR',
            'TBODY',
            'THEAD',
            'TABLE'
        ];
        if (node === el) return true;
        if (ALLOWED_PARENTS.indexOf(node.nodeName) === -1) return false;
        if (!node.parentNode) return false;
        return validateImageNodeParent(node.parentNode);
    }
    function liftImageNode(node, img) {
        let foundParent = false;
        let parent = node;
        while(!foundParent){
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            foundParent = validateImageNodeParent(parent.parentNode);
            if (!foundParent) // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            parent = parent.parentNode;
        }
        const cloned = parent.cloneNode();
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const target = parent !== el ? parent.parentNode : el;
        while(img.nextSibling)cloned.appendChild(img.nextSibling);
        if (node !== parent) while(node.nextSibling)cloned.appendChild(node.nextSibling);
        if (parent.nextSibling) {
            target.insertBefore(cloned, parent.nextSibling);
            target.insertBefore(img, cloned);
        } else {
            target.appendChild(img);
            target.appendChild(cloned);
        }
        /**
     * If the splitting operation results in
     * the old parent being empty, remove it
     */ if (node.childNodes.length === 0) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        node.parentNode.removeChild(node);
        /**
     * Remove cloned element if it's empty.
     */ if (cloned.childNodes.length === 0) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        cloned.parentNode.removeChild(cloned);
    }
    return el;
}


const $e985dce6263f3bba$export$1c401dbe379e8c65 = (()=>{
    function getMaxLength(text) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const matches = text.match(/`+/g) || [];
        return matches.reduce((prev, val)=>val.length > prev.length ? val : prev, '').length;
    }
    return function(text, minLength = 1) {
        const length = Math.max(minLength, getMaxLength(text) + 1);
        return (0, $74c7a8487430b8e3$export$345d822805ab3239)('`', length);
    };
})();
class $e985dce6263f3bba$export$61055fa707e69319 extends (0, $42JDa.MarkdownSerializerState) {
    /**
   *
   * @param state: MarkdownSerializerState
   * @param targetType: string
   * @param targetAttributes: Record<string, unknown>
   * @returns id of the state if the state is found in the idMap, otherwise returns null
   */ findStateIdMap(state, targetType, targetAttributes) {
        // eslint-disable-next-line guard-for-in
        for(const key in state.idMap){
            const { type: type, attributes: attributes } = state.idMap[key];
            // Check type first for early exit
            if (type !== targetType) continue;
            // Check if attributes match
            let attributesMatch = true;
            for(const attrKey in targetAttributes)// localId is a special attribute that is used to identify the node in the markdown and should be ignored on match
            if (attrKey !== 'localId' && targetAttributes[attrKey] !== attributes[attrKey]) {
                attributesMatch = false;
                break; // No need to check other attributes
            }
            if (attributesMatch) return key;
        }
        return null;
    }
    /**
   *
   * @param state: MarkdownSerializerState
   * @param type: string
   * @param attributes: Record<string, unknown>
   * @returns `id-[id]idMap` if the id is not found in the state
   */ getIdBasedOnIdMap(state, type, attributes) {
        const id = state.findStateIdMap(state, type, attributes);
        if (id) return id;
        return `id-${state.idCounter++}`;
    }
    updateFallbackState(error, child) {
        if (error instanceof Error) {
            const childTypeName = child.type.name;
            const errorMessage = error.message;
            const childFallbackState = this.fallbackState?.[childTypeName];
            Object.assign(this.fallbackState, {
                [childTypeName]: {
                    ...childFallbackState,
                    [errorMessage]: (childFallbackState?.[errorMessage] || 0) + 1
                }
            });
        } else throw error;
    }
    updateNonErrorFallbackState(node) {
        Object.assign(this.nonErrorFallbackState, {
            [node.type.name]: (this.nonErrorFallbackState[node.type.name] || 0) + 1
        });
    }
    /**
   * Defines the internal atBlank method used in the markdown serializer
   * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L241
   */ atBlank() {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return /(^|\n)$/.test(this.out);
    }
    /**
   * Defines the internal flushClose method used in the markdown serializer
   * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L202
   */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += '\n';
            if (size > 1) {
                let delimMin = this.delim;
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                const trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + '\n';
            }
            this.closed = null;
        }
    }
    /**
   * This method overide adds support for "options"
   * options is an object that can be used to pass additional information to the node serializer
   *
   * This is useful when a grandparent node has information that needs to be passed to a grandchild node
   *
   * For example, a table node has information about whether or not the table has a header row
   * This information needs to be passed to the tableRow and tableCell node serializers so that it can render the correct markdown
   * @see MarkdownSerializerState.render()
   */ render(node, parent, index, options) {
        if (!this.nodes[node.type.name]) throw new Error(`Token type \`${node.type.name}\` not supported by Markdown renderer`);
        if (options?.skipFallback) this.nodes[node.type.name].serialize({
            state: this,
            node: node,
            parent: parent,
            index: index,
            options: options
        });
        else try {
            this.nodes[node.type.name].serialize({
                state: this,
                node: node,
                parent: parent,
                index: index,
                options: options
            });
        } catch (error) {
            this.updateFallbackState(error, node);
            return this.nodes.fallback.serialize({
                state: this,
                node: node,
                parent: parent,
                index: index
            });
        }
    }
    renderContent(parent) {
        parent.forEach((child, _offset, index)=>{
            if (// If child is an empty Textblock we need to insert a zwnj-character in order to preserve that line in markdown
            child.isTextblock && !child.textContent && // If child is a Codeblock we need to handle this separately as we want to preserve empty code blocks
            !(child.type.name === 'codeBlock') && !(child.content && child.content.size > 0)) return this.nodes.empty_line.serialize({
                state: this,
                node: child,
                parent: parent,
                index: index
            });
            try {
                return this.render(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
                return this.nodes.fallback.serialize({
                    state: this,
                    node: child,
                    parent: parent,
                    index: index
                });
            }
        });
    }
    /**
   * This method override will properly escape backticks in text nodes with "code" mark enabled.
   * Bitbucket uses python-markdown which does not honor escaped backtick escape sequences \`
   * inside a backtick fence.
   *
   * @see MarkdownSerializerState.renderInline()
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderInline(parent, options) {
        const active = [];
        let trailing = '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const progress = (node, _, index)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let marks = node ? node.marks.filter((mark)=>this.marks[mark.type.name]) : [];
            let leading = trailing;
            trailing = '';
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const info = this.marks[mark.type.name];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return info && info.expelEnclosingWhitespace;
            })) {
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp, @typescript-eslint/no-non-null-assertion
                const [, lead, inner, trail] = /^(\s*)(.*?)(\s*)$/m.exec(node.text);
                leading += lead;
                trailing = trail;
                if (lead || trail) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    node = inner ? node.withText(inner) : null;
                    if (!node) marks = active;
                }
            }
            const code = marks.length && marks[marks.length - 1].type.name === 'code' && marks[marks.length - 1];
            const len = marks.length - (code ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            // eslint-disable-next-line no-labels
            outer: for(let i = 0; i < len; i++){
                const mark = marks[i];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (!this.marks[mark.type.name].mixable) break;
                for(let j = 0; j < active.length; j++){
                    const other = active[j];
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (!this.marks[other.type.name].mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            while(active.length < len){
                const add = marks[active.length];
                active.push(add);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.text(this.markString(add, true, parent, index), false);
            }
            if (node) {
                if (!code || !node.isText) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.render(node, parent, index);
                else if (node.text) {
                    // Generate valid monospace, fenced with series of backticks longer that backtick series inside it.
                    let text = node.text;
                    const backticks = $e985dce6263f3bba$export$1c401dbe379e8c65(node.text, 1);
                    // Make sure there is a space between fences, otherwise python-markdown renderer will get confused
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    if (text.match(/^`/)) text = ' ' + text;
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    if (text.match(/`$/)) text += ' ';
                    this.text(backticks + text + backticks, false);
                }
            }
        };
        parent.forEach((child, _offset, index)=>{
            if (options?.skipFallback) progress(child, parent, index);
            else try {
                progress(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
            }
        });
        progress(null);
    }
    addBlockMarks(state, node, renderFunction) {
        const closingTags = [];
        // This is temporary, only adding the marks that we support, once we get full support this will be removed
        const markFilters = [
            'alignment',
            'breakout',
            'border'
        ];
        const marks = node.marks.filter((mark)=>markFilters.includes(mark.type.name));
        if (marks.length === 0) {
            renderFunction();
            return;
        }
        marks.forEach((mark)=>{
            const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, mark.type.name, mark.attrs) : `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: mark.type.name,
                attributes: mark.attrs
            };
            state.write(`<custom data-type="${mark.type.name}_open" data-id="${id}" />\n\n`);
            closingTags.unshift(`<custom data-type="${mark.type.name}_close" />\n\n`);
        });
        renderFunction();
        state.write(closingTags.join(''));
    }
    constructor(featureToggles, mentionMap, idMap){
        // @ts-ignore -next-line
        super($e985dce6263f3bba$export$695720b7e7a61533, $e985dce6263f3bba$export$3a8025f2f3e0c64, {});
        // ignoring as generated types for node serializer is inaccurate
        // parent and index in node serializers should be optional
        // Typing this as a string -- to override the PMMarkdownSerializerState type of any
        // In the confluence build -- this results in the out property being set to undefined in the constructor
        // whereas in the dev server this is stripped when the code is transpiled.
        // When it is used in transpilation -- "undefined" is added to the start of the generated text
        // out: string;
        this.idMap = {};
        this.idCounter = 0;
        this.nodes = void 0;
        this.marks = void 0;
        this.featureToggles = {};
        this.mentionMap = {};
        /**
     * Defines the internal variables used in the markdown serializer
     * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L172
     */ this.delim = '';
        this.out = '';
        this.closed = null;
        /**
     * This is used to track the number of times a node has failed to render
     * This is useful for debugging purposes
     * - the key is the node type name
     * - the value is an object with
     *   - the error message as the key
     *   - and the number of times it has failed to render with that message as the value.
     */ this.fallbackState = {};
        /**
     * This is used to track the number of times a node has rendered
     * but has not completely converted to markdown
     * For example: Tables are supported in markdown, however we currently do not have full support
     * So we fallback to the simplest version of the node that our serializer can support
     */ this.nonErrorFallbackState = {};
        this.context = {
            insideTable: false
        };
        this.nodes = $e985dce6263f3bba$export$695720b7e7a61533;
        this.marks = $e985dce6263f3bba$export$3a8025f2f3e0c64;
        this.featureToggles = featureToggles || {};
        this.mentionMap = mentionMap || {};
        this.idMap = idMap || {};
        this.idCounter = Object.keys(this.idMap).length;
    }
}
const $e985dce6263f3bba$var$editorNodes = {
    blockquote: {
        serialize ({ state: state, node: node }) {
            state.wrapBlock('> ', null, node, ()=>state.renderContent(node));
        },
        support: 'full'
    },
    codeBlock: {
        serialize ({ state: state, node: node }) {
            const backticks = $e985dce6263f3bba$export$1c401dbe379e8c65(node.textContent, 3);
            state.write(backticks + (node.attrs.language || '') + '\n');
            state.text(node.textContent ? node.textContent : '\u200c', false);
            state.ensureNewLine();
            state.write(backticks);
            state.closeBlock(node);
        },
        support: 'full'
    },
    heading: {
        serialize ({ state: state, node: node }) {
            state.write(state.repeat('#', node.attrs.level) + ' ');
            state.renderInline(node);
            state.closeBlock(node);
        },
        support: 'full'
    },
    rule: {
        serialize ({ state: state, node: node }) {
            state.write(node.attrs.markup || '---');
            state.closeBlock(node);
        },
        support: 'full'
    },
    bulletList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'full'
    },
    orderedList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'full'
    },
    listItem: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const order = (0, $6ff1f24202635c31$export$4ea3c6bbdf8f7944)(parent);
            const delimiter = parent.type.name === 'bulletList' ? '* ' : `${order + index}. `;
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                // if at second child or more of list item, add a newline
                if (i > 0) state.write('\n');
                // if at first child of list item, add delimiter (e.g "1.").
                // if at second child or more of list item, only add spacing (not delimiter)
                if (i === 0) state.wrapBlock('  ', delimiter, node, ()=>state.render(child, parent, i));
                else state.wrapBlock('    ', null, node, ()=>state.render(child, parent, i));
                if (child.type.name === 'paragraph' && i > 0) state.write('\n');
                state.flushClose(1);
            }
            // if we're at the final list item, add a final closing newline
            if (index === parent.childCount - 1) state.write('\n');
        },
        support: 'full'
    },
    taskList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
                state.write('\n');
            }
            state.write('\n');
        },
        support: 'full'
    },
    taskItem: {
        serialize ({ state: state, node: node }) {
            const taskItemState = node.attrs.state;
            state.write(taskItemState === 'TODO' ? '- [ ] ' : '- [x] ');
            state.renderInline(node);
        },
        support: 'full'
    },
    paragraph: {
        serialize ({ state: state, node: node }) {
            state.renderInline(node);
            state.closeBlock(node);
        },
        support: 'full'
    },
    mediaGroup: {
        serialize ({ state: state, node: node }) {
            state.updateNonErrorFallbackState(node);
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'fallback'
    },
    mediaInline: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mediaInline',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="mediaInline" data-id="${id}"></custom>`);
            });
        },
        support: 'preview'
    },
    mediaSingle: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mediaSingle', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mediaSingle',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="media_single_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="media_single_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                /**
         * Currently, if the parent is a node we assume that mediaSingle is nested (e.g. inside a
         * table or list). In these cases we only output \n as there is often already new lines added
         * by the parent node.
         * Otherwise, if mediaSingle is not nested we add an extra new line.
         */ if (parent instanceof (0, $5SAOw.Node)) state.write('\n');
                else state.write('\n\n');
            }
        },
        support: 'preview'
    },
    caption: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'caption', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'caption',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="caption_open" data-id="${id}" />\n\n`);
                try {
                    state.renderInline(node, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback.serialize({
                        state: state,
                        node: node,
                        parent: parent,
                        index: index
                    });
                }
                // captions do not contain paragraphs, so we need to add a newline after the content
                state.write(`\n\n<custom data-type="caption_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                state.write(node.textContent);
            }
        },
        support: 'preview'
    },
    media: {
        serialize ({ state: state, node: node }) {
            // Creating this fake URl allows us to pass the media attributes to the markdown without using markdown plus
            // Which allows image retention when using rovo since it doesn't support markdown plus
            const baseUrl = `blob:${(0, $bd943.MEDIA_BASE_URL_STAGING)}/?`;
            const queryString = Object.entries(node.attrs).map(([key, value])=>key !== 'alt' ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : ``).join('&');
            const fakeUrl = `${baseUrl}${queryString}`;
            state.write(`![](${fakeUrl})${state.featureToggles.markdownPlusAddComplexNodes ? '\n\n' : ''}`);
        },
        support: 'full'
    },
    image: {
        serialize ({ state: state, node: node }) {
            // Note: the 'title' is not escaped in this flavor of markdown.
            state.write('![' + (0, $74c7a8487430b8e3$export$560888d6fe0cfe97)(node.attrs.alt) + '](' + node.attrs.src + (node.attrs.title ? ` '${(0, $74c7a8487430b8e3$export$560888d6fe0cfe97)(node.attrs.title)}'` : '') + ')');
        },
        support: 'full'
    },
    hardBreak: {
        serialize ({ state: state }) {
            state.write('  \n');
        },
        support: 'full'
    },
    text: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const previousNode = index === 0 ? null : parent.child(index - 1);
            let text = node.textContent;
            // BB converts 4 spaces at the beginning of the line to code block
            // that's why we escape 4 spaces with zero-width-non-joiner
            const fourSpaces = '    ';
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            if (!previousNode && /^\s{4}/.test(node.textContent)) text = node.textContent.replace(fourSpaces, '\u200c' + fourSpaces);
            const lines = text.split('\n');
            for(let i = 0; i < lines.length; i++){
                const startOfLine = state.atBlank() || !!state.closed;
                state.write();
                state.out += (0, $74c7a8487430b8e3$export$560888d6fe0cfe97)(lines[i], startOfLine, state.context.insideTable);
                if (i !== lines.length - 1) {
                    if (lines[i] && lines[i].length && lines[i + 1] && lines[i + 1].length) state.out += '  ';
                    state.out += '\n';
                }
            }
            // This is so we can determine which marks are most used that aren't being converted to markdown
            node.marks.forEach((mark)=>{
                // @ts-expect-error
                if (!$e985dce6263f3bba$export$3a8025f2f3e0c64[mark.type.name]) state.updateNonErrorFallbackState(mark);
            });
        },
        support: 'full'
    },
    empty_line: {
        serialize ({ state: state, node: node }) {
            state.write('\u200c'); // zero-width-non-joiner
            state.closeBlock(node);
        },
        support: 'full'
    },
    placeholder: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'placeholder', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'placeholder',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="placeholder" data-id="${id}">${node.attrs.text}</custom>`);
            }
        },
        support: 'custom'
    },
    mention: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const isLastNode = parent.childCount === index + 1;
            let delimiter = '';
            if (!isLastNode) {
                const nextNode = parent.child(index + 1);
                const nextNodeHasLeadingSpace = nextNode.textContent.indexOf(' ') === 0;
                delimiter = nextNodeHasLeadingSpace ? '' : ' ';
            }
            // Get the name from the map
            const name = state.mentionMap[node.attrs.id] || '';
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mention', {
                    ...node.attrs,
                    text: `@${name}`
                }) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mention',
                    // Update the attributes to include resolved name
                    attributes: {
                        ...node.attrs,
                        text: `@${name}`
                    }
                };
                if (state.featureToggles.markdownPlusAttributeTest) {
                    // @ts-expect-error
                    node.attrs.text = `@${name}`;
                    state.write(`<custom data-type="mention" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">@${name}</custom>`);
                } else state.write(`<custom data-type="mention" data-id="${id}">@${name}</custom>`);
            } else state.write(`${name}${delimiter}`);
        },
        support: 'custom'
    },
    date: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'date', node.attrs) : `id-${state.idCounter++}`;
                // Ensure localId is explicitly set to null if not present
                const attributes = {
                    ...node.attrs,
                    localId: node.attrs.localId ?? null
                };
                state.idMap[id] = {
                    type: 'date',
                    attributes: attributes
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="date" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
                else state.write(`<custom data-type="date" data-id="${id}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
            } else state.write(new Intl.DateTimeFormat().format(Number(node.attrs.timestamp)));
        },
        support: 'custom'
    },
    emoji: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'emoji', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'emoji',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="emoji" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${node.attrs.shortName}</custom>`);
                else state.write(`<custom data-type="emoji" data-id="${id}">${node.attrs.shortName}</custom>`);
            } else state.write(node.attrs.shortName);
        },
        support: 'custom'
    },
    inlineCard: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineCard', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineCard',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="smartlink" data-id="${id}">${node.attrs.url}</custom>`);
            } else state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'custom'
    },
    status: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'status', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'status',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="status" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${node.attrs.text}</custom>`);
                else state.write(`<custom data-type="status" data-id="${id}">${node.attrs.text}</custom>`);
            } else // this will trigger the fallback conversion (text)
            throw new Error('Token type `status` not supported by Markdown renderer');
        },
        support: 'custom'
    },
    layoutSection: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutSection', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'layoutSection',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="layoutSection_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="layoutSection_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    layoutColumn: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutColumn', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'layoutColumn',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="layoutColumn_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="layoutColumn_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    expand: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'expand', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'expand',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="expand_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="expand_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    nestedExpand: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'nestedExpand', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'nestedExpand',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="nestedExpand_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="nestedExpand_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    panel: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusPanels) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'panel', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'panel',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="panel_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="panel_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'custom'
    },
    blockCard: {
        serialize ({ state: state, node: node }) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'full'
    },
    embedCard: {
        serialize ({ state: state, node: node }) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'full'
    },
    decisionList: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionList', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionList',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionList_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`<custom data-type="decisionList_close" />\n\n`);
            } else {
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`\n\n`);
            }
        },
        support: 'custom'
    },
    decisionItem: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionItem', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionItem',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionItem_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`\n\n<custom data-type="decisionItem_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'custom'
    },
    extension: {
        serialize ({ state: state, node: node }) {
            // For native embed extension nodes, output the embedded URL as a markdown link
            // so that it's visible to Rovo (same as embedCard/blockCard serialization)
            if (node.attrs.extensionKey?.startsWith('native-embed:')) {
                const url = node.attrs.parameters?.macroParams?.url?.value;
                if (url) {
                    state.write(`[${url}](${url})`);
                    return;
                }
            }
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'extension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'extension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="extension" data-id="${id}" />\n\n`);
            }
        },
        support: 'custom'
    },
    inlineExtension: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="inlineExtension" data-id="${id}"></custom>`);
            }
        },
        support: 'custom'
    },
    bodiedExtension: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'bodiedExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'bodiedExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="bodiedExtension_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="bodiedExtension_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'custom'
    },
    fallback: {
        serialize ({ state: state, node: node }) {
            // If PMNode is an unhandled block node, we need to add a newline
            // after the content to prevent the next line from being rendered as
            // part of the block node.
            if (node.isBlock) state.write(`${node.textContent || node.attrs.text || ''}\n\n`);
            else state.write(node.textContent || node.attrs.text || '');
        },
        support: 'fallback'
    }
};
const $e985dce6263f3bba$export$695720b7e7a61533 = {
    ...$e985dce6263f3bba$var$editorNodes,
    ...(0, $deb7030063275628$export$2e2bcd8739ae039)
};
const $e985dce6263f3bba$export$3a8025f2f3e0c64 = {
    em: {
        open: '_',
        close: '_',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: '**',
        close: '**',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strike: {
        open: '~~',
        close: '~~',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open: '[',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        close (_state, mark) {
            return '](' + mark.attrs['href'] + ')';
        }
    },
    code: {
        open: '`',
        close: '`'
    }
};


/**
 * If the first node is a paragraph we need to wrap it in a paragraph node for the markdown conversion to work properly
 */ function $fb0b992a34319cb0$var$createTextWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (0, $8m4tT.findParentNodeClosestToPos)($from, (node)=>{
        return node.type.name === 'paragraph' || node.type.name === 'heading';
    })?.node;
    if (parent) return schema.nodes.doc.createChecked(null, schema.nodes[parent.type.name].createChecked(parent.attrs, fragment));
    else // If the node is a paragraph we need the parent to be a doc for the conversion to work correctly
    return schema.nodes.doc.createChecked(null, schema.nodes.paragraph.createChecked(null, fragment));
}
/**
 * This finds the closest list item parent to the current selection
 * Once found it will create a new list with the current fragment as its children
 */ function $fb0b992a34319cb0$var$createListItemWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (0, $8m4tT.findParentNodeClosestToPos)($from, (node)=>node.type.name === 'bulletList' || node.type.name === 'orderedList')?.node;
    if (parent) return schema.nodes[parent.type.name].createChecked(parent.attrs, fragment);
    return fragment;
}
/**
 * If the first node is a task item we need to wrap it in a task list node for the markdown conversion to work properly
 */ function $fb0b992a34319cb0$var$createTaskItemWrapper(schema, fragment) {
    return schema.nodes.doc.createChecked(null, schema.nodes.taskList.createChecked(null, fragment));
}
function $fb0b992a34319cb0$var$createLayoutColumnWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const parentSection = (0, $8m4tT.findParentNodeOfType)(schema.nodes.layoutSection)(editorView.state.selection);
    if (parentSection) // Needs to be a doc for the serializer to work as it
    // loops through the fragments children to render
    return schema.nodes.doc.createChecked(null, schema.nodes.layoutSection.createChecked(parentSection.node.attrs, fragment));
    return fragment;
}
/**
 * This function handles partial selections and it will fix any incomplete fragments that won't be converted properly
 * If you do a partial selection, it will not select the parent node of certain nodes text, listItems etc so once it hits the serializer
 * the serializer will just fallback to plain text and not convert the node properly.
 *
 * This function checks the first child of the current selection, if its a node that needs a parent it will find the closest parent
 * and create a new fragment that will be converted properly by the serializer
 */ function $fb0b992a34319cb0$var$checkFragment(editorView, schema, fragment) {
    switch(fragment?.firstChild?.type?.name){
        case 'text':
            return $fb0b992a34319cb0$var$createTextWrapper(editorView, fragment);
        case 'listItem':
            return $fb0b992a34319cb0$var$createListItemWrapper(editorView, fragment);
        case 'taskItem':
            return $fb0b992a34319cb0$var$createTaskItemWrapper(schema, fragment);
        case 'layoutColumn':
            return $fb0b992a34319cb0$var$createLayoutColumnWrapper(editorView, fragment);
        default:
            return fragment;
    }
}
function $fb0b992a34319cb0$export$cc6cac500a4da966({ editorView: editorView, fragment: fragment, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
    fragment = $fb0b992a34319cb0$var$checkFragment(editorView, editorView.state.schema, fragment);
    return $fb0b992a34319cb0$export$3d24004275aefeab({
        node: fragment,
        featureToggles: featureToggles,
        mentionMap: mentionMap,
        idMap: idMap
    });
}
function $fb0b992a34319cb0$export$3d24004275aefeab({ node: node, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
    const markdownSerializerState = new (0, $e985dce6263f3bba$export$61055fa707e69319)(featureToggles, mentionMap, idMap);
    markdownSerializerState.renderContent(node);
    const pmStats = new (0, $8nxxM.ProseMirrorContentStatistics)(node);
    const contentStatistics = pmStats.collectStatistics();
    const markdown = markdownSerializerState.out === '\u200c' ? '' : markdownSerializerState.out;
    return {
        markdown: markdown,
        fallbackState: markdownSerializerState.fallbackState,
        nonErrorFallbackState: markdownSerializerState.nonErrorFallbackState,
        idMap: markdownSerializerState.idMap,
        contentStatistics: contentStatistics
    };
}
module.exports["convertProsemirrorToMarkdown"] = $fb0b992a34319cb0$export$cc6cac500a4da966;
module.exports["convertProsemirrorNodeToMarkdown"] = $fb0b992a34319cb0$export$3d24004275aefeab;

});

parcelRegister("8nxxM", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");

class $13b081699855d8a3$export$acf14785d7d5b1be {
    /**
   * Calculate statistics for the ProseMirror content such as node counts, mark counts and total character count.
   */ collectStatistics() {
        const { nodeCounts: nodeCounts, markCounts: markCounts, linksCount: linksCount, mentionsCount: mentionsCount } = this.countNodesAndMarks();
        const { totalCharacterCount: totalCharacterCount } = this.calculateCharacterCounts();
        return {
            nodeCounts: nodeCounts,
            markCounts: markCounts,
            linksCount: linksCount,
            mentionsCount: mentionsCount,
            totalCharacterCount: totalCharacterCount,
            contextSelectionScope: undefined
        };
    }
    countNodesAndMarks() {
        const nodeCounts = new Map();
        const markCounts = new Map();
        let linksCount = 0;
        let mentionsCount = 0;
        this.content.descendants((node)=>{
            nodeCounts.set(node.type.name, (nodeCounts.get(node.type.name) || 0) + 1);
            const marks = node.marks;
            marks.forEach((mark)=>{
                markCounts.set(mark.type.name, (markCounts.get(mark.type.name) || 0) + 1);
            });
            const { nodes: { inlineCard: inlineCard, mention: mention }, marks: { link: link } } = node.type.schema;
            if (node.type === mention) mentionsCount++;
            if (node.type === inlineCard && node.attrs.url) linksCount++;
            if (marks.find((mark)=>mark.type === link)) linksCount++;
        });
        return {
            nodeCounts: Object.fromEntries(nodeCounts),
            markCounts: Object.fromEntries(markCounts),
            linksCount: linksCount,
            mentionsCount: mentionsCount
        };
    }
    calculateCharacterCounts() {
        let allTextContent = '';
        if (this.content instanceof (0, $5SAOw.Node)) allTextContent = this.content.textContent;
        else this.content.forEach((child)=>{
            allTextContent += child.textContent;
        });
        return {
            totalCharacterCount: allTextContent.length
        };
    }
    constructor(content){
        this.content = void 0;
        this.content = content;
    }
}
module.exports["ProseMirrorContentStatistics"] = $13b081699855d8a3$export$acf14785d7d5b1be;

});

parcelRegister("b4emg", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $hbEec = parcelRequire("hbEec");

const $8841f32d2d46ed1f$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });
module.exports["getEmptyADF"] = $8841f32d2d46ed1f$export$d109ab46c9575565;

});

parcelRegister("2CHXX", function(module, exports) {

var $1P1Tu = parcelRequire("1P1Tu");


var $bPHr8 = parcelRequire("bPHr8");

const $50c358168d133df8$export$a08ae3ac6db36809 = 'EMPTY_CONVERSATION_ID';
const $50c358168d133df8$var$initialState = {
    conversations: {
        EMPTY_CONVERSATION_ID: {
            id: $50c358168d133df8$export$a08ae3ac6db36809,
            messages: [],
            name: '',
            status: (0, $bPHr8.CHAT_STORE_STATUS).idle,
            traces: [],
            timeCreated: new Date().toISOString(),
            selectedAgentIds: []
        }
    },
    currentConversationId: $50c358168d133df8$export$a08ae3ac6db36809,
    isConversationsInitialized: false
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $50c358168d133df8$var$store;
const $50c358168d133df8$export$8572e013e9dc20c3 = (actions)=>{
    if (!$50c358168d133df8$var$store) $50c358168d133df8$var$store = (0, $1P1Tu.createStore)({
        name: 'ConversationAssistantStore',
        initialState: $50c358168d133df8$var$initialState,
        actions: actions
    });
    return $50c358168d133df8$var$store;
};
module.exports["EMPTY_CONVERSATION_ID"] = $50c358168d133df8$export$a08ae3ac6db36809;
module.exports["createChatStore"] = $50c358168d133df8$export$8572e013e9dc20c3;

});

parcelRegister("bPHr8", function(module, exports) {
var $6ad1677b7b0380c5$export$69799355b7de2229 = /*#__PURE__*/ function(StoreActionLoggableName) {
    StoreActionLoggableName["addStoreChatItem"] = "addStoreChatItem";
    StoreActionLoggableName["addHumanMessage"] = "addHumanMessage";
    StoreActionLoggableName["addAssistantMessage"] = "addAssistantMessage";
    StoreActionLoggableName["clearFollowUpMessages"] = "clearFollowUpMessages";
    StoreActionLoggableName["sendMessage"] = "sendMessage";
    StoreActionLoggableName["sendMessageConfirmedTools"] = "sendMessageConfirmedTools";
    StoreActionLoggableName["removeMessage"] = "removeMessage";
    StoreActionLoggableName["truncateFromLastHumanMessage"] = "truncateFromLastHumanMessage";
    StoreActionLoggableName["fetchConversation"] = "fetchConversation";
    StoreActionLoggableName["prefetchConversationMessages"] = "prefetchConversationMessages";
    StoreActionLoggableName["reconnectToInProgressStream"] = "reconnectToInProgressStream";
    StoreActionLoggableName["abortRequests"] = "abortRequests";
    StoreActionLoggableName["answerNow"] = "answerNow";
    StoreActionLoggableName["addErrorMessage"] = "addErrorMessage";
    StoreActionLoggableName["fetchConversationChannelsData"] = "fetchConversationChannelsData";
    StoreActionLoggableName["hydrateConversation"] = "hydrateConversation";
    StoreActionLoggableName["addAgentMessage"] = "addAgentMessage";
    StoreActionLoggableName["handleChatOpenPubsubAction"] = "handleChatOpenPubsubAction";
    StoreActionLoggableName["createConversationOptimistically"] = "createConversationOptimistically";
    StoreActionLoggableName["createSeededConversation"] = "createSeededConversation";
    StoreActionLoggableName["updateActionInvocationStatus"] = "updateActionInvocationStatus";
    StoreActionLoggableName["updateActionData"] = "updateActionData";
    StoreActionLoggableName["resolveConversationAction"] = "resolveConversationAction";
    StoreActionLoggableName["bulkResolveConversationActions"] = "bulkResolveConversationActions";
    StoreActionLoggableName["bulkResolveConversationUIActions"] = "bulkResolveConversationUIActions";
    StoreActionLoggableName["setSelectedConversation"] = "setSelectedConversation";
    StoreActionLoggableName["warmConversationCache"] = "warmConversationCache";
    StoreActionLoggableName["hasConversationMessages"] = "hasConversationMessages";
    StoreActionLoggableName["stopTask"] = "stopTask";
    return StoreActionLoggableName;
}({});
const $6ad1677b7b0380c5$export$8ec4190061b584d5 = (status)=>status?.type === 'AVAILABLE';
const $6ad1677b7b0380c5$export$fe950e85847f6d5d = {
    AVAILABLE: 'AVAILABLE',
    SWITCHING: 'SWITCHING',
    SWITCHING_REQUESTED: 'SWITCHING_REQUESTED',
    SWITCHED: 'SWITCHED',
    ERRORED: 'ERRORED'
};
var $6ad1677b7b0380c5$export$817d6b1b984afeb7 = /*#__PURE__*/ function(CHAT_STORE_STATUS) {
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["idle"] = 0] = "idle";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["loadingChat"] = 1] = "loadingChat";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["awaitingResponse"] = 2] = "awaitingResponse";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["typingResponse"] = 3] = "typingResponse";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["deactivatedAgentError"] = 4] = "deactivatedAgentError";
    return CHAT_STORE_STATUS;
}({});
const $6ad1677b7b0380c5$var$TERMINAL_TASK_STATES = [
    'Completed',
    'Failed',
    'Cancelled'
];
const $6ad1677b7b0380c5$export$e87901ebf76c08a1 = (state)=>$6ad1677b7b0380c5$var$TERMINAL_TASK_STATES.includes(state);
const $6ad1677b7b0380c5$export$75e97486ff2b4c62 = (message)=>'type' in message && message.type === 'HUMAN';
const $6ad1677b7b0380c5$export$d99f52ae2a325014 = (message)=>'type' in message && message.type === 'ASSISTANT';
const $6ad1677b7b0380c5$export$9e2d714e96946d26 = (message)=>'type' in message && message.type === 'ERROR';
const $6ad1677b7b0380c5$export$f2b8d80523e7041 = (message)=>$6ad1677b7b0380c5$export$75e97486ff2b4c62(message) || $6ad1677b7b0380c5$export$d99f52ae2a325014(message);
const $6ad1677b7b0380c5$export$61c7dbb423a56ae7 = (message)=>'type' in message && message.type === 'MEMORY_UPDATE';
const $6ad1677b7b0380c5$export$7c65a4fb7b6131a1 = (message)=>'type' in message && message.type === 'FOLLOW_UP';
const $6ad1677b7b0380c5$export$2e85f4812cb59241 = (message)=>'type' in message && message.type === 'LIVE_CHAT';
const $6ad1677b7b0380c5$export$20f0f8aded5b11e5 = (message)=>'type' in message && message.type === 'TWILIO_LIVE_CHAT_AGENT';
const $6ad1677b7b0380c5$export$908578fde1b22b55 = (message)=>$6ad1677b7b0380c5$export$75e97486ff2b4c62(message) && message.source === 'TWILIO_LIVE_CHAT';
const $6ad1677b7b0380c5$export$3db8a80b25c44828 = (message)=>$6ad1677b7b0380c5$export$20f0f8aded5b11e5(message) || $6ad1677b7b0380c5$export$908578fde1b22b55(message);
const $6ad1677b7b0380c5$export$d15e7fe0f58ee5d0 = (message)=>message.type === 'ACTION_PREPARE';
const $6ad1677b7b0380c5$export$533a80cec0f4f28f = (message)=>message.type === 'GUARD_BLOCK';
const $6ad1677b7b0380c5$export$155f16100a67670d = (message)=>'type' in message && message.type === 'USAGE_HINT';
const $6ad1677b7b0380c5$export$3070678f252266e3 = (invocationId, invokedActions)=>invokedActions && invokedActions[invocationId] || 'idle';
module.exports["StoreActionLoggableName"] = $6ad1677b7b0380c5$export$69799355b7de2229;
module.exports["isAnswerNowAvailable"] = $6ad1677b7b0380c5$export$8ec4190061b584d5;
module.exports["AnswerNowStatusType"] = $6ad1677b7b0380c5$export$fe950e85847f6d5d;
module.exports["CHAT_STORE_STATUS"] = $6ad1677b7b0380c5$export$817d6b1b984afeb7;
module.exports["isTerminalTaskState"] = $6ad1677b7b0380c5$export$e87901ebf76c08a1;
module.exports["isStoreHuman"] = $6ad1677b7b0380c5$export$75e97486ff2b4c62;
module.exports["isStoreAssistant"] = $6ad1677b7b0380c5$export$d99f52ae2a325014;
module.exports["isStoreError"] = $6ad1677b7b0380c5$export$9e2d714e96946d26;
module.exports["isStoreMessage"] = $6ad1677b7b0380c5$export$f2b8d80523e7041;
module.exports["isStoreFollowUp"] = $6ad1677b7b0380c5$export$7c65a4fb7b6131a1;
module.exports["isStoreGuardBlock"] = $6ad1677b7b0380c5$export$533a80cec0f4f28f;
module.exports["isStoreUsageHint"] = $6ad1677b7b0380c5$export$155f16100a67670d;
module.exports["getActionInvocationStatus"] = $6ad1677b7b0380c5$export$3070678f252266e3;

});

parcelRegister("4pEXC", function(module, exports) {
/* eslint-disable @atlaskit/platform/one-value-export-per-file -- This file predates the rule and is a shared subpath entry point consumed by many packages; splitting would require coordinated changes across the entire monorepo. */ 
var $b0F8r = parcelRequire("b0F8r");


var $b7FrM = parcelRequire("b7FrM");


var $lpRYt = parcelRequire("lpRYt");


var $ij2FZ = parcelRequire("ij2FZ");

const $cdcb92bd6c40797f$export$d801201dc544181 = (content)=>{
    /*
  This try-catch is a necessary guard rail against broken content to prevent higher level
  error boundaries from displaying the error and breaking the experience.
  */ try {
        return typeof content !== 'string' && 'type' in content && content.type === 'doc';
    } catch  {
        return false;
    }
};
const $cdcb92bd6c40797f$export$a236f395afded7e0 = (content, suggestionContent)=>{
    if ($cdcb92bd6c40797f$export$d801201dc544181(content)) {
        // Ensure the content is an array of nodes
        const updatedContent = Array.isArray(content.content) ? content.content : [
            content.content
        ];
        // Append the new paragraph node
        updatedContent.push({
            type: 'paragraph',
            content: [
                {
                    type: 'text',
                    text: suggestionContent
                }
            ]
        });
        // Return the updated DocNode
        return {
            ...content,
            content: updatedContent
        };
    }
    return `${content}\n\n${suggestionContent}`;
};
const $cdcb92bd6c40797f$var$pluginConfig = {
    linkify: {
        findFilepaths: $b0F8r.findFilepaths,
        isLinkInMatches: $b0F8r.isLinkInMatches
    },
    smartLinks: {
        regexStorage: globalThis.localStorage
    }
};
const $cdcb92bd6c40797f$export$3374c63d7715b4ce = new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, false));
const $cdcb92bd6c40797f$var$streamingAdfEncoder = new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, true));
const $cdcb92bd6c40797f$export$53ded0b846f45216 = (content, streaming = false, isExperimentEnabled, shouldShowAsInline, useGroupedCitations, xpcWrapUrl)=>{
    if ($cdcb92bd6c40797f$export$d801201dc544181(content)) return content;
    if (isExperimentEnabled || shouldShowAsInline || xpcWrapUrl) return new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, undefined, xpcWrapUrl)).encode(content);
    else if (useGroupedCitations) return streaming ? new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, true, undefined, undefined, true)).encode(content) : new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, useGroupedCitations)).encode(content);
    else return streaming ? $cdcb92bd6c40797f$var$streamingAdfEncoder.encode(content) : $cdcb92bd6c40797f$export$3374c63d7715b4ce.encode(content);
};
const $cdcb92bd6c40797f$export$cc924f6f2bb49b7c = (content)=>{
    const contentNodes = [];
    let lastIndex = 0;
    let match;
    let promptLength = 0;
    // Find all skill tag matches
    const matches = [];
    while((match = (0, $ij2FZ.ROVO_SKILL_TAG_PATTERN).exec(content)) !== null)matches.push({
        index: match.index,
        skillSlug: match[1],
        // The skill name without the slash
        length: match[0].length // Length of "/skill-name"
    });
    // Process the string segment by segment
    for(let i = 0; i < matches.length; i++){
        const currentMatch = matches[i];
        const matchStart = currentMatch.index;
        const matchEnd = matchStart + currentMatch.length;
        // Add text before the skill tag (if any)
        if (matchStart > lastIndex) {
            const textBefore = content.substring(lastIndex, matchStart);
            if (textBefore) {
                contentNodes.push({
                    type: 'text',
                    text: textBefore
                });
                promptLength += textBefore.length;
            }
        }
        // Add the skill tag as inlineExtension
        contentNodes.push({
            type: 'inlineExtension',
            attrs: {
                extensionKey: (0, $ij2FZ.ROVO_SKILL_COMBINED_EXTENSION_KEY),
                extensionType: (0, $ij2FZ.ROVO_SKILL_EXTENSION_TYPE),
                parameters: {
                    slug: currentMatch.skillSlug
                }
            }
        });
        promptLength += 1;
        lastIndex = matchEnd;
    }
    // Add remaining text after the last match (if any)
    if (lastIndex < content.length) {
        const textAfter = content.substring(lastIndex);
        if (textAfter) {
            contentNodes.push({
                type: 'text',
                text: textAfter
            });
            promptLength += textAfter.length;
        }
    }
    // If no matches were found, return the entire string as text
    if (contentNodes.length === 0) {
        contentNodes.push({
            type: 'text',
            text: content
        });
        promptLength += content.length;
    }
    return {
        adf: {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: contentNodes
                }
            ]
        },
        promptLength: promptLength
    };
};
const $cdcb92bd6c40797f$export$b663bc0d84e6eaa6 = '`';
// encodeAdf removes leading spaces, so prepend a text node with the segment's leading spaces to preserve them.
const $cdcb92bd6c40797f$var$preserveLeadingSpaces = (textSegment, nodes)=>{
    const leading = textSegment.match(/^\s*/)?.[0] ?? '';
    if (leading.length === 0) return nodes;
    return [
        {
            type: 'text',
            text: leading
        },
        ...nodes
    ];
};
// Collect all content nodes from all top-level blocks, since encodeAdf can return multiple paragraphs for e.g. "line1\n\nline2".
const $cdcb92bd6c40797f$var$getAllNodesFromSegmentAdf = (segmentAdf, fallbackSegment)=>{
    const blocks = segmentAdf.content ?? [];
    if (blocks.length === 0) return [
        {
            type: 'text',
            text: fallbackSegment
        }
    ];
    const nodes = blocks.flatMap((block)=>block.content ?? []);
    return nodes.length > 0 ? nodes : [
        {
            type: 'text',
            text: fallbackSegment
        }
    ];
};
const $cdcb92bd6c40797f$var$detectSkills = (content, skillMetadata)=>{
    if (!skillMetadata) return [];
    const regex = new RegExp((0, $ij2FZ.ROVO_SKILL_TAG_PATTERN).source, 'g');
    const matches = [
        ...content.matchAll(regex)
    ];
    if (matches.length === 0) return [];
    return matches.filter((m)=>m[1] in skillMetadata).map((m)=>({
            index: m.index ?? 0,
            slug: m[1],
            length: m[0].length
        }));
};
// The conversation input editor only supports a limited set of block node types.
// Convert unsupported block nodes to paragraph nodes so that prompts containing
// markdown headings (e.g. "## Title") or horizontal rules (e.g. "---") do not
// trigger "This editor does not support displaying this content: <type>" when inserted.
const $cdcb92bd6c40797f$var$sanitizeAdfForPromptInput = (adf)=>{
    if (!adf.content) return adf;
    return {
        ...adf,
        content: adf.content.flatMap((node)=>{
            if (node.type === 'heading') // Convert heading to paragraph, preserving inner text content
            return [
                {
                    type: 'paragraph',
                    content: node.content
                }
            ];
            if (node.type === 'rule') // Drop horizontal rules entirely — they have no content to preserve
            return [];
            return [
                node
            ];
        })
    };
};
const $cdcb92bd6c40797f$export$20cf1197bba4fe47 = (content, skillMetadata, shouldShowAsInline)=>{
    const skillMatches = $cdcb92bd6c40797f$var$detectSkills(content, skillMetadata);
    if (skillMatches.length === 0) {
        const { placeholderRange: placeholderRange } = $cdcb92bd6c40797f$var$getPlaceholderRange(content, 0);
        return {
            adf: $cdcb92bd6c40797f$var$sanitizeAdfForPromptInput($cdcb92bd6c40797f$export$53ded0b846f45216(content, false, undefined, shouldShowAsInline)),
            promptLength: content.length,
            ...placeholderRange && {
                placeholderRange: placeholderRange
            }
        };
    }
    return $cdcb92bd6c40797f$var$encodePromptWithSkills(content, skillMatches, skillMetadata);
};
const $cdcb92bd6c40797f$var$encodePromptWithSkills = (content, skillMatches, skillMetadata)=>{
    const contentNodes = [];
    let lastIndex = 0;
    let promptLength = 0;
    let placeholderRange;
    for(let i = 0; i < skillMatches.length; i++){
        const currentMatch = skillMatches[i];
        const matchStart = currentMatch.index;
        const matchEnd = matchStart + currentMatch.length;
        // Add text and placeholder range before the skill tag (if any)
        if (matchStart > lastIndex) {
            const textSegment = content.substring(lastIndex, matchStart);
            if (textSegment) {
                const { placeholderRange: range } = $cdcb92bd6c40797f$var$getPlaceholderRange(textSegment, promptLength);
                if (range) placeholderRange = range;
                const segmentAdf = $cdcb92bd6c40797f$export$53ded0b846f45216(textSegment);
                const nodes = $cdcb92bd6c40797f$var$getAllNodesFromSegmentAdf(segmentAdf, textSegment);
                contentNodes.push(...$cdcb92bd6c40797f$var$preserveLeadingSpaces(textSegment, nodes));
                promptLength += textSegment.length;
            }
        }
        // Add the skill tag as inlineExtension
        contentNodes.push({
            type: 'inlineExtension',
            attrs: {
                extensionKey: (0, $ij2FZ.ROVO_SKILL_COMBINED_EXTENSION_KEY),
                extensionType: (0, $ij2FZ.ROVO_SKILL_EXTENSION_TYPE),
                parameters: {
                    slug: currentMatch.slug,
                    ...skillMetadata?.[currentMatch.slug]
                }
            }
        });
        promptLength += 1;
        lastIndex = matchEnd;
    }
    // Add remaining text and placeholder range after the last match (if any)
    if (lastIndex < content.length) {
        const textSegment = content.substring(lastIndex);
        if (textSegment) {
            const { placeholderRange: range } = $cdcb92bd6c40797f$var$getPlaceholderRange(textSegment, promptLength);
            if (range) placeholderRange = range;
            const segmentAdf = $cdcb92bd6c40797f$export$53ded0b846f45216(textSegment);
            const nodes = $cdcb92bd6c40797f$var$getAllNodesFromSegmentAdf(segmentAdf, textSegment);
            contentNodes.push(...$cdcb92bd6c40797f$var$preserveLeadingSpaces(textSegment, nodes));
            promptLength += textSegment.length;
        }
    }
    return {
        adf: {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: contentNodes
                }
            ]
        },
        promptLength: promptLength,
        ...placeholderRange && {
            placeholderRange: placeholderRange
        }
    };
};
// Returns the placeholder range for link typeahead when content has `label` backticks.
const $cdcb92bd6c40797f$var$getPlaceholderRange = (segment, currentContentIndex)=>{
    const firstBacktick = segment.indexOf($cdcb92bd6c40797f$export$b663bc0d84e6eaa6);
    const lastBacktick = segment.lastIndexOf($cdcb92bd6c40797f$export$b663bc0d84e6eaa6);
    if (firstBacktick !== -1 && lastBacktick !== -1 && firstBacktick !== lastBacktick) {
        const label = segment.slice(firstBacktick + 1, lastBacktick);
        const start = currentContentIndex + firstBacktick + 1;
        return {
            placeholderRange: {
                start: start,
                end: start + label.length,
                label: label
            }
        };
    }
    return {};
};
module.exports["isAdfContent"] = $cdcb92bd6c40797f$export$d801201dc544181;
module.exports["appendContent"] = $cdcb92bd6c40797f$export$a236f395afded7e0;
module.exports["adfEncoder"] = $cdcb92bd6c40797f$export$3374c63d7715b4ce;
module.exports["encodeAdf"] = $cdcb92bd6c40797f$export$53ded0b846f45216;
module.exports["encodeSkillPromptToAdf"] = $cdcb92bd6c40797f$export$cc924f6f2bb49b7c;
module.exports["PROMPT_PLACEHOLDER_CHAR"] = $cdcb92bd6c40797f$export$b663bc0d84e6eaa6;
module.exports["encodePromptToAdf"] = $cdcb92bd6c40797f$export$20cf1197bba4fe47;

});

parcelRegister("cBi7Q", function(module, exports) {
const $a428bcb8f1a15d17$export$4b225aae27e9366b = '45c9c029-3180-4960-ab0d-db7cdeaf5f54';
const $a428bcb8f1a15d17$export$c87b1e2e3344192f = 1000;
const $a428bcb8f1a15d17$export$c4e7b6208a0b853e = 60;
const $a428bcb8f1a15d17$export$cd6b7e688e614eeb = $a428bcb8f1a15d17$export$c4e7b6208a0b853e * 60;
const $a428bcb8f1a15d17$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $a428bcb8f1a15d17$export$a0d33d6e93abfb90 = 'aiMateChatLoadPreference';
const $a428bcb8f1a15d17$export$e5a3af287978673c = (siteId)=>siteId ? `${$a428bcb8f1a15d17$export$a0d33d6e93abfb90}_${siteId}` : $a428bcb8f1a15d17$export$a0d33d6e93abfb90;
const $a428bcb8f1a15d17$export$e8114853eca81277 = 'ai-mate';
const $a428bcb8f1a15d17$export$45d167a0ef5aef8d = '/gateway/api/directory/graphql';
const $a428bcb8f1a15d17$export$1ea9613e3e37d315 = 30 * $a428bcb8f1a15d17$export$c4e7b6208a0b853e * $a428bcb8f1a15d17$export$c87b1e2e3344192f;
const $a428bcb8f1a15d17$export$501af059da333e01 = 5 * $a428bcb8f1a15d17$export$c4e7b6208a0b853e * $a428bcb8f1a15d17$export$c87b1e2e3344192f;
const $a428bcb8f1a15d17$export$f8d883b8f9181b19 = 'rovoChatLastMessageSentAt';
const $a428bcb8f1a15d17$export$d4e191820de5cb9e = 'ai_mate_agent';
const $a428bcb8f1a15d17$export$cf40b355c500b3f7 = 'f3a534d9-1498-e0d4-8b50-e058a8fb8156';
const $a428bcb8f1a15d17$export$85d90d98449e85fd = 140;
const $a428bcb8f1a15d17$export$cad0f6e78cd99203 = '600px';
const $a428bcb8f1a15d17$export$900371d5fadf47e7 = {
    NEW_CHAT_BUTTON: 'rovo-chat-new-chat-button',
    THUMBS_UP_BUTTON: 'rovo-chat-thumbs-up-button'
};
const $a428bcb8f1a15d17$export$73f6568f4f3fdeda = 380;
const $a428bcb8f1a15d17$export$2c094f7f70c376e3 = 480;
const $a428bcb8f1a15d17$export$2e9abc2f500a1704 = 280;
module.exports["FEEDBACK_COLLECTOR_ENTRYPOINT_ID"] = $a428bcb8f1a15d17$export$4b225aae27e9366b;
module.exports["MS_IN_SECOND"] = $a428bcb8f1a15d17$export$c87b1e2e3344192f;
module.exports["SECONDS_IN_HR"] = $a428bcb8f1a15d17$export$cd6b7e688e614eeb;
module.exports["getChatLoadPreferenceKey"] = $a428bcb8f1a15d17$export$e5a3af287978673c;
module.exports["AI_MATE_EXPERIENCE_ID"] = $a428bcb8f1a15d17$export$e8114853eca81277;
module.exports["SHORTER_TIMEOUT_BEFORE_NEW_CHAT"] = $a428bcb8f1a15d17$export$501af059da333e01;
module.exports["LS_LAST_MESSAGE_SENT_AT"] = $a428bcb8f1a15d17$export$f8d883b8f9181b19;
module.exports["DEFAULT_AGENT_NAMED_ID"] = $a428bcb8f1a15d17$export$d4e191820de5cb9e;
module.exports["DEFAULT_AGENT_UUID"] = $a428bcb8f1a15d17$export$cf40b355c500b3f7;
module.exports["MINI_MODAL_GREETING_HEIGHT"] = $a428bcb8f1a15d17$export$85d90d98449e85fd;
module.exports["MINI_MODAL_EXPANDED_HEIGHT"] = $a428bcb8f1a15d17$export$cad0f6e78cd99203;
module.exports["POLLINATOR_TEST_IDS"] = $a428bcb8f1a15d17$export$900371d5fadf47e7;
module.exports["SPLIT_LAYOUT_INITIAL_WIDTH"] = $a428bcb8f1a15d17$export$73f6568f4f3fdeda;
module.exports["SPLIT_LAYOUT_MIN_WIDTH"] = $a428bcb8f1a15d17$export$2c094f7f70c376e3;
module.exports["SPLIT_LAYOUT_ADJACENT_MIN_WIDTH"] = $a428bcb8f1a15d17$export$2e9abc2f500a1704;

});

parcelRegister("jEzab", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9823ae60ddf75b10$var$store = (0, $1P1Tu.createStore)({
    name: 'chatUseMessages',
    initialState: {},
    actions: {
        setMessages: (conversationId, messages)=>({ setState: setState })=>{
                setState({
                    [conversationId]: messages
                });
            },
        getMessages: (conversationId)=>({ getState: getState })=>{
                return getState()[conversationId] ?? [];
            }
    }
});
const $9823ae60ddf75b10$export$d5c60118ea64ef24 = (0, $9zUhf.createHook)($9823ae60ddf75b10$var$store, {
    selector: (state, { conversationId: conversationId })=>state[conversationId] ?? []
});
const $9823ae60ddf75b10$export$fcbbecdca7d55350 = (0, $9zUhf.createActionsHook)($9823ae60ddf75b10$var$store);
module.exports["useChatMessages"] = $9823ae60ddf75b10$export$d5c60118ea64ef24;
module.exports["useChatMessagesActions"] = $9823ae60ddf75b10$export$fcbbecdca7d55350;

});

parcelRegister("jJK7o", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4HDYO = parcelRequire("4HDYO");

/**
 * Tasks SSE Connection Manager
 *
 * A plain TS module (no React, no store) that manages a single shared SSE connection
 * to the Tasks stream endpoint (`GET /rovo/v1/tasks/stream`).
 *
 * Key design properties:
 * - **Single connection**: only one SSE connection is open at a time, regardless of
 *   how many consumers are subscribed.
 * - **Reference-counted**: connection opens when the first subscriber arrives,
 *   closes when the last subscriber leaves.
 * - **Tab-visibility aware**: connection is dropped when the tab becomes hidden and
 *   re-established when the tab becomes visible again. This is fully managed here,
 *   not by any React component.
 * - **Decoupled from React lifecycle**: module-level state survives component
 *   mount/unmount cycles.
 * - **External trigger support**: can subscribe
 *  by providing `getService` explicitly — no component mounting required.
 */ 
var $fFa3V = parcelRequire("fFa3V");


var $hTKp4 = parcelRequire("hTKp4");


var $1yaYZ = parcelRequire("1yaYZ");


var $ljUdP = parcelRequire("ljUdP");

// ─── Module-level state (singleton) ──────────────────────────────────────────
/** Active SSE fetch abort controller. Null when disconnected. */ let $2c48c7577059a1a6$var$abortController = null;
/** The AssistanceService instance used for the current (or next) connection. */ let $2c48c7577059a1a6$var$serviceRef = null;
/** All active subscribers. Connection is open iff this Set is non-empty. */ const $2c48c7577059a1a6$var$subscribers = new Set();
/** Cleanup function for the visibilitychange listener. Null when unbound. */ let $2c48c7577059a1a6$var$visibilityUnbind = null;
// ─── Internal helpers ─────────────────────────────────────────────────────────
/**
 * Opens the SSE connection using the stored `serviceRef`.
 * Fans out each incoming event to all current subscribers.
 * Safe to call if a connection is already open (no-op guard via abortController).
 */ async function $2c48c7577059a1a6$var$openConnection() {
    if (!$2c48c7577059a1a6$var$serviceRef) return;
    // Prevent duplicate connections
    if ($2c48c7577059a1a6$var$abortController) return;
    $2c48c7577059a1a6$var$abortController = new AbortController();
    const localAbort = $2c48c7577059a1a6$var$abortController;
    try {
        const { generator: generator } = await $2c48c7577059a1a6$var$serviceRef.getTasksStream(localAbort);
        for await (const message of generator){
            // Bail out if connection was closed while we were iterating
            if (localAbort.signal.aborted) break;
            // The SSE stream yields ParsedSSEMessage<ApiTaskSSEUpdate> wrappers.
            // The event_type is carried in the SSE `event:` envelope line → message.eventType.
            if (!(0, $ljUdP.isSSEMessage)(message)) continue;
            const event = message.data;
            const eventType = message.eventType ?? 'task_status';
            if (event) $2c48c7577059a1a6$var$subscribers.forEach((listener)=>listener(event, eventType));
        }
    } catch (error) {
        // AbortError is expected on intentional disconnect — swallow it silently
        if (error instanceof DOMException && error.name === 'AbortError') return;
        // Report unexpected errors to Sentry. We deliberately do NOT re-throw:
        // `openConnection` is invoked via `void openConnection()` at every call
        // site, so a thrown error would surface as an unhandled promise rejection
        // — which can crash strict hosts and would otherwise tear down the chat
        // session for what is only a side-channel failure.
        (0, $1yaYZ.logException)({
            name: 'rovoTasksSSEConnection',
            exception: error
        });
    } finally{
        // Ensure controller is cleared once the loop exits for any reason
        if ($2c48c7577059a1a6$var$abortController === localAbort) $2c48c7577059a1a6$var$abortController = null;
    }
}
/**
 * Aborts the current SSE connection.
 * Safe to call when already disconnected.
 */ function $2c48c7577059a1a6$var$closeConnection() {
    if ($2c48c7577059a1a6$var$abortController) {
        $2c48c7577059a1a6$var$abortController.abort();
        $2c48c7577059a1a6$var$abortController = null;
    }
}
/**
 * Binds a `visibilitychange` listener on the document.
 * - Tab hidden  → close connection
 * - Tab visible → re-open connection (reuses stored serviceRef)
 *
 * Binding is done once per subscriber session (first subscriber triggers it).
 */ function $2c48c7577059a1a6$var$bindVisibility() {
    if ($2c48c7577059a1a6$var$visibilityUnbind) // Already bound — nothing to do
    return;
    const doc = (0, $hTKp4.getDocument)();
    if (!doc) return;
    $2c48c7577059a1a6$var$visibilityUnbind = (0, $fFa3V.bind)(doc, {
        type: 'visibilitychange',
        listener: ()=>{
            if (doc.hidden) $2c48c7577059a1a6$var$closeConnection();
            else // Re-open connection when tab becomes visible again
            $2c48c7577059a1a6$var$openConnection();
        }
    });
}
/**
 * Removes the `visibilitychange` listener.
 * Called when the last subscriber unsubscribes.
 */ function $2c48c7577059a1a6$var$unbindVisibility() {
    $2c48c7577059a1a6$var$visibilityUnbind?.();
    $2c48c7577059a1a6$var$visibilityUnbind = null;
}
function $2c48c7577059a1a6$export$285816b4ea71cce1(getService, onEvent) {
    $2c48c7577059a1a6$var$subscribers.add(onEvent);
    if ($2c48c7577059a1a6$var$subscribers.size === 1) {
        // First subscriber — resolve service, open connection, bind visibility
        $2c48c7577059a1a6$var$serviceRef = getService();
        $2c48c7577059a1a6$var$bindVisibility();
        // Only open connection if tab is currently visible
        const doc = (0, $hTKp4.getDocument)();
        if (!doc || !doc.hidden) $2c48c7577059a1a6$var$openConnection();
    }
    return function unsubscribe() {
        $2c48c7577059a1a6$var$subscribers.delete(onEvent);
        if ($2c48c7577059a1a6$var$subscribers.size === 0) {
            // Last subscriber left — tear everything down
            $2c48c7577059a1a6$var$closeConnection();
            $2c48c7577059a1a6$var$unbindVisibility();
            $2c48c7577059a1a6$var$serviceRef = null;
        }
    };
}


// ─── API status → progress state mapping ──────────────────────────────────────
const $8d688fc2641b04e9$var$API_STATUS_TO_PROGRESS_STATE = {
    DRAFT: 'Draft',
    QUEUED: 'Queued',
    RUNNING: 'Running',
    AWAITING_DISAMBIGUATION: 'AwaitingDisambiguation',
    AWAITING_PLAN_CONFIRMATION: 'AwaitingPlanConfirmation',
    AWAITING_ACTION_CONFIRMATION: 'AwaitingActionConfirmation',
    COMPLETED: 'Completed',
    FAILED: 'Failed',
    CANCELLED: 'Cancelled'
};
const $8d688fc2641b04e9$export$f0ca788f58c1a6a9 = (status)=>$8d688fc2641b04e9$var$API_STATUS_TO_PROGRESS_STATE[status];
const $8d688fc2641b04e9$export$d5ce4d18fe97a26a = (existing, incoming)=>{
    if (!incoming || incoming.length === 0) return existing ?? null;
    if (!existing || existing.length === 0) return incoming;
    const toMs = (iso)=>new Date(iso).getTime();
    const incomingRanges = incoming.map((seg)=>({
            start: toMs(seg.startedAt),
            end: seg.endedAt ? toMs(seg.endedAt) : Date.now()
        }));
    const overlaps = (seg)=>{
        const start = toMs(seg.startedAt);
        const end = seg.endedAt ? toMs(seg.endedAt) : Date.now();
        return incomingRanges.some((r)=>start < r.end && end > r.start);
    };
    const retained = existing.filter((seg)=>!overlaps(seg));
    const merged = [
        ...retained,
        ...incoming
    ];
    return merged.sort((a, b)=>toMs(a.startedAt) - toMs(b.startedAt));
};


const $96184017db79a818$var$initialState = {
    tasksByTaskId: new Map(),
    activeConversationId: null,
    activeConversationLastAgentMessageId: null,
    activeConversationStatus: null,
    sseSubscriberCount: 0,
    sseConnected: false
};
// ─── Terminal status constants ────────────────────────────────────────────────
const $96184017db79a818$var$TERMINAL_STATUSES = new Set([
    'COMPLETED',
    'FAILED',
    'CANCELLED'
]);
const $96184017db79a818$var$TERMINAL_PROGRESS_STATES = new Set([
    'Completed',
    'Failed',
    'Cancelled'
]);
const $96184017db79a818$var$isTerminalStatus = (status)=>$96184017db79a818$var$TERMINAL_STATUSES.has(status);
const $96184017db79a818$var$isTerminalProgressState = (state)=>$96184017db79a818$var$TERMINAL_PROGRESS_STATES.has(state);
// ─── Status mapping ───────────────────────────────────────────────────────────
// Sourced from the shared `tasks-shared/task-helpers` module.
// ─── Merge helpers ────────────────────────────────────────────────────────────
/**
 * Returns true if `incoming` should overwrite `existing` for the same taskId.
 *
 * Monotonic rules:
 *   1. No existing → always accept incoming.
 *   2. Existing is terminal → only accept a strictly newer terminal update.
 *   3. Otherwise → accept if incoming.updated_at >= existing.updated_at.
 */ function $96184017db79a818$var$shouldOverwrite(existing, incomingUpdatedAt, incomingStatus) {
    if (!existing) return true;
    if ($96184017db79a818$var$isTerminalStatus(existing.rawStatus)) return $96184017db79a818$var$isTerminalStatus(incomingStatus) && incomingUpdatedAt > existing.updatedAt;
    return incomingUpdatedAt >= existing.updatedAt;
}
function $96184017db79a818$export$609ffd14cb121e86(raw) {
    if (!raw) return null;
    try {
        return Object.values(raw).map((value)=>{
            const parsed = JSON.parse(value);
            return {
                startedAt: parsed.startedAt,
                ...parsed.endedAt ? {
                    endedAt: parsed.endedAt
                } : {}
            };
        });
    } catch  {
        return null;
    }
}
function $96184017db79a818$export$27c41772233f8b90(raw) {
    if (!raw) return undefined;
    try {
        const todos = Object.values(raw).map((value)=>{
            const parsed = JSON.parse(value);
            return {
                id: parsed.id,
                content: parsed.content,
                status: parsed.status,
                priority: parsed.priority,
                active_form: parsed.activeForm ?? parsed.active_form
            };
        });
        return {
            todos: todos
        };
    } catch  {
        return undefined;
    }
}
// ─── Module-level SSE deduplication ──────────────────────────────────────────
/**
 * Reference-equality dedup tracker. Since subscribeToTasksSSE fans the same
 * event object reference to every subscriber, we track the last ingested
 * reference to avoid writing to the store N times for N mounted subscribers.
 */ let $96184017db79a818$var$lastIngestedSSEEvent = null;
const $96184017db79a818$var$store = (0, $1P1Tu.createStore)({
    name: 'tasks',
    initialState: $96184017db79a818$var$initialState,
    actions: {
        // ─── SSE Lifecycle ────────────────────────────────────────────────────
        mountSSESubscriber: (getService)=>({ getState: getState, setState: setState })=>{
                const { sseSubscriberCount: sseSubscriberCount } = getState();
                const newCount = sseSubscriberCount + 1;
                setState({
                    sseSubscriberCount: newCount
                });
                if (newCount === 1) {
                    // First subscriber — open SSE connection via existing ref-counted manager.
                    // The module-level subscribeToTasksSSE handles tab-visibility and reconnect.
                    const unsubscribe = (0, $2c48c7577059a1a6$export$285816b4ea71cce1)(getService, (event, eventType)=>{
                        // Deduplicate store ingestion across multiple mounted subscribers
                        if ($96184017db79a818$var$lastIngestedSSEEvent?.event !== event) {
                            (0, $4HDYO.defaultRegistry).getStore($96184017db79a818$var$store).actions.ingestTasksSSEEvent(event, eventType);
                            $96184017db79a818$var$lastIngestedSSEEvent = {
                                event: event,
                                eventType: eventType
                            };
                        }
                    });
                    // Store the unsubscribe fn at module level so unmountSSESubscriber can call it
                    $96184017db79a818$var$sseUnsubscribe = unsubscribe;
                }
            },
        unmountSSESubscriber: ()=>({ getState: getState, setState: setState })=>{
                const { sseSubscriberCount: sseSubscriberCount } = getState();
                const newCount = Math.max(0, sseSubscriberCount - 1);
                setState({
                    sseSubscriberCount: newCount
                });
                if (newCount === 0 && $96184017db79a818$var$sseUnsubscribe) {
                    $96184017db79a818$var$sseUnsubscribe();
                    $96184017db79a818$var$sseUnsubscribe = null;
                    $96184017db79a818$var$lastIngestedSSEEvent = null;
                }
            },
        _setSSEConnected: (connected)=>({ setState: setState })=>{
                setState({
                    sseConnected: connected
                });
            },
        // ─── Active Conversation Context ──────────────────────────────────────
        setActiveConversationContext: ({ conversationId: conversationId, lastAgentMessageId: lastAgentMessageId, status: status })=>({ setState: setState })=>{
                setState({
                    activeConversationId: conversationId,
                    activeConversationLastAgentMessageId: lastAgentMessageId,
                    activeConversationStatus: status
                });
            },
        // ─── SSE Ingestion ────────────────────────────────────────────────────
        ingestTasksSSEEvent: (event, eventType)=>({ getState: getState, setState: setState })=>{
                const state = getState();
                if (eventType === 'connected') {
                    setState({
                        sseConnected: true
                    });
                    return;
                }
                if (eventType === 'task_snapshot') {
                    const snapshot = event;
                    const tasks = snapshot.tasks ?? [];
                    if (tasks.length === 0) return;
                    const next = new Map(state.tasksByTaskId);
                    let changed = false;
                    for (const incoming of tasks){
                        const existing = next.get(incoming.task_id);
                        if (!$96184017db79a818$var$shouldOverwrite(existing, incoming.updated_at, incoming.status)) continue;
                        next.set(incoming.task_id, $96184017db79a818$var$mergeSSEUpdateIntoTask(existing, incoming));
                        changed = true;
                    }
                    if (changed) setState({
                        tasksByTaskId: next
                    });
                    return;
                }
                if (eventType === 'task_status') {
                    const update = event;
                    const conversationId = update.conversation_id ?? null;
                    // Guard A: reject if the owning conversation is actively streaming
                    // (CHAT_STORE_STATUS.idle = 0; non-idle means streaming/loading)
                    if (conversationId && conversationId === state.activeConversationId && state.activeConversationStatus !== null && state.activeConversationStatus !== 0 // CHAT_STORE_STATUS.idle
                    ) return;
                    // Guard B: reject stale SSE reconnect replays by currentMessageId mismatch
                    if (conversationId && conversationId === state.activeConversationId && update.current_message_id && state.activeConversationLastAgentMessageId && update.current_message_id !== state.activeConversationLastAgentMessageId) return;
                    const existing = state.tasksByTaskId.get(update.task_id);
                    const progressState = (0, $8d688fc2641b04e9$export$f0ca788f58c1a6a9)(update.status);
                    // Skip if already applied (same state from stream)
                    if (existing && existing.progressState === progressState && existing.currentMessageId === (update.current_message_id ?? null) && existing.updatedAt >= update.updated_at) return;
                    if (!$96184017db79a818$var$shouldOverwrite(existing, update.updated_at, update.status)) return;
                    const next = new Map(state.tasksByTaskId);
                    if (!existing) // Create-if-missing: task arrived via SSE before stream
                    next.set(update.task_id, $96184017db79a818$var$mergeSSEUpdateIntoTask(undefined, update));
                    else next.set(update.task_id, $96184017db79a818$var$mergeSSEUpdateIntoTask(existing, update));
                    setState({
                        tasksByTaskId: next
                    });
                    return;
                }
                if (eventType === 'task_todo_update') {
                    const update = event;
                    const conversationId = update.conversation_id ?? null;
                    // Guard A (parity with task_status): reject if the owning conversation
                    // is actively streaming. The in-flight stream will deliver a fresher
                    // todo snapshot momentarily.
                    if (conversationId && conversationId === state.activeConversationId && state.activeConversationStatus !== null && state.activeConversationStatus !== 0 // CHAT_STORE_STATUS.idle
                    ) return;
                    // Guard B (parity with task_status): reject stale SSE reconnect
                    // replays by currentMessageId mismatch.
                    if (conversationId && conversationId === state.activeConversationId && update.current_message_id && state.activeConversationLastAgentMessageId && update.current_message_id !== state.activeConversationLastAgentMessageId) return;
                    const existing = state.tasksByTaskId.get(update.task_id);
                    if (!existing || $96184017db79a818$var$isTerminalProgressState(existing.progressState)) return;
                    const todoSnapshot = $96184017db79a818$export$27c41772233f8b90(update.todo_list ?? undefined);
                    if (!todoSnapshot) return;
                    const next = new Map(state.tasksByTaskId);
                    next.set(update.task_id, {
                        ...existing,
                        todoSnapshot: todoSnapshot
                    });
                    setState({
                        tasksByTaskId: next
                    });
                }
            },
        // ─── Task Mutations from Stream ───────────────────────────────────────
        createTaskFromStream: ({ taskId: taskId, conversationId: conversationId, title: title, updatedAt: updatedAt, messageId: messageId, currentMessageId: currentMessageId, createdAt: createdAt, startedAt: startedAt, completedAt: completedAt, executionSegments: executionSegments })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                // Idempotency guard — skip if task already exists
                if (tasksByTaskId.has(taskId)) return;
                const newTask = {
                    taskId: taskId,
                    conversationId: conversationId,
                    agentId: null,
                    triggerType: null,
                    progressState: 'Draft',
                    rawStatus: 'DRAFT',
                    title: title,
                    plan: null,
                    resultSummary: null,
                    errorMessage: null,
                    todoSnapshot: undefined,
                    currentStep: null,
                    executionSegments: executionSegments ?? null,
                    messageId: messageId ?? null,
                    completionMessageId: null,
                    currentMessageId: currentMessageId ?? null,
                    seekingCompletedAck: false,
                    createdAt: createdAt ?? null,
                    startedAt: startedAt ?? null,
                    // Prefer the supplied updatedAt, then fall back to createdAt so the
                    // initial monotonic comparison in `shouldOverwrite` doesn't reject a
                    // real BE update that arrives with an older timestamp than `Date.now()`.
                    updatedAt: updatedAt ?? createdAt ?? new Date().toISOString(),
                    completedAt: completedAt ?? null
                };
                const next = new Map(tasksByTaskId);
                next.set(taskId, newTask);
                setState({
                    tasksByTaskId: next
                });
            },
        setTaskProgressState: ({ taskId: taskId, conversationId: conversationId, progressState: progressState, title: title, seekingCompletedAck: seekingCompletedAck, messageId: messageId, completionMessageId: completionMessageId, updatedAt: updatedAt, currentMessageId: currentMessageId, createdAt: createdAt, startedAt: startedAt, completedAt: completedAt, executionSegments: executionSegments, currentStep: currentStep, resultSummary: resultSummary, errorMessage: errorMessage })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const resolvedTaskId = taskId ?? (conversationId ? $96184017db79a818$var$findActiveTaskIdForConversation(tasksByTaskId, conversationId) : undefined);
                // Auto-create when there is no active task yet for the conversation.
                // Allows the chat-store to drive optimistic state changes
                // (e.g. AwaitingPlanConfirmation) before
                // the BE has issued a real task_id.
                if (!resolvedTaskId) {
                    if (!conversationId) return;
                    const localTaskId = `task-${Date.now()}`;
                    const newTask = {
                        taskId: localTaskId,
                        conversationId: conversationId,
                        agentId: null,
                        triggerType: null,
                        progressState: progressState,
                        rawStatus: $96184017db79a818$var$progressStateToApiStatus(progressState),
                        title: title ?? '',
                        plan: null,
                        resultSummary: resultSummary ?? null,
                        errorMessage: errorMessage ?? null,
                        todoSnapshot: undefined,
                        currentStep: currentStep ?? null,
                        executionSegments: executionSegments ?? null,
                        messageId: messageId ?? null,
                        completionMessageId: completionMessageId ?? null,
                        currentMessageId: currentMessageId ?? null,
                        seekingCompletedAck: seekingCompletedAck ?? false,
                        createdAt: createdAt ?? new Date().toISOString(),
                        startedAt: startedAt ?? null,
                        updatedAt: updatedAt ?? createdAt ?? new Date().toISOString(),
                        completedAt: completedAt ?? null
                    };
                    const next = new Map(tasksByTaskId);
                    next.set(localTaskId, newTask);
                    setState({
                        tasksByTaskId: next
                    });
                    return;
                }
                const existing = tasksByTaskId.get(resolvedTaskId);
                if (!existing) return;
                // Terminal state protection
                if ($96184017db79a818$var$isTerminalProgressState(existing.progressState)) return;
                const merged = {
                    ...existing,
                    progressState: progressState,
                    rawStatus: $96184017db79a818$var$progressStateToApiStatus(progressState),
                    ...title !== undefined ? {
                        title: title
                    } : {},
                    ...seekingCompletedAck !== undefined ? {
                        seekingCompletedAck: seekingCompletedAck
                    } : {},
                    ...messageId !== undefined ? {
                        messageId: messageId
                    } : {},
                    ...completionMessageId !== undefined ? {
                        completionMessageId: completionMessageId
                    } : {},
                    ...updatedAt !== undefined ? {
                        updatedAt: updatedAt
                    } : {},
                    ...currentMessageId !== undefined ? {
                        currentMessageId: currentMessageId
                    } : {},
                    ...createdAt !== undefined ? {
                        createdAt: createdAt
                    } : {},
                    ...startedAt !== undefined ? {
                        startedAt: startedAt
                    } : {},
                    ...completedAt !== undefined ? {
                        completedAt: completedAt
                    } : {},
                    ...executionSegments !== undefined ? {
                        executionSegments: (0, $8d688fc2641b04e9$export$d5ce4d18fe97a26a)(existing.executionSegments, executionSegments)
                    } : {},
                    // `null` is meaningful — explicit clear; `undefined` leaves field unchanged.
                    ...currentStep !== undefined ? {
                        currentStep: currentStep
                    } : {},
                    ...resultSummary !== undefined ? {
                        resultSummary: resultSummary
                    } : {},
                    ...errorMessage !== undefined ? {
                        errorMessage: errorMessage
                    } : {}
                };
                const next = new Map(tasksByTaskId);
                next.set(resolvedTaskId, merged);
                setState({
                    tasksByTaskId: next
                });
            },
        setTaskTodoSnapshot: ({ taskId: taskId, conversationId: conversationId, todoSnapshot: todoSnapshot })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const resolvedTaskId = taskId ?? (conversationId ? $96184017db79a818$var$findActiveTaskIdForConversation(tasksByTaskId, conversationId) : undefined);
                if (!resolvedTaskId) return;
                const existing = tasksByTaskId.get(resolvedTaskId);
                if (!existing || $96184017db79a818$var$isTerminalProgressState(existing.progressState)) return;
                const next = new Map(tasksByTaskId);
                next.set(resolvedTaskId, {
                    ...existing,
                    todoSnapshot: todoSnapshot
                });
                setState({
                    tasksByTaskId: next
                });
            },
        ackTaskCompleted: ({ taskId: taskId })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const existing = tasksByTaskId.get(taskId);
                if (!existing) return;
                const next = new Map(tasksByTaskId);
                next.set(taskId, {
                    ...existing,
                    seekingCompletedAck: false
                });
                setState({
                    tasksByTaskId: next
                });
            },
        clearTask: ({ taskId: taskId })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                if (!tasksByTaskId.has(taskId)) return;
                const next = new Map(tasksByTaskId);
                next.delete(taskId);
                setState({
                    tasksByTaskId: next
                });
            },
        // ─── REST Merge ───────────────────────────────────────────────────────
        mergeConversationChannelTasks: (remoteTasks)=>({ getState: getState, setState: setState })=>{
                if (!remoteTasks || remoteTasks.length === 0) return;
                // Sort ascending by created_at (oldest first, newest last = active)
                const sorted = [
                    ...remoteTasks
                ].sort((a, b)=>new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
                const { tasksByTaskId: tasksByTaskId } = getState();
                const next = new Map(tasksByTaskId);
                let changed = false;
                for (const remote of sorted){
                    const existing = next.get(remote.task_id);
                    const merged = $96184017db79a818$var$mergeChannelTaskIntoUnified(existing, remote);
                    next.set(remote.task_id, merged);
                    changed = true;
                }
                if (changed) setState({
                    tasksByTaskId: next
                });
            },
        mergeAllTasksSnapshot: (tasks)=>({ getState: getState, setState: setState })=>{
                if (!tasks) return;
                const { tasksByTaskId: tasksByTaskId } = getState();
                const next = new Map(tasksByTaskId);
                let changed = false;
                // 1. Upsert all tasks from the snapshot (REST is authoritative for tasks it returns).
                const snapshotIds = new Set();
                for (const incoming of tasks){
                    snapshotIds.add(incoming.task_id);
                    const existing = next.get(incoming.task_id);
                    if (!$96184017db79a818$var$shouldOverwrite(existing, incoming.updated_at, incoming.status)) continue;
                    next.set(incoming.task_id, $96184017db79a818$var$mergeSSEUpdateIntoTask(existing, incoming));
                    changed = true;
                }
                // 2. Reconcile: remove any task absent from the REST snapshot **only** when
                //    it's already in a terminal state. Non-terminal (in-flight) tasks may
                //    legitimately be present locally but not yet visible in REST (race), so
                //    we preserve them and rely on SSE to deliver their final state.
                for (const [taskId, task] of tasksByTaskId){
                    if (snapshotIds.has(taskId)) continue;
                    if ($96184017db79a818$var$isTerminalProgressState(task.progressState)) {
                        next.delete(taskId);
                        changed = true;
                    }
                }
                if (changed) setState({
                    tasksByTaskId: next
                });
            },
        // ─── Optimistic mutations from UI (tasks-list, etc.) ─────────────────
        /**
		 * Removes a single task by taskId. Used for optimistic delete from
		 * the tasks-list screen before the API call resolves.
		 */ removeTaskById: (taskId)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                if (!tasksByTaskId.has(taskId)) return;
                const next = new Map(tasksByTaskId);
                next.delete(taskId);
                setState({
                    tasksByTaskId: next
                });
            },
        /**
		 * Optimistically marks a task as Cancelled (terminal state). Used by the
		 * tasks-list stop action before the API call resolves.
		 */ markTaskCancelled: (taskId)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const existing = tasksByTaskId.get(taskId);
                if (!existing) return;
                const now = new Date().toISOString();
                const next = new Map(tasksByTaskId);
                next.set(taskId, {
                    ...existing,
                    progressState: 'Cancelled',
                    rawStatus: 'CANCELLED',
                    updatedAt: now,
                    completedAt: existing.completedAt ?? now
                });
                setState({
                    tasksByTaskId: next
                });
            },
        /**
		 * Optimistically updates a task's title. Used by the tasks-list rename
		 * action before the API call resolves.
		 */ setTaskTitle: (taskId, title)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const existing = tasksByTaskId.get(taskId);
                if (!existing || existing.title === title) return;
                const next = new Map(tasksByTaskId);
                next.set(taskId, {
                    ...existing,
                    title: title,
                    updatedAt: new Date().toISOString()
                });
                setState({
                    tasksByTaskId: next
                });
            },
        // ─── Conversation cleanup ─────────────────────────────────────────────
        removeTasksForConversation: (conversationId)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const next = new Map(tasksByTaskId);
                let changed = false;
                for (const [taskId, task] of tasksByTaskId)if (task.conversationId === conversationId) {
                    next.delete(taskId);
                    changed = true;
                }
                if (changed) setState({
                    tasksByTaskId: next
                });
            },
        // Read-only accessor — used by chat-store actions that need the latest
        // active task synchronously without going through React.
        getActiveTaskForConversation: (conversationId)=>({ getState: getState })=>{
                return $96184017db79a818$var$findActiveTaskForConversation(getState().tasksByTaskId, conversationId);
            },
        // Read-only accessor — single-task lookup by id. Same imperative shape as
        // `getActiveTaskForConversation` so chat-store callers don't need any
        // React state plumbing.
        getTaskById: (taskId)=>({ getState: getState })=>{
                return getState().tasksByTaskId.get(taskId);
            }
    }
});
// ─── Module-level SSE unsubscribe reference ───────────────────────────────────
// Stored outside the store state (not serializable, not reactive).
let $96184017db79a818$var$sseUnsubscribe = null;
/**
 * Finds the active task for a conversation.
 * Prefers the most recent **non-terminal** task; falls back to the most recent
 * task overall if all tasks for the conversation are in terminal state.
 *
 * "Active" semantics: a conversation has at most one in-flight task at any
 * point in time. Older tasks (terminal) remain associated with the conversation
 * for history but should not be treated as the current active task.
 */ /**
 * Internal selector helper. Use the `useActiveTaskForConversation` /
 * `useActiveTasksForConversations` hooks (React) or the
 * `getActiveTaskForConversation` action (non-React) instead.
 */ function $96184017db79a818$var$findActiveTaskForConversation(tasksByTaskId, conversationId) {
    let latestNonTerminal;
    let latestAny;
    for (const task of tasksByTaskId.values()){
        if (task.conversationId !== conversationId) continue;
        if (!latestAny || (task.createdAt ?? '') > (latestAny.createdAt ?? '')) latestAny = task;
        if (!$96184017db79a818$var$isTerminalProgressState(task.progressState)) {
            if (!latestNonTerminal || (task.createdAt ?? '') > (latestNonTerminal.createdAt ?? '')) latestNonTerminal = task;
        }
    }
    return latestNonTerminal ?? latestAny;
}
function $96184017db79a818$var$findActiveTaskIdForConversation(tasksByTaskId, conversationId) {
    return $96184017db79a818$var$findActiveTaskForConversation(tasksByTaskId, conversationId)?.taskId;
}
// ─── Internal merge helpers ───────────────────────────────────────────────────
function $96184017db79a818$var$progressStateToApiStatus(state) {
    const map = {
        Draft: 'DRAFT',
        Queued: 'QUEUED',
        Running: 'RUNNING',
        AwaitingDisambiguation: 'AWAITING_DISAMBIGUATION',
        AwaitingPlanConfirmation: 'AWAITING_PLAN_CONFIRMATION',
        AwaitingActionConfirmation: 'AWAITING_ACTION_CONFIRMATION',
        Completed: 'COMPLETED',
        Failed: 'FAILED',
        Cancelled: 'CANCELLED'
    };
    return map[state];
}
function $96184017db79a818$var$mergeSSEUpdateIntoTask(existing, incoming) {
    const progressState = (0, $8d688fc2641b04e9$export$f0ca788f58c1a6a9)(incoming.status);
    // `current_step` only exists on the SSE shape; REST snapshots don't carry it.
    const incomingCurrentStep = 'current_step' in incoming ? incoming.current_step ?? null : existing?.currentStep ?? null;
    // `agent_id` and `trigger_type` are on the REST shape but not on every SSE update.
    const incomingAgentId = 'agent_id' in incoming ? incoming.agent_id : existing?.agentId ?? null;
    const incomingTriggerType = 'trigger_type' in incoming ? incoming.trigger_type : existing?.triggerType ?? null;
    const incomingPlan = 'plan' in incoming ? incoming.plan ?? null : existing?.plan ?? null;
    const incomingCompletedAt = 'completed_at' in incoming ? incoming.completed_at ?? existing?.completedAt ?? null : existing?.completedAt ?? null;
    return {
        taskId: incoming.task_id,
        conversationId: incoming.conversation_id ?? existing?.conversationId ?? null,
        agentId: incomingAgentId,
        triggerType: incomingTriggerType,
        progressState: progressState,
        rawStatus: incoming.status,
        title: incoming.title,
        plan: incomingPlan,
        resultSummary: incoming.result_summary,
        errorMessage: incoming.error_message,
        todoSnapshot: existing?.todoSnapshot,
        currentStep: incomingCurrentStep,
        executionSegments: $96184017db79a818$export$609ffd14cb121e86(incoming.execution_segments ?? undefined),
        messageId: incoming.message_id ?? existing?.messageId ?? null,
        completionMessageId: incoming.completion_message_id ?? existing?.completionMessageId ?? null,
        currentMessageId: incoming.current_message_id ?? existing?.currentMessageId ?? null,
        // Local-only UI state: preserve from existing
        seekingCompletedAck: existing?.seekingCompletedAck ?? false,
        createdAt: incoming.created_at ?? existing?.createdAt ?? null,
        startedAt: incoming.started_at ?? existing?.startedAt ?? null,
        updatedAt: incoming.updated_at,
        completedAt: incomingCompletedAt
    };
}
function $96184017db79a818$var$mergeChannelTaskIntoUnified(existing, remote) {
    const progressState = (0, $8d688fc2641b04e9$export$f0ca788f58c1a6a9)(remote.status);
    const remoteExecutionSegments = $96184017db79a818$export$609ffd14cb121e86(remote.execution_segments ?? undefined);
    const remoteTodoSnapshot = $96184017db79a818$export$27c41772233f8b90(remote.todo_list ?? undefined);
    // Local wins for progressState and todoSnapshot when local is strictly newer
    const localIsNewer = existing?.updatedAt && existing.updatedAt > remote.updated_at;
    return {
        taskId: remote.task_id,
        conversationId: remote.conversation_id,
        agentId: remote.agent_id,
        triggerType: remote.trigger_type,
        progressState: localIsNewer ? existing?.progressState ?? progressState : progressState,
        rawStatus: localIsNewer ? existing?.rawStatus ?? remote.status : remote.status,
        title: remote.title,
        plan: remote.plan,
        resultSummary: remote.result_summary,
        errorMessage: remote.error_message,
        todoSnapshot: localIsNewer ? existing?.todoSnapshot : remoteTodoSnapshot ?? existing?.todoSnapshot,
        currentStep: existing?.currentStep ?? null,
        executionSegments: (0, $8d688fc2641b04e9$export$d5ce4d18fe97a26a)(existing?.executionSegments, remoteExecutionSegments),
        messageId: remote.message_id,
        completionMessageId: remote.completion_message_id,
        currentMessageId: remote.current_message_id,
        // Local-only: seekingCompletedAck NEVER overwritten by REST
        seekingCompletedAck: existing?.seekingCompletedAck ?? false,
        createdAt: remote.created_at,
        startedAt: remote.started_at,
        updatedAt: remote.updated_at,
        completedAt: remote.completed_at
    };
}
const $96184017db79a818$export$c2ad39067c031726 = (0, $9zUhf.createHook)($96184017db79a818$var$store);
const $96184017db79a818$export$e398e9c82ae1ea3e = (0, $9zUhf.createActionsHook)($96184017db79a818$var$store);
const $96184017db79a818$export$4a89b1af24c66aec = (0, $9zUhf.createHook)($96184017db79a818$var$store, {
    selector: (state, conversationId)=>{
        if (!conversationId) return undefined;
        return $96184017db79a818$var$findActiveTaskForConversation(state.tasksByTaskId, conversationId);
    }
});
const $96184017db79a818$export$37ef8d89dd7c4479 = (0, $9zUhf.createHook)($96184017db79a818$var$store, {
    selector: (state)=>Array.from(state.tasksByTaskId.values())
});
const $96184017db79a818$export$86ae895223d55438 = (0, $9zUhf.createHook)($96184017db79a818$var$store, {
    selector: (state, conversationIds)=>{
        const result = new Map();
        for (const id of conversationIds)result.set(id, $96184017db79a818$var$findActiveTaskForConversation(state.tasksByTaskId, id));
        return result;
    }
});
const $96184017db79a818$export$8adc54d746bc9a7f = (0, $9zUhf.createHook)($96184017db79a818$var$store, {
    selector: (state, taskId)=>state.tasksByTaskId.get(taskId)
});
const $96184017db79a818$export$2a84773e9f93301a = (0, $9zUhf.createHook)($96184017db79a818$var$store, {
    selector: (state)=>state.sseConnected
});
const $96184017db79a818$export$f68962e2c5dae5a0 = (task)=>({
        task_id: task.taskId,
        title: task.title,
        status: task.rawStatus,
        current_step: task.currentStep,
        result_summary: task.resultSummary,
        error_message: task.errorMessage,
        conversation_id: task.conversationId,
        message_id: task.messageId,
        completion_message_id: task.completionMessageId,
        current_message_id: task.currentMessageId,
        created_at: task.createdAt,
        started_at: task.startedAt,
        updated_at: task.updatedAt,
        // Preserve raw shape for execution_segments and todo_list (Record<string,string>).
        // We do not have the raw representation any more after parsing, so leave as null.
        execution_segments: null,
        todo_list: null
    });
module.exports["parseExecutionSegments"] = $96184017db79a818$export$609ffd14cb121e86;
module.exports["useTasksStoreActions"] = $96184017db79a818$export$e398e9c82ae1ea3e;
module.exports["useActiveTaskForConversation"] = $96184017db79a818$export$4a89b1af24c66aec;
module.exports["useAllTasks"] = $96184017db79a818$export$37ef8d89dd7c4479;
module.exports["useActiveTasksForConversations"] = $96184017db79a818$export$86ae895223d55438;
module.exports["unifiedTaskToApiSSE"] = $96184017db79a818$export$f68962e2c5dae5a0;

});

parcelRegister("5vtU3", function(module, exports) {
//list from https://hello.atlassian.net/wiki/spaces/rocx/pages/6474505700/Knowledge+Sources+list+connectors
const $f7a6f138216459ea$var$products1PListKnowleage = [
    'Atlassian Support Docs',
    'Confluence Data Centre',
    'Jira Data Center'
];
// platform/packages/search/search-ai/src/ai-answer-dialog/analytics-helpers.tsx
// list from https://atlassian.slack.com/archives/C08VA0N40A2/p1749172242825969?thread_ts=1749088363.059769&cid=C08VA0N40A2
const $f7a6f138216459ea$var$products1PList = new Set([
    'Assets',
    'Atlas',
    'Confluence',
    'Atlassian Analytics',
    'Atlassian Cloud',
    'Automation for Jira',
    'Bamboo',
    'Bitbucket',
    'Compass',
    'Goals',
    'Jira',
    'Jira Product Discovery',
    'Jira Service Management',
    'Jira Software',
    'Jira Work Management',
    'Jira Align',
    'Migration',
    'Loom',
    'Opsgenie',
    'Platform Experiences',
    'Projects',
    'Rovo',
    'Statuspage',
    'Trello',
    'webSearch',
    'web-page',
    'Fisheye and Crucible',
    'Crowd',
    'Sourcetree',
    'Unknown',
    'Focus',
    'file-upload',
    'Advanced Roadmaps For Jira',
    'Questions for Confluence',
    'csm',
    'Dewey Support',
    'Dewey JAC Support',
    'Help Aggregator',
    ...$f7a6f138216459ea$var$products1PListKnowleage
]);
const $f7a6f138216459ea$export$2777e093c10fa93d = (productName)=>!$f7a6f138216459ea$var$products1PList.has(productName);
module.exports["is3pApp"] = $f7a6f138216459ea$export$2777e093c10fa93d;

});

parcelRegister("ajfvU", function(module, exports) {
/* eslint-disable @atlaskit/platform/no-preconditioning -- Existing chat-store actions gate feature behavior from runtime flags. */ 
var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $cbc8g = parcelRequire("cbc8g");


var $6FQwA = parcelRequire("6FQwA");


var $4pEXC = parcelRequire("4pEXC");


var $16lEl = parcelRequire("16lEl");


var $1yaYZ = parcelRequire("1yaYZ");


var $8IKbl = parcelRequire("8IKbl");


var $5MO1q = parcelRequire("5MO1q");


var $ljUdP = parcelRequire("ljUdP");


var $flpNp = parcelRequire("flpNp");


var $99vXA = parcelRequire("99vXA");


var $2CHXX = parcelRequire("2CHXX");




const $ce0ec8f0bfa0c691$export$fc6a9cdad8ea90e0 = (agentId)=>{
    if (!agentId) return undefined;
    return {
        agent_id: agentId,
        agent_named_id: agentId,
        agent_name: '',
        creator_type: ''
    };
};
const $ce0ec8f0bfa0c691$export$9e56ee965c896858 = ({ conversation: conversation, fallbackAgentId: fallbackAgentId })=>{
    const storedConversationAgentId = conversation?.agent?.agent_id || undefined;
    return storedConversationAgentId && (0, $dh538.fg)('rovo_chat_agent_selection') ? storedConversationAgentId : fallbackAgentId;
};



var $bPHr8 = parcelRequire("bPHr8");


var $cBi7Q = parcelRequire("cBi7Q");


var $5MDfE = parcelRequire("5MDfE");


var $1K4cm = parcelRequire("1K4cm");

const $a37fef51f047b95d$export$bac56f3fc527f04b = (min, max)=>{
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
};





const $e81fd5fde2bdb998$export$c9b02612b90eeb6c = (agentId)=>{
    if (!agentId) return false;
    return agentId !== (0, $cBi7Q.DEFAULT_AGENT_NAMED_ID) && agentId !== (0, $cBi7Q.DEFAULT_AGENT_UUID);
};


const $af163ae683530e0f$var$UNKNOWN_TOOL_ID = 'UNKNOWN_TOOL_ID';
const $af163ae683530e0f$var$MCP_TOOL_SOURCE = 'MCP_TOOL';
/**
 * MCP tool keys are user-generated content and must not leak into analytics
 * payloads. For all other sources (including a missing `toolSource`) we
 * forward the raw key.
 */ const $af163ae683530e0f$var$redactToolKeyForPii = ({ toolDefinitionSource: toolDefinitionSource, key: key })=>toolDefinitionSource === $af163ae683530e0f$var$MCP_TOOL_SOURCE ? undefined : key;
const $af163ae683530e0f$var$buildBaseToolAttribute = ({ toolId: toolId, toolKey: toolKey, toolDefinitionSource: toolDefinitionSource })=>({
        toolId: toolId ?? $af163ae683530e0f$var$UNKNOWN_TOOL_ID,
        toolKey: $af163ae683530e0f$var$redactToolKeyForPii({
            toolDefinitionSource: toolDefinitionSource,
            key: toolKey
        }),
        toolDefinitionSource: toolDefinitionSource ?? null
    });
const $af163ae683530e0f$export$376e622a1b976e6e = (confirmedTools)=>confirmedTools.tools.map((tool)=>({
            ...$af163ae683530e0f$var$buildBaseToolAttribute({
                toolId: tool.tool_id,
                toolKey: tool.key,
                toolDefinitionSource: tool.tool_source
            }),
            resolutionType: tool.resolution?.type ?? 'UNKNOWN_RESOLUTION_TYPE'
        }));





const $9963cc910aac4af3$export$1afac255ab1e880e = ()=>{
    const lastMessageSentAt = localStorage.getItem((0, $cBi7Q.LS_LAST_MESSAGE_SENT_AT));
    if (!lastMessageSentAt) return null;
    const timestamp = parseInt(lastMessageSentAt);
    if (isNaN(timestamp)) return null;
    return timestamp;
};
const $9963cc910aac4af3$export$589976df4d188aac = (timestamp)=>{
    if (timestamp === null) {
        localStorage.removeItem((0, $cBi7Q.LS_LAST_MESSAGE_SENT_AT));
        return;
    }
    localStorage.setItem((0, $cBi7Q.LS_LAST_MESSAGE_SENT_AT), timestamp.toString());
};



var $iEWar = parcelRequire("iEWar");


var $jJK7o = parcelRequire("jJK7o");

const $4bca5e7215eb7baa$export$89a4ab1dea43d7ee = ({ conversationId: conversationId, taskMessage: taskMessage, messageId: messageId, target: target })=>{
    const executionSegments = (0, $jJK7o.parseExecutionSegments)(taskMessage.execution_segments);
    switch(taskMessage.status){
        case 'DRAFT':
            target.createTaskFromStream({
                conversationId: conversationId,
                taskId: taskMessage.task_id,
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'COMPLETED':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'Completed',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                seekingCompletedAck: true,
                completionMessageId: taskMessage.completion_message_id ?? messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'FAILED':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'Failed',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'CANCELLED':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'Cancelled',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'RUNNING':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'Running',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'AWAITING_ACTION_CONFIRMATION':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'AwaitingActionConfirmation',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        default:
            break;
    }
};
const $4bca5e7215eb7baa$export$6b58e85d865a8eef = (unifiedTasksActions)=>({
        createTaskFromStream: (args)=>unifiedTasksActions.createTaskFromStream(args),
        setTaskProgressState: (args)=>unifiedTasksActions.setTaskProgressState(args)
    });



var $9likX = parcelRequire("9likX");










const $90c63f46323387a6$export$60a662127f30e1e1 = (remoteConversation, localConversation)=>{
    return {
        id: remoteConversation.id,
        // Prioritize API data if present, otherwise use local or generate new
        name: remoteConversation.name ?? localConversation?.name ?? (0, $99vXA.generateConversationName)(),
        timeCreated: remoteConversation.time_created ?? localConversation?.timeCreated,
        lastMessage: remoteConversation.last_message ?? localConversation?.lastMessage ?? undefined,
        lastMessageType: remoteConversation.last_message_type ?? localConversation?.lastMessageType ?? [],
        selectedAgentIds: localConversation?.selectedAgentIds ?? [],
        lastMessageTimestamp: remoteConversation.last_message_timestamp ?? localConversation?.lastMessageTimestamp,
        lastAgentMessageStatus: remoteConversation.last_agent_message_status ?? localConversation?.lastAgentMessageStatus,
        readStatus: remoteConversation.readStatus ?? localConversation?.readStatus,
        tags: remoteConversation.tags ?? localConversation?.tags,
        // Use local state data if it exists (messages, status are maintained locally)
        messages: localConversation?.messages ?? [],
        status: localConversation?.status ?? (0, $bPHr8.CHAT_STORE_STATUS).idle,
        traces: localConversation?.traces ?? [],
        ...localConversation?.sourceAgentId ? {
            sourceAgentId: localConversation.sourceAgentId
        } : {},
        ...localConversation?.sourceId ? {
            sourceId: localConversation.sourceId
        } : {},
        // Preserve runtime abort controller so Stop button works after channels rehydration (e.g. refocus)
        ...localConversation?.storeAbortController != null ? {
            storeAbortController: localConversation.storeAbortController
        } : {},
        ...localConversation?.rovoSpaceId ? {
            rovoSpaceId: localConversation.rovoSpaceId
        } : {},
        // `agent` is optional on ConversationChannel, so the server-sourced channel can
        // omit it. Under rovo_chat_agent_selection the header derives its displayed
        // agent (name/avatar) ONLY from `conversation.agent`, so taking the remote
        // agent verbatim would overwrite a locally-seeded agent with `undefined` and
        // drop a specialist back to default Rovo (e.g. opening an existing chat with a
        // specific agent via URL params, then a channel rehydration on init/refocus).
        // Gate-on therefore falls back to the locally-seeded agent when the remote has
        // none; gate-off keeps the master baseline of taking the remote agent verbatim.
        // Cleanup: drop the gate when launched.
        agent: (0, $dh538.fg)('rovo_chat_agent_selection') ? remoteConversation.agent ?? localConversation?.agent : remoteConversation.agent,
        scopes: remoteConversation.scopes ?? localConversation?.scopes
    };
};


/* eslint-disable @atlaskit/platform/no-preconditioning, @atlaskit/platform/one-value-export-per-file -- no-preconditioning: Existing stream processing gates feature behavior from runtime flags. one-value-export-per-file: This file predates the rule and splitting is out of bounds for this change. */ 



var $5vtU3 = parcelRequire("5vtU3");











var $fFa3V = parcelRequire("fFa3V");

/**
 * Abort-aware sleep that resolves after `ms` or rejects early if the signal is aborted.
 * Falls back to a regular setTimeout when no signal is provided.
 */ const $92b0a6aa5f3cefb4$var$abortableSleep = (ms, signal)=>new Promise((resolve, reject)=>{
        if (signal?.aborted) {
            reject(signal.reason ?? new DOMException('Aborted', 'AbortError'));
            return;
        }
        let cleanup = ()=>{};
        const timer = setTimeout(()=>{
            cleanup();
            resolve();
        }, ms);
        if (signal) {
            const onAbort = ()=>{
                clearTimeout(timer);
                cleanup();
                reject(signal.reason ?? new DOMException('Aborted', 'AbortError'));
            };
            cleanup = (0, $fFa3V.bind)(signal, {
                type: 'abort',
                listener: onAbort,
                options: {
                    once: true
                }
            });
        }
    });
/**
 * Resolves when the browser reports it is online.
 * Returns immediately if already online, otherwise waits for the 'online' event.
 * Rejects if the signal is aborted while waiting.
 * @returns true if it had to wait for the 'online' event, false if already online.
 * Useful to distinguish between "was offline and recovered" vs "was already online".
 */ const $92b0a6aa5f3cefb4$var$waitForOnline = (signal)=>{
    if (typeof navigator === 'undefined' || navigator.onLine) return Promise.resolve(false);
    return new Promise((resolve, reject)=>{
        if (signal?.aborted) {
            reject(signal.reason ?? new DOMException('Aborted', 'AbortError'));
            return;
        }
        const onOnline = ()=>{
            cleanup();
            resolve(true);
        };
        const onAbort = ()=>{
            cleanup();
            reject(signal?.reason ?? new DOMException('Aborted', 'AbortError'));
        };
        const unbindOnline = (0, $fFa3V.bind)(window, {
            type: 'online',
            listener: onOnline,
            options: {
                once: true
            }
        });
        const unbindAbort = signal ? (0, $fFa3V.bind)(signal, {
            type: 'abort',
            listener: onAbort,
            options: {
                once: true
            }
        }) : ()=>{};
        const cleanup = ()=>{
            unbindOnline();
            unbindAbort();
        };
    });
};
const $92b0a6aa5f3cefb4$export$4dfcad98182a1ece = async ({ fn: fn, maxRetries: maxRetries = 3, retryCount: retryCount = 0, delay: delay = 1000, jitter: jitter = false, minDelay: minDelay = 500, pauseWhileOffline: pauseWhileOffline = false, postOnlineDelay: postOnlineDelay = 0, errorFilter: errorFilter, signal: signal, onRetry: onRetry })=>{
    // Mutable counter shared across recursive calls so that resetRetries() can
    // reset it from within fn() without needing to re-enter the call stack.
    const counter = {
        retryCount: retryCount,
        delay: delay
    };
    const resetRetries = ()=>{
        counter.retryCount = 0;
        counter.delay = delay;
    };
    const attempt = async ()=>{
        try {
            return await fn(resetRetries);
        } catch (error) {
            if (errorFilter && !errorFilter(error)) throw error;
            if (counter.retryCount >= maxRetries) throw error;
            onRetry?.(counter.retryCount + 1, error);
            if (pauseWhileOffline) {
                const recoveredFromOffline = await $92b0a6aa5f3cefb4$var$waitForOnline(signal);
                if (recoveredFromOffline && postOnlineDelay > 0) await $92b0a6aa5f3cefb4$var$abortableSleep(postOnlineDelay, signal);
            }
            const effectiveDelay = typeof jitter === 'number' ? counter.delay + Math.random() * jitter : jitter ? Math.max(minDelay, Math.random() * counter.delay) : counter.delay;
            await $92b0a6aa5f3cefb4$var$abortableSleep(effectiveDelay, signal);
            counter.delay *= 2;
            counter.retryCount += 1;
            return attempt();
        }
    };
    return attempt();
};















const $452e4ba611b5dc40$export$6f349e5fd508c97f = (onMergedEvent)=>{
    const buffers = new Map();
    const bufferEvent = (event)=>{
        const stepId = event.message.stepId;
        if (!stepId) return false;
        const existing = buffers.get(stepId);
        if (existing) {
            existing.chunks.push(event.message.content);
            existing.lastEvent = event;
        } else buffers.set(stepId, {
            chunks: [
                event.message.content
            ],
            lastEvent: event
        });
        return true;
    };
    const flush = ()=>{
        if (buffers.size === 0) return;
        // Snapshot + clear before invoking the callback so re-entrant flushes are safe.
        const entries = Array.from(buffers.entries());
        buffers.clear();
        for (const [, { chunks: chunks, lastEvent: lastEvent }] of entries)onMergedEvent({
            ...lastEvent,
            message: {
                ...lastEvent.message,
                content: chunks.join('')
            }
        });
    };
    const flushFiltered = (predicate)=>{
        if (buffers.size === 0) return;
        // Snapshot + clear before invoking the callback so re-entrant flushes are safe.
        const entries = Array.from(buffers.entries());
        buffers.clear();
        for (const [stepId, { chunks: chunks, lastEvent: lastEvent }] of entries){
            if (!predicate(stepId)) continue;
            onMergedEvent({
                ...lastEvent,
                message: {
                    ...lastEvent.message,
                    content: chunks.join('')
                }
            });
        }
    };
    return {
        bufferEvent: bufferEvent,
        flush: flush,
        flushFiltered: flushFiltered,
        size: ()=>buffers.size
    };
};













const $be423051027308ae$var$MAX_RECONNECT_ATTEMPTS = 5;
const $be423051027308ae$var$RETRY_BASE_DELAY_MS = 1000;
const $be423051027308ae$var$RECONNECT_JITTER_MS = 500;
const $be423051027308ae$var$POST_ONLINE_DELAY_MS = 2000;
const $be423051027308ae$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED = 'chat-unmounted';
async function* $be423051027308ae$export$a802bb7fa59dba39({ initialGenerator: initialGenerator, canReconnect: canReconnect, getReconnectGenerator: getReconnectGenerator, getEventId: getEventId, onBeforeFirstReconnect: onBeforeFirstReconnect, onReconnecting: onReconnecting, onReconnected: onReconnected, onFirstChunkAfterReconnect: onFirstChunkAfterReconnect, onStreamCompleted: onStreamCompleted, onStreamFailed: onStreamFailed, signal: signal, maxAttempts: maxAttempts = $be423051027308ae$var$MAX_RECONNECT_ATTEMPTS, shouldContinueRetrying: shouldContinueRetrying }) {
    let currentGenerator = initialGenerator;
    let lastEventId;
    let reconnectCount = 0;
    let reconnectionAttempted = false;
    let awaitingFirstChunkAfterReconnect = false;
    while(true)try {
        for await (const chunk of currentGenerator){
            if (signal?.aborted) return;
            const eventId = getEventId(chunk);
            if (eventId) lastEventId = eventId;
            if (awaitingFirstChunkAfterReconnect) {
                awaitingFirstChunkAfterReconnect = false;
                onFirstChunkAfterReconnect?.();
            }
            yield chunk;
        }
        if (reconnectionAttempted) onStreamCompleted?.();
        return;
    } catch (error) {
        if (error instanceof (0, $iEWar.StreamErrorException)) {
            if (reconnectionAttempted) onStreamFailed?.(error);
            throw error;
        }
        if (!(0, $f0918ff6cbefa0f7$export$4eef7b24ec94bbe8)(error) || !canReconnect() || reconnectCount >= maxAttempts || signal?.aborted) {
            if (reconnectionAttempted) onStreamFailed?.(error);
            throw error;
        }
        if (shouldContinueRetrying && !shouldContinueRetrying()) {
            if (reconnectionAttempted) onStreamFailed?.(error);
            throw error;
        }
        if (!reconnectionAttempted) {
            onBeforeFirstReconnect?.();
            reconnectionAttempted = true;
        }
        reconnectCount++;
        onReconnecting?.(reconnectCount, maxAttempts, lastEventId);
        currentGenerator = await (0, $92b0a6aa5f3cefb4$export$4dfcad98182a1ece)({
            fn: async ()=>getReconnectGenerator(lastEventId),
            maxRetries: 2,
            delay: $be423051027308ae$var$RETRY_BASE_DELAY_MS,
            jitter: $be423051027308ae$var$RECONNECT_JITTER_MS,
            pauseWhileOffline: true,
            postOnlineDelay: $be423051027308ae$var$POST_ONLINE_DELAY_MS,
            errorFilter: (0, $f0918ff6cbefa0f7$export$4eef7b24ec94bbe8),
            signal: signal
        });
        onReconnected?.();
        awaitingFirstChunkAfterReconnect = true;
    }
}
function $be423051027308ae$export$29bad1ab941da7cb({ generator: generator, conversationId: conversationId, abortController: abortController, assistanceService: assistanceService, sendAnalyticsEvent: sendAnalyticsEvent, experienceTracker: experienceTracker, getMessageId: getMessageId, canReconnect: canReconnect, updateCurrentConversation: updateCurrentConversation, getIsChatMounted: getIsChatMounted, analyticsAttributes: analyticsAttributes, onBeforeFirstReconnect: callerOnBeforeFirstReconnect, onReconnecting: callerOnReconnecting, onReconnected: callerOnReconnected, onFirstChunkAfterReconnect: callerOnFirstChunkAfterReconnect }) {
    let totalAttempts = 0;
    let perfMetrics;
    return $be423051027308ae$export$a802bb7fa59dba39({
        initialGenerator: generator,
        canReconnect: ()=>!!getMessageId() && canReconnect(),
        getReconnectGenerator: (lastEventId)=>{
            const messageId = getMessageId();
            if (!messageId) return Promise.reject(new Error('Cannot reconnect: messageId is not available'));
            return assistanceService.reconnectToMessageStream({
                conversationId: conversationId,
                messageId: messageId,
                lastEventId: lastEventId,
                controller: abortController
            }).then((r)=>r.generator);
        },
        getEventId: (chunk)=>(0, $ljUdP.isSSEMessage)(chunk) && chunk.id ? chunk.id : undefined,
        onBeforeFirstReconnect: ()=>{
            perfMetrics = (0, $f0918ff6cbefa0f7$export$4f5dbc9d3a9c9f98)({
                isDeepResearchEnabled: analyticsAttributes?.isDeepResearch,
                thinkDeeperEnabled: analyticsAttributes?.thinkDeeperEnabled,
                fastModeEnabled: analyticsAttributes?.fastModeEnabled
            });
            perfMetrics.timeToConnectToStreamMetrics.start();
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                id: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                attributes: {
                    conversationId: conversationId,
                    messageId: getMessageId(),
                    ...analyticsAttributes
                }
            });
            callerOnBeforeFirstReconnect?.();
        },
        onReconnecting: (attempt, maxAttempts, lastEventId)=>{
            totalAttempts = attempt;
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'retrying',
                actionSubject: 'rovoChatReconnection',
                attributes: {
                    conversationId: conversationId,
                    messageId: getMessageId(),
                    attempt: attempt,
                    maxAttempts: maxAttempts,
                    hasLastEventId: !!lastEventId,
                    ...analyticsAttributes
                }
            });
            updateCurrentConversation({
                traces: [
                    {
                        messageContent: `Connection lost. Retrying... (${attempt}/${maxAttempts})`,
                        status: 'loading'
                    }
                ]
            });
            callerOnReconnecting?.(attempt, maxAttempts);
        },
        onReconnected: ()=>{
            perfMetrics?.timeToConnectToStreamMetrics.stop();
            perfMetrics?.timeToResumeStreamMetrics.start();
            callerOnReconnected?.();
        },
        onFirstChunkAfterReconnect: ()=>{
            perfMetrics?.timeToResumeStreamMetrics.stop();
            callerOnFirstChunkAfterReconnect?.();
        },
        onStreamCompleted: ()=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                attributes: {
                    totalAttempts: totalAttempts,
                    conversationId: conversationId,
                    messageId: getMessageId(),
                    ...analyticsAttributes
                }
            });
        },
        onStreamFailed: (error)=>{
            perfMetrics?.timeToConnectToStreamMetrics.cancel();
            perfMetrics?.timeToResumeStreamMetrics.cancel();
            if (error instanceof Error && error.name === 'AbortError' || abortController.signal.aborted) experienceTracker.abort({
                name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                reason: 'Aborted'
            });
            else experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                error: error instanceof Error ? error : new Error(String(error)),
                attributes: {
                    totalAttempts: totalAttempts,
                    conversationId: conversationId,
                    messageId: getMessageId(),
                    ...analyticsAttributes
                }
            });
        },
        shouldContinueRetrying: getIsChatMounted ? ()=>{
            if (!getIsChatMounted()) {
                abortController.abort($be423051027308ae$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED);
                return false;
            }
            return true;
        } : undefined,
        signal: abortController.signal
    });
}





function $f0fdaf1fd06efef8$export$76ef465f684cfb18({ conversationId: conversationId, reconnectTimestamp: reconnectTimestamp, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, updateCurrentConversation: updateCurrentConversation, onFlush: onFlush }) {
    // Lazily initialised on first setMessages write — avoids copying the full
    // messages array upfront when multiple tabs reconnect simultaneously.
    // replayBuffering=true + replayBuffer=null → buffering, no write yet
    // replayBuffering=false + replayBuffer=null → flushed
    let replayBuffer = null;
    let replayBuffering = true;
    // Pre-seeded with { traces: [] } so flush always clears "Resuming response..."
    // even if no clearTracesIfNotEmpty call fires during replay.
    // null means flushed.
    let conversationPatch = {
        traces: []
    };
    // null means flushed.
    let researchQueue = [];
    // Per-step tracking for reconnect replay. Keyed by stepId.
    // stepTitleEvents: first STEP_TITLE seen (provides title + roundId).
    // stepCompletedEvents: last STEP_COMPLETED seen (marks step done).
    // Used by getCollapsedStepEvents() and getCompletedStepIds().
    const stepTitleEvents = new Map();
    const stepCompletedEvents = new Map();
    const trackStepEvent = (params)=>{
        const msg = params.streamMessage;
        if ((0, $ljUdP.isStreamResearchStepTitle)(msg) || (0, $ljUdP.isStreamResearchStepTitleShort)(msg)) {
            if (!stepTitleEvents.has(msg.message.stepId)) stepTitleEvents.set(msg.message.stepId, params);
        } else if ((0, $ljUdP.isStreamResearchStepCompleted)(msg)) stepCompletedEvents.set(msg.message.stepId, params);
    };
    const getCollapsedStepEvents = ()=>{
        const result = [];
        const allStepIds = new Set([
            ...Array.from(stepTitleEvents.keys()),
            ...Array.from(stepCompletedEvents.keys())
        ]);
        allStepIds.forEach((stepId)=>{
            const titleEvent = stepTitleEvents.get(stepId);
            const completedEvent = stepCompletedEvents.get(stepId);
            if (titleEvent) result.push(titleEvent);
            if (completedEvent) result.push(completedEvent);
        });
        return result;
    };
    const isBuffering = ()=>replayBuffering;
    const parseEventTime = (id)=>Number(id.split('-')[0]);
    const flush = ()=>{
        if (!isBuffering()) return;
        const buffered = replayBuffer;
        const patch = conversationPatch;
        const queued = researchQueue;
        // Mark flushed before dispatching so re-entrant calls go live.
        replayBuffering = false;
        replayBuffer = null;
        conversationPatch = null;
        researchQueue = null;
        if (buffered !== null) setMessages(conversationId, buffered);
        if (patch !== null) updateCurrentConversation(patch);
        // onFlush runs BEFORE the queued research dispatch so caller-side
        // buffers (e.g. reasoning chunks) populate step content first; the
        // collapse signals (ANSWER_PART, FINAL_RESPONSE) then fire on
        // already-populated steps, matching the source event order.
        onFlush?.();
        // react-sweet-state setState is synchronous — the research store reaches
        // its final state before React re-renders, giving one render with
        // researchCompleted=true and skipping intermediate spinner states.
        queued.forEach((params)=>processStreamResearch(params));
    };
    const batchedSetMessages = (convId, msgs)=>{
        if (replayBuffering && convId === conversationId) {
            replayBuffer = msgs;
            return;
        }
        setMessages(convId, msgs);
    };
    const batchedGetMessages = (convId)=>{
        if (replayBuffering && convId === conversationId) // Fall through to real store if no write has arrived yet.
        return replayBuffer ?? getMessages(convId);
        return getMessages(convId);
    };
    const batchedUpdateCurrentConversation = (patch)=>{
        if (conversationPatch !== null) {
            conversationPatch = {
                ...conversationPatch,
                ...patch
            };
            return;
        }
        updateCurrentConversation(patch);
    };
    const batchedProcessStreamResearch = (params)=>{
        if (researchQueue !== null) {
            if ((0, $ljUdP.isStreamResponse)(params.streamMessage)) {
                // Preserve ANSWER_PART if already queued so both hasReceivedAnswerPart
                // and researchCompleted are set at flush.
                const hasAnswerPart = researchQueue.some((p)=>(0, $ljUdP.isStreamAnswerPart)(p.streamMessage));
                researchQueue = hasAnswerPart ? [
                    ...researchQueue,
                    params
                ] : [
                    params
                ];
                return;
            }
            if ((0, $ljUdP.isStreamAnswerPart)(params.streamMessage)) {
                // Collapse to [STEP_TITLE, STEP_COMPLETED per step, ANSWER_PART] so
                // past rounds have steps in the store after flush — prevents "Rovo is
                // thinking" for completed rounds during mid-stream reload.
                researchQueue = [
                    ...getCollapsedStepEvents(),
                    params
                ];
                return;
            }
            trackStepEvent(params);
            researchQueue.push(params);
            return;
        }
        processStreamResearch(params);
    };
    async function* replayFlushGenerator(source) {
        let replayEventCount = 0;
        for await (const chunk of source){
            if (isBuffering() && chunk.id) {
                const eventTime = parseEventTime(chunk.id);
                if (!isNaN(eventTime) && eventTime >= reconnectTimestamp) flush();
            }
            // During replay, yield the event loop periodically to prevent the tab
            // from becoming unresponsive when processing large streams (e.g. 6K+ events).
            // This gives the browser a chance to handle user interactions and GC between batches.
            if (isBuffering()) {
                replayEventCount++;
                if (replayEventCount % 200 === 0) await new Promise((resolve)=>setTimeout(resolve, 0));
            }
            yield chunk;
        }
        // Stream ended while still in replay (response was complete on reconnect).
        flush();
    }
    return {
        wrapGenerator: replayFlushGenerator,
        batchedSetMessages: batchedSetMessages,
        batchedGetMessages: batchedGetMessages,
        batchedProcessStreamResearch: batchedProcessStreamResearch,
        batchedUpdateCurrentConversation: batchedUpdateCurrentConversation,
        getIsReplaying: isBuffering,
        getCompletedStepIds: ()=>new Set(stepCompletedEvents.keys())
    };
}


/* eslint-disable @atlaskit/platform/no-preconditioning -- Existing stream processing gates feature behavior from runtime flags. */ 






var $1oCLl = parcelRequire("1oCLl");


var $deF0K = parcelRequire("deF0K");


var $3vCSA = parcelRequire("3vCSA");























const $3e5408ba1f60d629$var$getSelectedAgentIdForSend = (inputSelectedAgentIds, allowSelectedAgentOverride = false)=>{
    const activeSelectedAgentDraftId = inputSelectedAgentIds?.at(-1)?.trim();
    if (activeSelectedAgentDraftId && allowSelectedAgentOverride && (0, $dh538.fg)('rovo_chat_agent_selection')) return activeSelectedAgentDraftId;
    return undefined;
};
const $3e5408ba1f60d629$export$4413981bab4da984 = ({ conversationAgent: conversationAgent, defaultAgent: defaultAgent, explicitAgentId: explicitAgentId, omitConversationDefaultAgentRequestFields: omitConversationDefaultAgentRequestFields = false, inputSelectedAgentIds: inputSelectedAgentIds, allowSelectedAgentOverride: allowSelectedAgentOverride = false })=>{
    // rovo_chat_agent_selection cleanup: delete this gate-off branch when the flag
    // is removed. This branch keys off `explicitAgentId !== undefined` (matching the
    // pre-feature behavior, including empty/whitespace-only values), whereas the
    // gate-on path treats an empty explicit id as "no explicit agent".
    if (!(0, $dh538.fg)('rovo_chat_agent_selection') && explicitAgentId !== undefined) {
        const isExplicitDefaultAgent = explicitAgentId === defaultAgent.id;
        return {
            routedSelectedAgentId: undefined,
            routingAgentId: explicitAgentId,
            agentIdForRequest: isExplicitDefaultAgent ? undefined : explicitAgentId,
            agentNamedIdForRequest: isExplicitDefaultAgent ? undefined : conversationAgent.named_id
        };
    }
    const normalizedExplicitAgentId = explicitAgentId || undefined;
    const routedSelectedAgentId = normalizedExplicitAgentId ? undefined : $3e5408ba1f60d629$var$getSelectedAgentIdForSend(inputSelectedAgentIds, allowSelectedAgentOverride);
    const routingAgentId = normalizedExplicitAgentId ?? routedSelectedAgentId ?? conversationAgent.id;
    if (normalizedExplicitAgentId) {
        // Explicit caller-provided agent id wins so non-chat flows are not
        // regressed by stored selected-agent state. Preserve the conversation agent's
        // named id for callers that still rely on named-id semantics.
        // rovo_chat_agent_selection cleanup: keep default-agent collapse after the
        // flag is removed; it matches the pre-feature default-Rovo wire contract.
        const isExplicitDefaultAgent = normalizedExplicitAgentId === defaultAgent.id;
        return {
            routedSelectedAgentId: undefined,
            routingAgentId: routingAgentId,
            agentIdForRequest: isExplicitDefaultAgent ? undefined : normalizedExplicitAgentId,
            agentNamedIdForRequest: isExplicitDefaultAgent ? undefined : conversationAgent.named_id
        };
    }
    if (routedSelectedAgentId) {
        // Selected-agent override is sent for routing; if the user explicitly
        // selected default Rovo we omit request fields so the backend treats
        // it as a normal default Rovo send.
        const isSelectedDefaultAgent = routedSelectedAgentId === defaultAgent.id;
        return {
            routedSelectedAgentId: routedSelectedAgentId,
            routingAgentId: routingAgentId,
            agentIdForRequest: isSelectedDefaultAgent ? undefined : routedSelectedAgentId,
            agentNamedIdForRequest: isSelectedDefaultAgent ? undefined : routedSelectedAgentId
        };
    }
    // No override preserves the caller/conversation request identity. The
    // `omitConversationDefaultAgentRequestFields` option is compatibility for the main
    // conversation-assistant wire contract and should remain when the flag is removed.
    const shouldOmitConversationDefaultAgentRequestFields = omitConversationDefaultAgentRequestFields && conversationAgent.id === defaultAgent.id;
    return {
        routedSelectedAgentId: undefined,
        routingAgentId: routingAgentId,
        agentIdForRequest: shouldOmitConversationDefaultAgentRequestFields ? undefined : conversationAgent.id,
        agentNamedIdForRequest: shouldOmitConversationDefaultAgentRequestFields ? undefined : conversationAgent.named_id
    };
};






var $52Fo2 = parcelRequire("52Fo2");





var $dgaTK = parcelRequire("dgaTK");

const $35034bc3bb470a3a$export$3ba003c3111d103f = ()=>{
    const subExperienceCollect = (0, $dgaTK.collectAllWithSubExperienceAttributes)([
        (0, $16lEl.ExperienceName).AIFC_MESSAGE,
        (0, $16lEl.ExperienceName).PREVIEW_CARD_RENDER
    ]);
    return (events, experience)=>{
        // these experiences only run if the user chooses to open the preview while streaming is in progress. if they fail, bubble it up, but we dont rely on them for success/abort, because they may not even start
        (0, $dgaTK.failExperienceOnSubExperienceFail)((0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED, experience, events);
        (0, $dgaTK.failExperienceOnSubExperienceFail)((0, $16lEl.ExperienceName).PREVIEW_CONTENT, experience, events);
        subExperienceCollect(events, experience);
    };
};









var $4eSde = parcelRequire("4eSde");

const $bdb6804a1ebe4c48$export$95d2102da86339f1 = ({ experienceTracker: experienceTracker, conversationId: conversationId, rootExperienceName: rootExperienceName, commonExperienceAttributes: commonExperienceAttributes })=>{
    experienceTracker.start({
        name: rootExperienceName,
        id: conversationId,
        collect: (0, $4eSde.createAifcExperienceCollect)(),
        attributes: commonExperienceAttributes
    });
    // Start AIFC_ALL_DATA_HANDLED - this replaces all explicit AIFC_UPDATE_CONTENT succeed/fail/abort calls
    // Product AIFC integration is responsible for succeeding this experience.
    experienceTracker.start({
        name: (0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED,
        id: conversationId,
        attributes: {
            ...commonExperienceAttributes,
            parentExperienceId: rootExperienceName
        }
    });
    experienceTracker.start({
        name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
        id: conversationId,
        attributes: {
            ...commonExperienceAttributes,
            parentExperienceId: rootExperienceName
        }
    });
    if ((0, $dh538.fg)('aifc-experience-timeout')) experienceTracker.start({
        name: (0, $16lEl.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
        id: `${conversationId}-initial`,
        attributes: {
            ...commonExperienceAttributes,
            parentExperienceId: rootExperienceName
        }
    });
};






var $e4JJO = parcelRequire("e4JJO");




var $1cjt9 = parcelRequire("1cjt9");


var $eWKku = parcelRequire("eWKku");









var $ceMRi = parcelRequire("ceMRi");

const $33eac1626c414e6d$export$4a48e8ee48123078 = (config)=>{
    let previousMessageTimestamp = performance.now();
    let previousMessageTemplate;
    let previousMessageType;
    let maxDeadAirMs = 0;
    let totalDeadAirMs = 0;
    let maxPreviousMessageTemplate;
    let maxCurrentMessageTemplate;
    let maxPreviousMessageType;
    let maxCurrentMessageType;
    let deadAirIntervalsMs = [];
    const shouldIgnoreMessage = (message)=>{
        return (0, $ljUdP.isConversationChannelDataMessage)(message) || (0, $ljUdP.isStreamHeartbeat)(message) || (0, $ljUdP.isStreamDynamicLayoutSubAgent)(message) || (0, $ljUdP.isStreamAnswerGenerationType)(message);
    };
    const shouldCountMessage = (message)=>{
        return (0, $ljUdP.isStreamResearchPayload)(message) || (0, $ljUdP.isStreamResearchPlan)(message) || (0, $ljUdP.isStreamTrace)(message) || (0, $ljUdP.isStreamThinkDeeperTriggered)(message) || (0, $ljUdP.isStreamAnswerPart)(message) || (0, $ljUdP.isStreamReasoningPart)(message) || (0, $ljUdP.isStreamActionPart)(message) || (0, $ljUdP.isStreamResponse)(message) || (0, $ljUdP.isFollowUpMessage)(message) || (0, $ljUdP.isStreamActionClassification)(message) || (0, $ljUdP.isStreamActionPrepare)(message) || (0, $ljUdP.isStreamActionComplete)(message) || (0, $ljUdP.isStreamActionError)(message) || (0, $ljUdP.isStreamError)(message) || (0, $ljUdP.isStreamTodoSnapshot)(message);
    };
    const getMessageTemplate = (message)=>{
        return 'message' in message && message.message?.message_template;
    };
    const commonMetadata = {
        messageId: config.messageId,
        conversationId: config.conversationId,
        traceId: config.traceId,
        productKey: config.productKey,
        isExplicitDeepResearchEnabled: config.deepResearchEnabled,
        isExplicitThinkDeeperEnabled: config.thinkDeeperEnabled,
        isExplicitFastModeEnabled: config.fastModeEnabled,
        isWebSearchEnabled: config.webSearchEnabled,
        isAIFC: config.isAIFC,
        isExplicitThinkFasterEnabled: false,
        isImplicitThinkDeeper: false,
        hasSwitchedToFastThinking: false
    };
    const trackDeadAir = (deadAirMs, previousTemplate, currentTemplate, previousType, currentType)=>{
        const intervalMetric = (0, $1K4cm.deadAirMetrics).createDeadAirIntervalMetrics();
        const now = performance.now();
        intervalMetric.start({
            startTime: now - deadAirMs
        });
        intervalMetric.stop({
            stopTime: now,
            customData: {
                ...commonMetadata,
                previousMessageTemplate: previousTemplate ?? '',
                messageTemplate: currentTemplate ?? '',
                previousMessageType: previousType ?? '',
                messageType: currentType ?? ''
            }
        });
        totalDeadAirMs += deadAirMs;
        deadAirIntervalsMs.push(Math.round(deadAirMs)); // integer ms is enough accuray
        if (deadAirMs > maxDeadAirMs) {
            maxDeadAirMs = deadAirMs;
            maxPreviousMessageTemplate = previousTemplate;
            maxCurrentMessageTemplate = currentTemplate;
            maxPreviousMessageType = previousType;
            maxCurrentMessageType = currentType;
        }
    };
    const update = (streamMessage)=>{
        if (shouldIgnoreMessage(streamMessage)) return;
        if (!shouldCountMessage(streamMessage)) {
            config.sendAnalyticsEvent({
                eventType: 'operational',
                action: 'unrecognized',
                actionSubject: 'deadAirTrackerMessage',
                attributes: {
                    messageType: streamMessage.type ?? 'unknown',
                    messageTemplate: getMessageTemplate(streamMessage) ?? 'unknown',
                    conversationId: config.conversationId,
                    traceId: config.traceId
                }
            });
            return;
        }
        const currentTimestamp = performance.now();
        const currentTemplate = getMessageTemplate(streamMessage);
        if (currentTemplate === 'THINK_DEEPER_TRIGGERED') commonMetadata.isImplicitThinkDeeper = true;
        const currentMessageType = streamMessage.type;
        // Skip consecutive streaming messages (continuous token/content generation)
        // ANSWER_PART: Standard LLM response tokens
        // REASONING_PART: Think deeper extended reasoning phases (streamed thinking)
        // ACTION_PART: AIFC content generation chunks (whiteboards, documents, etc.)
        const isConsecutiveAnswerPart = previousMessageType === 'ANSWER_PART' && currentMessageType === 'ANSWER_PART';
        const isConsecutiveReasoningPart = previousMessageType === 'REASONING_PART' && currentMessageType === 'REASONING_PART';
        const isConsecutiveActionPart = previousMessageType === 'ACTION_PART' && currentMessageType === 'ACTION_PART';
        if (isConsecutiveAnswerPart || isConsecutiveReasoningPart || isConsecutiveActionPart) {
            previousMessageTimestamp = currentTimestamp;
            previousMessageTemplate = currentTemplate;
            previousMessageType = currentMessageType;
            return;
        }
        const deadAirMs = currentTimestamp - previousMessageTimestamp;
        // Skip negligible intervals (noise)
        if (!(0, $ceMRi.shouldExcludeInterval)(deadAirMs)) trackDeadAir(deadAirMs, previousMessageTemplate, currentTemplate, previousMessageType, currentMessageType);
        previousMessageTimestamp = currentTimestamp;
        previousMessageTemplate = currentTemplate;
        previousMessageType = currentMessageType;
    };
    const emitMaxDeadAir = ()=>{
        if (maxDeadAirMs === 0) return;
        const maxDeadAirMetric = (0, $1K4cm.deadAirMetrics).createDeadAirMaxMetrics();
        const now = performance.now();
        maxDeadAirMetric.start({
            startTime: now - maxDeadAirMs
        });
        maxDeadAirMetric.stop({
            stopTime: now,
            customData: {
                ...commonMetadata,
                maxDeadAirMs: maxDeadAirMs,
                totalDeadAirMs: Math.round(totalDeadAirMs),
                deadAirIntervalsMs: JSON.stringify(deadAirIntervalsMs),
                previousMessageTemplate: maxPreviousMessageTemplate ?? '',
                messageTemplate: maxCurrentMessageTemplate ?? '',
                previousMessageType: maxPreviousMessageType ?? '',
                messageType: maxCurrentMessageType ?? ''
            }
        });
    };
    const complete = ()=>{
        emitMaxDeadAir();
    };
    const cancel = ()=>{
        emitMaxDeadAir();
    };
    return {
        update: update,
        complete: complete,
        cancel: cancel,
        resetTimestamp: ()=>{
            previousMessageTimestamp = performance.now();
        }
    };
};





/**
 * Util function to determine the page context where Rovo chat is being used.
 *
 * This uses the existing context objects (editorContext, whiteboardContext, databaseContext)
 * and AI feature context to determine the surface, and falls back to the browser URL when no
 * context is available.
 *
 * This attribute is used on unified AI events (aiResult viewed, aiInteraction initiated)
 * to distinguish which surface Rovo chat was used on (e.g. edit page, view page, whiteboard, database).
 *
 * This is exported only for testing purposes.
 */ const $bb60cdbb8ebc402b$export$1303843c2f44065a = ({ editorContext: editorContext, whiteboardContext: whiteboardContext, databaseContext: databaseContext, aiFeatureContext: aiFeatureContext, browserUrl: browserUrl })=>{
    // Priority 1: Use existing context objects for reliable detection
    if (editorContext) return editorContext.isViewMode ? 'confluence-page-view' : 'confluence-page-edit';
    if (whiteboardContext) return whiteboardContext.isViewMode ? 'whiteboard-view' : 'whiteboard-edit';
    if (databaseContext) return 'database';
    if (aiFeatureContext?.jira_view_context) {
        const jiraContext = aiFeatureContext.jira_view_context;
        return typeof jiraContext.viewType === 'string' ? `jira-view-${jiraContext.viewType}` : 'jira-view';
    }
    // Priority 2: Fall back to URL-based detection when no context is available
    const url = browserUrl ?? (typeof window !== 'undefined' ? window.location.href : '');
    if (url.includes('/wiki/') && url.includes('/edit')) return 'confluence-page-edit';
    if (url.includes('/wiki/')) return 'confluence-page-view';
    if (url.includes('/whiteboard/')) return 'whiteboard';
    if (url.includes('/database/')) return 'database';
    return 'unknown';
};


/**
 * Util function to derive a generic view context attribute for analytics.
 *
 * Reads the AI feature context (populated by product-specific publishers, e.g. the Jira
 * Issue Navigator and Backlog views) and returns a flat record of scalar values that can
 * be attached to unified AI events (e.g. aiInteraction initiated) without leaking any
 * product-specific nested shape.
 *
 * Returns `undefined` when no known view context is available, in which case no
 * `viewContext` attribute is attached to the event.
 *
 * This is exported only for testing purposes.
 */ const $d097db038375fc24$export$20af16720c0f9c71 = ({ aiFeatureContext: aiFeatureContext })=>{
    if (!aiFeatureContext?.jira_view_context) return undefined;
    const jiraCtx = aiFeatureContext.jira_view_context;
    const ids = jiraCtx.selectedIssueIdentifiers;
    const projects = jiraCtx.projectIdentifiers;
    const filters = jiraCtx.filterIdentifiers;
    const jqlStrings = jiraCtx.jqlStrings;
    return {
        numberOfWorkItems: Array.isArray(ids) ? ids.length : 0,
        numberOfProjects: Array.isArray(projects) ? projects.length : 0,
        numberOfFilters: Array.isArray(filters) ? filters.length : 0,
        numberOfJqlStrings: Array.isArray(jqlStrings) ? jqlStrings.length : 0,
        viewType: typeof jiraCtx.viewType === 'string' ? jiraCtx.viewType : 'unknown'
    };
};









// The General Agent runtime UUID (DEFAULT_AGENT_UUID) doubles as the Solution Architect Agent
// runtime identity, which is currently the only agent with minion verification implemented. Minion
// verification analytics are gated to this identity (and the default named-id) for that reason.
const $bd83b455fe877f94$var$possible_agents = [
    (0, $cBi7Q.DEFAULT_AGENT_UUID),
    (0, $cBi7Q.DEFAULT_AGENT_NAMED_ID)
];
const $bd83b455fe877f94$var$MINION_VERIFICATION_ITEMS = [
    {
        alias: 'design-solution',
        minionId: 'SolutionArchitectMinion'
    },
    {
        alias: 'rovo-agent-builder',
        minionId: 'AgentBuilderMinion'
    },
    {
        alias: 'build-automation',
        minionId: 'AutomationWorkflowBuilderMinion'
    }
];
const $bd83b455fe877f94$export$8bfbf77736e8f6e2 = ({ minionAlias: minionAlias, agentId: agentId, minionsOutput: minionsOutput, sendAnalyticsEvent: sendAnalyticsEvent })=>{
    if (!minionAlias) return;
    if (agentId && !$bd83b455fe877f94$var$possible_agents.includes(agentId)) return;
    $bd83b455fe877f94$var$MINION_VERIFICATION_ITEMS.forEach(({ alias: alias, minionId: minionId })=>{
        if (alias !== minionAlias) return;
        const hasAliasMatch = minionsOutput.some((output)=>output.minion_id === minionId);
        sendAnalyticsEvent({
            eventType: 'track',
            action: hasAliasMatch ? 'matched' : 'mismatched',
            actionSubject: 'aiMateMinionVerification',
            attributes: {
                name: minionId
            }
        });
    });
};



const $3ba7c8b5e2cd14b7$export$cb6128fc3a3c8081 = ()=>{
    const abortController = new AbortController();
    let resolveAbort;
    const confirmAbort = ()=>{
        resolveAbort();
    };
    const abort = ()=>{
        abortController.abort();
        return new Promise((resolve)=>{
            resolveAbort = resolve;
        });
    };
    return {
        abortController: abortController,
        storeAbortController: {
            abort: abort
        },
        confirmAbort: confirmAbort
    };
};


const $77299565342080aa$export$e3d8e4fb1ec788d1 = ()=>{
    try {
        if (window.top) window.top.__rovoStreamResponseMessages__ = [];
    } catch  {
    // Ignore cross-origin frame access errors
    }
};
const $77299565342080aa$export$7d55b756f7f2ed43 = (message)=>{
    try {
        if (window.top) {
            if (!window.top.__rovoStreamResponseMessages__) window.top.__rovoStreamResponseMessages__ = [];
            const serialised = JSON.stringify(message);
            window.top.__rovoStreamResponseMessages__.push(serialised);
        }
    } catch  {
    // Ignore cross-origin frame access errors
    }
};
const $77299565342080aa$export$e884abe68ebbc0aa = ()=>{
    try {
        const messages = window.top?.__rovoStreamResponseMessages__ ?? [];
        return messages.join('\n');
    } catch  {
        // Ignore cross-origin frame access errors
        return '';
    }
};
const $77299565342080aa$export$a50d66ef75a63fe5 = ()=>{
    try {
        if (window.top) window.top.__rovoStreamResponseOutput__ = $77299565342080aa$export$e884abe68ebbc0aa;
    } catch  {
    // Ignore cross-origin frame access errors
    }
};
$77299565342080aa$export$a50d66ef75a63fe5();



var $cteoa = parcelRequire("cteoa");

/**
 * Helper function to stop/end metrics, that can only be called once
 */ const $54793c520b6b8872$var$getRequestedModeAttributes = (trackingAttributes)=>({
        ...(0, $9likX.interactionModeRequestedAttributes)(trackingAttributes.interactionModeRequested),
        ...trackingAttributes.aiFeatureName && {
            aiFeatureName: trackingAttributes.aiFeatureName
        }
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $54793c520b6b8872$var$getMetricEndHelper = (metrics)=>{
    let called = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (result, customData)=>{
        if (!called) {
            if (result === 'stop') metrics.stop({
                customData: customData
            });
            else metrics.cancel();
            called = true;
        }
    };
};
function $54793c520b6b8872$export$7459a30868c458f({ routedSelectedAgentId: routedSelectedAgentId, value: value }) {
    return routedSelectedAgentId ? undefined : value;
}
const $54793c520b6b8872$var$getInitialTrackingAttributes = (agentId, instrumentationId, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, taskModeEnabled, webSearchEnabled, messageSources, isFirstPrompt, prompt, files, appFilters, template, forcedContentType)=>{
    return {
        pluginsInvoked: new Set(),
        skillsInvoked: [],
        executedStratusSkill: false,
        hasSources: false,
        messageId: '',
        humanMessageId: '',
        requestId: undefined,
        messageActions: [],
        messageDynamicUIData: [],
        invokedFrom: undefined,
        instrumentationId: instrumentationId,
        messageSentTimeStamp: new Date().toISOString(),
        citedProductList: {},
        sourceProducts: {},
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        taskModeEnabled: taskModeEnabled,
        webSearchEnabled: webSearchEnabled,
        interactionSource: messageSources?.interactionSource,
        followUpSource: messageSources?.followUpSource ?? 'none',
        aiFeatureName: messageSources?.aiFeatureName,
        isFirstPrompt: isFirstPrompt,
        promptFeatures: (0, $e4JJO.extractContentFeatures)(prompt),
        fileCount: files?.length ?? 0,
        appFilters: appFilters ?? [],
        appFilterCount: appFilters?.length ?? 0,
        template: template,
        deepResearchInvoked: false,
        forcedContentType: forcedContentType,
        interactionModeRequested: (0, $9likX.getInteractionModeRequested)({
            deepResearchEnabled: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            fastModeEnabled: fastModeEnabled,
            taskModeEnabled: taskModeEnabled
        })
    };
};
const $54793c520b6b8872$var$getOptimisticMessageTypes = (deepResearchEnabled, webSearchEnabled)=>{
    const messageType = [];
    if ((0, $dh538.fg)('rovo_chat_chat_history_refresh')) {
        if (deepResearchEnabled) messageType.push('DEEP_RESEARCH');
        if (webSearchEnabled) messageType.push('WEB_SEARCH');
    }
    return {
        messageType: messageType
    };
};
const $54793c520b6b8872$var$initLatencyMetrics = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, agentId: agentId })=>{
    const rovoCustomAgent = (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId);
    const sendMessageLatencyMetrics = (0, $1K4cm.messageLatencyMetrics).createSendMessageMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const timeToFirstAnswerPartLatencyMetrics = (0, $1K4cm.messageLatencyMetrics).createTimeToFirstAnswerPartMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const timeToFirstActionPartLatencyMetrics = (0, $1K4cm.messageLatencyMetrics).createTimeToFirstActionPartMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const timeToActionCompletionLatencyMetrics = (0, $1K4cm.messageLatencyMetrics).createTimeToActionCompletionMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const metricsStartTime = window.performance.now();
    sendMessageLatencyMetrics.start({
        startTime: metricsStartTime
    });
    timeToFirstAnswerPartLatencyMetrics.start({
        startTime: metricsStartTime
    });
    if ((0, $dh538.fg)('aifc_create_enabled') || (0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true)) {
        timeToFirstActionPartLatencyMetrics.start();
        timeToActionCompletionLatencyMetrics.start();
    }
    const stopInteractionMetricsTimeToFirstAnswerPart = $54793c520b6b8872$var$getMetricEndHelper(timeToFirstAnswerPartLatencyMetrics);
    const stopInteractionMetricsTimeToFirstActionPart = $54793c520b6b8872$var$getMetricEndHelper(timeToFirstActionPartLatencyMetrics);
    const stopInteractionMetricsTimeToActionCompletion = $54793c520b6b8872$var$getMetricEndHelper(timeToActionCompletionLatencyMetrics);
    const cancelStreamingMetrics = ()=>{
        stopInteractionMetricsTimeToFirstAnswerPart('cancel');
        stopInteractionMetricsTimeToFirstActionPart('cancel');
        stopInteractionMetricsTimeToActionCompletion('cancel');
    };
    return {
        sendMessageLatencyMetrics: sendMessageLatencyMetrics,
        timeToFirstAnswerPartLatencyMetrics: timeToFirstAnswerPartLatencyMetrics,
        timeToFirstActionPartLatencyMetrics: timeToFirstActionPartLatencyMetrics,
        timeToActionCompletionLatencyMetrics: timeToActionCompletionLatencyMetrics,
        stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart,
        stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart,
        stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion,
        cancelStreamingMetrics: cancelStreamingMetrics,
        metricsStartTime: metricsStartTime
    };
};
const $54793c520b6b8872$var$hydrateStoreWithNewMessage = (dispatch, conversationId, messageType, tmpHumanMessageId, tmpAssistantMessageId, prompt, files, sourceAgentIdForTemporaryLocalConversation, setConversationData, addHumanMessage, addAssistantMessage, clearFollowUpMessages, routedSelectedAgentId)=>{
    const { abortController: abortController, storeAbortController: storeAbortController, confirmAbort: confirmAbort } = (0, $3ba7c8b5e2cd14b7$export$cb6128fc3a3c8081)();
    const updateCurrentConversation = (data)=>{
        dispatch(setConversationData({
            conversationId: conversationId,
            data: data
        }));
    };
    // Author the optimistic assistant by per-turn override (`routedSelectedAgentId`),
    // else caller intent (`sourceAgentIdForTemporaryLocalConversation` = explicit/default
    // agent) — never the routing fallback, which would resolve to the conversation agent
    // and mis-author a cross-surface default-Rovo "ask Rovo". See ai-mate AGENTS.md
    // "Rovo Chat agent identity, routing, and display". Gate-off keeps caller intent;
    // on flag cleanup keep the `routedSelectedAgentId ?? sourceAgentId...` form.
    const normalizedRoutedSelectedAgentId = routedSelectedAgentId || undefined;
    const optimisticAssistantAuthorNamedId = (0, $dh538.fg)('rovo_chat_agent_selection') && normalizedRoutedSelectedAgentId ? normalizedRoutedSelectedAgentId : sourceAgentIdForTemporaryLocalConversation;
    updateCurrentConversation({
        status: (0, $bPHr8.CHAT_STORE_STATUS).awaitingResponse,
        storeAbortController: storeAbortController,
        lastMessageType: messageType,
        lastAgentMessageStatus: 'IN_PROGRESS'
    });
    dispatch(addHumanMessage({
        id: tmpHumanMessageId,
        content: prompt,
        conversationId: conversationId,
        fileUploads: files
    }));
    dispatch(addAssistantMessage({
        id: tmpAssistantMessageId,
        content: '',
        conversationId: conversationId,
        // Authored by the routed agent (see derivation above) so the per-turn
        // "{agent} is thinking" indicator reflects it.
        agentNamedId: optimisticAssistantAuthorNamedId
    }));
    dispatch(clearFollowUpMessages({
        conversationId: conversationId
    }));
    return {
        abortController: abortController,
        storeAbortController: storeAbortController,
        confirmAbort: confirmAbort,
        updateCurrentConversation: updateCurrentConversation
    };
};
const $54793c520b6b8872$var$handleEditorContextAnalytics = ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, userPreference: userPreference, sendAnalyticsEvent: sendAnalyticsEvent, activeTargetId: activeTargetId, isStagingArea: stagingAreaFromStore })=>{
    // If AIFC is not enabled, we should not send analytics
    if (!(0, $dh538.fg)('aifc_create_enabled')) return;
    const inStagingArea = contentContext === 'staging-area';
    // Source values for Inline Rovo
    const sourceEligible = source === 'CONFLUENCE_INLINE_EDITOR' || source === 'INLINE_EDITOR' || source === 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON' || source === 'CONFLUENCE_WHITEBOARD_BRAINSTORMING_FOLLOW_UP';
    const shouldProvideContext = // Inline Rovo
    sourceEligible || // Within staging area & not the first prompt
    inStagingArea && !isFirstPrompt || // Not within staging area, default to user preference
    !inStagingArea && !!userPreference;
    // If there's no editor context when we should be providing it,
    // something went wrong so send analytics to track
    if (shouldProvideContext) sendAnalyticsEvent({
        eventType: 'operational',
        action: 'missing',
        actionSubject: 'editorContext',
        attributes: {
            contentContext: contentContext,
            source: source,
            userPreference: userPreference,
            isFirstPrompt: isFirstPrompt,
            activeTargetId: activeTargetId,
            isStagingArea: stagingAreaFromStore
        }
    });
};
function $54793c520b6b8872$export$780f1f00b9b71ec({ editorContext: editorContext, whiteboardContext: whiteboardContext, databaseContext: databaseContext, slidesContext: slidesContext }) {
    if (editorContext) return 'page';
    if (whiteboardContext) return 'whiteboard';
    if (databaseContext) return 'database';
    if (slidesContext) return 'slide';
    return undefined;
}
function $54793c520b6b8872$export$6258c857812ade71({ contentContextValue: contentContextValue, existingExperience: existingExperience, chatContextContentType: chatContextContentType, isViewMode: isViewMode }) {
    if (contentContextValue === 'global' && !existingExperience && chatContextContentType) return {
        experience: isViewMode ? 'chat_view' : 'chat_edit',
        contentTypes: [
            chatContextContentType
        ]
    };
    return undefined;
}
const $54793c520b6b8872$var$populateSendMessageContext = async (chatContextStoreActions, isFirstPrompt, source, addCurrentPageAsContextUserPreference, contentContextValue, creationContextParams, productKey, sendAnalyticsEvent, activeTargetId, lastAssistantMessageDynamicUiType, skipEditorContext, isRemixAction, searchArtifact)=>{
    const editorContext = skipEditorContext ? undefined : await chatContextStoreActions.getEditorContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId
    });
    const currentTarget = chatContextStoreActions.getTarget(contentContextValue, activeTargetId);
    // If there's no editor context available and the current target CAN
    // provide context, send analytics to track this error state
    if (!editorContext && !skipEditorContext && currentTarget?.canProvideContext) $54793c520b6b8872$var$handleEditorContextAnalytics({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        userPreference: !!addCurrentPageAsContextUserPreference,
        sendAnalyticsEvent: sendAnalyticsEvent,
        activeTargetId: !!activeTargetId,
        isStagingArea: chatContextStoreActions.getIsStagingArea()
    });
    const whiteboardContext = await chatContextStoreActions.getWhiteboardContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId
    });
    const slidesContext = await chatContextStoreActions.getSlidesContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId
    });
    const databaseContext = await chatContextStoreActions.getDatabaseContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId
    });
    const dashboardEditorContext = await chatContextStoreActions.getDashboardEditorContext({
        contentContext: contentContextValue,
        activeTargetId: activeTargetId
    });
    const browserContext = await chatContextStoreActions.getBrowserContext({
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        enabled: (0, $c6GJD.default).getExperimentValue('rovo_extension_dom_improvement', 'rovo_extension_dom_context_improvement_enabled', false, {
            fireExperimentExposure: false
        })
    });
    const jiraContext = await (async ()=>{
        // Only fetch Jira context when in staging area and product is Jira
        // and not the first prompt (refinement messages)
        if (!isFirstPrompt && (contentContextValue === 'staging-area' || (0, $dh538.fg)('jira-aifc-enable-preview-card-in-chat-v2')) && productKey === 'jira' && (0, $dh538.fg)('jira_aifc_enabled')) return chatContextStoreActions.getJiraContext?.();
        return undefined;
    })();
    const additionalCreationContext = editorContext?.additionalContext;
    const additionalCreationContextParams = creationContextParams?.additionalContext;
    if (editorContext && editorContext.additionalContext) delete editorContext.additionalContext;
    const useGenericEditorSkill = editorContext?.useGenericEditorSkill;
    if (editorContext && 'useGenericEditorSkill' in editorContext) delete editorContext.useGenericEditorSkill;
    const isViewMode = contentContextValue === 'staging-area' ? !!editorContext?.isViewMode : !!(editorContext?.isViewMode || whiteboardContext?.isViewMode || slidesContext?.isViewMode || databaseContext?.isViewMode);
    const creationContextIsViewMode = (0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true) ? creationContextParams?.isViewMode !== undefined ? creationContextParams.isViewMode : isViewMode : isViewMode;
    const isDraftLockedForEditing = !!editorContext?.isDraftLockedForEditing;
    // CWR follow-up/edit prompts in the staging area.
    // isRemixAction should be all that's needed to check remix.
    // source and creationContextParams.source checks included as future-proofing measures
    const isCwrEditFollowUp = contentContextValue === 'staging-area' && !isFirstPrompt && source !== 'remix' && creationContextParams?.source !== 'remix' && !isRemixAction;
    const editorContentType = $54793c520b6b8872$export$780f1f00b9b71ec({
        editorContext: editorContext,
        whiteboardContext: whiteboardContext,
        databaseContext: databaseContext,
        slidesContext: slidesContext
    });
    const cwrEditContentType = isCwrEditFollowUp ? editorContentType : undefined;
    // Bookmark
    return {
        browserContext: browserContext,
        editorContext: editorContext,
        whiteboardContext: whiteboardContext,
        slidesContext: slidesContext,
        databaseContext: databaseContext,
        dashboardEditorContext: dashboardEditorContext,
        additionalContext: {
            spaceCreateContext: await chatContextStoreActions.getSpaceCreateContext({
                isFirstPrompt: isFirstPrompt,
                contentContext: contentContextValue
            }),
            creationContext: {
                ...creationContextParams ? creationContextParams : {},
                isStagingArea: contentContextValue === 'staging-area',
                productKey: productKey,
                // When `contentMauiId` or `mediaFileId` is present, we don't need to send the source
                // Ideally we want to set it upstream, but we need to ensure we don't break existing functionality
                source: editorContext?.contentMauiId || editorContext?.mediaFileId ? 'remix' : // If source is explicitly passed, use that, otherwise rely on creationContextParams.source which is set at creation entry point (e.g. 'remix', 'ai-first-creation')
                source ?? creationContextParams?.source,
                isViewMode: creationContextIsViewMode,
                isDraftLockedForEditing: isDraftLockedForEditing,
                ...creationContextIsViewMode && editorContext?.isViewMode && !creationContextParams?.experience ? {
                    experience: 'inline_view',
                    contentTypes: [
                        'page'
                    ]
                } : {},
                useGenericEditorSkill: useGenericEditorSkill,
                additionalContext: additionalCreationContext || additionalCreationContextParams ? {
                    ...additionalCreationContext,
                    ...additionalCreationContextParams
                } : undefined,
                ...jiraContext && {
                    jiraContext: jiraContext
                },
                ...(0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true) && {
                    ...editorContext?.dynamicUiSource && {
                        dynamicUiSource: {
                            ...editorContext.dynamicUiSource,
                            ...creationContextParams?.dynamicUiSource?.fragmentAdf && {
                                fragmentAdf: creationContextParams.dynamicUiSource.fragmentAdf
                            }
                        }
                    },
                    ...(isRemixAction || source === 'remix' || creationContextParams?.source === 'remix') && {
                        dynamicUiType: editorContext?.dynamicUiType || creationContextParams?.dynamicUiType || lastAssistantMessageDynamicUiType
                    },
                    contentMauiId: editorContext?.contentMauiId ?? creationContextParams?.contentMauiId,
                    mediaFileId: editorContext?.mediaFileId ?? creationContextParams?.mediaFileId
                },
                // Derive experience and contentTypes for CWR follow-up/edit prompts.
                ...isCwrEditFollowUp && {
                    experience: 'cwr_edit',
                    ...cwrEditContentType && {
                        contentTypes: [
                            cwrEditContentType
                        ]
                    }
                },
                // Derive experience and contentTypes for Rovo Chat sidebar when a page/whiteboard/database/slides is open.
                ...!isCwrEditFollowUp && $54793c520b6b8872$export$6258c857812ade71({
                    contentContextValue: contentContextValue,
                    existingExperience: creationContextParams?.experience,
                    chatContextContentType: editorContentType,
                    isViewMode: isViewMode
                })
            },
            userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            search_artifact: searchArtifact
        },
        aiFeatureContext: chatContextStoreActions.getAIFeatureContext(),
        jiraWorkflowContext: chatContextStoreActions.getJiraWorkflowContext(),
        dashboardContext: chatContextStoreActions.getDashboardContext(),
        useCurrentBrowsingContext: chatContextStoreActions.useCurrentBrowsingContext(!!addCurrentPageAsContextUserPreference)
    };
};
const $54793c520b6b8872$var$handleSendMessageServiceCallFailure = (error, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, webSearchEnabled, streamActionInfo, chatContextStoreActions, experienceTracker, sendMessageExperienceNameCompiled, trackingAttributes, updateCurrentConversation, sendMessageLatencyMetrics, cancelStreamingMetrics, broadcastStreamLifecycle, confirmAbort, trackAIMAUEvent, messageSources, abortController, hasLoggedInitiatedEvent, tmpAssistantMessageId, clearMessageResearch, getState, conversationId, storeUserMessages)=>{
    // Convert deep research related errors to DeepResearchError when deep research is enabled
    let convertedError = error;
    if (deepResearchEnabled) convertedError = new (0, $iEWar.DeepResearchError)(error.message, {
        traceId: error.errorAttributes?.traceId,
        requestId: error.errorAttributes?.requestId
    });
    // Returns bad request error because agent is deactivated or user has no permission
    const isAgentDeactivated = error instanceof (0, $flpNp.ApiError) && error.errorAttributes.errorCode?.includes((0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_DEACTIVATED);
    const isNoAgentPermission = error instanceof (0, $flpNp.ApiError) && error.errorAttributes.errorCode?.includes((0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_FORBIDDEN) && (0, $dh538.fg)('convo-ai-enable-agents-use-permission');
    if (isAgentDeactivated || isNoAgentPermission) {
        experienceTracker.fail({
            name: sendMessageExperienceNameCompiled,
            error: error,
            attributes: {
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                fastModeEnabled: fastModeEnabled,
                webSearchEnabled: webSearchEnabled,
                llmDebugLogsEnabled: storeUserMessages,
                isStreamAction: streamActionInfo.isAction,
                actionKey: streamActionInfo.actionKey,
                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
            }
        });
        if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
        // Delaying the initiated event firing allows us to create the pairing appropriately,
        // for any initiated events leading up to an error or dismiss state with a
        // hashed ID
        trackAIMAUEvent({
            type: 'initiated',
            subjectId: messageSources?.interactionSource,
            proactive: false,
            userGenerated: true,
            timestamp: trackingAttributes.messageSentTimeStamp,
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            pageContext: trackingAttributes.pageContext,
            viewContext: trackingAttributes.viewContext,
            attributes: {
                ...$54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
            }
        });
        trackAIMAUEvent({
            type: 'error',
            userGenerated: true,
            messageId: trackingAttributes.requestId,
            timestamp: new Date().toISOString(),
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            attributes: $54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
        });
        updateCurrentConversation({
            status: (0, $bPHr8.CHAT_STORE_STATUS).deactivatedAgentError,
            traces: [],
            errorCode: (0, $dh538.fg)('convo-ai-enable-agents-use-permission') ? error.errorAttributes.errorCode : undefined
        });
        sendMessageLatencyMetrics.cancel();
        cancelStreamingMetrics();
        broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
        return;
    } else if (error instanceof Error && error.name === 'AbortError') {
        // Check if the abort was programmatic or not. `abortController.signal.aborted` is a readonly field that is only set to true when called programmatically
        // The browser can abort requests to free up resources & save power (esp. on background tabs). When it does this, it **does not** set `abortController.signal.aborted` to true
        const isProgrammaticAbort = abortController.signal.aborted;
        experienceTracker.abort({
            name: sendMessageExperienceNameCompiled,
            reason: 'Aborted',
            attributes: {
                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                isProgrammaticAbort: isProgrammaticAbort
            }
        });
        if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
        // Delaying the initiated event firing allows us to create the pairing appropriately,
        // for any initiated events leading up to an error or dismiss state with a
        // hashed ID
        trackAIMAUEvent({
            type: 'initiated',
            subjectId: messageSources?.interactionSource,
            proactive: false,
            userGenerated: true,
            timestamp: trackingAttributes.messageSentTimeStamp,
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            pageContext: trackingAttributes.pageContext,
            viewContext: trackingAttributes.viewContext,
            attributes: {
                ...$54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
            }
        });
        trackAIMAUEvent({
            type: 'dismissed',
            userGenerated: true,
            messageId: trackingAttributes.requestId,
            timestamp: new Date().toISOString(),
            singleInstrumentationID: trackingAttributes.instrumentationId,
            subjectId: trackingAttributes.interactionSource,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            attributes: $54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
        });
        updateCurrentConversation((0, $cteoa.clearStatus)({
            lastAgentMessageStatus: isProgrammaticAbort ? 'CANCELLED' : 'FAILED'
        }));
        (0, $cteoa.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
        clearMessageResearch({
            messageId: tmpAssistantMessageId
        });
        sendMessageLatencyMetrics.cancel();
        cancelStreamingMetrics();
        broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ABORTED);
        confirmAbort();
        return;
    } else {
        experienceTracker.fail({
            name: sendMessageExperienceNameCompiled,
            error: error,
            attributes: {
                deepResearchEnabled: deepResearchEnabled,
                fastModeEnabled: fastModeEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                webSearchEnabled: webSearchEnabled,
                llmDebugLogsEnabled: storeUserMessages,
                isStreamAction: streamActionInfo.isAction,
                actionKey: streamActionInfo.actionKey,
                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
            }
        });
        if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
        // Delaying the initiated event firing allows us to create the pairing appropriately,
        // for any initiated events leading up to an error or dismiss state with a
        // hashed ID
        trackAIMAUEvent({
            type: 'initiated',
            subjectId: messageSources?.interactionSource,
            proactive: false,
            userGenerated: true,
            timestamp: trackingAttributes.messageSentTimeStamp,
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            pageContext: trackingAttributes.pageContext,
            viewContext: trackingAttributes.viewContext,
            attributes: {
                ...$54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
            }
        });
        trackAIMAUEvent({
            type: 'error',
            userGenerated: true,
            messageId: trackingAttributes.requestId,
            timestamp: new Date().toISOString(),
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            attributes: $54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
        });
        sendMessageLatencyMetrics.cancel();
        cancelStreamingMetrics();
        broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
        throw convertedError;
    }
};
const $54793c520b6b8872$export$5a07e6227eed9665 = ({ streamMessage: streamMessage, tmpAssistantMessageId: tmpAssistantMessageId, conversationId: conversationId, deepResearchEnabled: deepResearchEnabled, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, researchState: researchState })=>{
    let deepResearchInvoked = false;
    if ((0, $ljUdP.isStreamResearchStart)(streamMessage) && // The same message_template is used for thinking deeper + deep research
    // so we need to check the specific trace message to differentiate them
    streamMessage.message.content === 'Starting deep research execution') deepResearchInvoked = true;
    // Implicit round detection for think deeper:
    // When answer content has accumulated (from ANSWER_PART messages) and new
    // research step information arrives, we know a new round is starting.
    // We retroactively create a research plan for the completed round using
    // the accumulated answer content, clear the streamed content, and increment
    // the round counter so subsequent steps are grouped under the new round.
    if (researchState.hasAccumulatedAnswerContent && (0, $ljUdP.isStreamResearchPayload)(streamMessage)) {
        // Read the accumulated answer content from the assistant message
        const accumulatedContent = (0, $cteoa.getStoreAssistantMessageContent)(getMessages(conversationId), tmpAssistantMessageId);
        // Create a research plan for the completed round with the accumulated content
        addImplicitResearchPlan({
            messageId: tmpAssistantMessageId,
            content: accumulatedContent,
            roundId: researchState.clientRoundCounter
        });
        // Increment round counter for the new incoming steps
        researchState.clientRoundCounter++;
        // Clear the assistant message content so the new round starts fresh
        const clearedMessages = (0, $cteoa.clearStoreAssistantMessageContent)(getMessages(conversationId), tmpAssistantMessageId);
        setMessages(conversationId, clearedMessages);
        // Reset tracking flags
        researchState.hasAccumulatedAnswerContent = false;
        resetHasReceivedAnswerPart({
            messageId: tmpAssistantMessageId
        });
    }
    if ((0, $ljUdP.isStreamResearchPayload)(streamMessage) || (0, $ljUdP.isStreamResponse)(streamMessage) || (0, $ljUdP.isStreamAnswerPart)(streamMessage) || (0, $ljUdP.isStreamReasoningPart)(streamMessage) || (0, $ljUdP.isStreamSkill)(streamMessage) || (0, $ljUdP.isStreamThinkDeeperTriggered)(streamMessage)) {
        // When implicit rounds are active, override roundId on research step messages
        // so they are grouped under the current client-managed round
        if (researchState.clientRoundCounter > 0 && (0, $ljUdP.isStreamResearchPayload)(streamMessage) && 'message' in streamMessage && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        'roundId' in streamMessage.message) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        streamMessage.message.roundId = researchState.clientRoundCounter;
        processStreamResearch({
            messageId: tmpAssistantMessageId,
            streamMessage: streamMessage,
            isDeepResearch: deepResearchEnabled ?? false
        });
    }
    if ((0, $ljUdP.isStreamResearchPlan)(streamMessage)) processStreamResearch({
        messageId: tmpAssistantMessageId,
        streamMessage: streamMessage,
        isDeepResearch: deepResearchEnabled ?? false
    });
    // Track that answer content has accumulated so implicit round detection
    // can detect a new round starting when the next research payload arrives
    if ((0, $ljUdP.isStreamAnswerPart)(streamMessage)) researchState.hasAccumulatedAnswerContent = true;
    return {
        deepResearchInvoked: deepResearchInvoked
    };
};
const $54793c520b6b8872$export$efb69f1fe7577739 = async ({ prompt: prompt, generator: generator, productKey: productKey, answerIndex: answerIndex, tmpHumanMessageId: tmpHumanMessageId, tmpAssistantMessageId: tmpAssistantMessageId, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, sendMessageExperienceNameCompiled: sendMessageExperienceNameCompiled, traceId: traceId, updateCurrentConversation: updateCurrentConversation, trackingAttributes: trackingAttributes, conversationId: conversationId, getState: getState, promptStreamHook: promptStreamHook, openChat: openChat, openChatOnError: openChatOnError, experienceTracker: experienceTracker, setMessages: setMessages, getMessages: getMessages, processStreamResearch: processStreamResearch, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamError: processMessageStreamError, processMessageStreamActionClassification: processMessageStreamActionClassification, containerOnTempMessageIdReplaced: containerOnTempMessageIdReplaced, updateResearchMessageId: updateResearchMessageId, sendAnalyticsEvent: sendAnalyticsEvent, chatContextStoreActions: chatContextStoreActions, stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart, stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart, stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion, broadcastStreamLifecycle: broadcastStreamLifecycle, sendMessageLatencyMetrics: sendMessageLatencyMetrics, cancelStreamingMetrics: cancelStreamingMetrics, onTempMessageIdReplacedOverride: onTempMessageIdReplacedOverride, streamActionInfo: streamActionInfo, trackAIMAUEvent: trackAIMAUEvent, messageSources: messageSources, additionalAnalyticAttributes: additionalAnalyticAttributes, hasLoggedInitiatedEvent: hasLoggedInitiatedEvent, clearMessageResearch: clearMessageResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, viewDeadAirBroker: viewDeadAirBroker, minionAlias: minionAlias, agentId: agentId, agentName: agentName, agentIdentityAccountId: agentIdentityAccountId, creationContextParams: creationContextParams, storeUserMessages: storeUserMessages, skillSelectionSource: skillSelectionSource, assistanceService: assistanceService, abortController: abortController, getIsChatMounted: getIsChatMounted, metricsStartTime: metricsStartTime, onTaskStatusUpdate: onTaskStatusUpdate, onTodoSnapshot: onTodoSnapshot, onPromptRedacted: onPromptRedacted, onPromptBlocked: onPromptBlocked, onResponseRedacted: onResponseRedacted, onResponseBlocked: onResponseBlocked, onAttachmentBlocked: onAttachmentBlocked })=>{
    updateCurrentConversation({
        traces: []
    });
    // Set to true when a guard event (PROMPT_REDACTION or PROMPT_BLOCKED) is received.
    // The backend always follows these events with an ERROR event to terminate the stream,
    // which should be treated as a successful end of the guard flow, not a real error.
    let guardEventReceived = false;
    let hasReceivedFinalResponse = false;
    let hasReceivedFollowUp = false;
    let hasReceivedActionComplete = false;
    let hasReceivedActionClassification = false;
    let isLuminaAnswerGenerationType = false;
    let agentMessageId;
    let lastEventId;
    let isReconnectSupported = false;
    // Guards against repeated metric switches if multiple REASONING_PART messages arrive.
    let hasAbortedForImplicitThinkDeeper = false;
    // Think-deeper metrics started when implicit think-deeper is detected mid-stream. Null otherwise.
    let implicitThinkDeeperSendMessageMetrics = null;
    let implicitThinkDeeperTimeToFirstAnswerPartMetrics = null;
    // The experience name for the reliability SLO when implicit think-deeper is detected. Null otherwise.
    let implicitThinkDeeperExperienceName = null;
    // Client-side implicit round tracking for think deeper.
    // Passed by reference into processResearchStreamMessage so state is shared.
    const researchState = {
        clientRoundCounter: 0,
        hasAccumulatedAnswerContent: false
    };
    // Gate the details-tag preprocessor to 3P-agent conversations only.
    // Lazily initialised on the first chunk: the conversation's agent metadata
    // is set by `createConversationOptimistically` which may run after this
    // function is defined but before the first chunk arrives.
    let processStreamMarkdownInstance = null;
    let processStreamMarkdownMultiTagInstance = null;
    const getShouldPreprocessDetails = ()=>(0, $cteoa.shouldPreprocessDetailsForConversation)(getState(), conversationId);
    const getProcessStreamMarkdown = ()=>{
        if (!processStreamMarkdownInstance) processStreamMarkdownInstance = (0, $cteoa.createStreamMarkdownProcessor)({
            shouldPreprocessDetails: getShouldPreprocessDetails()
        });
        return processStreamMarkdownInstance;
    };
    const getProcessStreamMarkdownMultiTag = ()=>{
        if (!processStreamMarkdownMultiTagInstance) processStreamMarkdownMultiTagInstance = (0, $cteoa.createStreamMarkdownMultiTagProcessor)({
            shouldPreprocessDetails: getShouldPreprocessDetails()
        });
        return processStreamMarkdownMultiTagInstance;
    };
    let latestStreamMessage;
    const streamStats = $54793c520b6b8872$var$getStreamStats();
    // Between-chunks inactivity watchdog (logs once per stall, re-arms on chunks)
    const inactivity = $54793c520b6b8872$export$23f1f8f522f4bdd({
        baseMs: 90000,
        sendAnalyticsEvent: (event)=>{
            sendAnalyticsEvent({
                ...event,
                attributes: {
                    ...event.attributes,
                    ...streamStats.getStats(),
                    isDeepResearchEnabled: deepResearchEnabled,
                    isThinkDeeperEnabled: thinkDeeperEnabled,
                    isFastModeEnabled: fastModeEnabled,
                    isWebSearchEnabled: webSearchEnabled,
                    isAIFCStreaminAction: streamActionInfo.isAction,
                    conversationId: conversationId,
                    instrumentationId: trackingAttributes.instrumentationId,
                    requestId: trackingAttributes.requestId,
                    interactionSource: trackingAttributes.interactionSource,
                    contentContext: chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global',
                    userAgent: navigator?.userAgent
                }
            });
        }
    });
    // Dead air tracking - monitors gaps between meaningful stream messages
    const deadAirTracker = (0, $33eac1626c414e6d$export$4a48e8ee48123078)({
        messageId: tmpAssistantMessageId,
        conversationId: conversationId,
        traceId: traceId ?? '',
        productKey: productKey ?? '',
        deepResearchEnabled: deepResearchEnabled ?? false,
        thinkDeeperEnabled: thinkDeeperEnabled ?? false,
        fastModeEnabled: fastModeEnabled ?? false,
        webSearchEnabled: webSearchEnabled ?? false,
        isAIFC: streamActionInfo.isAction,
        sendAnalyticsEvent: sendAnalyticsEvent
    });
    viewDeadAirBroker?.start({
        messageId: tmpAssistantMessageId,
        conversationId: conversationId,
        traceId: traceId ?? '',
        productKey: productKey ?? '',
        reasoningMode: deepResearchEnabled ? 'deep-research' : thinkDeeperEnabled ? 'think-deeper' : fastModeEnabled ? 'fast' : 'auto',
        isAIFCEnabled: streamActionInfo.isAction,
        isWebSearchEnabled: webSearchEnabled ?? false
    });
    // Reset the stream response recording for a new stream session
    let canRecordStreamResponses = false;
    try {
        const isLocalStorageDebuggerEnabled = localStorage.getItem('__rovoChatResponseDebugger__') === 'true' && (0, $dh538.fg)('rovo_debug_network_response_localstorage');
        const isDebuggerEnabled = window.top?.__rovoChatResponseDebugger__ || isLocalStorageDebuggerEnabled;
        canRecordStreamResponses = Boolean(isDebuggerEnabled && (0, $dh538.fg)('editor-4209_sse_stream_debug'));
    } catch  {
        canRecordStreamResponses = false;
    }
    if (canRecordStreamResponses) (0, $77299565342080aa$export$e3d8e4fb1ec788d1)();
    // Arm the inactivity watchdog
    inactivity?.arm();
    /*****************************
   *
   * Stream processing START
   *
   *****************************/ const streamToIterate = (0, $be423051027308ae$export$29bad1ab941da7cb)({
        generator: generator,
        conversationId: conversationId,
        abortController: abortController,
        assistanceService: assistanceService,
        sendAnalyticsEvent: sendAnalyticsEvent,
        experienceTracker: experienceTracker,
        getMessageId: ()=>agentMessageId,
        canReconnect: ()=>!!(agentMessageId && isReconnectSupported) && (0, $c6GJD.default).getExperimentValue('rovo_chat_reconnect_all_experiment', 'isEnabled', false),
        updateCurrentConversation: updateCurrentConversation,
        getIsChatMounted: getIsChatMounted,
        analyticsAttributes: {
            isDeepResearch: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            fastModeEnabled: fastModeEnabled
        },
        onBeforeFirstReconnect: ()=>{
            const chat = getMessages(conversationId);
            const alreadySwapped = (0, $cteoa.findStoreMessageIndex)(chat, agentMessageId) >= 0;
            if (!alreadySwapped) {
                setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageId)({
                    chat: chat,
                    oldId: tmpAssistantMessageId,
                    newId: agentMessageId
                }));
                updateResearchMessageId({
                    messageId: tmpAssistantMessageId,
                    newMessageId: agentMessageId
                });
            }
            tmpAssistantMessageId = agentMessageId;
        },
        onReconnected: ()=>{
            inactivity?.arm();
        },
        onFirstChunkAfterReconnect: ()=>{
            deadAirTracker?.resetTimestamp();
        }
    });
    try {
        for await (const streamObj of streamToIterate){
            // Track the last event ID for potential reconnection (legacy path)
            if ((0, $ljUdP.isSSEMessage)(streamObj) && streamObj.id) lastEventId = streamObj.id;
            const streamMessage = (0, $ljUdP.isSSEMessage)(streamObj) ? streamObj.data : streamObj;
            // Record the raw stream message for debugging purposes
            // This allows developers to copy/paste SSE responses for examples/tests
            if (canRecordStreamResponses) (0, $77299565342080aa$export$7d55b756f7f2ed43)(streamMessage);
            latestStreamMessage = streamMessage;
            deadAirTracker?.update(streamMessage);
            streamStats.update(streamMessage);
            // any chunk = proof of life
            inactivity?.onChunk();
            // Note: We do NOT skip stream messages during SWITCHING.
            // Stream processing continues normally until FAST_MODE_ENABLED is received,
            // at which point research steps are cleared and status is set to SWITCHED.
            // Usually the first stream part
            if ((0, $ljUdP.isConversationChannelDataMessage)(streamMessage)) {
                agentMessageId = streamMessage.assistant_message_id;
                updateCurrentConversation({
                    name: streamMessage.name,
                    lastMessageTimestamp: streamMessage.last_message_timestamp ?? new Date().toISOString(),
                    timeCreated: streamMessage.time_created,
                    ...streamMessage.scopes && {
                        scopes: streamMessage.scopes
                    }
                });
                trackingAttributes.instrumentationId = agentMessageId;
                trackingAttributes.messageId = agentMessageId;
                if (agentMessageId && agentMessageId !== tmpAssistantMessageId && (0, $dh538.fg)('cc-cwr-fix-finalizing-cancelled-request')) {
                    const oldTmpId = tmpAssistantMessageId;
                    setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageId)({
                        chat: getMessages(conversationId),
                        oldId: oldTmpId,
                        newId: agentMessageId
                    }));
                    updateResearchMessageId({
                        messageId: oldTmpId,
                        newMessageId: agentMessageId
                    });
                    tmpAssistantMessageId = agentMessageId;
                    (onTempMessageIdReplacedOverride || containerOnTempMessageIdReplaced)?.(oldTmpId, agentMessageId);
                }
                trackingAttributes.invokedFrom = creationContextParams?.source === 'remix' ? creationContextParams?.source : undefined;
                const remixNodeTypes = creationContextParams?.dynamicUiSource ? (0, $e4JJO.getTopLevelNodeTypes)(creationContextParams.dynamicUiSource.fullAdf, creationContextParams.dynamicUiSource.startLocalId ?? '', creationContextParams.dynamicUiSource.endLocalId ?? '') : undefined;
                const remixWordCount = creationContextParams?.dynamicUiSource?.fragmentAdf ? (0, $e4JJO.countFragmentWords)(creationContextParams.dynamicUiSource.fragmentAdf) : undefined;
                if (remixNodeTypes) trackingAttributes.remixNodeTypes = remixNodeTypes;
                if (remixWordCount !== undefined) trackingAttributes.remixWordCount = remixWordCount;
                trackAIMAUEvent({
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    timestamp: streamMessage.last_message_timestamp,
                    singleInstrumentationID: agentMessageId,
                    deepResearchEnabled: deepResearchEnabled ?? false,
                    thinkDeeperEnabled: thinkDeeperEnabled ?? false,
                    fastModeEnabled: fastModeEnabled ?? false,
                    webSearchEnabled: webSearchEnabled ?? false,
                    pageContext: trackingAttributes.pageContext,
                    viewContext: trackingAttributes.viewContext,
                    invokedFrom: trackingAttributes.invokedFrom,
                    attributes: {
                        ...$54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes),
                        ...additionalAnalyticAttributes && additionalAnalyticAttributes,
                        ...remixNodeTypes !== undefined && {
                            remixNodeTypes: remixNodeTypes
                        },
                        ...remixWordCount !== undefined && {
                            remixWordCount: remixWordCount
                        }
                    }
                });
                hasLoggedInitiatedEvent = true;
            } else if ((0, $ljUdP.isScopeDeterminedMessage)(streamMessage)) updateCurrentConversation({
                scopes: streamMessage.scopes
            });
            else {
                const conversation = getState().conversations[getState().currentConversationId];
                if (conversation) {
                    if (conversation.status !== (0, $bPHr8.CHAT_STORE_STATUS).typingResponse) updateCurrentConversation({
                        status: (0, $bPHr8.CHAT_STORE_STATUS).typingResponse
                    });
                }
            }
            if ((0, $ljUdP.isStreamReconnectSupportPart)(streamMessage)) isReconnectSupported = true;
            if ((0, $ljUdP.isStreamAnswerGenerationType)(streamMessage) && (0, $dh538.fg)('rovo_chat_enable_lumina')) {
                isLuminaAnswerGenerationType = streamMessage.message.answer_generation_type === 'LUMINA';
                setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageAnswerGenerationType)(getMessages(conversationId), tmpAssistantMessageId, streamMessage.message.answer_generation_type));
            }
            {
                const { deepResearchInvoked: deepResearchInvoked } = $54793c520b6b8872$export$5a07e6227eed9665({
                    streamMessage: streamMessage,
                    tmpAssistantMessageId: tmpAssistantMessageId,
                    conversationId: conversationId,
                    deepResearchEnabled: deepResearchEnabled,
                    getMessages: getMessages,
                    setMessages: setMessages,
                    processStreamResearch: processStreamResearch,
                    addImplicitResearchPlan: addImplicitResearchPlan,
                    resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                    researchState: researchState
                });
                if (deepResearchInvoked) trackingAttributes.deepResearchInvoked = true;
            }
            // The backend autonomously triggered thinking mode (implicit think-deeper) even though
            // the user did not explicitly enable it. Cancel the auto-mode browser metrics so these
            // slow requests don't count against the <16s/<30s SLOs, and re-attribute them to the
            // think-deeper metrics instead.
            if (!thinkDeeperEnabled && !hasAbortedForImplicitThinkDeeper && (0, $ljUdP.isStreamThinkDeeperTriggered)(streamMessage)) {
                hasAbortedForImplicitThinkDeeper = true;
                // Cancel auto-mode metrics so they are not recorded in the SLOs
                stopInteractionMetricsTimeToFirstAnswerPart('cancel');
                sendMessageLatencyMetrics.cancel();
                // Re-attribute to think-deeper metrics (100s SLO target)
                implicitThinkDeeperSendMessageMetrics = (0, $1K4cm.messageLatencyMetrics).createSendMessageMetrics({
                    thinkDeeperEnabled: true
                });
                implicitThinkDeeperTimeToFirstAnswerPartMetrics = (0, $1K4cm.messageLatencyMetrics).createTimeToFirstAnswerPartMetrics({
                    thinkDeeperEnabled: true
                });
                implicitThinkDeeperSendMessageMetrics.start({
                    startTime: metricsStartTime
                });
                implicitThinkDeeperTimeToFirstAnswerPartMetrics.start({
                    startTime: metricsStartTime
                });
                // Abort the auto-mode reliability SLO experience and start the think-deeper one
                // so implicit think-deeper requests don't count against the auto-mode reliability SLO.
                implicitThinkDeeperExperienceName = (0, $16lEl.sendMessageExperienceName)({
                    thinkDeeperEnabled: true
                });
                experienceTracker.abort({
                    name: sendMessageExperienceNameCompiled,
                    reason: 'Re-attributed to think-deeper reliability SLO'
                });
                experienceTracker.start({
                    name: implicitThinkDeeperExperienceName,
                    id: conversationId,
                    startTime: metricsStartTime,
                    attributes: {
                        conversationId: conversationId,
                        interactionSource: trackingAttributes.interactionSource,
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
                    }
                });
            }
            // This is the first moment we have the network request id for E2E event tracking
            // Store requestId on human message for E2E event tracking
            if (!trackingAttributes.requestId && 'metadata' in streamMessage) trackingAttributes.requestId = streamMessage.metadata?.request_id ?? undefined;
            if ((0, $ljUdP.isStreamResponse)(streamMessage)) trackingAttributes.interactionModeExecuted = (0, $9likX.getInteractionModeExecutedFromStreamResponse)(streamMessage);
            // Handle MEMORY_UPDATE trace messages - create a persistent StoreMemoryUpdate message
            if ((0, $ljUdP.isStreamMemoryUpdate)(streamMessage) && (0, $c6GJD.default).getExperimentValue('memory_management_ux', 'isEnabled', false)) {
                const originalContent = streamMessage.message.content;
                const isMemoryTraceContentEmpty = !originalContent;
                let memoryContent = originalContent;
                let isMemoryContentAfterParsingEmpty = false;
                // Parse memory content: remove "Update memory:" prefix and trim
                if (memoryContent) {
                    memoryContent = memoryContent.replace(/^update\s+memory:\s*/i, '').trim();
                    isMemoryContentAfterParsingEmpty = !memoryContent;
                }
                const memoryUpdateMessage = {
                    type: 'MEMORY_UPDATE',
                    content: memoryContent || undefined // Use undefined instead of empty string
                };
                // Track memory update parsing events
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'parsed',
                    actionSubject: 'memoryUpdate',
                    attributes: {
                        isMemoryTraceContentEmpty: isMemoryTraceContentEmpty,
                        isMemoryContentAfterParsingEmpty: isMemoryContentAfterParsingEmpty,
                        conversationId: conversationId
                    }
                });
                setMessages(conversationId, (0, $cteoa.addMemorytoLatestAssistantMessage)({
                    chat: getMessages(conversationId),
                    answerId: tmpAssistantMessageId,
                    memory: memoryUpdateMessage,
                    useIndex: answerIndex
                }));
            }
            // Usually the second stream part, before anything else occurs
            if ((0, $ljUdP.isStreamTrace)(streamMessage)) {
                if (!deepResearchEnabled) // we do not want traces that are not marked for deep research to be accumulated when starting research,
                // the ones that are marked are processed above in processResearchStreamMessage
                updateCurrentConversation({
                    traces: (0, $cteoa.dedupeTraceMessagesWithLatest)([
                        ...(0, $cteoa.getConversationTraces)(getState(), conversationId),
                        (0, $cteoa.getTraceFromStreamMessage)(streamMessage)
                    ])
                });
                promptStreamHook?.onTraceMessage?.(streamMessage, tmpAssistantMessageId, openChat);
                setMessages(conversationId, (0, $cteoa.addRequestIdToLatestHumanMessage)(getMessages(conversationId), trackingAttributes.requestId));
            }
            // Handle Answer Now fast mode traces for extended thinking
            // Answer Now feature - handle fast mode traces
            if ((0, $ljUdP.isStreamFastModeResponseAvailable)(streamMessage) && agentMessageId) // Fast mode response is available - show Answer Now button
            // Store both IDs in AVAILABLE status:
            // - tmpMessageId: for store operations (finding/updating the message)
            // - remoteMessageId: for the Answer Now API call
            setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageAnswerNowStatus)(getMessages(conversationId), tmpAssistantMessageId, {
                type: (0, $bPHr8.AnswerNowStatusType).AVAILABLE,
                tmpMessageId: tmpAssistantMessageId,
                remoteMessageId: agentMessageId
            }));
            if ((0, $ljUdP.isStreamFastModeEnabled)(streamMessage)) {
                // Fast mode has been enabled:
                // 1. Set status to SWITCHED (hides button)
                // 2. Clear research steps for this message
                setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageAnswerNowStatus)(getMessages(conversationId), tmpAssistantMessageId, {
                    type: (0, $bPHr8.AnswerNowStatusType).SWITCHED
                }));
                // Clear research steps when switching to fast mode
                clearMessageResearch({
                    messageId: tmpAssistantMessageId
                });
            }
            if ((0, $ljUdP.isStreamRemoveAnswerNow)(streamMessage)) (0, $cteoa.clearAnswerNowStatusForMessageIfSet)(conversationId, tmpAssistantMessageId, getMessages, setMessages);
            // isStreamResearchPlan is handled by processResearchStreamMessage (called earlier in this loop)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let commonExperienceAttributes = {
                llmDebugLogsEnabled: storeUserMessages
            };
            if ((0, $ljUdP.isStreamActionClassification)(streamMessage)) {
                promptStreamHook?.onActionClassification?.(streamMessage, tmpAssistantMessageId, conversationId);
                const actionKey = streamMessage.message.action_key;
                hasReceivedActionClassification = true;
                const actualContentType = (0, $deF0K.getAIFCContentType)({
                    key: actionKey
                });
                commonExperienceAttributes = {
                    ...commonExperienceAttributes,
                    actionKey: actionKey,
                    contentType: actualContentType,
                    isStagingArea: chatContextStoreActions.getIsStagingArea(),
                    humanMessageCount: getMessages(conversationId).filter((m)=>m.type === 'HUMAN').length,
                    product: productKey
                };
                if (trackingAttributes.forcedContentType) sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'compared',
                    actionSubject: 'forcedContentType',
                    actionSubjectId: 'contentTypeMatch',
                    attributes: {
                        forcedContentType: trackingAttributes.forcedContentType,
                        actualContentType: actualContentType,
                        matched: actualContentType.endsWith(`-${trackingAttributes.forcedContentType}`),
                        actionKey: actionKey
                    }
                });
                const isUpdateAction = (0, $deF0K.isUpdatableAction)({
                    key: actionKey
                });
                if (isUpdateAction && (!commonExperienceAttributes.isStagingArea || commonExperienceAttributes.humanMessageCount > 1)) {
                    const rootExperienceName = commonExperienceAttributes.isStagingArea ? (0, $16lEl.ExperienceName).AIFC_UPDATE_CONTENT : (0, $16lEl.ExperienceName).UPDATE_CONTENT_IN_CHAT;
                    (0, $bdb6804a1ebe4c48$export$95d2102da86339f1)({
                        experienceTracker: experienceTracker,
                        conversationId: conversationId,
                        rootExperienceName: rootExperienceName,
                        commonExperienceAttributes: commonExperienceAttributes
                    });
                }
                const isCreateAction = (0, $deF0K.isCreatableAction)({
                    key: actionKey
                });
                if (isCreateAction) {
                    // initial prompt from staging area has its own AIFC_GENERATE_CONTENT experience - dont start this one
                    if (!commonExperienceAttributes.isStagingArea || commonExperienceAttributes.humanMessageCount > 1) {
                        experienceTracker.start({
                            name: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT,
                            id: conversationId,
                            collect: (0, $35034bc3bb470a3a$export$3ba003c3111d103f)(),
                            attributes: commonExperienceAttributes
                        });
                        experienceTracker.start({
                            name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
                            id: conversationId,
                            attributes: {
                                ...commonExperienceAttributes,
                                parentExperienceId: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
                            }
                        });
                        experienceTracker.start({
                            name: (0, $16lEl.ExperienceName).PREVIEW_CARD_RENDER,
                            id: conversationId,
                            timeout: deepResearchEnabled ? undefined : 60000,
                            // 60 second timeout
                            attributes: {
                                ...commonExperienceAttributes,
                                parentExperienceId: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
                            }
                        });
                        // Product AIFC integration is responsible for succeeding this experience.
                        experienceTracker.start({
                            name: (0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED,
                            id: conversationId,
                            attributes: {
                                ...commonExperienceAttributes,
                                parentExperienceId: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
                            }
                        });
                    } else {
                        // update AIFC_GENERATE_CONTENT now that intent detection is complete. This experience starts as the user sends the message on the initial prompt screen
                        experienceTracker.updateAttributes({
                            name: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT,
                            attributes: commonExperienceAttributes
                        });
                        experienceTracker.updateAttributes({
                            name: (0, $16lEl.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
                            attributes: commonExperienceAttributes
                        });
                    }
                }
            }
            if (((0, $ljUdP.isStreamActionPart)(streamMessage) || (0, $ljUdP.isStreamActionPrepare)(streamMessage)) && (0, $dh538.fg)('aifc_create_enabled')) {
                // Update action tracking info
                if (!streamActionInfo.isAction) {
                    streamActionInfo.isAction = true;
                    streamActionInfo.actionKey = streamMessage.message.key;
                }
                // track attribute for action prepare
                if ((0, $ljUdP.isStreamActionPrepare)(streamMessage) && (0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true)) {
                    const actionData = streamMessage.message.data;
                    experienceTracker.updateAttributes({
                        name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
                        attributes: {
                            dynamicUiSubtype: actionData?.dynamicUiSubtype
                        }
                    });
                    // Remix flows skip ACTION_CLASSIFICATION and go straight to ACTION_PREPARE,
                    // so we start PREVIEW_CARD_RENDER here for remix flows.
                    // Only start when rovo chat is mounted/visible to the user.
                    if (getIsChatMounted?.() && (0, $3vCSA.isRemixGeneratedFlow)({
                        key: streamMessage.message.key,
                        data: streamMessage.message.data
                    })) {
                        const remixActionKey = streamMessage.message.key;
                        const actualContentType = (0, $deF0K.getAIFCContentType)({
                            key: remixActionKey
                        });
                        experienceTracker.start({
                            name: (0, $16lEl.ExperienceName).PREVIEW_CARD_RENDER,
                            id: conversationId,
                            timeout: 60000,
                            attributes: {
                                ...commonExperienceAttributes,
                                actionKey: remixActionKey,
                                contentType: actualContentType,
                                isStagingArea: chatContextStoreActions.getIsStagingArea(),
                                humanMessageCount: getMessages(conversationId).filter((m)=>m.type === 'HUMAN').length,
                                product: productKey,
                                featureArea: 'remix',
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                remixType: (0, $3vCSA.getDynamicUiType)(streamMessage.message)
                            }
                        });
                    }
                }
                if ((0, $ljUdP.isStreamActionPart)(streamMessage)) {
                    const actionData = streamMessage.message.data;
                    stopInteractionMetricsTimeToFirstActionPart('stop', {
                        actionType: 'action-part',
                        conversationId: conversationId,
                        actionPartKey: (0, $cteoa.getActionPartKeyForMetrics)(streamMessage.message.key, creationContextParams?.source, actionData?.dynamicUiSubtype),
                        interactionSource: messageSources?.interactionSource,
                        remixType: creationContextParams?.dynamicUiType
                    });
                }
                if ((0, $dh538.fg)('aifc_set_accumulated_data_on_message')) {
                    const actionKey = streamMessage.message.key;
                    const lastAction = (0, $cteoa.findLastAssistantAction)(getMessages(conversationId), (action)=>action.key === actionKey);
                    if (lastAction && (0, $3vCSA.isAccumulatedAction)(actionKey)) {
                        const isAccumulatedActionType = (0, $3vCSA.getAccumulatedActionTypeGuard)(actionKey);
                        if (isAccumulatedActionType(streamMessage.message.data)) {
                            const primaryAccumulatedData = (0, $3vCSA.getPrimaryAccumulatedValue)(lastAction);
                            if (primaryAccumulatedData?.value) streamMessage.message.data.previousAccumulatedData = primaryAccumulatedData.value;
                        }
                    }
                }
                processMessageStreamAction?.(tmpAssistantMessageId, streamMessage, traceId, trackingAttributes.requestId, undefined, {
                    singleInstrumentationId: trackingAttributes.instrumentationId
                }, agentId ? {
                    id: agentId,
                    name: agentName ?? '',
                    identityAccountId: agentIdentityAccountId ?? null
                } : undefined);
                promptStreamHook?.onActionPart?.(streamMessage, tmpAssistantMessageId, conversationId, openChat);
                const updatedMessages = (0, $cteoa.addActionPart)({
                    chat: getMessages(conversationId),
                    messageId: tmpAssistantMessageId,
                    actionPart: streamMessage,
                    ...(0, $dh538.fg)('aifc_set_accumulated_data_on_message') ? {
                        actionUpdaterOverride: (0, $3vCSA.customActionUpdater)
                    } : {}
                });
                if ((0, $ljUdP.isStreamActionPrepare)(streamMessage)) {
                    const actionMessage = streamMessage.message;
                    // Abort the remix-edit-existing UFO experience if the streamed action is not remix.
                    if (!(0, $3vCSA.isRemixGeneratedFlow)(actionMessage)) (0, $16lEl.remixEditExistingExperience).abort({
                        metadata: {
                            reason: 'non-remix-action'
                        }
                    });
                    setMessages(conversationId, [
                        ...updatedMessages,
                        {
                            type: 'ACTION_PREPARE',
                            action: actionMessage
                        }
                    ]);
                } else setMessages(conversationId, updatedMessages);
            }
            const isAIFCEnabled = (0, $dh538.fg)('aifc_create_enabled');
            const canHandleStreamActionClassification = (0, $dh538.fg)('platform_editor_ai_promptversion_in_analytics');
            if ((0, $ljUdP.isStreamActionClassification)(streamMessage) && isAIFCEnabled && canHandleStreamActionClassification && streamMessage.message.metadata) // Send ACTION_CLASSIFICATION metadata to the Editor Rovo bridge
            processMessageStreamActionClassification?.(tmpAssistantMessageId, streamMessage, traceId, trackingAttributes.requestId, {
                singleInstrumentationId: trackingAttributes.instrumentationId
            });
            if ((0, $ljUdP.isStreamActionComplete)(streamMessage) && (0, $dh538.fg)('aifc_create_enabled')) {
                hasReceivedActionComplete = true;
                processMessageStreamComplete?.(tmpAssistantMessageId, streamMessage, traceId, trackingAttributes.requestId, {
                    singleInstrumentationId: trackingAttributes.instrumentationId
                });
                const actionMessage = streamMessage.message;
                setMessages(conversationId, [
                    ...getMessages(conversationId),
                    {
                        type: 'ACTION_COMPLETE',
                        action: actionMessage
                    }
                ]);
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).AIFC_MESSAGE
                });
            }
            if ((0, $ljUdP.isStreamAnswerPart)(streamMessage)) {
                stopInteractionMetricsTimeToFirstAnswerPart('stop', {
                    answerType: 'stream-answer-part',
                    conversationId: conversationId
                });
                // Stop the implicit think-deeper time-to-first-answer-part metric if active
                implicitThinkDeeperTimeToFirstAnswerPartMetrics?.stop({
                    customData: {
                        answerType: 'stream-answer-part',
                        conversationId: conversationId
                    }
                });
                // Clear Answer Now status when ANSWER_PART is received
                // This handles the case where the stream starts answering without user clicking Answer Now
                (0, $cteoa.clearAnswerNowStatusForMessageIfSet)(conversationId, tmpAssistantMessageId, getMessages, setMessages);
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $cteoa.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                let processedStreamMessage = streamMessage;
                let hasMarkdownData = false;
                if (!isLuminaAnswerGenerationType && (0, $dh538.fg)('rovo_enable_component_streaming')) {
                    if ((0, $dh538.fg)('ai_mate_handle_multi_tags_in_stream_msg')) {
                        const result = getProcessStreamMarkdownMultiTag()(processedStreamMessage);
                        processedStreamMessage = result.processedStreamMessage;
                        if (Object.keys(result.markdownData).length > 0) {
                            hasMarkdownData = true;
                            setMessages(conversationId, (0, $cteoa.addAnswerPartWithMarkdownDataMap)({
                                chat: getMessages(conversationId),
                                answerId: tmpAssistantMessageId,
                                answerPart: processedStreamMessage,
                                markdownData: result.markdownData,
                                useIndex: answerIndex
                            }));
                        }
                    } else {
                        const result = getProcessStreamMarkdown()(processedStreamMessage);
                        processedStreamMessage = result.processedStreamMessage;
                        if (result.markdownData) {
                            hasMarkdownData = true;
                            setMessages(conversationId, (0, $cteoa.addAnswerPartWithMarkdownData)({
                                chat: getMessages(conversationId),
                                answerId: tmpAssistantMessageId,
                                answerPart: processedStreamMessage,
                                markdownData: result.markdownData,
                                useIndex: answerIndex
                            }));
                        }
                    }
                }
                if (!isLuminaAnswerGenerationType) promptStreamHook?.onAnswerPart?.(processedStreamMessage, tmpAssistantMessageId, conversationId);
                if (!hasMarkdownData) setMessages(conversationId, (0, $cteoa.addAnswerPart)({
                    chat: getMessages(conversationId),
                    answerId: tmpAssistantMessageId,
                    answerPart: streamMessage,
                    useIndex: answerIndex
                }));
            // hasAccumulatedAnswerContent tracking is handled by processResearchStreamMessage
            }
            /**********************************************************
       *
       * FINAL_RESPONSE processing
       *
       **********************************************************/ if ((0, $ljUdP.isStreamResponse)(streamMessage)) {
                hasReceivedFinalResponse = true;
                const humanMessage = streamMessage?.message?.human_message;
                const humanMessageId = humanMessage?.id?.toString();
                const agentMessageId = streamMessage?.message?.message?.id.toString();
                // Record the backend-assigned conversation ID on the optimistic entry so the
                // space sidenav merge logic can dedupe between the local optimistic entry
                // (client UUID) and the API-returned entry (backend ID), and display the
                // correct name from the chat store rather than the timestamp fallback.
                const backendConversationId = streamMessage?.message?.message?.conversation_channel_id;
                if (backendConversationId) updateCurrentConversation({
                    backendConversationId: backendConversationId
                });
                const minionOrchestrationOutputs = streamMessage?.message?.message?.minion_outputs;
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $cteoa.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                const { processedStreamMessage: processedStreamMessage, markdownData: markdownData } = !isLuminaAnswerGenerationType ? (0, $cteoa.processStreamResponseMarkdown)({
                    streamMessage: streamMessage,
                    messageId: agentMessageId,
                    conversationId: conversationId,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    shouldPreprocessDetails: (0, $cteoa.shouldPreprocessDetailsForConversation)(getState(), conversationId)
                }) : {
                    processedStreamMessage: streamMessage,
                    markdownData: {}
                };
                // Finish view dead air tracking before rendering final response
                // This ensures the last tracked interval is up to FINAL_RESPONSE arrival,
                // and any DOM updates from replaceAnswerData are not tracked
                viewDeadAirBroker?.finish('completed');
                promptStreamHook?.onFinalResponse?.(processedStreamMessage, tmpAssistantMessageId);
                setMessages(conversationId, (0, $cteoa.replaceAnswerData)({
                    chat: getMessages(conversationId),
                    answerId: tmpAssistantMessageId,
                    content: processedStreamMessage,
                    useIndex: answerIndex,
                    humanMessageId: humanMessageId,
                    markdownData: Object.keys(markdownData).length > 0 ? markdownData : undefined,
                    onMessageIdChanged: onTempMessageIdReplacedOverride || containerOnTempMessageIdReplaced
                }));
                if (humanMessageId) setMessages(conversationId, (0, $cteoa.updateHumanMessageId)({
                    chat: getMessages(conversationId),
                    oldId: tmpHumanMessageId,
                    newId: humanMessageId,
                    parentMessageId: humanMessage?.parent_message_id
                }));
                if ((0, $dh538.fg)('aifc_create_enabled')) {
                    const allMessages = getMessages(conversationId);
                    const isValidAction = (0, $cteoa.handleStagingAreaActionValidation)(allMessages, conversationId, traceId, chatContextStoreActions, experienceTracker, getMessages, setMessages, sendMessageLatencyMetrics, cancelStreamingMetrics, commonExperienceAttributes, productKey, minionOrchestrationOutputs);
                    if (!isValidAction) return {
                        hasReceivedFinalResponse: hasReceivedFinalResponse,
                        hasLoggedInitiatedEvent: hasLoggedInitiatedEvent,
                        guardEventReceived: guardEventReceived
                    };
                    const finalActions = processedStreamMessage.message.message.actions || [];
                    if (finalActions.length > 0) {
                        const firstActionData = finalActions[0]?.data;
                        stopInteractionMetricsTimeToActionCompletion('stop', {
                            conversationId: conversationId,
                            actionType: 'final-actions',
                            actionCount: finalActions.length,
                            actionKeys: finalActions.map((a)=>a.key),
                            actionPartKey: (0, $cteoa.getActionPartKeyForMetrics)(streamActionInfo.actionKey, creationContextParams?.source, firstActionData?.dynamicUiSubtype),
                            interactionSource: messageSources?.interactionSource,
                            remixType: creationContextParams?.dynamicUiType
                        });
                    } else stopInteractionMetricsTimeToActionCompletion('cancel');
                }
                // Update tracking attributes from FINAL_RESPONSE using the shared extractor.
                const streamMeta = (0, $cteoa.extractStreamMeta)(streamMessage, skillSelectionSource, (0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true));
                if (!hasLoggedInitiatedEvent) {
                    trackingAttributes.messageId = agentMessageId;
                    trackingAttributes.instrumentationId = agentMessageId;
                }
                trackingAttributes.humanMessageId = streamMeta.humanMessageId;
                trackingAttributes.hasSources = streamMeta.hasSources;
                trackingAttributes.citedProductList = streamMeta.citedProductList;
                trackingAttributes.sourceProducts = streamMeta.sourceProducts;
                trackingAttributes.messageActions = streamMeta.messageActions;
                trackingAttributes.messageDynamicUIData = streamMeta.messageDynamicUIData;
                trackingAttributes.invokedFrom = streamMeta.invokedFrom;
                trackingAttributes.scenarioId = streamMeta.scenarioId;
                trackingAttributes.sources = streamMeta.responseSources;
                trackingAttributes.usesJsm = streamMeta.usesJsm;
                // Keep Set type for compatibility with downstream consumers that call Array.from()
                trackingAttributes.pluginsInvoked = new Set(streamMeta.pluginsInvoked);
                trackingAttributes.skillsInvoked = streamMeta.skillsInvoked;
                trackingAttributes.executedStratusSkill = streamMeta.executedStratusSkill;
                const flatMinionOutputs = minionOrchestrationOutputs?.flat() ?? [];
                // Analytics: Verify if minion alias matches minion id
                (0, $bd83b455fe877f94$export$8bfbf77736e8f6e2)({
                    minionAlias: minionAlias,
                    agentId: agentId,
                    minionsOutput: flatMinionOutputs,
                    sendAnalyticsEvent: sendAnalyticsEvent
                });
                updateResearchMessageId({
                    messageId: tmpAssistantMessageId,
                    newMessageId: agentMessageId
                });
            }
            if ((0, $ljUdP.isStreamDynamicLayoutSubAgent)(streamMessage) && (0, $dh538.fg)('rovo_chat_enable_lumina')) setMessages(conversationId, (0, $cteoa.addSubAgentMessageToStoreAssistantMessage)(getMessages(conversationId), tmpAssistantMessageId, streamMessage));
            if ((0, $ljUdP.isStreamAgenticUi)(streamObj) && (0, $dh538.fg)('jira_ai_rendering_a2ui')) {
                const normalizedAgenticUiMessage = {
                    ...streamObj.data,
                    type: 'AGENTIC_UI'
                };
                setMessages(conversationId, (0, $cteoa.addAgenticUiMessage)(getMessages(conversationId), tmpAssistantMessageId, normalizedAgenticUiMessage));
            }
            if ((0, $ljUdP.isFollowUpMessage)(streamMessage)) {
                hasReceivedFollowUp = true;
                const messages = getMessages(conversationId);
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $cteoa.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                const augmentedFollowUp = (0, $cteoa.appendCreatePageFollowUpIfNeeded)(messages, streamMessage, productKey);
                setMessages(conversationId, [
                    ...messages,
                    {
                        type: 'FOLLOW_UP',
                        content: augmentedFollowUp,
                        id: (0, $a37fef51f047b95d$export$bac56f3fc527f04b)(0, 1000000),
                        agentMessageId: (0, $cteoa.getLastAgentMessageID)(messages),
                        humanMessageId: trackingAttributes.humanMessageId
                    }
                ]);
            }
            /**
       * Task status processing
       */ if ((0, $ljUdP.isStreamTaskStatus)(streamMessage)) onTaskStatusUpdate?.(streamMessage);
            /**
       * Todo snapshot processing
       */ if ((0, $ljUdP.isStreamTodoSnapshot)(streamMessage)) onTodoSnapshot?.({
                todos: streamMessage.message.todos
            });
            if ((0, $ljUdP.isStreamActionError)(streamMessage)) {
                sendMessageLatencyMetrics.cancel();
                cancelStreamingMetrics();
                processMessageStreamError?.({
                    actionKey: streamActionInfo.actionKey,
                    errorType: streamMessage?.message?.key,
                    errorMessage: streamMessage?.message?.data?.message,
                    traceId: traceId
                });
                promptStreamHook?.onError?.(streamMessage, tmpAssistantMessageId, {
                    openChatOnError: openChatOnError,
                    conversationId: conversationId
                });
                broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
                const actionError = new (0, $iEWar.StreamErrorException)(streamMessage.message.data?.message || 'Action execution failed', {
                    detail: {
                        message: {
                            content: streamMessage?.message?.data?.message || 'Action execution failed',
                            message_template: streamMessage?.message?.key
                        },
                        metadata: {
                            ...streamMessage.metadata,
                            isStagingArea: chatContextStoreActions.getIsStagingArea(),
                            productKey: productKey
                        }
                    },
                    traceId: traceId
                });
                experienceTracker.fail({
                    name: sendMessageExperienceNameCompiled,
                    error: actionError,
                    attributes: {
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        isDeepResearchEnabled: deepResearchEnabled,
                        isThinkDeeperEnabled: thinkDeeperEnabled,
                        isFastModeEnabled: fastModeEnabled,
                        isWebSearchEnabled: webSearchEnabled,
                        llmDebugLogsEnabled: storeUserMessages,
                        productKey: productKey,
                        isStreamAction: streamActionInfo.isAction,
                        actionKey: streamActionInfo.actionKey
                    }
                });
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
                    error: actionError,
                    attributes: {
                        productKey: productKey,
                        isStreamAction: streamActionInfo.isAction,
                        actionKey: streamActionInfo.actionKey,
                        llmDebugLogsEnabled: storeUserMessages,
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        latestStreamMessageMillisOffset: latestStreamMessage && 'millisOffset' in latestStreamMessage ? latestStreamMessage.millisOffset : undefined,
                        latestStreamMessageType: latestStreamMessage?.type
                    }
                });
                if ((0, $dh538.fg)('aifc-experience-timeout')) {
                    const reason = streamActionInfo.isAction ? 'action_error_while_executing_action' : 'action_error_without_classification';
                    for (const name of [
                        (0, $16lEl.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
                        (0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED
                    ])experienceTracker.fail({
                        name: name,
                        error: actionError,
                        attributes: {
                            productKey: productKey,
                            actionKey: streamActionInfo.actionKey,
                            reason: reason
                        }
                    });
                }
                throw actionError;
            }
            if ((0, $ljUdP.isStreamPromptRedaction)(streamMessage)) {
                const redactingTypes = (0, $c6GJD.default).getExperiment('rovo_chat_redacting_guard_config').value?.value ?? [];
                if (redactingTypes.includes(streamMessage.type) && (0, $dh538.fg)('rovo-guard-ui-redaction-and-blocking')) // Do NOT set guardEventReceived — the stream continues with the actual response after redaction.
                onPromptRedacted?.(streamMessage);
            }
            if ((0, $ljUdP.isStreamPromptBlock)(streamMessage)) {
                const blockingTypes = (0, $c6GJD.default).getExperiment('rovo_chat_blocking_guard_config').value?.value ?? [];
                if (blockingTypes.includes(streamMessage.type) && (0, $dh538.fg)('rovo-guard-ui-redaction-and-blocking')) {
                    guardEventReceived = true;
                    onPromptBlocked?.(streamMessage);
                }
            }
            if ((0, $ljUdP.isStreamResponseRedaction)(streamMessage)) {
                const redactingTypes = (0, $c6GJD.default).getExperiment('rovo_chat_redacting_guard_config').value?.value ?? [];
                if (redactingTypes.includes(streamMessage.type) && (0, $dh538.fg)('rovo-guard-ui-redaction-and-blocking')) // Do NOT set guardEventReceived — stream continues after response redaction.
                onResponseRedacted?.(streamMessage);
            }
            if ((0, $ljUdP.isStreamResponseBlock)(streamMessage)) {
                const blockingTypes = (0, $c6GJD.default).getExperiment('rovo_chat_blocking_guard_config').value?.value ?? [];
                if (blockingTypes.includes(streamMessage.type) && (0, $dh538.fg)('rovo-guard-ui-redaction-and-blocking')) {
                    guardEventReceived = true;
                    onResponseBlocked?.(streamMessage);
                }
            }
            if ((0, $ljUdP.isStreamAttachmentBlock)(streamMessage)) {
                const blockingTypes = (0, $c6GJD.default).getExperiment('rovo_chat_blocking_guard_config').value?.value ?? [];
                if (blockingTypes.includes(streamMessage.type) && (0, $dh538.fg)('rovo-guard-ui-redaction-and-blocking')) {
                    guardEventReceived = true;
                    onAttachmentBlocked?.(streamMessage);
                }
            }
            if ((0, $ljUdP.isStreamError)(streamMessage)) {
                processMessageStreamError?.({
                    actionKey: streamActionInfo.actionKey,
                    errorType: streamMessage?.message?.message_template,
                    errorMessage: streamMessage?.message?.content,
                    traceId: traceId
                });
                // If a guard event (PROMPT_REDACTION, PROMPT_BLOCKED, RESPONSE_BLOCKED, or ATTACHMENT_BLOCKED) was
                // already received, the backend always follows with an ERROR to terminate the stream.
                // Treat it as a normal end of the guard flow — break without throwing.
                if (guardEventReceived) break;
                const { message: message, metadata: metadata, millisOffset: millisOffset, type: type } = streamMessage;
                // AUP violations are still considered successful
                if ((0, $ljUdP.isStreamAUPError)(streamMessage)) {
                    experienceTracker.succeed({
                        name: sendMessageExperienceNameCompiled
                    });
                    experienceTracker.succeed({
                        name: (0, $16lEl.ExperienceName).AIFC_MESSAGE
                    });
                }
                sendMessageLatencyMetrics.cancel();
                deadAirTracker?.cancel();
                viewDeadAirBroker?.finish('errored');
                cancelStreamingMetrics();
                promptStreamHook?.onError?.(streamMessage, tmpAssistantMessageId, {
                    openChatOnError: openChatOnError,
                    conversationId: conversationId
                });
                broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
                throw new (0, $iEWar.StreamErrorException)(message?.content || 'Unknown', {
                    detail: {
                        message: message,
                        metadata: metadata,
                        millisOffset: millisOffset,
                        type: type
                    },
                    traceId: traceId
                });
            }
        }
    } catch (error) {
        /* for await catch block */ const err = error instanceof Error ? error : new Error(String(error));
        if (err instanceof (0, $iEWar.StreamErrorException)) throw err;
        // this is for any errors that happening during processing the stream
        // e.g. BE terminates streaming suddenly
        sendMessageLatencyMetrics.cancel();
        deadAirTracker?.cancel();
        viewDeadAirBroker?.finish('aborted');
        cancelStreamingMetrics();
        if ((0, $cteoa.isClientSideStreamingError)(err)) {
            const reconnectionPossible = agentMessageId && isReconnectSupported;
            if (reconnectionPossible && !(0, $c6GJD.default).getExperimentValue('rovo_chat_reconnect_all_experiment', 'isEnabled', false)) {
                setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageId)({
                    chat: getMessages(conversationId),
                    oldId: tmpAssistantMessageId,
                    newId: agentMessageId
                }));
                updateResearchMessageId({
                    messageId: tmpAssistantMessageId,
                    newMessageId: agentMessageId
                });
                throw new (0, $iEWar.StreamDisconnectedError)(err.message ?? 'Stream client side error', {
                    agentMessageId: agentMessageId,
                    conversationId: conversationId,
                    answerIndex: answerIndex,
                    lastEventId: lastEventId,
                    originalError: err,
                    traceId: traceId,
                    detail: {
                        millisOffset: latestStreamMessage && 'millisOffset' in latestStreamMessage ? latestStreamMessage.millisOffset : undefined,
                        type: latestStreamMessage?.type ?? ''
                    }
                });
            }
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'failed',
                actionSubject: 'rovoChatStream',
                attributes: {
                    ...streamStats.getStats(),
                    isDeepResearchEnabled: deepResearchEnabled,
                    isThinkDeeperEnabled: thinkDeeperEnabled,
                    isFastModeEnabled: fastModeEnabled,
                    isWebSearchEnabled: webSearchEnabled,
                    isAIFCStreaminAction: streamActionInfo.isAction,
                    isReconnectable: reconnectionPossible,
                    conversationId: conversationId,
                    instrumentationId: trackingAttributes.instrumentationId,
                    requestId: trackingAttributes.requestId,
                    interactionSource: trackingAttributes.interactionSource,
                    contentContext: chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global',
                    userAgent: navigator?.userAgent,
                    error: err.message
                }
            });
        }
        broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
        // When reconnect attempt fails
        if (!deepResearchEnabled && (0, $dh538.fg)('aifc-experience-timeout')) {
            const reason = streamActionInfo.isAction ? 'stream_error_during_action' : 'stream_error_before_classification';
            for (const name of [
                (0, $16lEl.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
                (0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED
            ])experienceTracker.fail({
                name: name,
                error: err,
                attributes: {
                    productKey: productKey,
                    actionKey: streamActionInfo.actionKey,
                    reason: reason
                }
            });
        }
        throw new (0, $iEWar.StreamGeneratorError)(err.message ?? 'Stream generator error', {
            traceId: traceId,
            detail: {
                millisOffset: latestStreamMessage && 'millisOffset' in latestStreamMessage ? latestStreamMessage.millisOffset : undefined,
                type: latestStreamMessage?.type ?? ''
            }
        }, err);
    } finally{
        inactivity?.stop();
        deadAirTracker?.complete();
        viewDeadAirBroker?.finish('completed');
    }
    /**********************************************************
   *
   * Stream processing END
   *
   **********************************************************/ if (hasReceivedActionClassification && !hasReceivedActionComplete && hasReceivedFinalResponse) // In the case ACTION_COMPLETE was never sent, it's likely that `AdfEditorMinion` early-exits with "no operations returned by LLM". So we abort the experiences rather than letting them timeout. This can potentially happen when LLM needs clarification.
    (0, $52Fo2.abortGenerateContentChildExperiences)(experienceTracker, 'stream_completed_without_action_complete', {
        actionKey: streamActionInfo.actionKey,
        productKey: productKey
    });
    if (!hasReceivedFollowUp && hasReceivedFinalResponse) {
        const messages = getMessages(conversationId);
        if ((0, $cteoa.shouldAppendCreatePageFollowUp)(messages, productKey)) setMessages(conversationId, [
            ...messages,
            {
                type: 'FOLLOW_UP',
                content: (0, $cteoa.createSyntheticCreatePageFollowUp)(),
                id: (0, $a37fef51f047b95d$export$bac56f3fc527f04b)(0, 1000000),
                agentMessageId: (0, $cteoa.getLastAgentMessageID)(messages),
                humanMessageId: trackingAttributes.humanMessageId
            }
        ]);
    }
    updateCurrentConversation({
        sourceAgentId: (0, $cteoa.getSourceAgentId)(getMessages(conversationId), (0, $cteoa.getConversation)(getState(), conversationId))
    });
    return {
        hasReceivedFinalResponse: hasReceivedFinalResponse,
        hasLoggedInitiatedEvent: hasLoggedInitiatedEvent,
        hasAbortedForImplicitThinkDeeper: hasAbortedForImplicitThinkDeeper,
        implicitThinkDeeperSendMessageMetrics: implicitThinkDeeperSendMessageMetrics,
        implicitThinkDeeperExperienceName: implicitThinkDeeperExperienceName,
        guardEventReceived: guardEventReceived
    };
};
/**
 * Compute the per-send routing identity for a send.
 *
 * Wraps `deriveAgentSendRequestIdentity` with the shared inputs (default agent,
 * explicit caller agent id, and the draft-only-on-chatInput override rule) so the
 * outer early-handler fallback and the inner per-send path stay in lockstep.
 *
 * The no-override wire/routing fallback follows the CALLER's agent intent
 * (`conversationAgentForRequest`), not necessarily the stored conversation agent:
 * in-sidebar sends pass the conversation's own agent, a cross-surface pass-over
 * passes default Rovo. This keeps author and wire consistent for the turn and
 * matches gate-off. See ai-mate AGENTS.md "Rovo Chat agent identity, routing, and
 * display".
 */ const $54793c520b6b8872$var$deriveSendRoutingIdentity = ({ conversationAgentForRequest: conversationAgentForRequest, agentIdParam: agentIdParam, inputSelectedAgentIds: inputSelectedAgentIds, messageSources: messageSources, omitConversationDefaultAgentRequestFields: omitConversationDefaultAgentRequestFields })=>(0, $3e5408ba1f60d629$export$4413981bab4da984)({
        conversationAgent: conversationAgentForRequest,
        defaultAgent: (0, $1cjt9.DEFAULT_AGENT),
        explicitAgentId: agentIdParam,
        omitConversationDefaultAgentRequestFields: omitConversationDefaultAgentRequestFields,
        inputSelectedAgentIds: inputSelectedAgentIds,
        // The unsent agent-selector draft only routes when the send originates with
        // `messageSources.interactionSource === 'chatInput'`; cross-surface handoffs
        // (e.g. the Confluence inline Rovo input) must not inherit the sidebar's draft.
        allowSelectedAgentOverride: messageSources?.interactionSource === 'chatInput'
    });
/**
 * Build the optimistic `conversation.agent` metadata used when a send creates the
 * conversation. Prefers the already-stored conversation agent, then the caller's
 * rich agent metadata when it matches the resolved conversation agent id, then a
 * provisional placeholder built from that id (the header hydrates the rest).
 */ const $54793c520b6b8872$var$buildOptimisticConversationAgent = ({ agent: agent, currentConversation: currentConversation, conversationAgentId: conversationAgentId })=>{
    const callerAgentMatchesConversation = agent.id === conversationAgentId;
    const callerAgentConversationMetadata = callerAgentMatchesConversation ? {
        agent_id: agent.id,
        agent_named_id: agent.external_config_reference ?? agent.named_id,
        agent_name: agent.name,
        creator_type: agent.creator_type,
        identity_account_id: agent.identity_account_id ?? undefined,
        is_default: agent.is_default,
        forge_url: agent.icon ?? undefined
    } : undefined;
    return currentConversation?.agent ?? callerAgentConversationMetadata ?? (0, $ce0ec8f0bfa0c691$export$fc6a9cdad8ea90e0)(conversationAgentId);
};
const $54793c520b6b8872$export$9558791053c77c34 = ({ prompt: prompt, agent: /*
  As of RAGE-60 the default agent is no longer required to be sent to the backend, however
  it is still required for other local logic
  TODO: https://product-fabric.atlassian.net/browse/RAGE-418
  */ agent = (0, $1cjt9.DEFAULT_AGENT), agentId: agentIdParam, conversationId: conversationIdParam, storeUserMessages: storeUserMessages, messageSources: messageSources, files: files, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, taskModeEnabled: taskModeEnabled, webSearchEnabled: webSearchEnabled, appFilters: appFilters, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, productKey: productKey, source: source, promptStreamHook: promptStreamHook, creationContextParams: creationContextParams, additionalAnalyticAttributes: additionalAnalyticAttributes, contentContext: contentContext, minionAlias: minionAlias, onTempMessageIdReplacedOverride: onTempMessageIdReplacedOverride, contentId: contentId, openChat: openChat, openChatOnError: openChatOnError, agentVersion: agentVersion, spaceId: spaceId, searchArtifact: searchArtifact, skillSelectionSource: skillSelectionSource, skipEditorContext: skipEditorContext, shouldExtractConversationScopes: shouldExtractConversationScopes, parentMessageId: parentMessageId, editRollback: editRollback, setConversationData: setConversationData, createConversationOptimistically: createConversationOptimistically, addHumanMessage: addHumanMessage, addAssistantMessage: addAssistantMessage, clearFollowUpMessages: clearFollowUpMessages, setSelectedConversation: setSelectedConversation, reconnectToInProgressStream: reconnectToInProgressStream })=>async ({ dispatch: dispatch, getState: getState, setState: setState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, chatContextStoreActions: chatContextStoreActions, trackAIMAUEvent: trackAIMAUEvent, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, markIncompleteResearchesErrored: markIncompleteResearchesErrored, updateResearchMessageId: updateResearchMessageId, clearMessageResearch: clearMessageResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, getChatInitiator: getChatInitiator, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamError: processMessageStreamError, processMessageStreamActionClassification: processMessageStreamActionClassification, broadcastStreamStatus: broadcastStreamStatus, onNewConversationStartingWithSendMessage: onNewConversationStartingWithSendMessage, onTempMessageIdReplaced: containerOnTempMessageIdReplaced, browserContextSanitizer: browserContextSanitizer, viewDeadAirBroker: viewDeadAirBroker, getIsChatMounted: getIsChatMounted, capabilities: capabilities, unifiedTasksActions: unifiedTasksActions })=>{
        const initialConversationForRouting = (0, $cteoa.getConversation)(getState(), conversationIdParam ?? getState().currentConversationId);
        const conversationAgentIdForRoutingFallback = (0, $ce0ec8f0bfa0c691$export$9e56ee965c896858)({
            conversation: initialConversationForRouting,
            fallbackAgentId: agent.id
        });
        // `sourceAgentId` for the temporary local conversation; per-turn routing is computed by `deriveSendRoutingIdentity`.
        const sourceAgentIdForTemporaryLocalConversation = agentIdParam ?? agent.id;
        // Early error/success handlers can run before the inner send path recomputes
        // request routing and updates `activeSendMessageExperienceName`. Start with
        // the best synchronous routing identity so those handlers classify analytics
        // consistently if the send exits early.
        const { routingAgentId: fallbackRoutingAgentId } = $54793c520b6b8872$var$deriveSendRoutingIdentity({
            conversationAgentForRequest: {
                id: conversationAgentIdForRoutingFallback,
                named_id: agent.named_id
            },
            agentIdParam: agentIdParam,
            inputSelectedAgentIds: initialConversationForRouting?.selectedAgentIds,
            messageSources: messageSources
        });
        let activeSendMessageExperienceName = (0, $16lEl.sendMessageExperienceName)({
            deepResearchEnabled: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            fastModeEnabled: fastModeEnabled,
            isCustomRovoAgent: (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(fallbackRoutingAgentId)
        });
        const { messageType: messageType } = $54793c520b6b8872$var$getOptimisticMessageTypes(deepResearchEnabled, webSearchEnabled);
        (0, $9963cc910aac4af3$export$589976df4d188aac)(Date.now());
        const getActiveSendMessageExperienceName = ()=>activeSendMessageExperienceName;
        let pageContext;
        // Snapshot captured right before the optimistic add when `editRollback` is set,
        // so that a terminal failure can restore the conversation to its pre-edit state
        // by slicing back to this length and re-appending `editRollback.restoreMessages`.
        let rollbackSnapshot;
        const performEditRollback = ()=>{
            if (!editRollback || !rollbackSnapshot) return;
            const { conversationId: rollbackConvId, lengthBeforeOptimistic: lengthBeforeOptimistic } = rollbackSnapshot;
            const current = getMessages(rollbackConvId);
            setMessages(rollbackConvId, [
                ...current.slice(0, lengthBeforeOptimistic),
                ...editRollback.restoreMessages
            ]);
        };
        const sendMessageFn = async ({ conversationId: conversationId })=>{
            const currentConversation = (0, $cteoa.getConversation)(getState(), conversationId);
            const currentConversationAgentId = (0, $ce0ec8f0bfa0c691$export$9e56ee965c896858)({
                conversation: currentConversation,
                fallbackAgentId: conversationAgentIdForRoutingFallback
            });
            const conversationAgentForOptimisticCreation = $54793c520b6b8872$var$buildOptimisticConversationAgent({
                agent: agent,
                currentConversation: currentConversation,
                conversationAgentId: currentConversationAgentId
            });
            const { routedSelectedAgentId: routedSelectedAgentId, routingAgentId: routingAgentId, agentIdForRequest: agentIdForRequest, agentNamedIdForRequest: agentNamedIdForRequest } = $54793c520b6b8872$var$deriveSendRoutingIdentity({
                conversationAgentForRequest: {
                    id: agent.id,
                    named_id: agent.named_id
                },
                agentIdParam: agentIdParam,
                inputSelectedAgentIds: currentConversation?.selectedAgentIds,
                messageSources: messageSources,
                omitConversationDefaultAgentRequestFields: true
            });
            const sendMessageExperienceNameCompiled = (0, $16lEl.sendMessageExperienceName)({
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                fastModeEnabled: fastModeEnabled,
                isCustomRovoAgent: (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(routingAgentId)
            });
            activeSendMessageExperienceName = sendMessageExperienceNameCompiled;
            const resolvedAgentVersion = agentVersion ?? currentConversation?.agentVersion;
            if (currentConversation?.storeAbortController) // Silently aborting if there is another operation in progress
            return;
            const tmpHumanMessageId = (0, $cteoa.generateId)();
            const tmpAssistantMessageId = (0, $cteoa.generateTmpMessageId)(conversationId);
            let generator;
            let responseData;
            let hasLoggedInitiatedEvent = false;
            const isFirstPrompt = (0, $cteoa.isEmptyConversation)(conversationId);
            const contentContextFromStore = chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global';
            const contentContextValue = contentContext ?? contentContextFromStore;
            let trackingAttributes = $54793c520b6b8872$var$getInitialTrackingAttributes(routingAgentId, tmpAssistantMessageId, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, taskModeEnabled, webSearchEnabled, messageSources, isFirstPrompt, prompt, files, appFilters, {
                templateId: creationContextParams?.templateInput?.templateId,
                templateType: creationContextParams?.templateInput?.templateType
            }, creationContextParams?.forcedContentType);
            // Prepare fields for the temporary local conversation created before the backend returns one.
            const conversationAgentForTemporaryLocalConversation = (0, $dh538.fg)('rovo_chat_agent_selection') ? conversationAgentForOptimisticCreation : undefined;
            const conversationAgentFieldsForTemporaryLocalConversation = conversationAgentForTemporaryLocalConversation ? {
                agent: conversationAgentForTemporaryLocalConversation
            } : {};
            if (isFirstPrompt) {
                conversationId = crypto.randomUUID();
                onNewConversationStartingWithSendMessage(conversationId, {
                    deepResearchEnabled: deepResearchEnabled,
                    thinkDeeperEnabled: thinkDeeperEnabled,
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode,
                    fastModeEnabled: fastModeEnabled,
                    ...taskModeEnabled ? {
                        planModeEnabled: taskModeEnabled
                    } : {},
                    webSearchEnabled: webSearchEnabled,
                    useCurrentPageContext: addCurrentPageAsContextUserPreference,
                    appFilters: appFilters
                });
                // Create the conversation with its initial identity; first-turn routing may
                // refine `conversation.agent` below.
                dispatch(createConversationOptimistically({
                    id: conversationId,
                    status: (0, $bPHr8.CHAT_STORE_STATUS).awaitingResponse,
                    sourceAgentId: currentConversation?.sourceAgentId ?? sourceAgentIdForTemporaryLocalConversation,
                    lastMessageType: messageType,
                    lastAgentMessageStatus: 'IN_PROGRESS',
                    selectedAgentIds: currentConversation?.selectedAgentIds ? [
                        ...currentConversation.selectedAgentIds
                    ] : undefined,
                    // Immediately scope the optimistic conversation to the space so it
                    // appears under the space in the sidenav rather than the regular list.
                    ...spaceId && (0, $dh538.fg)('rovo_chat_spaces_fe') ? {
                        rovoSpaceId: spaceId
                    } : {},
                    ...resolvedAgentVersion && (0, $dh538.fg)('rovo_agent_versioning_enabled') ? {
                        agentVersion: resolvedAgentVersion
                    } : {},
                    ...conversationAgentFieldsForTemporaryLocalConversation
                }));
                // First-turn routing can refine display identity; keep `sourceAgentId` as history.
                const normalizedRoutingAgentId = routingAgentId || undefined;
                const routedConversationAgent = (0, $ce0ec8f0bfa0c691$export$fc6a9cdad8ea90e0)(normalizedRoutingAgentId);
                if ((0, $dh538.fg)('rovo_chat_agent_selection') && routedConversationAgent && normalizedRoutingAgentId !== currentConversationAgentId) dispatch(setConversationData({
                    conversationId: conversationId,
                    data: {
                        agent: routedConversationAgent
                    }
                }));
            }
            const { sendMessageLatencyMetrics: sendMessageLatencyMetrics, stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart, stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart, stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion, cancelStreamingMetrics: cancelStreamingMetrics, metricsStartTime: metricsStartTime } = $54793c520b6b8872$var$initLatencyMetrics({
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                fastModeEnabled: fastModeEnabled,
                agentId: routingAgentId
            });
            experienceTracker.start({
                name: sendMessageExperienceNameCompiled,
                id: conversationId,
                attributes: {
                    conversationId: conversationId,
                    interactionSource: messageSources?.interactionSource,
                    featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
                }
            });
            const chatInitiator = getChatInitiator();
            const { isRemixFollowUp: isRemixFollowUp, lastAssistantMessageDynamicUiType: lastAssistantMessageDynamicUiType } = (()=>{
                const lastAction = (0, $cteoa.findLastAssistantAction)(getMessages(conversationId), ()=>true);
                if (!lastAction || !(0, $3vCSA.isRemixGeneratedFlow)(lastAction)) return {
                    isRemixFollowUp: false,
                    lastAssistantMessageDynamicUiType: undefined
                };
                // BE stores dynamicUiType under `contentType` in action data
                const contentType = lastAction.data?.contentType;
                return {
                    isRemixFollowUp: true,
                    lastAssistantMessageDynamicUiType: contentType
                };
            })();
            let sendMessageContext;
            try {
                sendMessageContext = await $54793c520b6b8872$var$populateSendMessageContext(chatContextStoreActions, isFirstPrompt, source, addCurrentPageAsContextUserPreference, contentContextValue, creationContextParams, productKey, sendAnalyticsEvent, contentId, lastAssistantMessageDynamicUiType, skipEditorContext, isRemixFollowUp, searchArtifact);
            } catch (error) {
                experienceTracker.fail({
                    name: sendMessageExperienceNameCompiled,
                    error: error,
                    attributes: {
                        deepResearchEnabled: deepResearchEnabled,
                        fastModeEnabled: fastModeEnabled,
                        thinkDeeperEnabled: thinkDeeperEnabled,
                        webSearchEnabled: webSearchEnabled,
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        failureSource: 'populateSendMessageContext'
                    }
                });
                // Note: We don't track error in error event as discussed here:
                // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/341408/overview#comment-2004687398
                sendMessageLatencyMetrics.cancel();
                cancelStreamingMetrics();
                return;
            }
            // spaceId comes from the emptyChatLaunch projectContext (e.g. rovo-for-you space card chat button).
            const resolvedSpaceId = spaceId ?? sendMessageContext.aiFeatureContext?.projectContext?.spaceId;
            const storeState = chatContextStoreActions.getAllContext();
            trackingAttributes.contextProvided = Object.entries(storeState).reduce((acc, [key, value])=>{
                acc[key] = Boolean(value);
                return acc;
            }, {});
            trackingAttributes.contextProvided.editorContext = Boolean(sendMessageContext.editorContext);
            trackingAttributes.contextProvided.whiteboardContext = Boolean(sendMessageContext.whiteboardContext);
            trackingAttributes.contextProvided.slidesContext = Boolean(sendMessageContext.slidesContext);
            trackingAttributes.contextProvided.databaseContext = Boolean(sendMessageContext.databaseContext);
            trackingAttributes.contextProvided.browserContext = Boolean(sendMessageContext.browserContext);
            trackingAttributes.contextProvided.dashboardContext = Boolean(sendMessageContext.dashboardContext);
            trackingAttributes.contextProvided.aiFeatureContext = Boolean(sendMessageContext.aiFeatureContext);
            trackingAttributes.contextProvided.jiraWorkflowContext = Boolean(sendMessageContext.jiraWorkflowContext);
            trackingAttributes.contextProvided.domContext = Boolean(sendMessageContext.browserContext?.context?.htmlBody);
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'sent',
                actionSubject: 'message',
                attributes: {
                    timestamp: undefined,
                    messageId: trackingAttributes.humanMessageId,
                    interactionSource: trackingAttributes.interactionSource,
                    followUpSource: trackingAttributes.followUpSource,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    maxModeEnabled: trackingAttributes.taskModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    contextProvided: trackingAttributes.contextProvided,
                    initiator: chatInitiator,
                    isFirstPrompt: trackingAttributes.isFirstPrompt,
                    promptFeatures: trackingAttributes.promptFeatures,
                    fileCount: trackingAttributes.fileCount,
                    appFilters: trackingAttributes.appFilters,
                    appFilterCount: trackingAttributes.appFilterCount,
                    has3pApps: trackingAttributes.appFilters?.some((app)=>(0, $5vtU3.is3pApp)(app.friendlyName)),
                    template: trackingAttributes.template,
                    deepResearchInvoked: trackingAttributes.deepResearchInvoked,
                    conversationChannelId: conversationId
                }
            });
            if (editRollback && !rollbackSnapshot) rollbackSnapshot = {
                conversationId: conversationId,
                lengthBeforeOptimistic: getMessages(conversationId).length
            };
            const { abortController: abortController, confirmAbort: confirmAbort, updateCurrentConversation: updateCurrentConversation } = $54793c520b6b8872$var$hydrateStoreWithNewMessage(dispatch, conversationId, messageType, tmpHumanMessageId, tmpAssistantMessageId, prompt, files, sourceAgentIdForTemporaryLocalConversation, setConversationData, addHumanMessage, addAssistantMessage, clearFollowUpMessages, routedSelectedAgentId);
            // Assumed the insert is successful and inserts at the last position
            const answerIndex = getMessages(conversationId).length - 1;
            // Broadcast stream status to content targets for state sharing
            const broadcastStreamLifecycle = (0, $cteoa.createBroadcastStreamLifecycle)({
                broadcastStreamStatus: broadcastStreamStatus,
                chatContextStoreActions: chatContextStoreActions,
                contentContextValue: contentContextValue,
                targetId: contentId,
                assistantMessageId: tmpAssistantMessageId
            });
            // Initialize action tracking
            let streamActionInfo = {
                isAction: false
            };
            // Create message stream
            try {
                // Derive page context for analytics from the available context objects
                pageContext = (0, $bb60cdbb8ebc402b$export$1303843c2f44065a)({
                    editorContext: sendMessageContext.editorContext,
                    whiteboardContext: sendMessageContext.whiteboardContext,
                    databaseContext: sendMessageContext.databaseContext,
                    aiFeatureContext: sendMessageContext.aiFeatureContext,
                    browserUrl: sendMessageContext.browserContext?.context?.browserUrl
                });
                trackingAttributes.pageContext = pageContext;
                trackingAttributes.viewContext = (0, $d097db038375fc24$export$20af16720c0f9c71)({
                    aiFeatureContext: sendMessageContext.aiFeatureContext
                });
                trackingAttributes.invokedFrom = (0, $cteoa.getInvokedFrom)({
                    messageActionKey: streamActionInfo?.actionKey
                });
                // Check if the Jira refresh experiment is enabled but default is set to `true` to pass all non-Jira products
                // Omit caller source controls only for sends routed by `routedSelectedAgentId`;
                // see `getSourceControlValueForBackend`.
                const webSearchEnabledForBackend = $54793c520b6b8872$export$7459a30868c458f({
                    routedSelectedAgentId: routedSelectedAgentId,
                    value: webSearchEnabled
                });
                const appFiltersForBackend = $54793c520b6b8872$export$7459a30868c458f({
                    routedSelectedAgentId: routedSelectedAgentId,
                    value: appFilters
                });
                const agentNamedIdForBackend = (0, $dh538.fg)('rovo_chat_agent_selection') ? agentNamedIdForRequest : undefined;
                const result = await assistanceService.sendMessageStream({
                    message: prompt,
                    agentId: agentIdForRequest,
                    // Gate-off must not introduce `recipient_agent_named_id` on the wire.
                    agentNamedId: agentNamedIdForBackend,
                    controller: abortController,
                    conversationId: conversationId,
                    storeMessage: storeUserMessages,
                    citationsEnabled: true,
                    fileIds: files?.map((file)=>file.id),
                    deepResearchEnabled: deepResearchEnabled,
                    thinkDeeperEnabled: thinkDeeperEnabled,
                    planModeEnabled: taskModeEnabled,
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode,
                    fastModeEnabled: fastModeEnabled,
                    webSearchEnabled: webSearchEnabledForBackend,
                    appFilters: appFiltersForBackend?.map((app)=>app.source),
                    browserContext: sendMessageContext.browserContext,
                    editorContext: sendMessageContext.editorContext,
                    whiteboardContext: sendMessageContext.whiteboardContext,
                    slidesContext: sendMessageContext.slidesContext,
                    databaseContext: sendMessageContext.databaseContext,
                    additionalContext: sendMessageContext.additionalContext,
                    aiFeatureContext: sendMessageContext.aiFeatureContext,
                    jiraWorkflowContext: sendMessageContext.jiraWorkflowContext,
                    dashboardContext: sendMessageContext.dashboardContext,
                    dashboardEditorContext: sendMessageContext.dashboardEditorContext,
                    useCurrentBrowsingContext: sendMessageContext.useCurrentBrowsingContext,
                    browserContextSanitizer: browserContextSanitizer,
                    optInToDeepResearchV2: true,
                    optInThinkDeeperMessages: true,
                    optInAnsNow: true,
                    optInNewToolTraces: (0, $c6GJD.default).getExperimentValue('rovo_chat_thinking_traces_improvements', 'isEnabled', false, {
                        fireExperimentExposure: false
                    }),
                    optInNewTeamworkTraceIcons: (0, $dh538.fg)('rovo_chat_enable_twg_trace_team26'),
                    optInSSEStream: true,
                    ...resolvedAgentVersion ? {
                        agentVersion: resolvedAgentVersion
                    } : {},
                    ...resolvedSpaceId ? {
                        spaceId: resolvedSpaceId
                    } : {},
                    capabilities: capabilities,
                    shouldExtractConversationScopes: shouldExtractConversationScopes,
                    parentMessageId: parentMessageId
                });
                generator = result.generator;
                responseData = result.responseData;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if ((0, $dh538.fg)('aifc_show_error_ui_for_inline_rovo')) promptStreamHook?.onError?.(error, tmpAssistantMessageId, {
                    openChatOnError: openChatOnError,
                    conversationId: conversationId
                });
                performEditRollback();
                $54793c520b6b8872$var$handleSendMessageServiceCallFailure(error, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, webSearchEnabled, streamActionInfo, chatContextStoreActions, experienceTracker, sendMessageExperienceNameCompiled, trackingAttributes, updateCurrentConversation, sendMessageLatencyMetrics, cancelStreamingMetrics, broadcastStreamLifecycle, confirmAbort, trackAIMAUEvent, messageSources, abortController, hasLoggedInitiatedEvent, tmpAssistantMessageId, clearMessageResearch, getState, conversationId, storeUserMessages);
                return;
            }
            const { hasReceivedFinalResponse: hasReceivedFinalResponse, hasLoggedInitiatedEvent: hasLoggedInitiatedEventForStream, hasAbortedForImplicitThinkDeeper: hasAbortedForImplicitThinkDeeper, implicitThinkDeeperSendMessageMetrics: implicitThinkDeeperSendMessageMetrics, implicitThinkDeeperExperienceName: implicitThinkDeeperExperienceName, guardEventReceived: wasGuardTerminated } = await $54793c520b6b8872$export$efb69f1fe7577739({
                prompt: prompt,
                generator: generator,
                productKey: productKey,
                answerIndex: answerIndex,
                tmpHumanMessageId: tmpHumanMessageId,
                tmpAssistantMessageId: tmpAssistantMessageId,
                thinkDeeperEnabled: thinkDeeperEnabled,
                fastModeEnabled: fastModeEnabled,
                deepResearchEnabled: deepResearchEnabled,
                webSearchEnabled: webSearchEnabled,
                sendMessageExperienceNameCompiled: sendMessageExperienceNameCompiled,
                traceId: responseData?.traceId,
                updateCurrentConversation: updateCurrentConversation,
                trackingAttributes: trackingAttributes,
                conversationId: conversationId,
                getState: getState,
                promptStreamHook: promptStreamHook,
                openChat: openChat,
                openChatOnError: openChatOnError,
                experienceTracker: experienceTracker,
                setMessages: setMessages,
                getMessages: getMessages,
                processStreamResearch: processStreamResearch,
                processMessageStreamAction: processMessageStreamAction,
                processMessageStreamComplete: processMessageStreamComplete,
                processMessageStreamError: processMessageStreamError,
                processMessageStreamActionClassification: processMessageStreamActionClassification,
                containerOnTempMessageIdReplaced: containerOnTempMessageIdReplaced,
                updateResearchMessageId: updateResearchMessageId,
                sendAnalyticsEvent: sendAnalyticsEvent,
                chatContextStoreActions: chatContextStoreActions,
                stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart,
                stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart,
                stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion,
                broadcastStreamLifecycle: broadcastStreamLifecycle,
                sendMessageLatencyMetrics: sendMessageLatencyMetrics,
                cancelStreamingMetrics: cancelStreamingMetrics,
                onTempMessageIdReplacedOverride: onTempMessageIdReplacedOverride,
                streamActionInfo: streamActionInfo,
                trackAIMAUEvent: trackAIMAUEvent,
                messageSources: messageSources,
                additionalAnalyticAttributes: additionalAnalyticAttributes,
                hasLoggedInitiatedEvent: hasLoggedInitiatedEvent,
                clearMessageResearch: clearMessageResearch,
                addImplicitResearchPlan: addImplicitResearchPlan,
                resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                viewDeadAirBroker: viewDeadAirBroker,
                creationContextParams: creationContextParams,
                minionAlias: assistanceService.getConfig().minionAlias,
                agentId: routingAgentId,
                agentName: agent?.name,
                agentIdentityAccountId: agent?.identity_account_id,
                storeUserMessages: storeUserMessages,
                skillSelectionSource: skillSelectionSource,
                assistanceService: assistanceService,
                abortController: abortController,
                getIsChatMounted: getIsChatMounted,
                metricsStartTime: metricsStartTime,
                onTaskStatusUpdate: (streamMessage)=>{
                    if (!unifiedTasksActions || !(0, $dh538.fg)('rovo_chat_enable_tasks')) return;
                    (0, $4bca5e7215eb7baa$export$89a4ab1dea43d7ee)({
                        conversationId: conversationId,
                        taskMessage: streamMessage.message,
                        messageId: trackingAttributes.messageId,
                        target: (0, $4bca5e7215eb7baa$export$6b58e85d865a8eef)(unifiedTasksActions)
                    });
                },
                onTodoSnapshot: ({ todos: todos })=>{
                    if (!unifiedTasksActions || !(0, $dh538.fg)('rovo_chat_enable_tasks')) return;
                    unifiedTasksActions.setTaskTodoSnapshot({
                        conversationId: conversationId,
                        todoSnapshot: {
                            todos: todos
                        }
                    });
                },
                onPromptBlocked: (streamMessage)=>{
                    const chat = getMessages(conversationId);
                    const withoutPlaceholder = chat.filter((_, idx)=>idx !== answerIndex);
                    const guardBlock = {
                        type: 'GUARD_BLOCK',
                        id: String((0, $a37fef51f047b95d$export$bac56f3fc527f04b)(0, 1000000)),
                        time_created: new Date().toISOString(),
                        traceId: streamMessage.metadata?.request_id ?? undefined,
                        blockType: streamMessage.type
                    };
                    setMessages(conversationId, [
                        ...withoutPlaceholder,
                        guardBlock
                    ]);
                },
                onPromptRedacted: (streamMessage)=>{
                    // Only update the human message with the redacted prompt.
                    // Keep the assistant placeholder — the stream continues with the actual response.
                    const chat = getMessages(conversationId);
                    let lastHumanIdx = -1;
                    chat.forEach((m, i)=>{
                        if ((0, $bPHr8.isStoreHuman)(m)) lastHumanIdx = i;
                    });
                    if (lastHumanIdx === -1) return;
                    const newChat = [
                        ...chat
                    ];
                    newChat[lastHumanIdx] = {
                        ...chat[lastHumanIdx],
                        redactedPrompt: streamMessage.message.redacted_prompt
                    };
                    setMessages(conversationId, newChat);
                },
                onResponseRedacted: (streamMessage)=>{
                    // Set redactedResponse on the latest assistant message so the scribble UI renders.
                    // Do NOT set guardEventReceived — the stream continues after response redaction.
                    const chat = getMessages(conversationId);
                    let lastAssistantIdx = -1;
                    chat.forEach((m, i)=>{
                        if ((0, $bPHr8.isStoreAssistant)(m)) lastAssistantIdx = i;
                    });
                    if (lastAssistantIdx === -1) return;
                    const newChat = [
                        ...chat
                    ];
                    newChat[lastAssistantIdx] = {
                        ...chat[lastAssistantIdx],
                        redactedResponse: streamMessage.message.redacted_response
                    };
                    setMessages(conversationId, newChat);
                },
                onResponseBlocked: (streamMessage)=>{
                    const chat = getMessages(conversationId);
                    const withoutPlaceholder = chat.filter((_, idx)=>idx !== answerIndex);
                    const guardBlock = {
                        type: 'GUARD_BLOCK',
                        id: String((0, $a37fef51f047b95d$export$bac56f3fc527f04b)(0, 1000000)),
                        time_created: new Date().toISOString(),
                        traceId: streamMessage.metadata?.request_id ?? undefined,
                        blockType: streamMessage.type
                    };
                    setMessages(conversationId, [
                        ...withoutPlaceholder,
                        guardBlock
                    ]);
                },
                onAttachmentBlocked: (streamMessage)=>{
                    const chat = getMessages(conversationId);
                    const withoutPlaceholder = chat.filter((_, idx)=>idx !== answerIndex);
                    const guardBlock = {
                        type: 'GUARD_BLOCK',
                        id: String((0, $a37fef51f047b95d$export$bac56f3fc527f04b)(0, 1000000)),
                        time_created: new Date().toISOString(),
                        traceId: streamMessage.metadata?.request_id ?? undefined,
                        blockType: streamMessage.type
                    };
                    setMessages(conversationId, [
                        ...withoutPlaceholder,
                        guardBlock
                    ]);
                }
            });
            hasLoggedInitiatedEvent = hasLoggedInitiatedEventForStream;
            // TODO: This should be behind the !aborted logic, but due to a bug in the BE service, aborted requests
            // will client connection with the server yet still complete in the background. This results in the UI showing
            // no message updates, until reload when the actual resolved message can be sesen.
            // Once that is fixed, we can place this behind the !aborted logic.
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'received',
                actionSubject: 'agentMessage',
                attributes: {
                    // messageId must remain the ID received from the server in the FINAL_RESPONSE
                    // in order to map correctly to our event funnel, e.g `agentMessage received` -> `agentResponse content copied`
                    messageId: trackingAttributes.messageId,
                    humanMessageId: trackingAttributes.humanMessageId,
                    pluginsInvoked: Array.from(trackingAttributes.pluginsInvoked),
                    requestId: trackingAttributes.requestId,
                    hasSources: trackingAttributes.hasSources,
                    citedProductList: trackingAttributes.citedProductList,
                    sourceProducts: trackingAttributes.sourceProducts,
                    has3pApps: Object.keys(trackingAttributes.sourceProducts ?? {}).some((0, $5vtU3.is3pApp)),
                    timestamp: new Date().toISOString(),
                    messageActions: trackingAttributes.messageActions,
                    messageDynamicUIData: trackingAttributes.messageDynamicUIData,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    initiator: chatInitiator,
                    deepResearchInvoked: trackingAttributes.deepResearchInvoked,
                    scenarioId: trackingAttributes.scenarioId
                }
            });
            const wasProgrammaticallyAborted = abortController.signal.aborted;
            updateCurrentConversation((0, $cteoa.clearStatus)({
                lastAgentMessageStatus: wasProgrammaticallyAborted ? 'CANCELLED' : 'SUCCESSFUL'
            }));
            setMessages(conversationId, (0, $cteoa.markStreamingMessagesAsComplete)(getMessages(conversationId)));
            if (abortController.signal.aborted) {
                if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
                // Delaying the initiated event firing allows us to create the pairing appropriately,
                // for any initiated events leading up to an error or dismiss state with a
                // hashed ID
                trackAIMAUEvent({
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    timestamp: trackingAttributes.messageSentTimeStamp,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    pageContext: trackingAttributes.pageContext,
                    viewContext: trackingAttributes.viewContext,
                    attributes: {
                        ...$54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
                    }
                });
                trackAIMAUEvent({
                    type: 'dismissed',
                    userGenerated: true,
                    messageId: trackingAttributes.messageId,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    subjectId: trackingAttributes.interactionSource,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    attributes: {
                        ...$54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
                    }
                });
                confirmAbort();
                broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ABORTED);
                // Call the cancel API if we have a message ID
                if (trackingAttributes.messageId) assistanceService.cancelMessageStream({
                    conversationId: conversationId,
                    messageId: trackingAttributes.messageId
                })// eslint-disable-next-line @typescript-eslint/no-explicit-any
                .catch((error)=>{
                    // Log but don't throw - the abort is already happening
                    (0, $1yaYZ.logException)({
                        name: 'rovoCancelMessageStream',
                        exception: error,
                        tags: {
                            conversationId: conversationId,
                            messageId: trackingAttributes.messageId
                        }
                    });
                });
                // For implicit think-deeper, the auto-mode experience was already aborted inside processStream;
                // abort the re-attributed think-deeper experience instead.
                experienceTracker.abort({
                    name: hasAbortedForImplicitThinkDeeper ? implicitThinkDeeperExperienceName ?? (0, $16lEl.ExperienceName).SEND_TD_MESSAGE : sendMessageExperienceNameCompiled,
                    reason: 'Aborted',
                    attributes: {
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        isProgrammaticAbort: true // always true because we're within abortController.signal.aborted (further explained in similar abort for AbortError case)
                    }
                });
                experienceTracker.abort({
                    name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
                    reason: 'stream aborted'
                });
                // Always mark incomplete researches as errored on abort — the backend can
                // autonomously trigger think-deeper even in auto mode
                markIncompleteResearchesErrored({
                    messageId: tmpAssistantMessageId
                });
                // Clear research data to remove lingering think deeper state
                clearMessageResearch({
                    messageId: tmpAssistantMessageId
                });
                return;
            } else {
                if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
                // Delaying the initiated event firing allows us to create the pairing appropriately,
                // for any initiated events leading up to an error or dismiss state with a
                // hashed ID
                trackAIMAUEvent({
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    timestamp: trackingAttributes.messageSentTimeStamp,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    pageContext: trackingAttributes.pageContext,
                    viewContext: trackingAttributes.viewContext,
                    attributes: {
                        ...$54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
                    }
                });
                //If we're done processing the stream and no answer part has been processed, then it means that the BE is hanging. Throw an error
                if (!hasReceivedFinalResponse && !wasGuardTerminated) {
                    const agentDetails = await assistanceService.getAgentDetails(routingAgentId);
                    if (agentDetails.deactivated) {
                        // If agent is deactivated, throw correct error
                        const agentError = new (0, $iEWar.NoFinalResponseError)('The selected agent may no longer be available.', {
                            traceId: responseData?.traceId
                        });
                        experienceTracker.fail({
                            name: sendMessageExperienceNameCompiled,
                            error: agentError,
                            attributes: {
                                deepResearchEnabled: deepResearchEnabled,
                                thinkDeeperEnabled: thinkDeeperEnabled,
                                fastModeEnabled: fastModeEnabled,
                                webSearchEnabled: webSearchEnabled,
                                llmDebugLogsEnabled: storeUserMessages,
                                isStreamAction: streamActionInfo.isAction,
                                actionKey: streamActionInfo.actionKey,
                                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
                            }
                        });
                        trackAIMAUEvent({
                            type: 'error',
                            userGenerated: true,
                            messageId: trackingAttributes.requestId,
                            timestamp: new Date().toISOString(),
                            singleInstrumentationID: trackingAttributes.instrumentationId,
                            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                            fastModeEnabled: trackingAttributes.fastModeEnabled,
                            webSearchEnabled: trackingAttributes.webSearchEnabled,
                            attributes: {
                                ...creationContextParams?.dynamicUiType && {
                                    dynamicUiType: creationContextParams.dynamicUiType
                                },
                                ...creationContextParams?.dynamicUiSubtype && {
                                    dynamicUiSubtype: creationContextParams.dynamicUiSubtype
                                },
                                ...trackingAttributes?.invokedFrom && {
                                    invokedFrom: trackingAttributes.invokedFrom
                                },
                                ...streamActionInfo?.actionKey && {
                                    actionKey: streamActionInfo.actionKey
                                },
                                ...$54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
                            }
                        });
                        updateCurrentConversation({
                            status: (0, $bPHr8.CHAT_STORE_STATUS).deactivatedAgentError,
                            traces: []
                        });
                        sendMessageLatencyMetrics.cancel();
                        cancelStreamingMetrics();
                        broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
                        return;
                    } else {
                        // Agent is active, BE hanging
                        const timeoutError = new (0, $iEWar.NoFinalResponseError)('The response took too long and timed out. Try refreshing the page.', {
                            traceId: responseData?.traceId
                        });
                        experienceTracker.fail({
                            name: sendMessageExperienceNameCompiled,
                            error: timeoutError,
                            attributes: {
                                deepResearchEnabled: deepResearchEnabled,
                                thinkDeeperEnabled: thinkDeeperEnabled,
                                fastModeEnabled: fastModeEnabled,
                                webSearchEnabled: webSearchEnabled,
                                llmDebugLogsEnabled: storeUserMessages,
                                isStreamAction: streamActionInfo.isAction,
                                actionKey: streamActionInfo.actionKey,
                                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
                            }
                        });
                        trackAIMAUEvent({
                            type: 'error',
                            userGenerated: true,
                            messageId: trackingAttributes.requestId,
                            timestamp: new Date().toISOString(),
                            singleInstrumentationID: trackingAttributes.instrumentationId,
                            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                            fastModeEnabled: trackingAttributes.fastModeEnabled,
                            webSearchEnabled: trackingAttributes.webSearchEnabled,
                            attributes: {
                                ...creationContextParams?.dynamicUiType && {
                                    dynamicUiType: creationContextParams.dynamicUiType
                                },
                                ...creationContextParams?.dynamicUiSubtype && {
                                    dynamicUiSubtype: creationContextParams.dynamicUiSubtype
                                },
                                ...trackingAttributes?.invokedFrom && {
                                    invokedFrom: trackingAttributes.invokedFrom
                                },
                                ...streamActionInfo?.actionKey && {
                                    actionKey: streamActionInfo.actionKey
                                },
                                ...$54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
                            }
                        });
                        sendMessageLatencyMetrics.cancel();
                        cancelStreamingMetrics();
                        broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
                        throw timeoutError;
                    }
                }
                /**
       * IMPORTANT: CRITICAL ANALYTICS EVENT
       *
       * This event is essential for business metrics and monitoring.
       *
       * DO NOT MODIFY the structure, content, or emission logic of this event without:
       *   - Careful review of potential impacts on data quality, privacy, and business reporting.
       *   - Explicit approval from both analytics and security stakeholders.
       *
       * Reference: Incident HOT-120175 (UGC page title and URLs leak)
       * Event Registry: https://data-portal.internal.atlassian.com/analytics/registry/68936?tabIndex=Details
       */ const dynamicUiType = creationContextParams?.dynamicUiType ?? sendMessageContext?.editorContext?.dynamicUiType;
                trackAIMAUEvent({
                    type: 'viewed',
                    subjectId: messageSources?.followUpSource,
                    messageId: trackingAttributes.messageId,
                    source: messageSources?.interactionSource,
                    messageActions: trackingAttributes.messageActions,
                    messageDynamicUIData: trackingAttributes.messageDynamicUIData,
                    invokedFrom: trackingAttributes.invokedFrom,
                    proactive: false,
                    userGenerated: true,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: new Date().toISOString(),
                    citedProductList: trackingAttributes.citedProductList,
                    sourceProducts: trackingAttributes.sourceProducts,
                    pluginsInvoked: Array.from(trackingAttributes.pluginsInvoked),
                    skillsInvoked: trackingAttributes.skillsInvoked,
                    executedStratusSkill: trackingAttributes.executedStratusSkill,
                    responseSources: trackingAttributes.sources,
                    usesJsm: trackingAttributes.usesJsm,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    conversationChannelId: conversationId,
                    scenarioId: trackingAttributes.scenarioId,
                    pageContext: trackingAttributes.pageContext,
                    attributes: {
                        ...(0, $9likX.interactionModeExecutedAttributes)(trackingAttributes.interactionModeExecuted),
                        ...dynamicUiType && {
                            dynamicUiType: dynamicUiType
                        },
                        ...creationContextParams?.dynamicUiSubtype && {
                            dynamicUiSubtype: creationContextParams.dynamicUiSubtype
                        },
                        isTabVisible: typeof document !== 'undefined' && document.visibilityState === 'visible',
                        ...additionalAnalyticAttributes && additionalAnalyticAttributes,
                        ...creationContextParams?.dynamicUiSource && {
                            remixNodeTypes: trackingAttributes.remixNodeTypes,
                            ...trackingAttributes.remixWordCount !== undefined && {
                                remixWordCount: trackingAttributes.remixWordCount
                            }
                        },
                        ...trackingAttributes.aiFeatureName && {
                            aiFeatureName: trackingAttributes.aiFeatureName
                        }
                    }
                });
                // Experience is aborted in `abortRequests`
                // For implicit think-deeper, succeed the re-attributed think-deeper reliability SLO instead
                experienceTracker.succeed({
                    name: hasAbortedForImplicitThinkDeeper ? implicitThinkDeeperExperienceName ?? (0, $16lEl.ExperienceName).SEND_TD_MESSAGE : sendMessageExperienceNameCompiled
                });
                // Broadcast that the stream has completed successfully
                broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).COMPLETED);
                if ((0, $dh538.fg)('rovo_chat_chat_history_refresh')) //If user is viewing a different conversation or not viewing ConversationAssitant, optimistically set conversation to unread
                {
                    if (getState().currentConversationId !== conversationId) dispatch(setConversationData({
                        conversationId: conversationId,
                        data: {
                            readStatus: false
                        }
                    }));
                }
            }
            // For implicit think-deeper, stop the re-attributed think-deeper metric instead
            if (!hasAbortedForImplicitThinkDeeper) sendMessageLatencyMetrics.stop({
                customData: messageSources?.interactionSource ? {
                    interactionSource: messageSources.interactionSource
                } : undefined
            });
            else implicitThinkDeeperSendMessageMetrics?.stop({
                customData: messageSources?.interactionSource ? {
                    interactionSource: messageSources.interactionSource
                } : undefined
            });
        };
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        try {
            await sendMessageFn({
                conversationId: conversationId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // Legacy reconnection path: handle StreamDisconnectedError thrown by processStream
            // when rovo_chat_reconnect_all_experiment is OFF.
            if (error instanceof (0, $iEWar.StreamDisconnectedError)) {
                const reconnectionOnComplete = (result)=>{
                    if (result.success) {
                        const meta = result.streamMeta;
                        trackAIMAUEvent({
                            type: 'viewed',
                            subjectId: messageSources?.followUpSource,
                            messageId: error.agentMessageId,
                            source: messageSources?.interactionSource,
                            messageActions: meta?.messageActions,
                            proactive: false,
                            userGenerated: true,
                            singleInstrumentationID: error.agentMessageId,
                            timestamp: new Date().toISOString(),
                            deepResearchEnabled: deepResearchEnabled,
                            thinkDeeperEnabled: thinkDeeperEnabled,
                            fastModeEnabled: fastModeEnabled,
                            webSearchEnabled: webSearchEnabled,
                            conversationChannelId: error.conversationId,
                            citedProductList: meta?.citedProductList ?? {},
                            sourceProducts: meta?.sourceProducts ?? {},
                            pluginsInvoked: meta?.pluginsInvoked,
                            skillsInvoked: meta?.skillsInvoked,
                            responseSources: meta?.responseSources,
                            usesJsm: meta?.usesJsm,
                            scenarioId: meta?.scenarioId,
                            pageContext: pageContext,
                            attributes: {
                                ...(0, $9likX.interactionModeExecutedAttributes)(meta?.interactionModeExecuted),
                                ...messageSources?.aiFeatureName && {
                                    aiFeatureName: messageSources.aiFeatureName
                                }
                            }
                        });
                        experienceTracker.succeed({
                            name: getActiveSendMessageExperienceName()
                        });
                    } else {
                        sendAnalyticsEvent({
                            eventType: 'track',
                            action: 'failed',
                            actionSubject: 'rovoChatStream',
                            attributes: {
                                isDeepResearchEnabled: deepResearchEnabled,
                                isThinkDeeperEnabled: thinkDeeperEnabled,
                                isWebSearchEnabled: webSearchEnabled,
                                isAIFCStreaminAction: false,
                                isReconnectable: true,
                                conversationId: conversationId,
                                instrumentationId: error.agentMessageId,
                                requestId: error.agentMessageId,
                                interactionSource: messageSources?.interactionSource,
                                contentContext: chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global',
                                userAgent: navigator?.userAgent,
                                error: error.message
                            }
                        });
                        trackAIMAUEvent({
                            type: 'error',
                            userGenerated: true,
                            messageId: error.agentMessageId,
                            singleInstrumentationID: error.agentMessageId,
                            timestamp: new Date().toISOString(),
                            deepResearchEnabled: deepResearchEnabled,
                            thinkDeeperEnabled: thinkDeeperEnabled,
                            fastModeEnabled: fastModeEnabled,
                            webSearchEnabled: webSearchEnabled,
                            attributes: {
                                ...(0, $9likX.interactionModeRequestedAttributes)((0, $9likX.getInteractionModeRequested)({
                                    deepResearchEnabled: deepResearchEnabled,
                                    thinkDeeperEnabled: thinkDeeperEnabled,
                                    fastModeEnabled: fastModeEnabled,
                                    taskModeEnabled: taskModeEnabled
                                }))
                            }
                        });
                        experienceTracker.fail({
                            name: getActiveSendMessageExperienceName(),
                            error: result.error ?? new Error('Reconnection failed'),
                            attributes: {
                                deepResearchEnabled: deepResearchEnabled,
                                thinkDeeperEnabled: thinkDeeperEnabled,
                                fastModeEnabled: fastModeEnabled,
                                webSearchEnabled: webSearchEnabled,
                                llmDebugLogsEnabled: storeUserMessages,
                                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
                            }
                        });
                    }
                };
                await dispatch(reconnectToInProgressStream({
                    conversationId: error.conversationId,
                    messageId: error.agentMessageId,
                    answerIndex: error.answerIndex,
                    isDeepResearch: deepResearchEnabled,
                    lastEventId: error.lastEventId,
                    abortCurrentRequest: true,
                    onComplete: reconnectionOnComplete
                }));
                return;
            }
            if ((0, $ljUdP.isChannelNotFoundError)(error)) {
                const createdChannel = await assistanceService.createConversationChannel();
                setState({
                    conversations: {
                        ...getState().conversations,
                        [createdChannel.id]: {
                            id: createdChannel.id,
                            name: createdChannel.name,
                            timeCreated: createdChannel.time_created,
                            status: (0, $bPHr8.CHAT_STORE_STATUS).idle,
                            traces: [],
                            selectedAgentIds: createdChannel.agent && (0, $dh538.fg)('rovo_chat_chat_history_refresh') ? [
                                createdChannel.agent.agent_id
                            ] : [],
                            messages: [],
                            ...createdChannel.agent && (0, $dh538.fg)('rovo_chat_chat_history_refresh') ? {
                                agent: createdChannel.agent
                            } : {}
                        }
                    }
                });
                setMessages(createdChannel.id, []);
                dispatch(setSelectedConversation({
                    conversationId: createdChannel.id
                }));
                await sendMessageFn({
                    conversationId: createdChannel.id
                });
            } else {
                performEditRollback();
                throw error;
            }
        }
    };
const $54793c520b6b8872$var$getStreamStats = ()=>{
    const stats = {
        totalChunks: 0,
        traceChunks: 0,
        answerChunks: 0,
        actionChunks: 0,
        researchChunks: 0,
        otherChunks: 0,
        firstChunkAt: undefined,
        lastChunkAt: undefined,
        sumInterChunkMs: 0,
        pluginsObserved: new Set()
    };
    const update = (streamMessage)=>{
        const now = performance.now();
        stats.totalChunks += 1;
        if (stats.firstChunkAt === undefined) stats.firstChunkAt = now;
        if (stats.lastChunkAt !== undefined) stats.sumInterChunkMs += now - stats.lastChunkAt;
        stats.lastChunkAt = now;
        if ((0, $ljUdP.isStreamTrace)(streamMessage)) stats.traceChunks += 1;
        else if ((0, $ljUdP.isStreamAnswerPart)(streamMessage)) stats.answerChunks += 1;
        else if ((0, $ljUdP.isStreamResearchPayload)(streamMessage)) stats.researchChunks += 1;
        else if ((0, $ljUdP.isStreamActionPart)(streamMessage) || (0, $ljUdP.isStreamActionPrepare)(streamMessage)) // Count action-related chunks (prepare/part)
        stats.actionChunks += 1;
        else // Count unknown chunks
        stats.otherChunks += 1;
        // Observe plugin names if present early (often only present on final response)
        const invocations = (0, $ljUdP.isStreamResponse)(streamMessage) ? streamMessage.message?.message?.plugin_invocations : [];
        if (Array.isArray(invocations)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        invocations.forEach((p)=>p?.plugin_name && stats.pluginsObserved.add(p.plugin_name));
    };
    const getStats = ()=>{
        const avgGapMs = stats.totalChunks > 1 ? Math.round(stats.sumInterChunkMs / (stats.totalChunks - 1)) : 0;
        return {
            ...stats,
            pluginsObserved: Array.from(stats.pluginsObserved),
            averageGapMs: avgGapMs
        };
    };
    return {
        update: update,
        getStats: getStats
    };
};
const $54793c520b6b8872$export$23f1f8f522f4bdd = (config)=>{
    let armed = false;
    let firstChunkArrived = false;
    let timer;
    let stallCount = 0;
    const clearTimer = ()=>{
        if (timer !== undefined) {
            clearTimeout(timer);
            timer = undefined;
        }
    };
    const schedule = (stage)=>{
        clearTimer();
        const timeoutMs = config.baseMs;
        timer = setTimeout(()=>{
            stallCount += 1;
            config.sendAnalyticsEvent({
                eventType: 'track',
                action: 'timeout',
                actionSubject: 'rovoChatStream',
                attributes: {
                    stallCount: stallCount,
                    stage: stage,
                    timeoutMs: timeoutMs
                }
            });
            // Keep armed so we continue to detect subsequent stalls until chunks resume
            schedule('betweenChunks');
        }, timeoutMs);
    };
    return {
        arm: ()=>{
            if (armed) return;
            armed = true;
            // Start pre-first-chunk watchdog waiting for the first stream event
            schedule('newResponse');
        },
        onChunk: ()=>{
            if (!armed) return;
            if (firstChunkArrived === false) {
                firstChunkArrived = true;
                // After the first chunk, schedule timeout waiting for the next event
                schedule('firstGap');
                return;
            }
            // For subsequent chunks, re-arm the between-chunks watchdog
            schedule('betweenChunks');
        },
        stop: ()=>{
            clearTimer();
            armed = false;
        }
    };
};






const $f0918ff6cbefa0f7$export$f74ad34bb7f49ad1 = async ({ generator: generator, messageId: messageId, conversationId: conversationId, isDeepResearch: isDeepResearch, isStagingArea: isStagingArea, answerIndex: answerIndex, traceId: traceId, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, getState: getState, updateCurrentConversation: updateCurrentConversation, sendAnalyticsEvent: sendAnalyticsEvent, onStreamEvent: onStreamEvent, getIsReplaying: getIsReplaying, reasoningChunkBuffer: reasoningChunkBuffer, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, onStreamEnd: onStreamEnd, onTaskStatusDraft: onTaskStatusDraft, onTaskStatusCompleted: onTaskStatusCompleted, onTodoSnapshot: onTodoSnapshot, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamActionClassification: processMessageStreamActionClassification })=>{
    // Gate the details-tag preprocessor to 3P-agent conversations only.
    const shouldPreprocessDetails = (0, $cteoa.shouldPreprocessDetailsForConversation)(getState(), conversationId);
    const processStreamMarkdown = (0, $cteoa.createStreamMarkdownProcessor)({
        shouldPreprocessDetails: shouldPreprocessDetails
    });
    const processStreamMarkdownMultiTag = (0, $cteoa.createStreamMarkdownMultiTagProcessor)({
        shouldPreprocessDetails: shouldPreprocessDetails
    });
    let latestStreamMessage;
    let hasReceivedFinalResponse = false;
    // Research store state shared across stream messages
    const researchState = {
        clientRoundCounter: 0,
        hasAccumulatedAnswerContent: false
    };
    let requestId;
    try {
        for await (const streamObj of generator){
            const streamMessage = streamObj.data;
            latestStreamMessage = streamMessage;
            onStreamEvent('chunk', streamMessage, streamObj.id);
            // TRACE events are not handled in reconnect; drop early to skip
            // the remaining type-checks below.
            if ((0, $ljUdP.isStreamTrace)(streamMessage)) continue;
            // This is the first moment we have the network request id for E2E event tracking
            // Store requestId on human message for E2E event tracking
            if (!requestId && 'metadata' in streamMessage) requestId = streamMessage.metadata?.request_id ?? undefined;
            // Buffer REASONING_PART during replay; bufferEvent returns false for
            // orphan chunks (no stepId) so they fall through.
            if (reasoningChunkBuffer && getIsReplaying?.() && (0, $ljUdP.isStreamReasoningPart)(streamMessage) && reasoningChunkBuffer.bufferEvent(streamMessage)) continue;
            /**
       * Research store processing — handles think-deeper traces, implicit round
       * detection, and research plan updates for all message types.
       */ (0, $54793c520b6b8872$export$5a07e6227eed9665)({
                streamMessage: streamMessage,
                tmpAssistantMessageId: messageId,
                conversationId: conversationId,
                deepResearchEnabled: isDeepResearch ?? false,
                getMessages: getMessages,
                setMessages: setMessages,
                processStreamResearch: processStreamResearch,
                addImplicitResearchPlan: addImplicitResearchPlan,
                resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                researchState: researchState
            });
            /**
       * Task status processing
       */ if ((0, $ljUdP.isStreamTaskStatus)(streamMessage)) {
                const taskMessage = streamMessage.message;
                if (taskMessage.status === 'DRAFT') onTaskStatusDraft?.({
                    taskId: taskMessage.task_id,
                    title: taskMessage.title,
                    updatedAt: taskMessage.updated_at,
                    messageId: messageId
                });
                else if (taskMessage.status === 'COMPLETED') onTaskStatusCompleted?.({
                    title: taskMessage.title,
                    updatedAt: taskMessage.updated_at,
                    completionMessageId: messageId
                });
            }
            /**
       *  snapshot processing
       */ if ((0, $ljUdP.isStreamTodoSnapshot)(streamMessage)) onTodoSnapshot?.({
                todos: streamMessage.message.todos
            });
            /**
       *  ANSWER_PART  processing
       */ if ((0, $ljUdP.isStreamAnswerPart)(streamMessage)) {
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $cteoa.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                let processedStreamMessage = streamMessage;
                let hasMarkdownData = false;
                if ((0, $dh538.fg)('ai_mate_handle_multi_tags_in_stream_msg')) {
                    const result = processStreamMarkdownMultiTag(processedStreamMessage);
                    processedStreamMessage = result.processedStreamMessage;
                    if (Object.keys(result.markdownData).length > 0) {
                        hasMarkdownData = true;
                        setMessages(conversationId, (0, $cteoa.addAnswerPartWithMarkdownDataMap)({
                            chat: getMessages(conversationId),
                            answerId: messageId,
                            answerPart: processedStreamMessage,
                            markdownData: result.markdownData,
                            useIndex: answerIndex
                        }));
                    }
                } else {
                    const result = processStreamMarkdown(processedStreamMessage);
                    processedStreamMessage = result.processedStreamMessage;
                    if (result.markdownData) {
                        hasMarkdownData = true;
                        setMessages(conversationId, (0, $cteoa.addAnswerPartWithMarkdownData)({
                            chat: getMessages(conversationId),
                            answerId: messageId,
                            answerPart: processedStreamMessage,
                            markdownData: result.markdownData,
                            useIndex: answerIndex
                        }));
                    }
                }
                if (!hasMarkdownData) setMessages(conversationId, (0, $cteoa.addAnswerPart)({
                    chat: getMessages(conversationId),
                    answerId: messageId,
                    answerPart: streamMessage,
                    useIndex: answerIndex
                }));
            }
            if ((0, $ljUdP.isStreamAnswerGenerationType)(streamMessage) && (0, $dh538.fg)('rovo_chat_enable_lumina')) setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageAnswerGenerationType)(getMessages(conversationId), messageId, streamMessage.message.answer_generation_type));
            if (((0, $ljUdP.isStreamActionPart)(streamMessage) || (0, $ljUdP.isStreamActionPrepare)(streamMessage)) && (0, $dh538.fg)('aifc_create_enabled')) {
                const updatedMessages = (0, $cteoa.addActionPart)({
                    chat: getMessages(conversationId),
                    messageId: messageId,
                    actionPart: streamMessage,
                    useIndex: answerIndex
                });
                if ((0, $ljUdP.isStreamActionPrepare)(streamMessage)) {
                    const actionMessage = streamMessage.message;
                    setMessages(conversationId, [
                        ...updatedMessages,
                        {
                            type: 'ACTION_PREPARE',
                            action: actionMessage
                        }
                    ]);
                } else setMessages(conversationId, updatedMessages);
                // Gated behind aifc_fix_reconnect_stream_overlap so rollback is safe.
                if ((0, $dh538.fg)('aifc_fix_reconnect_stream_overlap')) {
                    if (!getIsReplaying?.()) processMessageStreamAction?.(messageId, streamMessage, traceId, requestId, undefined, {
                        singleInstrumentationId: messageId
                    });
                    else sendAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'suppressed',
                            actionSubject: 'streamActionPart',
                            actionSubjectId: 'reconnectReplay',
                            source: 'reconnectToInProgressStreamProvider',
                            attributes: {
                                messageId: messageId,
                                conversationId: conversationId,
                                reason: 'replay',
                                key: (0, $ljUdP.isStreamActionPart)(streamMessage) ? streamMessage.message?.key : 'prepare'
                            }
                        }
                    });
                } else processMessageStreamAction?.(messageId, streamMessage, traceId, requestId, undefined, {
                    singleInstrumentationId: messageId
                });
            }
            if ((0, $ljUdP.isStreamActionComplete)(streamMessage) && (0, $dh538.fg)('aifc_create_enabled')) {
                const actionMessage = streamMessage.message;
                setMessages(conversationId, [
                    ...getMessages(conversationId),
                    {
                        type: 'ACTION_COMPLETE',
                        action: actionMessage
                    }
                ]);
                // Gated behind aifc_fix_reconnect_stream_overlap so rollback is safe.
                if ((0, $dh538.fg)('aifc_fix_reconnect_stream_overlap')) {
                    if (!getIsReplaying?.()) processMessageStreamComplete?.(messageId, streamMessage, traceId, requestId, {
                        singleInstrumentationId: messageId
                    });
                    else sendAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'suppressed',
                            actionSubject: 'streamActionComplete',
                            actionSubjectId: 'reconnectReplay',
                            source: 'reconnectToInProgressStreamProvider',
                            attributes: {
                                messageId: messageId,
                                conversationId: conversationId,
                                reason: 'replay',
                                key: actionMessage?.key
                            }
                        }
                    });
                } else processMessageStreamComplete?.(messageId, streamMessage, traceId, requestId, {
                    singleInstrumentationId: messageId
                });
            }
            if ((0, $ljUdP.isStreamActionClassification)(streamMessage) && (0, $dh538.fg)('aifc_create_enabled')) {
                if ((0, $dh538.fg)('platform_editor_ai_promptversion_in_analytics')) // Only call during live phase. If ACTION_CLASSIFICATION arrives during
                // replay it means the editor already received it before disconnect.
                {
                    if (!getIsReplaying?.()) processMessageStreamActionClassification?.(messageId, streamMessage, traceId, requestId, {
                        singleInstrumentationId: messageId
                    });
                }
            }
            /**
       * FINAL_RESPONSE processing
       */ if ((0, $ljUdP.isStreamResponse)(streamMessage)) {
                hasReceivedFinalResponse = true;
                const humanMessageId = streamMessage?.message?.human_message?.id.toString();
                const { processedStreamMessage: processedStreamMessage, markdownData: markdownData } = (0, $cteoa.processStreamResponseMarkdown)({
                    streamMessage: streamMessage,
                    messageId: messageId,
                    conversationId: conversationId,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    shouldPreprocessDetails: shouldPreprocessDetails
                });
                setMessages(conversationId, (0, $cteoa.replaceAnswerData)({
                    chat: getMessages(conversationId),
                    answerId: messageId,
                    content: processedStreamMessage,
                    useIndex: answerIndex,
                    humanMessageId: humanMessageId,
                    markdownData: Object.keys(markdownData).length > 0 ? markdownData : undefined
                }));
                // Update the StoreHuman entry's ID from the temporary client-generated ID
                // to the real server-assigned ID. After a page reload this is a no-op because
                // the store already contains the real ID.
                if (humanMessageId) {
                    const currentHumanMessageId = (0, $cteoa.getAssociatedHumanMessageId)(getMessages(conversationId), messageId);
                    if (currentHumanMessageId && currentHumanMessageId !== humanMessageId) setMessages(conversationId, (0, $cteoa.updateHumanMessageId)({
                        chat: getMessages(conversationId),
                        oldId: currentHumanMessageId,
                        newId: humanMessageId
                    }));
                }
            }
            /**
       * Follow up processing
       */ if ((0, $ljUdP.isFollowUpMessage)(streamMessage)) {
                const messages = getMessages(conversationId);
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $cteoa.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                setMessages(conversationId, [
                    ...messages,
                    {
                        type: 'FOLLOW_UP',
                        content: streamMessage,
                        id: (0, $a37fef51f047b95d$export$bac56f3fc527f04b)(0, 1000000),
                        agentMessageId: (0, $cteoa.getLastAgentMessageID)(messages)
                    }
                ]);
            }
            /**
       * Action error processing
       */ if ((0, $ljUdP.isStreamActionError)(streamMessage)) {
                const actionError = new (0, $iEWar.StreamErrorException)(streamMessage.message.data?.message || 'Action execution failed', {
                    detail: {
                        message: {
                            content: streamMessage?.message?.data?.message || 'Action execution failed',
                            message_template: streamMessage?.message?.key
                        },
                        metadata: {
                            ...streamMessage.metadata,
                            isStagingArea: isStagingArea
                        }
                    },
                    traceId: traceId
                });
                throw actionError;
            }
            if ((0, $ljUdP.isStreamError)(streamMessage)) {
                onStreamEvent('error', streamMessage, streamObj.id);
                const { message: message, metadata: metadata, millisOffset: millisOffset, type: type } = streamMessage;
                throw new (0, $iEWar.StreamErrorException)(message?.content || 'Unknown', {
                    detail: {
                        message: message,
                        metadata: metadata,
                        millisOffset: millisOffset,
                        type: type
                    },
                    traceId: traceId
                });
            }
        }
        // Drain any remaining buffered chunks and clear the periodic timer.
        //cancelReasoningFlush();
        onStreamEnd?.();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error instanceof (0, $iEWar.StreamErrorException)) throw error;
        throw new (0, $iEWar.StreamGeneratorError)(error.message ?? 'Stream generator error', {
            traceId: traceId,
            detail: {
                millisOffset: latestStreamMessage && 'millisOffset' in latestStreamMessage ? latestStreamMessage.millisOffset : undefined,
                type: latestStreamMessage?.type ?? ''
            }
        }, error);
    }
    return {
        hasReceivedFinalResponse: hasReceivedFinalResponse
    };
};
const $f0918ff6cbefa0f7$export$4f5dbc9d3a9c9f98 = (params)=>{
    const timeToConnectToStreamMetrics = (0, $1K4cm.reconnectionMetrics).createTimeToConnectToStreamMetrics({
        deepResearchEnabled: params.isDeepResearchEnabled,
        thinkDeeperEnabled: params.thinkDeeperEnabled,
        fastModeEnabled: params.fastModeEnabled
    });
    const timeToResumeStreamMetrics = (0, $1K4cm.reconnectionMetrics).createTimeToResumeStreamMetrics({
        deepResearchEnabled: params.isDeepResearchEnabled,
        thinkDeeperEnabled: params.thinkDeeperEnabled,
        fastModeEnabled: params.fastModeEnabled
    });
    return {
        timeToConnectToStreamMetrics: timeToConnectToStreamMetrics,
        timeToResumeStreamMetrics: timeToResumeStreamMetrics
    };
};
const $f0918ff6cbefa0f7$var$MAX_RECONNECT_ATTEMPTS = 3;
const $f0918ff6cbefa0f7$var$RETRY_BASE_DELAY_MS = 1000;
const $f0918ff6cbefa0f7$var$POST_ONLINE_DELAY_MS = 2000;
const $f0918ff6cbefa0f7$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED = 'chat-unmounted';
const $f0918ff6cbefa0f7$export$4eef7b24ec94bbe8 = (error)=>{
    if (error instanceof Error && error.name === 'AbortError') return false;
    // StreamGeneratorError wraps the original error as `cause` — check the underlying error
    if (error instanceof (0, $iEWar.StreamGeneratorError)) return (0, $cteoa.isClientSideStreamingError)(error.cause ?? error);
    return (0, $cteoa.isClientSideStreamingError)(error);
};
const $f0918ff6cbefa0f7$export$d8454bf5b2ffdf29 = ({ conversationId: conversationId, messageId: messageId, answerIndex: _answerIndex, isDeepResearch: isDeepResearch, lastEventId: lastEventId, setConversationData: setConversationData, abortCurrentRequest: abortCurrentRequest, onComplete: onComplete, isAutoReconnect: isAutoReconnect, isReconnectToAll: isReconnectToAll })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, chatContextStoreActions: chatContextStoreActions, markIncompleteResearchesErrored: markIncompleteResearchesErrored, endReconnection: endReconnection, startReconnection: startReconnection, isReconnecting: isReconnecting, getIsChatMounted: getIsChatMounted, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamActionClassification: processMessageStreamActionClassification, unifiedTasksActions: unifiedTasksActions })=>{
        const currentConversation = getState().conversations[conversationId];
        if (abortCurrentRequest && currentConversation?.storeAbortController) currentConversation.storeAbortController.abort();
        // Skip reconnection if there is another operation in progress
        if (currentConversation?.storeAbortController && !abortCurrentRequest || isReconnecting(conversationId)) return;
        startReconnection(conversationId, messageId);
        const reconnectionPerformanceMetrics = $f0918ff6cbefa0f7$export$4f5dbc9d3a9c9f98({
            isDeepResearchEnabled: isDeepResearch,
            thinkDeeperEnabled: false,
            fastModeEnabled: false
        });
        let totalAttempts = 0;
        const reconnectStartedAt = new Date().toISOString();
        // TODO not complete information, ideally the message in progress should indicate what was the requested mode even before message is completed
        const requestedModeAttributes = (0, $9likX.interactionModeRequestedAttributes)(isDeepResearch ? 'deep_research' : 'auto');
        const metrics = {
            // Reconnection metrics
            onReconnectStarted: ()=>{
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.start();
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    id: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    attributes: {
                        conversationId: conversationId,
                        messageId: messageId,
                        isDeepResearch: isDeepResearch,
                        isAutoReconnect: isAutoReconnect
                    }
                });
                // Only fire MAU events for page-load auto-reconnects, not send-message reconnects.
                // Todo isAutoReconnect check should be removed after reconnect-all experiment roll out,
                // reconnect-action will be only triggered on page load.
                if (isAutoReconnect) trackAIMAUEvent({
                    type: 'initiated',
                    userGenerated: true,
                    proactive: false,
                    triggeredByAutoReconnect: true,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    timestamp: reconnectStartedAt,
                    attributes: requestedModeAttributes
                });
            },
            // Was able to connect to active stream
            onReconnectEstablished: ()=>{
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.stop();
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.start();
            },
            onReconnectFailed: (error)=>{
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.cancel();
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.cancel();
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    error: error,
                    attributes: {
                        conversationId: conversationId,
                        messageId: messageId,
                        isDeepResearch: isDeepResearch,
                        totalAttempts: totalAttempts
                    }
                });
                if (isAutoReconnect) trackAIMAUEvent({
                    type: 'error',
                    userGenerated: true,
                    proactive: false,
                    triggeredByAutoReconnect: true,
                    messageId: messageId,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    timestamp: new Date().toISOString(),
                    attributes: requestedModeAttributes
                });
            },
            onReconnectChunkReceived: ()=>{
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.stop();
            },
            onReconnectAborted: ()=>{
                experienceTracker.abort({
                    name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    reason: 'Aborted'
                });
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.cancel();
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.cancel();
                // Todo isAutoReconnect check should be removed after reconnect-all experiment roll out,
                if (isAutoReconnect) trackAIMAUEvent({
                    type: 'dismissed',
                    userGenerated: true,
                    proactive: false,
                    triggeredByAutoReconnect: true,
                    messageId: messageId,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    timestamp: new Date().toISOString(),
                    attributes: requestedModeAttributes
                });
            },
            onReconnectSucceeded: ()=>{
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    attributes: {
                        totalAttempts: totalAttempts,
                        conversationId: conversationId,
                        messageId: messageId,
                        isDeepResearch: isDeepResearch,
                        isAutoReconnect: isAutoReconnect
                    }
                });
                if (isAutoReconnect) {
                    trackAIMAUEvent({
                        type: 'viewed',
                        userGenerated: true,
                        proactive: false,
                        triggeredByAutoReconnect: true,
                        messageId: messageId,
                        singleInstrumentationID: messageId,
                        deepResearchEnabled: isDeepResearch ?? false,
                        citedProductList: streamMeta?.citedProductList ?? {},
                        sourceProducts: streamMeta?.sourceProducts ?? {},
                        pluginsInvoked: streamMeta?.pluginsInvoked,
                        skillsInvoked: streamMeta?.skillsInvoked,
                        executedStratusSkill: streamMeta?.executedStratusSkill,
                        responseSources: streamMeta?.responseSources,
                        usesJsm: streamMeta?.usesJsm,
                        messageActions: streamMeta?.messageActions,
                        conversationChannelId: conversationId,
                        timestamp: new Date().toISOString(),
                        attributes: {
                            ...streamMeta?.interactionModeExecuted ? {
                                interactionModeExecuted: streamMeta.interactionModeExecuted
                            } : {}
                        }
                    });
                    // Fire agentMessage received for funnel parity with processStream.
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'received',
                        actionSubject: 'agentMessage',
                        attributes: {
                            messageId: messageId,
                            humanMessageId: streamMeta?.humanMessageId,
                            pluginsInvoked: streamMeta?.pluginsInvoked ?? [],
                            citedProductList: streamMeta?.citedProductList,
                            sourceProducts: streamMeta?.sourceProducts,
                            has3pApps: Object.keys(streamMeta?.sourceProducts ?? {}).some((0, $5vtU3.is3pApp)),
                            timestamp: new Date().toISOString(),
                            messageActions: streamMeta?.messageActions,
                            deepResearchEnabled: isDeepResearch ?? false,
                            initiator: 'rovoChat',
                            deepResearchInvoked: isDeepResearch ?? false,
                            scenarioId: streamMeta?.scenarioId,
                            isReconnect: true
                        }
                    });
                }
            }
        };
        const updateCurrentConversation = (data)=>{
            dispatch(setConversationData({
                conversationId: conversationId,
                data: data
            }));
        };
        const cancelMessageStream = ()=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            assistanceService.cancelMessageStream({
                conversationId: conversationId,
                messageId: messageId
            }).catch((err)=>{
                (0, $1yaYZ.logException)({
                    name: 'rovoCancelMessageStream',
                    exception: err,
                    tags: {
                        conversationId: conversationId,
                        messageId: messageId
                    }
                });
            });
        };
        const messages = getMessages(conversationId);
        const answerIndex = _answerIndex ?? (0, $cteoa.findStoreMessageIndex)(messages, messageId);
        const { abortController: abortController, storeAbortController: storeAbortController, confirmAbort: confirmAbort } = (0, $3ba7c8b5e2cd14b7$export$cb6128fc3a3c8081)();
        let traceId;
        let streamMeta;
        let currentLastEventId = lastEventId;
        let reconnectSucceeded = false;
        const connectAndProcessStream = async ()=>{
            const { generator: generator, responseData: responseData } = await assistanceService.reconnectToMessageStream({
                conversationId: conversationId,
                messageId: messageId,
                lastEventId: currentLastEventId,
                controller: abortController
            });
            traceId = responseData?.traceId;
            metrics.onReconnectEstablished();
            const { hasReceivedFinalResponse: hasReceivedFinalResponse } = await $f0918ff6cbefa0f7$export$f74ad34bb7f49ad1({
                generator: generator,
                traceId: responseData?.traceId,
                messageId: messageId,
                conversationId: conversationId,
                answerIndex: answerIndex,
                isStagingArea: chatContextStoreActions.getIsStagingArea(),
                isDeepResearch: isDeepResearch,
                getState: getState,
                setMessages: setMessages,
                getMessages: getMessages,
                processStreamResearch: processStreamResearch,
                processMessageStreamAction: processMessageStreamAction,
                processMessageStreamComplete: processMessageStreamComplete,
                processMessageStreamActionClassification: processMessageStreamActionClassification,
                sendAnalyticsEvent: sendAnalyticsEvent,
                updateCurrentConversation: updateCurrentConversation,
                addImplicitResearchPlan: addImplicitResearchPlan,
                resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                onStreamEvent: (event, streamMessage, eventId)=>{
                    // Update currentLastEventId progressively as we process each event
                    // so that retries can resume from the last successfully processed event
                    if (eventId) currentLastEventId = eventId;
                    if (event === 'chunk') {
                        metrics.onReconnectChunkReceived();
                        if (streamMessage && (0, $ljUdP.isStreamResponse)(streamMessage)) streamMeta = (0, $cteoa.extractStreamMeta)(streamMessage);
                    }
                    if (event === 'error') {
                        if ((0, $ljUdP.isStreamAUPError)(streamMessage)) {
                            reconnectSucceeded = true;
                            metrics.onReconnectSucceeded();
                        }
                    }
                }
            });
            if (abortController.signal.aborted) throw new DOMException('Reconnect aborted', 'AbortError');
            if (!hasReceivedFinalResponse) throw new (0, $iEWar.NoFinalResponseError)('The response took too long and timed out. Try refreshing the page.', {
                traceId: traceId
            });
        };
        //** CONNECT TO STREAM (with retry) */
        try {
            metrics.onReconnectStarted();
            updateCurrentConversation({
                status: (0, $bPHr8.CHAT_STORE_STATUS).typingResponse,
                traces: [
                    {
                        messageContent: 'Resuming response...',
                        status: 'loading'
                    }
                ],
                storeAbortController: storeAbortController
            });
            const isReconnectAllEnabled = isReconnectToAll ?? false;
            if (isReconnectAllEnabled) {
                const reconnect = (eventId)=>assistanceService.reconnectToMessageStream({
                        conversationId: conversationId,
                        messageId: messageId,
                        lastEventId: eventId,
                        controller: abortController
                    });
                // Capture timestamp BEFORE the API call so that any live chunks
                // still in-flight during the round-trip are correctly identified
                // as live rather than replay.
                const reconnectTimestamp = Date.now();
                const { generator: initialGenerator, responseData: responseData } = await reconnect(currentLastEventId);
                traceId = responseData?.traceId;
                metrics.onReconnectEstablished();
                const wrappedGenerator = (0, $be423051027308ae$export$a802bb7fa59dba39)({
                    initialGenerator: initialGenerator,
                    canReconnect: ()=>!abortController.signal.aborted,
                    getReconnectGenerator: (eventId)=>reconnect(eventId).then((r)=>r.generator),
                    getEventId: (chunk)=>chunk.id ? chunk.id : undefined,
                    onReconnecting: (attempt, maxAttempts, eventId)=>{
                        totalAttempts = attempt;
                        sendAnalyticsEvent({
                            eventType: 'track',
                            action: 'retrying',
                            actionSubject: 'rovoChatReconnection',
                            attributes: {
                                conversationId: conversationId,
                                messageId: messageId,
                                isDeepResearch: isDeepResearch,
                                attempt: attempt,
                                maxAttempts: maxAttempts,
                                hasLastEventId: !!eventId
                            }
                        });
                        updateCurrentConversation({
                            traces: [
                                {
                                    messageContent: `Connection lost. Retrying... (${attempt}/${maxAttempts})`,
                                    status: 'loading'
                                }
                            ]
                        });
                    },
                    onReconnected: ()=>{
                        metrics.onReconnectEstablished();
                    },
                    shouldContinueRetrying: ()=>{
                        if (!getIsChatMounted()) {
                            abortController.abort($f0918ff6cbefa0f7$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED);
                            return false;
                        }
                        return true;
                    },
                    signal: abortController.signal
                });
                // Batch store updates and chunk-merge REASONING_PART during replay;
                // both flushed together via onFlush at the replay→live boundary.
                const reasoningChunkBuffer = (0, $452e4ba611b5dc40$export$6f349e5fd508c97f)((mergedEvent)=>{
                    processStreamResearch({
                        messageId: messageId,
                        streamMessage: mergedEvent,
                        isDeepResearch: isDeepResearch ?? false
                    });
                });
                const { wrapGenerator: wrapGenerator, batchedSetMessages: batchedSetMessages, batchedGetMessages: batchedGetMessages, batchedProcessStreamResearch: batchedProcessStreamResearch, batchedUpdateCurrentConversation: batchedUpdateCurrentConversation, getIsReplaying: getIsReplaying, getCompletedStepIds: getCompletedStepIds } = (0, $f0fdaf1fd06efef8$export$76ef465f684cfb18)({
                    conversationId: conversationId,
                    reconnectTimestamp: reconnectTimestamp,
                    getMessages: getMessages,
                    setMessages: setMessages,
                    processStreamResearch: processStreamResearch,
                    updateCurrentConversation: updateCurrentConversation,
                    // Use flushFiltered so reasoning chunks for already-completed steps
                    // are dropped — this prevents spurious "Rovo is thinking" rounds
                    // from appearing in the research expandable after reconnect replay.
                    // Steps that are still in-progress (no STEP_COMPLETED seen) are
                    // flushed normally so live streaming continues correctly.
                    onFlush: ()=>reasoningChunkBuffer.flushFiltered((stepId)=>!getCompletedStepIds().has(stepId))
                });
                const { hasReceivedFinalResponse: hasReceivedFinalResponse } = await $f0918ff6cbefa0f7$export$f74ad34bb7f49ad1({
                    generator: wrapGenerator(wrappedGenerator),
                    traceId: responseData?.traceId,
                    messageId: messageId,
                    conversationId: conversationId,
                    answerIndex: answerIndex,
                    isStagingArea: chatContextStoreActions.getIsStagingArea(),
                    isDeepResearch: isDeepResearch,
                    getState: getState,
                    setMessages: batchedSetMessages,
                    getMessages: batchedGetMessages,
                    processStreamResearch: batchedProcessStreamResearch,
                    processMessageStreamAction: // skip batching for Stream Actions for now, since string accumulation is not guarnateed and vary based on the action type.
                    // TODO: should be imrpoved in future snapshot event support.
                    processMessageStreamAction,
                    processMessageStreamComplete: processMessageStreamComplete,
                    processMessageStreamActionClassification: processMessageStreamActionClassification,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    updateCurrentConversation: batchedUpdateCurrentConversation,
                    getIsReplaying: getIsReplaying,
                    reasoningChunkBuffer: reasoningChunkBuffer,
                    addImplicitResearchPlan: addImplicitResearchPlan,
                    resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                    onStreamEnd: ()=>{
                        // Mirror onFlush: drop reasoning for completed steps.
                        reasoningChunkBuffer.flushFiltered((stepId)=>!getCompletedStepIds().has(stepId));
                    },
                    onTaskStatusDraft: ({ taskId: taskId, title: title, updatedAt: updatedAt, messageId: msgId })=>{
                        if (!unifiedTasksActions || !(0, $dh538.fg)('rovo_chat_enable_tasks')) return;
                        unifiedTasksActions.createTaskFromStream({
                            conversationId: conversationId,
                            taskId: taskId,
                            title: title,
                            updatedAt: updatedAt,
                            messageId: msgId
                        });
                    },
                    onTaskStatusCompleted: ({ title: title, updatedAt: updatedAt, completionMessageId: completionMessageId })=>{
                        if (!unifiedTasksActions || !(0, $dh538.fg)('rovo_chat_enable_tasks')) return;
                        unifiedTasksActions.setTaskProgressState({
                            conversationId: conversationId,
                            progressState: 'Completed',
                            title: title,
                            updatedAt: updatedAt,
                            seekingCompletedAck: true,
                            completionMessageId: completionMessageId
                        });
                    },
                    onTodoSnapshot: ({ todos: todos })=>{
                        if (!unifiedTasksActions || !(0, $dh538.fg)('rovo_chat_enable_tasks')) return;
                        unifiedTasksActions.setTaskTodoSnapshot({
                            conversationId: conversationId,
                            todoSnapshot: {
                                todos: todos
                            }
                        });
                    },
                    onStreamEvent: (event, streamMessage, eventId)=>{
                        if (event === 'chunk') {
                            metrics.onReconnectChunkReceived();
                            if (streamMessage && (0, $ljUdP.isStreamResponse)(streamMessage)) streamMeta = (0, $cteoa.extractStreamMeta)(streamMessage);
                        }
                        if (event === 'error') {
                            if ((0, $ljUdP.isStreamAUPError)(streamMessage)) {
                                reconnectSucceeded = true;
                                metrics.onReconnectSucceeded();
                            }
                        }
                    }
                });
                if (abortController.signal.aborted) throw new DOMException('Reconnect aborted', 'AbortError');
                if (!hasReceivedFinalResponse) throw new (0, $iEWar.NoFinalResponseError)('The response took too long and timed out. Try refreshing the page.', {
                    traceId: traceId
                });
            } else // Legacy path: exponentialRetry wraps the full connect + process cycle
            await (0, $92b0a6aa5f3cefb4$export$4dfcad98182a1ece)({
                fn: connectAndProcessStream,
                maxRetries: $f0918ff6cbefa0f7$var$MAX_RECONNECT_ATTEMPTS,
                delay: $f0918ff6cbefa0f7$var$RETRY_BASE_DELAY_MS,
                postOnlineDelay: $f0918ff6cbefa0f7$var$POST_ONLINE_DELAY_MS,
                errorFilter: (error)=>{
                    if (!getIsChatMounted()) {
                        abortController.abort($f0918ff6cbefa0f7$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED);
                        return false;
                    }
                    return $f0918ff6cbefa0f7$export$4eef7b24ec94bbe8(error);
                },
                jitter: true,
                signal: abortController.signal,
                pauseWhileOffline: true,
                onRetry: (attempt, _error)=>{
                    totalAttempts = attempt + 1;
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'retrying',
                        actionSubject: 'rovoChatReconnection',
                        attributes: {
                            conversationId: conversationId,
                            messageId: messageId,
                            isDeepResearch: isDeepResearch,
                            attempt: attempt,
                            maxAttempts: $f0918ff6cbefa0f7$var$MAX_RECONNECT_ATTEMPTS,
                            hasLastEventId: !!currentLastEventId
                        }
                    });
                    updateCurrentConversation({
                        traces: [
                            {
                                messageContent: `Connection lost. Retrying... (${attempt}/${$f0918ff6cbefa0f7$var$MAX_RECONNECT_ATTEMPTS})`,
                                status: 'loading'
                            }
                        ]
                    });
                }
            });
            metrics.onReconnectSucceeded();
            onComplete?.({
                success: true,
                streamMeta: streamMeta
            });
        } catch (error) {
            if (error instanceof Error && error.name === 'AbortError' || abortController.signal.aborted) {
                confirmAbort();
                updateCurrentConversation({
                    lastAgentMessageStatus: 'FAILED'
                });
                metrics.onReconnectAborted();
                // Only cancel the message stream if the abort reason is not the chat unmounted reason
                if (abortController.signal.reason !== $f0918ff6cbefa0f7$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED) cancelMessageStream();
                return;
            }
            if (!reconnectSucceeded) metrics.onReconnectFailed(error);
            if (isDeepResearch) markIncompleteResearchesErrored({
                messageId: messageId
            });
            onComplete?.({
                success: reconnectSucceeded,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        } finally{
            endReconnection(conversationId);
            updateCurrentConversation((0, $cteoa.clearStatus)({}));
            setMessages(conversationId, (0, $cteoa.markStreamingMessagesAsComplete)(getMessages(conversationId)));
        }
    };





























const $434fbbd3906b07f0$var$getErrorReason = ({ error: error, storeError: storeError, currentConversationId: currentConversationId, conversations: conversations })=>{
    if ((0, $ljUdP.isHipaaError)(error)) return 'hipaa';
    if ((0, $ljUdP.isAUPViolationError)(error)) return 'aupViolation';
    if ((0, $ljUdP.isChannelNotFoundError)(error)) return 'channelNotFound';
    if (!conversations?.[currentConversationId] || (0, $cteoa.isEmptyConversation)(currentConversationId)) return 'noActiveConversation';
    if (storeError.status_code === 429 || (0, $ljUdP.isRateLimitedError)(error)) return 'rateLimited';
    return 'generic';
};
const $434fbbd3906b07f0$var$reportChatError = (sendAnalyticsEvent, reason, storeError)=>{
    if (!(0, $dh538.fg)('ai_mate_unhandled_error_reporting')) return;
    sendAnalyticsEvent({
        eventType: 'operational',
        action: 'unhandledError',
        actionSubject: 'aiMate',
        attributes: {
            reason: reason,
            statusCode: storeError.status_code,
            messageTemplate: storeError.message_template,
            errorType: storeError.errorType,
            traceId: storeError.traceId,
            errorContent: storeError.content,
            ...storeError.storeActionExecutionError ? {
                actionLoggableName: storeError.storeActionExecutionError.actionLoggableName
            } : {}
        }
    });
};
const $434fbbd3906b07f0$export$769f721a7d2183c3 = (props)=>{
    const { args: args, api: api, actionLoggableName: actionLoggableName, error: error, containerProps: containerProps, actionErrorHandler: actionErrorHandler, setConversationData: setConversationData } = props;
    const { getState: getState, setState: setState, dispatch: dispatch } = api;
    (0, $1yaYZ.addSentryBreadcrumb)(`createSafeAction: ${actionLoggableName} errored`);
    const storeError = (0, $cteoa.createStoreError)(error, undefined, actionLoggableName);
    const errorReason = $434fbbd3906b07f0$var$getErrorReason({
        error: error,
        storeError: storeError,
        currentConversationId: getState().currentConversationId,
        conversations: getState().conversations
    });
    // ============================================
    // PHASE 1: Mandatory checks (cannot be overridden)
    // ============================================
    // Handle experience tracking
    // Rate limits are ignored because they trigger a retry, not an experience termination
    if (props?.experienceName && errorReason !== 'rateLimited') {
        if (errorReason === 'aupViolation') {
            const aupError = error;
            containerProps.experienceTracker.abort({
                name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
                reason: aupError.detail.message.message_template,
                attributes: {
                    ...aupError.errorAttributes,
                    errorType: error instanceof (0, $iEWar.StreamErrorException) ? 'StreamErrorException' : ''
                }
            });
        } else containerProps.experienceTracker.fail({
            name: props.experienceName(args),
            error: error instanceof Error ? error : new Error(String(error))
        });
    }
    // Handle restricted use errors
    if (errorReason === 'hipaa') {
        containerProps.setConversationError({
            type: 'hipaa',
            underlyingError: storeError
        });
        $434fbbd3906b07f0$var$reportChatError(containerProps.sendAnalyticsEvent, 'hipaa', storeError);
        return;
    }
    // ============================================
    // PHASE 2: Action-specific error handling (optional)
    // ============================================
    if (actionErrorHandler) {
        const result = actionErrorHandler({
            args: args,
            error: error,
            storeError: storeError,
            containerProps: containerProps,
            errorReason: errorReason
        });
        if (!result?.proceedToDefaultHandling) return;
    }
    // ============================================
    // PHASE 3: Default error handlers
    // ============================================
    if (errorReason === 'channelNotFound') {
        containerProps.setConversationError({
            type: 'conversationNotFound',
            underlyingError: storeError
        });
        $434fbbd3906b07f0$var$reportChatError(containerProps.sendAnalyticsEvent, 'channelNotFound', storeError);
        return;
    }
    if (errorReason === 'noActiveConversation') {
        containerProps.setConversationError({
            type: 'conversationEmptyOrNotPresentInStore',
            underlyingError: storeError
        });
        $434fbbd3906b07f0$var$reportChatError(containerProps.sendAnalyticsEvent, 'noActiveConversation', storeError);
        if (storeError.message_template === (0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).ROVO_PRODUCT_NOT_ACTIVE) containerProps.setRovoEnabled(false, storeError.message_template);
        return;
    }
    const currentConversationId = getState().currentConversationId;
    if (errorReason === 'rateLimited') {
        const rateLimitState = props?.getRateLimitState?.(args) ?? {};
        setState({
            conversations: {
                ...getState().conversations,
                [currentConversationId]: {
                    ...getState().conversations[currentConversationId],
                    ...(0, $cteoa.clearStatus)({
                        lastAgentMessageStatus: 'FAILED'
                    })
                }
            }
        });
        containerProps.setConversationError({
            type: 'rateLimited',
            underlyingError: storeError,
            rateLimitedActionType: rateLimitState.isDeepResearchAttempt ? 'deep-research' : 'generic'
        });
        $434fbbd3906b07f0$var$reportChatError(containerProps.sendAnalyticsEvent, 'rateLimited', storeError);
        return;
    }
    dispatch(setConversationData({
        conversationId: currentConversationId,
        data: {
            ...(0, $cteoa.clearStatus)({
                lastAgentMessageStatus: 'FAILED'
            })
        }
    }));
    const currentMessages = containerProps.getMessages(currentConversationId);
    const lastMessage = currentMessages[currentMessages.length - 1];
    const isDuplicateError = lastMessage && (0, $bPHr8.isStoreError)(lastMessage) && lastMessage.content === storeError.content;
    if (!isDuplicateError) containerProps.setMessages(currentConversationId, [
        ...currentMessages,
        storeError
    ]);
    const errorAttributes = error?.errorAttributes;
    containerProps.experienceTracker.fail({
        name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
        error: error instanceof Error ? error : new Error(String(error)),
        attributes: {
            latestStreamMessageType: errorAttributes?.latestStreamMessageType,
            latestStreamMessageMillisOffset: errorAttributes?.latestStreamMessageMillisOffset
        }
    });
    $434fbbd3906b07f0$var$reportChatError(containerProps.sendAnalyticsEvent, 'generic', storeError);
};





const $0b6866794de633f9$var$HIGHLIGHT_ACTION_INLINE_VIEW_PAGE_CREATION_CONTEXT_PARAMS = {
    experience: 'inline_view',
    contentTypes: [
        'page'
    ]
};
/**
 * Resolve the agent to seed into `conversation.agent` for optimistic/seeded
 * conversation creation. Precedence:
 * - Under `rovo_chat_agent_selection`: the backend-returned agent if present,
 *   otherwise a provisional agent built from the known agent id (so the header,
 *   which reads only `conversation.agent.agent_id`, can hydrate it).
 * - Otherwise (legacy): the backend agent only when `rovo_chat_chat_history_refresh`
 *   is on; else no seed.
 *
 * rovo_chat_agent_selection cleanup: drop the gate and always seed from
 * `backendAgent ?? createProvisionalConversationAgent(agentId)`.
 */ const $0b6866794de633f9$var$resolveConversationSeedAgent = ({ backendAgent: backendAgent, agentId: agentId, legacyAgent: legacyAgent })=>{
    if ((0, $dh538.fg)('rovo_chat_agent_selection')) return backendAgent ?? (0, $ce0ec8f0bfa0c691$export$fc6a9cdad8ea90e0)(agentId);
    return legacyAgent && (0, $dh538.fg)('rovo_chat_chat_history_refresh') ? legacyAgent : undefined;
};
/**
 * Util action to initialize conversation with conversationId
 */ const $0b6866794de633f9$var$initializeConversationData = ({ conversationId: conversationId, data: data })=>({ getState: getState, setState: setState })=>{
        setState({
            conversations: {
                ...getState().conversations,
                [conversationId]: {
                    ...getState().conversations[conversationId] ?? {},
                    ...data
                }
            }
        });
    };
/**
 * Util action to allow updating the conversation based on `conversationId`
 * without needing to keep spreading the existing
 *
 * Similar to `initializeConversationData`, the difference is, it will not allow the the data to be updated if there is no existing conversation
 */ const $0b6866794de633f9$var$setConversationData = ({ conversationId: conversationId, data: data })=>({ getState: getState, setState: setState })=>{
        if (!getState().conversations[conversationId]) return;
        setState({
            conversations: {
                ...getState().conversations,
                [conversationId]: {
                    ...getState().conversations[conversationId] ?? {},
                    ...data
                }
            }
        });
    };
/**
 * Reset an existing conversation into the loading state ahead of a (re)fetch.
 *
 * This is a partial patch of only the fields the loading reset actually changes:
 * status, messages, traces, selectedAgentIds and sourceAgentId. Every other field —
 * notably `conversation.agent` (the header's display identity), `name`, `id` and
 * `timeCreated` — is preserved automatically by the shallow merge, so callers do not
 * need to re-copy carry-over fields or special-case agent preservation behind a gate.
 *
 * No-ops if the conversation does not exist (callers always guard for an existing,
 * non-empty, idle conversation before resetting).
 */ const $0b6866794de633f9$var$resetConversationForLoading = ({ conversationId: conversationId, traces: traces, sourceAgentId: sourceAgentId })=>({ getState: getState, setState: setState })=>{
        const existing = getState().conversations[conversationId];
        if (!existing) return;
        setState({
            conversations: {
                ...getState().conversations,
                [conversationId]: {
                    ...existing,
                    status: (0, $bPHr8.CHAT_STORE_STATUS).loadingChat,
                    messages: [],
                    traces: traces,
                    selectedAgentIds: existing.selectedAgentIds ?? [],
                    sourceAgentId: sourceAgentId
                }
            }
        });
    };
/**
 * Utils function to remove conversation from store
 */ const $0b6866794de633f9$var$removeConversationFromStore = ({ conversationId: conversationId })=>({ getState: getState, setState: setState })=>{
        const { [conversationId]: _, ...otherConversations } = getState().conversations;
        setState({
            conversations: otherConversations
        });
    };
const $0b6866794de633f9$export$f65ce059a9114838 = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(actionLoggableName, actionHOF, props)=>(...args)=>async (api, containerProps)=>{
            /*
   Add custom logic here
  */ // General try/catch statement to handle unexpected errors
            try {
                (0, $1yaYZ.addSentryBreadcrumb)(`createSafeAction: executing ${actionLoggableName}`);
                // Here we call the action callback
                // Same as dispatch(actionHOF)
                const action = actionHOF(...args);
                // Here we execute the action i.e. what happens internally when the action is dispatched
                const result = await action(api, containerProps);
                return result;
            } catch (error) {
                (0, $434fbbd3906b07f0$export$769f721a7d2183c3)({
                    args: args,
                    api: api,
                    actionLoggableName: actionLoggableName,
                    error: error,
                    containerProps: containerProps,
                    setConversationData: $0b6866794de633f9$var$setConversationData,
                    experienceName: props?.experienceName,
                    getRateLimitState: props?.getRateLimitState,
                    actionErrorHandler: props?.actionErrorHandler
                });
                return undefined;
            }
        };
/**
 * ************************************************************
 * Private Actions
 * ************************************************************
 */ const $0b6866794de633f9$var$addStoreChatItem = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).addStoreChatItem, ({ message: message, conversationId: conversationIdParam })=>({ getState: getState }, { setMessages: setMessages, getMessages: getMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        setMessages(conversationId, [
            ...getMessages(conversationId),
            message
        ]);
    });
const $0b6866794de633f9$var$addHumanMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).addHumanMessage, ({ id: id, content: content, conversationId: conversationIdParam, isFromSeededConversation: isFromSeededConversation = false, requestId: requestId, fileUploads: fileUploads })=>({ getState: getState, dispatch: dispatch })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        dispatch($0b6866794de633f9$var$addStoreChatItem({
            message: (0, $cteoa.createStoreHuman)(id, content, isFromSeededConversation, requestId, fileUploads),
            conversationId: conversationId
        }));
    });
const $0b6866794de633f9$var$addAssistantMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).addAssistantMessage, ({ id: id, content: content, conversationId: conversationIdParam, agentNamedId: agentNamedId })=>({ getState: getState, dispatch: dispatch })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        dispatch($0b6866794de633f9$var$addStoreChatItem({
            message: (0, $cteoa.createStoreAssistant)({
                id: id,
                content: content,
                agentNamedId: agentNamedId,
                conversationId: conversationId
            }),
            conversationId: conversationId
        }));
    });
/**
 * ************************************************************
 * Public Actions
 * ************************************************************
 */ const $0b6866794de633f9$var$clearFollowUpMessages = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).clearFollowUpMessages, ({ conversationId: conversationIdParam })=>({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const filteredMessages = messages.filter((message)=>!(0, $bPHr8.isStoreFollowUp)(message));
        setMessages(conversationId, filteredMessages);
    });
/**
 * Send a message to the assistant and add it to react-sweet-state
 *
 * @param agentId -- this parameter will be prioritised over agent.id
 */ const $0b6866794de633f9$var$sendMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).sendMessage, (props)=>(0, $54793c520b6b8872$export$9558791053c77c34)({
        ...props,
        setConversationData: $0b6866794de633f9$var$setConversationData,
        createConversationOptimistically: $0b6866794de633f9$var$createConversationOptimistically,
        addHumanMessage: $0b6866794de633f9$var$addHumanMessage,
        addAssistantMessage: $0b6866794de633f9$var$addAssistantMessage,
        clearFollowUpMessages: $0b6866794de633f9$var$clearFollowUpMessages,
        setSelectedConversation: $0b6866794de633f9$var$setSelectedConversation,
        reconnectToInProgressStream: $0b6866794de633f9$var$reconnectToInProgressStream
    }), {
    experienceName: (args)=>(0, $16lEl.sendMessageExperienceName)({
            deepResearchEnabled: args[0]?.deepResearchEnabled,
            thinkDeeperEnabled: args[0]?.thinkDeeperEnabled,
            fastModeEnabled: args[0]?.fastModeEnabled
        }),
    getRateLimitState: (args)=>({
            isDeepResearchAttempt: args[0]?.deepResearchEnabled
        })
});
/**
 * Similar action to `sendMessage` with the barebone functionalities to confirm tools/skills/actions
 *
 * Initially this will assume that this function only created on existing conversation
 */ const $0b6866794de633f9$var$sendMessageConfirmedTools = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).sendMessageConfirmedTools, ({ conversationId: conversationIdParam, agentId: agentId, confirmed_tools: confirmed_tools, messageSources: messageSources, storeUserMessages: storeUserMessages = false, webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, taskModeEnabled: taskModeEnabled, includeAIFeatureContext: includeAIFeatureContext, agentVersion: agentVersion, actionedAnalyticsAttributes: actionedAnalyticsAttributes, resolutionType: resolutionType })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, chatContextStoreActions: chatContextStoreActions, experienceTracker: experienceTracker, getMessages: getMessages, setMessages: setMessages, trackAIMAUEvent: trackAIMAUEvent, trackAgentEvent: trackAgentEvent, processStreamResearch: processStreamResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, clearMessageResearch: clearMessageResearch, updateResearchMessageId: updateResearchMessageId, markIncompleteResearchesErrored: markIncompleteResearchesErrored, sendAnalyticsEvent: sendAnalyticsEvent, getIsChatMounted: getIsChatMounted, capabilities: capabilities, unifiedTasksActions: unifiedTasksActions })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const resolvedAgentVersion = agentVersion ?? getState().conversations[conversationId]?.agentVersion;
        // Collection of callbacks for experience and performance tracking
        const expAndPerfTrackers = {
            start: ()=>{
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).SEND_CONFIRMED_TOOLS_MESSAGE,
                    id: conversationId,
                    attributes: {
                        conversationId: conversationId,
                        interactionSource: messageSources?.interactionSource
                    }
                });
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFinishStream.start();
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.start();
            },
            firstAnswerPartReceived: ()=>{
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.stop();
            },
            succeed: ()=>{
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).SEND_CONFIRMED_TOOLS_MESSAGE
                });
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFinishStream.stop();
            },
            aupError: ()=>{
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).SEND_CONFIRMED_TOOLS_MESSAGE
                });
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFinishStream.stop();
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.stop();
            },
            agentDeactivated: ({ error: error })=>{
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).SEND_CONFIRMED_TOOLS_MESSAGE,
                    error: error
                });
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFinishStream.cancel();
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.cancel();
            },
            abort: ()=>{
                experienceTracker.abort({
                    name: (0, $16lEl.ExperienceName).SEND_CONFIRMED_TOOLS_MESSAGE,
                    reason: 'Aborted'
                });
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFinishStream.cancel();
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.cancel();
            },
            fail: ({ error: error })=>{
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).SEND_CONFIRMED_TOOLS_MESSAGE,
                    error: error
                });
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFinishStream.stop();
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.stop();
            }
        };
        const requestedModeAttributes = (0, $9likX.interactionModeRequestedAttributes)((0, $9likX.getInteractionModeRequested)({
            deepResearchEnabled: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            fastModeEnabled: fastModeEnabled,
            taskModeEnabled: taskModeEnabled
        }));
        const trackingAttributes = {
            isRovoCustomAgent: (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId),
            sendMessageReason: 'TOOLS_CONFIRMATION',
            aiFeatureName: messageSources?.aiFeatureName
        };
        // Source executed mode from the originating assistant message (the one this
        // confirmed-tools action is being executed against). `confirmed_tools.message_id`
        // is the assistant message id whose tool calls the user just confirmed.
        const originatingAssistantMessage = getMessages(conversationId).find((item)=>(0, $bPHr8.isStoreAssistant)(item) && item.content?.message?.message?.id === confirmed_tools.message_id);
        const interactionModeExecutedFromOriginatingAssistantMessage = (0, $9likX.getInteractionModeExecutedFromStoreAssistant)(originatingAssistantMessage);
        const isCancelled = (0, $dh538.fg)('rovo_mcp_tools_action_key_analytics') && resolutionType === 'cancelled';
        const tools = (0, $af163ae683530e0f$export$376e622a1b976e6e)(confirmed_tools);
        const agentAnalyticsAttributes = {
            touchPoint: 'chatSendMessageConfirmedTools',
            tools: tools
        };
        // Collection of callbacks for analytics tracking
        const analyticsTrackers = {
            /**
     * There are 2 AIMAU events here, because in resumption we're doing 2 things
     * 1. We're confirming the previous tools result
     * 2. And the confirmation triggers a LLM chat streaming
     */ initiated: ({ timestamp: timestamp })=>{
                const actionKey = (0, $dh538.fg)('rovo_mcp_tools_action_key_analytics') ? confirmed_tools.tools[0]?.key : undefined;
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'actioned',
                    actionResult: isCancelled ? 'toolsExecutionCancelled' : 'toolsExecutionConfirmed',
                    proactive: false,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    attributes: {
                        ...(0, $dh538.fg)('jira-ai-agentic-planning-technical-changes') ? actionedAnalyticsAttributes : {},
                        ...interactionModeExecutedFromOriginatingAssistantMessage ? {
                            interactionModeExecuted: interactionModeExecutedFromOriginatingAssistantMessage
                        } : {},
                        ...actionKey ? {
                            actionKey: actionKey
                        } : {},
                        ...trackingAttributes.aiFeatureName && {
                            aiFeatureName: trackingAttributes.aiFeatureName
                        }
                    }
                });
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: timestamp,
                    attributes: requestedModeAttributes
                });
                // @deprecated kept for Data Science (DS) consumers. Replaced by backend unified instrumentation: https://hello.atlassian.net/wiki/spaces/DATA/pages/7037248568/Backend+Unified+Instrumentation+for+Skills+Tools+Subagents
                if (agentId && (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId)) trackAgentEvent({
                    action: isCancelled ? 'toolsExecutionCancelled' : 'toolsExecutionConfirmed',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId,
                        ...(0, $dh538.fg)('jira-ai-agentic-planning-technical-changes') && actionedAnalyticsAttributes
                    }
                });
            },
            aborted: ()=>{
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'dismissed',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    messageId: trackingAttributes.messageId,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    attributes: requestedModeAttributes
                });
                // @deprecated kept for Data Science (DS) consumers. Replaced by backend unified instrumentation: https://hello.atlassian.net/wiki/spaces/DATA/pages/7037248568/Backend+Unified+Instrumentation+for+Skills+Tools+Subagents
                if (agentId && (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId)) trackAgentEvent({
                    action: 'toolsExecutionStreamStopped',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId
                    }
                });
            },
            viewed: ()=>{
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'viewed',
                    proactive: false,
                    userGenerated: true,
                    source: messageSources?.interactionSource,
                    messageId: trackingAttributes.messageId,
                    subjectId: messageSources?.followUpSource,
                    citedProductList: {},
                    sourceProducts: {},
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: new Date().toISOString(),
                    attributes: {
                        ...trackingAttributes.interactionModeExecuted ? {
                            interactionModeExecuted: trackingAttributes.interactionModeExecuted
                        } : {},
                        ...trackingAttributes.aiFeatureName && {
                            aiFeatureName: trackingAttributes.aiFeatureName
                        }
                    }
                });
                // @deprecated kept for Data Science (DS) consumers. Replaced by backend unified instrumentation: https://hello.atlassian.net/wiki/spaces/DATA/pages/7037248568/Backend+Unified+Instrumentation+for+Skills+Tools+Subagents
                if (agentId && (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId)) trackAgentEvent({
                    action: 'toolsExecutionResultViewed',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId,
                        scenarioId: trackingAttributes.scenarioId
                    }
                });
            },
            error: ()=>{
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'error',
                    proactive: false,
                    userGenerated: true,
                    messageId: trackingAttributes.requestId,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: new Date().toISOString(),
                    attributes: requestedModeAttributes
                });
                // @deprecated kept for Data Science (DS) consumers. Replaced by backend unified instrumentation: https://hello.atlassian.net/wiki/spaces/DATA/pages/7037248568/Backend+Unified+Instrumentation+for+Skills+Tools+Subagents
                if (agentId && (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId)) trackAgentEvent({
                    action: 'toolsExecutionResultError',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId
                    }
                });
            }
        };
        const updateCurrentConversation = (data)=>{
            dispatch($0b6866794de633f9$var$setConversationData({
                conversationId: conversationId,
                data: data
            }));
        };
        const { abortController: abortController, storeAbortController: storeAbortController, confirmAbort: confirmAbort } = (0, $3ba7c8b5e2cd14b7$export$cb6128fc3a3c8081)();
        let hasReceivedFinalResponse = false;
        let generator;
        let responseData;
        let hasLoggedInitiatedEvent = false;
        // Hoisted so it is accessible in the catch block for clearMessageResearch
        let tmpAssistantMessageId = (0, $cteoa.generateTmpMessageId)(conversationId);
        // Reconnect state — populated once we receive the conversation channel data message
        let agentMessageId;
        let isReconnectSupported = false;
        const handleAbort = ()=>{
            expAndPerfTrackers.abort();
            confirmAbort();
            clearMessageResearch({
                messageId: tmpAssistantMessageId
            });
            !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                timestamp: trackingAttributes.initiatedTimestamp
            });
            analyticsTrackers.aborted();
            // Call the cancel API to stop backend processing
            if (trackingAttributes.messageId && trackingAttributes.messageId !== tmpAssistantMessageId) assistanceService.cancelMessageStream({
                conversationId: conversationId,
                messageId: trackingAttributes.messageId
            }).catch(()=>{
                // Log but don't throw - the abort is already happening
                (0, $1yaYZ.addSentryBreadcrumb)({
                    message: 'Failed to cancel message stream after abort in sendMessageConfirmedTools',
                    data: {
                        conversationId: conversationId,
                        messageId: trackingAttributes.messageId
                    }
                });
            });
        };
        try {
            expAndPerfTrackers.start();
            // change the conversation status
            updateCurrentConversation({
                storeAbortController: storeAbortController,
                status: (0, $bPHr8.CHAT_STORE_STATUS).awaitingResponse,
                lastAgentMessageStatus: 'IN_PROGRESS'
            });
            if (unifiedTasksActions && (0, $dh538.fg)('rovo_chat_enable_tasks')) {
                // Optimistic update goes directly to the tasks store. Explicitly clears
                // current_step / result_summary / error_message so the row resets to a
                // fresh "now running" state.
                const activeTask = unifiedTasksActions.getActiveTaskForConversation(conversationId);
                if (activeTask?.taskId) unifiedTasksActions.setTaskProgressState({
                    taskId: activeTask.taskId,
                    progressState: 'Running',
                    title: activeTask.title ?? '',
                    updatedAt: new Date().toISOString(),
                    currentStep: null,
                    resultSummary: null,
                    errorMessage: null
                });
            }
            // Only add assistant message
            dispatch($0b6866794de633f9$var$addAssistantMessage({
                id: tmpAssistantMessageId,
                content: '',
                conversationId: conversationId,
                agentNamedId: agentId
            }));
            dispatch($0b6866794de633f9$var$clearFollowUpMessages({
                conversationId: conversationId
            }));
            trackingAttributes.messageId = tmpAssistantMessageId;
            trackingAttributes.instrumentationId = tmpAssistantMessageId;
            // Assumed the insert is successful and inserts at the last position
            const answerIndex = getMessages(conversationId).length - 1;
            // Call the BE endpoint
            trackingAttributes.initiatedTimestamp = new Date().toISOString();
            const response = await assistanceService.sendMessageConfirmedTools({
                conversationId: conversationId,
                agentId: agentId,
                confirmed_tools: confirmed_tools,
                controller: abortController,
                optInSSEStream: true,
                storeMessage: storeUserMessages,
                webSearchEnabled: webSearchEnabled,
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                alphaExtendedThinkingMode: alphaExtendedThinkingMode,
                fastModeEnabled: fastModeEnabled,
                ...taskModeEnabled ? {
                    planModeEnabled: taskModeEnabled
                } : {},
                ...includeAIFeatureContext && {
                    aiFeatureContext: chatContextStoreActions.getAIFeatureContext()
                },
                ...resolvedAgentVersion ? {
                    agentVersion: resolvedAgentVersion
                } : {},
                optInToDeepResearchV2: true,
                optInThinkDeeperMessages: true,
                optInAnsNow: true,
                optInNewToolTraces: (0, $c6GJD.default).getExperimentValue('rovo_chat_thinking_traces_improvements', 'isEnabled', false, {
                    fireExperimentExposure: false
                }),
                optInNewTeamworkTraceIcons: (0, $dh538.fg)('rovo_chat_enable_twg_trace_team26'),
                capabilities: capabilities
            });
            generator = response.generator;
            responseData = response.responseData;
            // Update action invocation statuses based on the confirmed_tools payload
            if ((0, $dh538.fg)('rovo_chat_enable_tasks')) dispatch($0b6866794de633f9$var$updateConfirmedToolsActionStatuses({
                conversationId: conversationId,
                messageId: confirmed_tools.message_id,
                tools: confirmed_tools.tools,
                status: 'fromResolution'
            }));
            /**
     * --------
     * Stream processing START
     * --------
     */ updateCurrentConversation({
                status: (0, $bPHr8.CHAT_STORE_STATUS).typingResponse
            });
            // Research store state shared across stream messages
            const researchState = {
                clientRoundCounter: 0,
                hasAccumulatedAnswerContent: false
            };
            const processStreamMarkdown = (0, $cteoa.createStreamMarkdownProcessor)();
            const streamToIterate = (0, $be423051027308ae$export$29bad1ab941da7cb)({
                generator: generator,
                conversationId: conversationId,
                abortController: abortController,
                assistanceService: assistanceService,
                sendAnalyticsEvent: sendAnalyticsEvent,
                experienceTracker: experienceTracker,
                getMessageId: ()=>agentMessageId,
                canReconnect: ()=>!!(agentMessageId && isReconnectSupported) && (0, $c6GJD.default).getExperimentValue('rovo_chat_reconnect_all_experiment', 'isEnabled', false),
                updateCurrentConversation: updateCurrentConversation,
                getIsChatMounted: getIsChatMounted,
                analyticsAttributes: {
                    isDeepResearch: deepResearchEnabled,
                    thinkDeeperEnabled: thinkDeeperEnabled,
                    fastModeEnabled: fastModeEnabled
                },
                onBeforeFirstReconnect: ()=>{
                    if (agentMessageId) {
                        const chat = getMessages(conversationId);
                        const alreadySwapped = (0, $cteoa.findStoreMessageIndex)(chat, agentMessageId) >= 0;
                        if (!alreadySwapped) {
                            // Swap the tmp message ID → real agent message ID in the
                            // message store so addAnswerPart/replaceAnswerData ID
                            // validation doesn't throw on the replayed stream chunks.
                            setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageId)({
                                chat: chat,
                                oldId: tmpAssistantMessageId,
                                newId: agentMessageId
                            }));
                            updateResearchMessageId({
                                messageId: tmpAssistantMessageId,
                                newMessageId: agentMessageId
                            });
                        }
                        // Reassign so subsequent processResearchStreamMessage calls
                        // and addAnswerPart/replaceAnswerData use the real agent
                        // message ID as the key.
                        tmpAssistantMessageId = agentMessageId;
                    }
                }
            });
            for await (const streamObj of streamToIterate){
                const streamMessage = (0, $ljUdP.isSSEMessage)(streamObj) ? streamObj.data : streamObj;
                /**
       * Research store processing — handles think-deeper traces, implicit round
       * detection, and research plan updates for all message types.
       */ (0, $54793c520b6b8872$export$5a07e6227eed9665)({
                    streamMessage: streamMessage,
                    tmpAssistantMessageId: tmpAssistantMessageId,
                    conversationId: conversationId,
                    deepResearchEnabled: deepResearchEnabled,
                    getMessages: getMessages,
                    setMessages: setMessages,
                    processStreamResearch: processStreamResearch,
                    addImplicitResearchPlan: addImplicitResearchPlan,
                    resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                    researchState: researchState
                });
                /**
       * Conversation channel data processing (usually the first stream part)
       */ if ((0, $ljUdP.isConversationChannelDataMessage)(streamMessage)) {
                    agentMessageId = streamMessage.assistant_message_id;
                    trackingAttributes.instrumentationId = agentMessageId;
                    trackingAttributes.messageId = agentMessageId;
                    analyticsTrackers.initiated({
                        timestamp: trackingAttributes.initiatedTimestamp
                    });
                    hasLoggedInitiatedEvent = true;
                    // Update the research store with the real message ID once we have it
                    updateResearchMessageId({
                        messageId: tmpAssistantMessageId,
                        newMessageId: agentMessageId
                    });
                }
                /**
       * Reconnect support detection
       */ if ((0, $ljUdP.isStreamReconnectSupportPart)(streamMessage)) isReconnectSupported = true;
                /**
       * Trace processing
       */ if ((0, $ljUdP.isStreamTrace)(streamMessage)) {
                    if (!trackingAttributes.requestId) trackingAttributes.requestId = streamMessage.metadata?.request_id;
                    updateCurrentConversation({
                        traces: (0, $cteoa.dedupeTraceMessagesWithLatest)([
                            ...getState().conversations[conversationId]?.traces ?? [],
                            (0, $cteoa.getTraceFromStreamMessage)(streamMessage)
                        ])
                    });
                }
                /**
       * Answer part processing
       */ if ((0, $ljUdP.isStreamAnswerPart)(streamMessage)) {
                    expAndPerfTrackers.firstAnswerPartReceived();
                    (0, $cteoa.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                    let processedStreamMessage = streamMessage;
                    let processedStreamResult = null;
                    if ((0, $dh538.fg)('rovo_enable_component_streaming')) {
                        processedStreamResult = processStreamMarkdown(processedStreamMessage);
                        processedStreamMessage = processedStreamResult.processedStreamMessage;
                    }
                    if (processedStreamResult && processedStreamResult.markdownData && (0, $dh538.fg)('rovo_enable_component_streaming')) setMessages(conversationId, (0, $cteoa.addAnswerPartWithMarkdownData)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        answerPart: processedStreamMessage,
                        markdownData: processedStreamResult.markdownData,
                        useIndex: answerIndex
                    }));
                    else setMessages(conversationId, (0, $cteoa.addAnswerPart)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        answerPart: processedStreamMessage,
                        useIndex: answerIndex
                    }));
                }
                /**
       * Final response processing
       */ if ((0, $ljUdP.isStreamResponse)(streamMessage)) {
                    trackingAttributes.interactionModeExecuted = streamMessage.message?.message?.message_metadata?.interaction_mode_executed;
                    hasReceivedFinalResponse = true;
                    const humanMessageId = streamMessage?.message?.human_message?.id.toString();
                    const finalAgentMessageId = streamMessage?.message?.message?.id.toString();
                    (0, $cteoa.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                    const { processedStreamMessage: processedFinalMessage, markdownData: markdownData } = (0, $cteoa.processStreamResponseMarkdown)({
                        streamMessage: streamMessage,
                        messageId: finalAgentMessageId,
                        conversationId: conversationId,
                        sendAnalyticsEvent: sendAnalyticsEvent
                    });
                    setMessages(conversationId, (0, $cteoa.replaceAnswerData)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        content: processedFinalMessage,
                        useIndex: answerIndex,
                        humanMessageId: humanMessageId,
                        markdownData: Object.keys(markdownData).length > 0 ? markdownData : undefined
                    }));
                    // Update the research store key so rounds persist after the message ID changes
                    if (finalAgentMessageId && finalAgentMessageId !== tmpAssistantMessageId) updateResearchMessageId({
                        messageId: tmpAssistantMessageId,
                        newMessageId: finalAgentMessageId
                    });
                    trackingAttributes.humanMessageId = humanMessageId;
                    trackingAttributes.scenarioId = streamMessage.message.message?.scenario?.id;
                    if (!hasLoggedInitiatedEvent) {
                        trackingAttributes.messageId = finalAgentMessageId;
                        trackingAttributes.instrumentationId = finalAgentMessageId;
                    }
                }
                /**
       * Follow up processing
       */ if ((0, $ljUdP.isFollowUpMessage)(streamMessage)) {
                    const messages = getMessages(conversationId);
                    (0, $cteoa.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                    setMessages(conversationId, [
                        ...messages,
                        {
                            type: 'FOLLOW_UP',
                            content: streamMessage,
                            id: (0, $a37fef51f047b95d$export$bac56f3fc527f04b)(0, 1000000),
                            agentMessageId: (0, $cteoa.getLastAgentMessageID)(messages),
                            humanMessageId: trackingAttributes.humanMessageId
                        }
                    ]);
                }
                /**
       * Task status processing
       */ if ((0, $ljUdP.isStreamTaskStatus)(streamMessage)) {
                    if (unifiedTasksActions && (0, $dh538.fg)('rovo_chat_enable_tasks')) (0, $4bca5e7215eb7baa$export$89a4ab1dea43d7ee)({
                        conversationId: conversationId,
                        taskMessage: streamMessage.message,
                        messageId: trackingAttributes.messageId,
                        target: (0, $4bca5e7215eb7baa$export$6b58e85d865a8eef)(unifiedTasksActions)
                    });
                }
                /**
       * Todo snapshot processing
       */ if ((0, $ljUdP.isStreamTodoSnapshot)(streamMessage)) {
                    if (unifiedTasksActions && (0, $dh538.fg)('rovo_chat_enable_tasks')) unifiedTasksActions.setTaskTodoSnapshot({
                        conversationId: conversationId,
                        todoSnapshot: {
                            todos: streamMessage.message.todos
                        }
                    });
                }
                /**
       * Error processing
       */ if ((0, $ljUdP.isStreamError)(streamMessage)) {
                    const { message: message, metadata: metadata, millisOffset: millisOffset, type: type } = streamMessage;
                    // AUP violations are still considered successful
                    if ((0, $ljUdP.isStreamAUPError)(streamMessage)) expAndPerfTrackers.aupError();
                    throw new (0, $iEWar.StreamErrorException)(message?.content || 'Unknown', {
                        detail: {
                            message: message,
                            metadata: metadata,
                            millisOffset: millisOffset,
                            type: type
                        },
                        traceId: response.responseData?.traceId
                    });
                }
            }
        } catch (error) {
            const isAgentDeactivated = error instanceof (0, $flpNp.ApiError) && error.errorAttributes.errorCode?.includes((0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_DEACTIVATED);
            const isNoAgentPermission = error instanceof (0, $flpNp.ApiError) && error.errorAttributes.errorCode?.includes((0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_FORBIDDEN) && (0, $dh538.fg)('convo-ai-enable-agents-use-permission');
            if (isAgentDeactivated || isNoAgentPermission) {
                expAndPerfTrackers.agentDeactivated({
                    error: error
                });
                updateCurrentConversation({
                    status: (0, $bPHr8.CHAT_STORE_STATUS).deactivatedAgentError,
                    traces: [],
                    errorCode: (0, $dh538.fg)('convo-ai-enable-agents-use-permission') ? error.errorAttributes.errorCode : undefined
                });
                // Mark all confirmed tool actions as errored
                if ((0, $dh538.fg)('rovo_chat_enable_tasks')) dispatch($0b6866794de633f9$var$updateConfirmedToolsActionStatuses({
                    conversationId: conversationId,
                    messageId: confirmed_tools.message_id,
                    tools: confirmed_tools.tools,
                    status: 'errored'
                }));
                !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                    timestamp: trackingAttributes.initiatedTimestamp
                });
                analyticsTrackers.error();
                return;
            }
            if (error instanceof Error && error.name === 'AbortError') {
                handleAbort();
                return;
            }
            // Mark all confirmed tool actions as errored
            if ((0, $dh538.fg)('rovo_chat_enable_tasks')) dispatch($0b6866794de633f9$var$updateConfirmedToolsActionStatuses({
                conversationId: conversationId,
                messageId: confirmed_tools.message_id,
                tools: confirmed_tools.tools,
                status: 'errored'
            }));
            expAndPerfTrackers.fail({
                error: error instanceof Error ? error : new Error(String(error))
            });
            markIncompleteResearchesErrored({
                messageId: tmpAssistantMessageId
            });
            !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                timestamp: trackingAttributes.initiatedTimestamp
            });
            analyticsTrackers.error();
            throw error;
        } finally{
            updateCurrentConversation((0, $cteoa.clearStatus)({}));
            setMessages(conversationId, (0, $cteoa.markStreamingMessagesAsComplete)(getMessages(conversationId)));
        }
        /**
   * --------
   * Stream processing END
   * --------
   */ // Handle programmatic abort — the generator may exit cleanly without throwing AbortError
        // when the abort controller is signalled. Check the signal to detect this case.
        if (abortController.signal.aborted) {
            handleAbort();
            return;
        }
        // if stream finishes without FINAL_RESPONSE, BE is hanging
        if (!hasReceivedFinalResponse) {
            const error = new (0, $iEWar.NoFinalResponseError)('The response took too long and timed out. Try refreshing the page.', {
                traceId: responseData?.traceId
            });
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).SEND_CONFIRMED_TOOLS_MESSAGE,
                error: error
            });
            markIncompleteResearchesErrored({
                messageId: tmpAssistantMessageId
            });
            !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                timestamp: trackingAttributes.initiatedTimestamp
            });
            analyticsTrackers.error();
            throw error;
        }
        !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
            timestamp: trackingAttributes.initiatedTimestamp
        });
        analyticsTrackers.viewed();
        expAndPerfTrackers.succeed();
        if ((0, $dh538.fg)('rovo_chat_chat_history_refresh')) //If user is viewing a different conversation or not viewing ConversationAssitant, optimistically set conversation to unread
        {
            if (getState().currentConversationId !== conversationId) dispatch($0b6866794de633f9$var$setConversationData({
                conversationId: conversationId,
                data: {
                    readStatus: false
                }
            }));
        }
    });
const $0b6866794de633f9$var$removeMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).removeMessage, ({ messageId: messageId, conversationId: conversationIdParam })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const filteredMessages = messages.filter((message)=>{
            if ((0, $bPHr8.isStoreError)(message) || (0, $bPHr8.isStoreFollowUp)(message)) return message.id !== messageId;
            else if ((0, $bPHr8.isStoreHuman)(message)) return message.content.id !== String(messageId);
            else return true;
        });
        setMessages(conversationId, filteredMessages);
    });
/**
 * Hides the last HUMAN message + everything after it, and returns the removed
 * slice so the caller can pass it as `editRollback.restoreMessages` to
 * `sendMessage` for automatic rollback on terminal failure.
 */ const $0b6866794de633f9$var$truncateFromLastHumanMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).truncateFromLastHumanMessage, ({ conversationId: conversationIdParam })=>({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return [];
        const messages = getMessages(conversationId);
        const lastHumanIdx = (0, $cteoa.findLastIndex)(messages, (0, $bPHr8.isStoreHuman));
        if (lastHumanIdx < 0) return [];
        const tail = messages.slice(lastHumanIdx);
        setMessages(conversationId, messages.slice(0, lastHumanIdx));
        return tail;
    });
/**
 * Reconnects to an in-progress message stream when loading a conversation
 * where the last message has async_status 'IN_PROGRESS'
 */ const $0b6866794de633f9$var$reconnectToInProgressStream = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).reconnectToInProgressStream, ({ conversationId: conversationId, messageId: messageId, lastEventId: lastEventId, isDeepResearch: isDeepResearch, abortCurrentRequest: abortCurrentRequest, answerIndex: answerIndex, onComplete: onComplete, isAutoReconnect: isAutoReconnect })=>(0, $f0918ff6cbefa0f7$export$d8454bf5b2ffdf29)({
        conversationId: conversationId,
        messageId: messageId,
        lastEventId: lastEventId,
        isDeepResearch: isDeepResearch,
        abortCurrentRequest: abortCurrentRequest,
        answerIndex: answerIndex,
        onComplete: onComplete,
        isAutoReconnect: isAutoReconnect,
        setConversationData: $0b6866794de633f9$var$setConversationData
    }), {
    experienceName: ()=>(0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM
});
const $0b6866794de633f9$export$31bb5ed5e2cc3184 = ({ latestMessages: latestMessages, conversationId: conversationId, sendAnalyticsEvent: sendAnalyticsEvent, shouldPreprocessDetails: shouldPreprocessDetails = false })=>{
    const messages = [];
    for (const message of latestMessages){
        if ((0, $ljUdP.isHumanMessage)(message)) {
            // Human messages should only have application/json+a2ui if they have sent an action
            // we skip this message as there is nothing to render but this is persisted for flexibility
            // there should be no cases where a human renders A2UI from their messages
            if (typeof message.content === 'object' && message.content !== null && 'data_parts_mime_type' in message.content && message.content.data_parts_mime_type === 'application/json+a2ui' && (0, $dh538.fg)('jira_ai_rendering_a2ui')) continue;
            messages.push((0, $cteoa.createStoreHumanWithContent)(message));
        } else if ((0, $ljUdP.isStreamResponse)(message)) {
            // Process boundary content for historical assistant messages
            let processedMessage = message;
            const markdownData = {};
            // Rewrite HTML `<details><summary>` blocks into the Rovo-native `▞…▚`
            // boundary before the existing extractor runs so historical messages
            // render identically to their streamed form. Must happen BEFORE the
            // expand extractor below (which consumes `▞…▚`).
            if (shouldPreprocessDetails) processedMessage = (0, $cteoa.preprocessStreamResponseDetails)(processedMessage);
            // Apply the same boundary content extraction logic as streaming messages
            if ((0, $dh538.fg)('rovo_enable_data_sculptor')) {
                const sculptorMsg = (0, $cteoa.extractMarkdownContent)({
                    streamMessage: processedMessage,
                    boundaryStart: '[^sculptor:start^]',
                    boundaryEnd: '[^sculptor:end^]',
                    replacementContent: '[^sculptor^]'
                });
                processedMessage = sculptorMsg.processedStreamMessage;
                sculptorMsg.boundaryContents.forEach((content, index)=>{
                    markdownData[`sculptor-${index}`] = content;
                });
            }
            const expandOpenTag = "\u259E";
            const expandCloseTag = "\u259A";
            const expandPlaceholder = '[^expand^]';
            const expandMsg = (0, $cteoa.extractMarkdownContent)({
                streamMessage: processedMessage,
                boundaryStart: expandOpenTag,
                boundaryEnd: expandCloseTag,
                replacementContent: expandPlaceholder
            });
            processedMessage = expandMsg.processedStreamMessage;
            expandMsg.boundaryContents.forEach((content, index)=>{
                markdownData[`expand-${index}`] = content;
            });
            const chartPlaceholder = '[^chart^]';
            // When processing conversation history, process both unicode and non-unicode tags
            // to handle previous conversations that used the non-unicode tag
            // Once di_chat_chart_tag_unicode is rolled out, chartMsg can be removed after 30 days
            let chartIndex = 0;
            const chartMsg = (0, $cteoa.extractMarkdownContent)({
                streamMessage: processedMessage,
                boundaryStart: '[^chart:start^]',
                boundaryEnd: '[^chart:end^]',
                replacementContent: chartPlaceholder
            });
            processedMessage = chartMsg.processedStreamMessage;
            chartMsg.boundaryContents.forEach((content)=>{
                markdownData[`chart-${chartIndex}`] = content;
                chartIndex++;
            });
            if (chartMsg?.boundaryContents && chartMsg.boundaryContents.length > 0) sendAnalyticsEvent({
                eventType: 'track',
                action: 'extracted',
                actionSubject: 'vizPluginChartNonUnicode',
                attributes: {
                    messageId: message?.message?.message?.id.toString(),
                    conversationId: conversationId,
                    chartCount: chartMsg.boundaryContents.length,
                    timestamp: new Date().toISOString()
                }
            });
            const unicodeChartMsg = (0, $cteoa.extractMarkdownContent)({
                streamMessage: processedMessage,
                boundaryStart: "\u25F4",
                boundaryEnd: "\u25F6",
                replacementContent: chartPlaceholder
            });
            processedMessage = unicodeChartMsg.processedStreamMessage;
            unicodeChartMsg.boundaryContents.forEach((content)=>{
                markdownData[`chart-${chartIndex}`] = content;
                chartIndex++;
            });
            if ((0, $dh538.fg)('rovo_chat_enable_inline_lumina')) {
                const luminaMsg = (0, $cteoa.extractMarkdownContent)({
                    streamMessage: processedMessage,
                    boundaryStart: "\u25D0",
                    boundaryEnd: "\u25D1",
                    replacementContent: '\n\n[^lumina^]\n\n'
                });
                processedMessage = luminaMsg.processedStreamMessage;
                luminaMsg.boundaryContents.forEach((content, index)=>{
                    markdownData[`lumina-${index}`] = content;
                });
            }
            // When the backend returns structured content (A2UI messages), normalize
            // it back to a plain text string and extract data_parts for A2UI rendering.
            let extractedA2UIMessages;
            if ((0, $dh538.fg)('jira_ai_rendering_a2ui')) {
                const a2uiResult = (0, $cteoa.extractA2UIFromStructuredContent)(processedMessage.message?.message?.content);
                if (a2uiResult) {
                    processedMessage.message.message.content = a2uiResult.textContent;
                    extractedA2UIMessages = a2uiResult.a2uiMessages;
                }
            }
            // Create StoreAssistant with processed boundary data
            const storeAssistant = (0, $cteoa.createStoreAssistantWithContent)(processedMessage);
            if (Object.keys(markdownData).length > 0) storeAssistant.markdownData = markdownData;
            // Mark message as historical since it's loaded from conversation history
            storeAssistant.isHistorical = true;
            if (extractedA2UIMessages) storeAssistant.agenticUiMessages = extractedA2UIMessages;
            messages.push(storeAssistant);
        }
    }
    return messages;
};
const $0b6866794de633f9$export$9c99f879b5701ba2 = (latestMessages)=>{
    if (!(0, $dh538.fg)('rovo_agent_versioning_enabled')) return undefined;
    for (const message of latestMessages)if ((0, $ljUdP.isStreamResponse)(message)) {
        const agentAuthor = message.message?.message?.agent_author;
        if (agentAuthor?.versionId || agentAuthor?.versionType) return {
            versionId: agentAuthor.versionId,
            versionType: agentAuthor.versionType,
            versionNumber: agentAuthor.versionNumber
        };
        return undefined;
    }
    return undefined;
};
const $0b6866794de633f9$var$restoreTaskModeForConversation = ({ conversationId: conversationId, messages: messages })=>(_, { setReasoningMode: setReasoningMode, unifiedTasksActions: unifiedTasksActions })=>{
        if (!(0, $dh538.fg)('rovo_chat_enable_tasks') || !unifiedTasksActions) return;
        const activeTask = unifiedTasksActions.getActiveTaskForConversation(conversationId);
        const lastAgentMsgId = (0, $cteoa.getLastAgentMessageID)(messages);
        if (activeTask && !(0, $bPHr8.isTerminalTaskState)(activeTask.progressState) && lastAgentMsgId && activeTask.currentMessageId === lastAgentMsgId) setReasoningMode(conversationId, 'task');
    };
const $0b6866794de633f9$var$isForbiddenConversationError = (error)=>error instanceof (0, $flpNp.ApiError) && error.errorAttributes?.statusCode === 403;
const $0b6866794de633f9$var$handleForbiddenConversation = ({ conversationId: conversationId, dispatch: dispatch, sendAnalyticsEvent: sendAnalyticsEvent, showFlag: showFlag })=>{
    const rovoParams = (0, $6FQwA.getRovoParams)();
    const isConversationIdInRovoParams = !!rovoParams?.conversationId;
    sendAnalyticsEvent({
        eventType: 'track',
        action: 'forbidden',
        actionSubject: 'rovoChatFetchConversation',
        attributes: {
            isConversationIdInRovoParams: isConversationIdInRovoParams
        }
    });
    dispatch($0b6866794de633f9$var$removeConversationFromStore({
        conversationId: conversationId
    }));
    dispatch($0b6866794de633f9$var$setSelectedConversation({
        conversationId: (0, $2CHXX.EMPTY_CONVERSATION_ID)
    }));
    if (isConversationIdInRovoParams) (0, $6FQwA.updatePageRovoParams)({
        conversationId: undefined
    });
    showFlag?.((0, $5MDfE.StoreErrorFlagId).CONVERSATION_FORBIDDEN);
};
const $0b6866794de633f9$var$fetchConversation = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).fetchConversation, ({ conversationId: conversationIdParam, messageIdSelectedForPreview: messageIdSelectedForPreview })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, getMessages: getMessages, setMessages: setMessages, showFlag: showFlag, setReasoningMode: setReasoningMode })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const conversation = getState().conversations[conversationId];
        if (conversation?.status !== (0, $bPHr8.CHAT_STORE_STATUS).idle || (0, $cteoa.isEmptyConversation)(conversationId)) return;
        if (conversation.skipNextFetch) {
            dispatch($0b6866794de633f9$var$setConversationData({
                conversationId: conversationId,
                data: {
                    skipNextFetch: false
                }
            }));
            return;
        }
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).FETCH_CHAT,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        if (conversation.storeAbortController) await conversation.storeAbortController?.abort();
        dispatch($0b6866794de633f9$var$resetConversationForLoading({
            conversationId: conversationId,
            traces: messageIdSelectedForPreview && (0, $dh538.fg)('aifc_create_enabled') ? [] : [
                {
                    messageContent: 'Reloading chat',
                    status: 'loading'
                }
            ],
            sourceAgentId: (0, $cteoa.getSourceAgentId)(getMessages(conversationId), (0, $cteoa.getConversation)(getState(), conversationId))
        }));
        let serviceChat;
        try {
            serviceChat = await assistanceService.getChat(conversationId);
        } catch (e) {
            if ((0, $ljUdP.isChannelNotFoundError)(e)) {
                //We succeed this event because in sendMessage, we create a new channel if we receive a 404 response
                // Users will not see this error, so exclude it from Sentry
                //This is a fix due to an incompatible BE API change
                sendAnalyticsEvent({
                    eventType: 'operational',
                    action: 'notFound',
                    actionSubject: 'rovoChatFetchConversation'
                });
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).FETCH_CHAT
                });
                dispatch($0b6866794de633f9$var$createConversationOptimistically({
                    sourceAgentId: (0, $cteoa.getSourceAgentId)(getMessages(conversationId), (0, $cteoa.getConversation)(getState(), conversationId))
                }));
                dispatch($0b6866794de633f9$var$removeConversationFromStore({
                    conversationId: conversationId
                }));
                if ((0, $dh538.fg)('rovo_supress_deleted_convo_errors')) return;
            }
            if ($0b6866794de633f9$var$isForbiddenConversationError(e) && (0, $dh538.fg)('rovo_chat_improved_conversation_403_handling')) {
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).FETCH_CHAT,
                    error: e
                });
                $0b6866794de633f9$var$handleForbiddenConversation({
                    conversationId: conversationId,
                    dispatch: dispatch,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    showFlag: showFlag
                });
                return;
            }
            throw e;
        }
        // There's a bug currently in the playwright pubsub test where when adding in a new
        // async function to sendMessageStream it causes the message to be dropped
        const status = getState().conversations[conversationId]?.status;
        if (status !== (0, $bPHr8.CHAT_STORE_STATUS).loadingChat) return;
        const latestMessages = serviceChat;
        const messages = $0b6866794de633f9$export$31bb5ed5e2cc3184({
            latestMessages: latestMessages,
            conversationId: conversationId,
            sendAnalyticsEvent: sendAnalyticsEvent,
            shouldPreprocessDetails: (0, $cteoa.shouldPreprocessDetailsForConversation)(getState(), conversationId)
        });
        const fetchedAgentVersion = $0b6866794de633f9$export$9c99f879b5701ba2(latestMessages);
        dispatch($0b6866794de633f9$var$setConversationData({
            conversationId: conversationId,
            data: {
                ...(0, $cteoa.clearStatus)({
                    lastAgentMessageStatus: 'SUCCESSFUL'
                }),
                sourceAgentId: (0, $cteoa.getSourceAgentId)(getMessages(conversationId), (0, $cteoa.getConversation)(getState(), conversationId)),
                ...fetchedAgentVersion ? {
                    agentVersion: fetchedAgentVersion
                } : {}
            }
        }));
        // Check if the last message has async_status 'IN_PROGRESS' and reconnect to the stream
        const lastMessage = latestMessages.at(-1);
        const isDeepResearch = lastMessage?.message?.message?.message_metadata?.deep_research;
        if ((0, $ljUdP.isInProgressStreamResponse)(lastMessage) && (isDeepResearch || (0, $c6GJD.default).getExperimentValue('rovo_chat_reconnect_all_experiment', 'isEnabled', false))) {
            const messageId = lastMessage.message.message.id;
            // Clear the "Message is in progress" content of the last agent message
            const updatedMessages = (0, $cteoa.clearStoreAssistantMessageContent)(messages, messageId);
            setMessages(conversationId, updatedMessages);
            dispatch($0b6866794de633f9$var$reconnectToInProgressStream({
                conversationId: conversationId,
                messageId: messageId,
                isDeepResearch: isDeepResearch,
                isAutoReconnect: true,
                isReconnectToAll: (0, $c6GJD.default).getExperimentValue('rovo_chat_reconnect_all_experiment', 'isEnabled', false)
            }));
        } else setMessages(conversationId, messages);
        dispatch($0b6866794de633f9$var$restoreTaskModeForConversation({
            conversationId: conversationId,
            messages: messages
        }));
        experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).FETCH_CHAT
        });
    }, {
    experienceName: ()=>(0, $16lEl.ExperienceName).FETCH_CHAT
});
// Abort requests for a specific conversation, or ALL conversations if no conversationId is passed
const $0b6866794de633f9$var$abortRequests = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).abortRequests, ({ conversationId: conversationId, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, taskModeEnabled: taskModeEnabled, deepResearchEnabled: deepResearchEnabled } = {})=>({ getState: getState, dispatch: dispatch }, { experienceTracker: experienceTracker, setReasoningMode: setReasoningMode, isReconnecting: isReconnecting, unifiedTasksActions: unifiedTasksActions, getMessages: getMessages, setMessages: setMessages })=>{
        const conversations = getState().conversations;
        const abortConversationStream = (conversation)=>{
            if (conversation?.storeAbortController) {
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).ABORT_AGENT_STREAM,
                    id: conversation?.id,
                    attributes: {
                        conversationId: conversation?.id,
                        isReconnecting: isReconnecting(conversation?.id ?? '')
                    }
                });
                conversation.storeAbortController.abort();
                if ((0, $dh538.fg)('cc-cwr-fix-finalizing-cancelled-request') && conversation.id && !isReconnecting(conversation.id)) {
                    const currentMessages = getMessages(conversation.id);
                    const nextMessages = (0, $cteoa.markInFlightActionsAsCancelled)(currentMessages);
                    if (nextMessages !== currentMessages) setMessages(conversation.id, nextMessages);
                }
                experienceTracker.abort({
                    name: (0, $16lEl.sendMessageExperienceName)({
                        deepResearchEnabled: deepResearchEnabled,
                        thinkDeeperEnabled: thinkDeeperEnabled,
                        fastModeEnabled: fastModeEnabled
                    }),
                    reason: 'Aborted',
                    attributes: {
                        isProgrammaticAbort: true
                    }
                });
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).ABORT_AGENT_STREAM
                });
                if (taskModeEnabled && conversation?.id && unifiedTasksActions && (0, $dh538.fg)('rovo_chat_enable_tasks')) unifiedTasksActions.setTaskProgressState({
                    conversationId: conversation.id,
                    progressState: 'Cancelled',
                    updatedAt: new Date().toISOString()
                });
            }
        };
        if (conversationId) abortConversationStream(conversations[conversationId]);
        else Object.values(conversations).forEach(abortConversationStream);
    }, {
    experienceName: ()=>(0, $16lEl.ExperienceName).ABORT_AGENT_STREAM
});
/**
 * Triggers Answer Now functionality to fast-forward extended thinking.
 * This action performs an optimistic update:
 * 1. Sets answerNowStatus to SWITCHING immediately
 * 2. Calls the Answer Now API endpoint
 * 3. Sets status to ERRORED if API call fails (hides button, prevents retry)
 *
 * Note: Research steps and message content are NOT cleared here - they continue
 * to be displayed during SWITCHING. Clearing happens when FAST_MODE_ENABLED is received.
 */ const $0b6866794de633f9$var$answerNow = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).answerNow, ({ conversationId: conversationIdParam, tmpMessageId: tmpMessageId, remoteMessageId: remoteMessageId })=>async ({ getState: getState, setState: setState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        // Helper to update conversation traces
        const updateConversationTrace = (traceMessage)=>{
            const state = getState();
            const conversation = state.conversations[conversationId];
            if (conversation) setState({
                conversations: {
                    ...state.conversations,
                    [conversationId]: {
                        ...conversation,
                        traces: [
                            {
                                messageContent: traceMessage
                            }
                        ]
                    }
                }
            });
        };
        // Verify the message exists and has answerNowStatus === AVAILABLE
        // Also prevents duplicate requests if status is already SWITCHING
        const messages = getMessages(conversationId);
        const targetMessage = messages.find((msg)=>(0, $bPHr8.isStoreAssistant)(msg) && msg.content?.message?.message?.id === tmpMessageId);
        if (!targetMessage || !(0, $bPHr8.isStoreAssistant)(targetMessage) || !(0, $bPHr8.isAnswerNowAvailable)(targetMessage.answerNowStatus)) return;
        // Optimistic update: Set SWITCHING status first and update trace message
        const updatedMessages = (0, $cteoa.updateStoreAssistantMessageAnswerNowStatus)(getMessages(conversationId), tmpMessageId, {
            type: (0, $bPHr8.AnswerNowStatusType).SWITCHING
        });
        setMessages(conversationId, updatedMessages);
        updateConversationTrace('Generating answer now!');
        // Start experience tracking
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).ANSWER_NOW,
            id: conversationId,
            attributes: {
                conversationId: conversationId,
                remoteMessageId: remoteMessageId,
                tmpMessageId: tmpMessageId
            }
        });
        try {
            // Call the Answer Now API with the remote (BE-provided) message ID
            await assistanceService.answerNow(conversationId, remoteMessageId);
            // Only set SWITCHING_REQUESTED if status is still SWITCHING (race condition guard)
            const currentMessages = getMessages(conversationId);
            const currentMessage = currentMessages.find((msg)=>(0, $bPHr8.isStoreAssistant)(msg) && msg.content?.message?.message?.id === tmpMessageId);
            if (currentMessage && (0, $bPHr8.isStoreAssistant)(currentMessage) && currentMessage.answerNowStatus?.type === (0, $bPHr8.AnswerNowStatusType).SWITCHING) {
                const successMessages = (0, $cteoa.updateStoreAssistantMessageAnswerNowStatus)(currentMessages, tmpMessageId, {
                    type: (0, $bPHr8.AnswerNowStatusType).SWITCHING_REQUESTED
                });
                setMessages(conversationId, successMessages);
            }
            // Track success
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).ANSWER_NOW
            });
        } catch (error) {
            // Only set ERRORED if status is still SWITCHING (race condition guard)
            const currentMessages = getMessages(conversationId);
            const currentMessage = currentMessages.find((msg)=>(0, $bPHr8.isStoreAssistant)(msg) && msg.content?.message?.message?.id === tmpMessageId);
            if (currentMessage && (0, $bPHr8.isStoreAssistant)(currentMessage) && currentMessage.answerNowStatus?.type === (0, $bPHr8.AnswerNowStatusType).SWITCHING) {
                const erroredMessages = (0, $cteoa.updateStoreAssistantMessageAnswerNowStatus)(currentMessages, tmpMessageId, {
                    type: (0, $bPHr8.AnswerNowStatusType).ERRORED
                });
                setMessages(conversationId, erroredMessages);
                updateConversationTrace('Generating faster answer failed, continuing with current mode');
            }
            // Track failure
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).ANSWER_NOW,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        }
    });
const $0b6866794de633f9$var$addErrorMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).addErrorMessage, ({ error: error, conversationId: conversationId, errorPrefix: errorPrefix })=>({ dispatch: dispatch })=>{
        dispatch($0b6866794de633f9$var$addStoreChatItem({
            message: (0, $cteoa.createStoreError)(error, errorPrefix),
            conversationId: conversationId
        }));
    });
const $0b6866794de633f9$var$fetchConversationChannelsData = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).fetchConversationChannelsData, ({ isInitialLoad: isInitialLoad = false } = {})=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, unifiedTasksActions: unifiedTasksActions })=>{
        if (isInitialLoad) experienceTracker.start({
            id: (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD,
            name: (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD
        });
        else experienceTracker.start({
            id: (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS,
            name: (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS
        });
        // Capture conversation IDs before API call to detect changes during the call
        const conversationsBeforeAPICall = new Set(Object.keys(getState().conversations));
        let channelsFromAPI = await assistanceService.getConversationChannels();
        const { conversations: conversations, currentConversationId: currentConversationId } = getState();
        const channelIds = new Set(channelsFromAPI.map((channel)=>channel.id));
        // Identify conversations deleted during the API call (were there before but aren't now)
        const conversationsDeletedDuringCall = new Set(Array.from(conversationsBeforeAPICall).filter((id)=>!conversations[id] && !(0, $cteoa.isEmptyConversation)(id)));
        // Identify conversations created during the API call (exist in state but weren't there before and aren't in API response)
        const conversationsCreatedDuringCall = new Set(Object.keys(conversations).filter((id)=>!conversationsBeforeAPICall.has(id) && !channelIds.has(id)));
        // Preserve all local conversations not yet on the server
        // (they may have just finished processing or be in-flight)
        // e.g. optimistic conversation when URL params are used to open a chat
        const optimisticConversationsToPreserve = new Set(Object.keys(conversations).filter((id)=>!channelIds.has(id) && !(0, $cteoa.isEmptyConversation)(id)));
        const conversationIdsToPreserve = new Set([
            ...conversationsCreatedDuringCall,
            ...optimisticConversationsToPreserve
        ]);
        const conversationsToPreserve = Object.fromEntries(Array.from(conversationIdsToPreserve, (id)=>[
                id,
                conversations[id]
            ]));
        // Build a reverse lookup from backendConversationId → local optimistic conversation.
        // This allows us to find the local entry (which carries rovoSpaceId and other
        // optimistic fields) even when the API returns the backend-assigned ID which differs
        // from the client-generated UUID stored in the local conversation.
        const localConversationByBackendId = new Map(Object.values(conversations).filter((c)=>Boolean(c.backendConversationId)).map((c)=>[
                c.backendConversationId,
                c
            ]));
        const processedChannels = channelsFromAPI.filter((channel)=>!conversationsDeletedDuringCall.has(channel.id)) // Exclude deleted conversations
        .reduce((acc, channel)=>{
            // Look up the local conversation first by its direct ID, then by the
            // backendConversationId that was recorded on the optimistic entry once the
            // FINAL_RESPONSE arrived. This ensures fields like rovoSpaceId that are
            // set on the optimistic conversation are preserved in the merged result.
            const localConversation = conversations[channel.id] ?? localConversationByBackendId.get(channel.id);
            acc[channel.id] = (0, $90c63f46323387a6$export$60a662127f30e1e1)(channel, localConversation);
            return acc;
        }, {});
        // Seed unified tasks store with channel tasks.
        if (unifiedTasksActions) {
            const allChannelTasks = channelsFromAPI.flatMap((channel)=>channel.tasks ?? []);
            if (allChannelTasks.length > 0) unifiedTasksActions.mergeConversationChannelTasks(allChannelTasks);
        }
        // Hydrate the store with the fetched conversation channels
        // whilst preserving the empty state and and any conversations created during the API call, so drafts are never lost
        // due to rehydration (e.g window refocus) when this is called
        setState({
            conversations: {
                EMPTY_CONVERSATION_ID: conversations[0, $2CHXX.EMPTY_CONVERSATION_ID],
                ...processedChannels,
                ...conversationsToPreserve
            },
            isConversationsInitialized: true
        });
        const currentConversationDeleted = !(0, $cteoa.isEmptyConversation)(currentConversationId) && !channelIds.has(currentConversationId) && !conversationIdsToPreserve.has(currentConversationId);
        if (currentConversationDeleted && !isInitialLoad) dispatch($0b6866794de633f9$var$setSelectedConversation({
            conversationId: (0, $2CHXX.EMPTY_CONVERSATION_ID)
        }));
        if (isInitialLoad && (0, $dh538.fg)('rovo_chat_enable_tasks')) dispatch($0b6866794de633f9$var$restoreTaskModeIfNeeded());
        experienceTracker.succeed({
            name: isInitialLoad ? (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD : (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS
        });
    }, {
    experienceName: (args)=>args?.[0]?.isInitialLoad ? (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD : (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS,
    actionErrorHandler: (context)=>{
        const { onError: onError, ...args } = context.args?.[0] ?? {};
        return onError ? onError({
            ...context,
            args: args
        }) : {
            proceedToDefaultHandling: true
        };
    }
});
const $0b6866794de633f9$var$getTimeoutBeforeExpiration = ()=>{
    return 0, $cBi7Q.SHORTER_TIMEOUT_BEFORE_NEW_CHAT;
};
/*
 * This action runs on initial load to hydrate this in-memory store (chatStore)
 * with data from either URL parameters or LocalStorage. URL parameters take precedence.
 *
 * Setting the currentConversationId (using setSelectedConversation or createConversationOptimistically)
 * may implicitly trigger fetching of conversation messages.
 *
 * Any change to currentConversationId will trigger a useEffect in ChatHistory,
 * which then executes the `fetchConversation` action.
 */ const $0b6866794de633f9$var$hydrateConversationWithExternalParams = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).hydrateConversation, ({ autoSelectConversation: autoSelectConversation })=>async ({ getState: getState, dispatch: dispatch }, { siteId: siteId, experienceTracker: experienceTracker, setChatStatus: setChatStatus, initChatInitiator: initChatInitiator, insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder, setStagingAreaMode: setStagingAreaMode, setMessageIdSelectedForPreview: setMessageIdSelectedForPreview, getStoreUserMessagesPreference: getStoreUserMessagesPreference })=>{
        experienceTracker.start({
            id: (0, $16lEl.ExperienceName).HYDRATE_CONVERSATION,
            name: (0, $16lEl.ExperienceName).HYDRATE_CONVERSATION
        });
        const rovoParamsUnsanitized = (0, $6FQwA.getRovoParams)();
        const rovoParams = Object.fromEntries(Object.entries(rovoParamsUnsanitized).filter(([, v])=>v !== 'undefined'));
        let initWithParams = autoSelectConversation && rovoParams.pathway === 'chat';
        const { currentConversationId: currentConversationId } = getState();
        if (rovoParams.stagingAreaOpen && (0, $dh538.fg)('aifc_create_enabled')) {
            setStagingAreaMode('inline', 'rovoChat');
            (0, $6FQwA.updatePageRovoParams)({
                stagingAreaOpen: undefined
            });
        }
        if (rovoParams.messageIdSelectedForPreview && (0, $dh538.fg)('aifc_create_enabled')) {
            setMessageIdSelectedForPreview(rovoParams.messageIdSelectedForPreview);
            (0, $6FQwA.updatePageRovoParams)({
                messageIdSelectedForPreview: undefined
            });
        }
        if (rovoParams.triggerOpen) // if the rovo chat was actually open with url param
        initChatInitiator(rovoParams.initiator);
        // Process params as a priority
        if (initWithParams) {
            const localConversation = rovoParams.conversationId ? getState().conversations[rovoParams.conversationId] : undefined;
            if (rovoParams.conversationId && localConversation) {
                dispatch($0b6866794de633f9$var$setSelectedConversation({
                    conversationId: rovoParams.conversationId,
                    sourceAgentId: rovoParams.agentId
                }));
                // Clear conversationId from URL after consuming it so subsequent chat opens
                // don't reuse it and get stuck in the same conversation.
                (0, $6FQwA.updatePageRovoParams)({
                    conversationId: undefined
                });
            } else dispatch($0b6866794de633f9$var$createConversationOptimistically({
                id: rovoParams.conversationId,
                sourceAgentId: rovoParams.agentId
            }));
            if (rovoParams.prompt) {
                // For cases where the prompt is a json string containing ADF, we need to parse it
                const shouldParse = (0, $cteoa.isValidAdfJsonString)(rovoParams.prompt);
                const prompt = shouldParse ? JSON.parse(rovoParams.prompt) : rovoParams.prompt;
                if (rovoParams.insertPrompt === 'highlight-action') // URL-param highlight actions are emitted from the Confluence view-page
                // surface, so this context is intentionally page-only.
                insertHighlightActionsEditorPlaceholder(prompt, $0b6866794de633f9$var$HIGHLIGHT_ACTION_INLINE_VIEW_PAGE_CREATION_CONTEXT_PARAMS);
                else dispatch($0b6866794de633f9$var$sendMessage({
                    prompt: (0, $4pEXC.encodeAdf)(prompt),
                    agentId: rovoParams.agentId,
                    // Use the user's preference for storing messages
                    // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
                    // value when BE user settings are fully rolled out; BE overrides it via the capability header.
                    storeUserMessages: getStoreUserMessagesPreference?.() ?? false,
                    messageSources: {
                        interactionSource: 'urlParam'
                    }
                }));
            }
            // for UFO performance tracking dimensions
            (0, $cbc8g.addUFOCustomData)({
                isEmptyConversation: !rovoParams.conversationId,
                hasInitialPrompt: !!rovoParams.prompt
            });
        } else if (autoSelectConversation) {
            const timeoutBeforeNewChat = $0b6866794de633f9$var$getTimeoutBeforeExpiration();
            const targetConversationId = localStorage?.getItem((0, $cBi7Q.getChatLoadPreferenceKey)(siteId)) ?? (0, $2CHXX.EMPTY_CONVERSATION_ID);
            const lastMessageSentAt = (0, $9963cc910aac4af3$export$1afac255ab1e880e)();
            const hasTargetChanged = targetConversationId !== currentConversationId;
            const isTargetExpired = lastMessageSentAt && Date.now() - lastMessageSentAt >= timeoutBeforeNewChat;
            const isTargetConversationEmpty = (0, $cteoa.isEmptyConversation)(targetConversationId);
            const hasLocalTargetConversation = Boolean(getState().conversations[targetConversationId]);
            // start new conversation: if recent expired
            if (isTargetExpired) {
                dispatch($0b6866794de633f9$var$setSelectedConversation({
                    conversationId: (0, $2CHXX.EMPTY_CONVERSATION_ID)
                }));
                (0, $9963cc910aac4af3$export$589976df4d188aac)(null);
            // start new conversation: if target conversation was set to new (e.g. in another tab)
            } else if (hasTargetChanged && isTargetConversationEmpty) dispatch($0b6866794de633f9$var$setSelectedConversation({
                conversationId: (0, $2CHXX.EMPTY_CONVERSATION_ID)
            }));
            else if (hasTargetChanged && hasLocalTargetConversation) dispatch($0b6866794de633f9$var$setSelectedConversation({
                conversationId: targetConversationId
            }));
            else if (hasTargetChanged) dispatch($0b6866794de633f9$var$createConversationOptimistically({
                id: targetConversationId
            }));
            // for UFO performance tracking dimensions
            (0, $cbc8g.addUFOCustomData)({
                isEmptyConversation: !isTargetExpired && hasTargetChanged
            });
        }
        // Set online status later, to ensure that pubsub listener doesn't race condition with store init state
        setChatStatus('online');
        experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).HYDRATE_CONVERSATION
        });
    }, {
    experienceName: ()=>(0, $16lEl.ExperienceName).HYDRATE_CONVERSATION
});
const $0b6866794de633f9$var$addAgentMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).addAgentMessage, ({ conversationId: conversationId, agentNamedId: agentNamedId, content: content })=>({ dispatch: dispatch })=>{
        dispatch($0b6866794de633f9$var$addAssistantMessage({
            id: (0, $cteoa.generateId)(),
            content: content,
            conversationId: conversationId,
            agentNamedId: agentNamedId
        }));
    });
const $0b6866794de633f9$var$handleChatOpenPubsubAction = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).handleChatOpenPubsubAction, ({ conversationId: conversationId, agentId: agentId })=>async ({ getState: getState, dispatch: dispatch })=>{
        // IF convo id is the current chat
        // refetch the chat, do not create new one
        if (conversationId === getState().currentConversationId) {
            // Keep the agent id from this `chat-new` event. When the new selected-agent
            // identity model is off, preserve the older hydration gate as the kill switch.
            const shouldStoreChatNewAgentId = !!agentId && ((0, $dh538.fg)('rovo_chat_agent_selection') || (0, $dh538.fg)('jira_ai_adding_agent_id_improving_agent_hydration'));
            if (shouldStoreChatNewAgentId) {
                const conversationAgentFromChatNew = (0, $dh538.fg)('rovo_chat_agent_selection') ? (0, $ce0ec8f0bfa0c691$export$fc6a9cdad8ea90e0)(agentId) : undefined;
                const conversationAgentFieldsFromChatNew = conversationAgentFromChatNew ? {
                    agent: conversationAgentFromChatNew
                } : {};
                dispatch($0b6866794de633f9$var$setConversationData({
                    conversationId: conversationId,
                    data: {
                        sourceAgentId: agentId,
                        ...conversationAgentFieldsFromChatNew
                    }
                }));
            }
            dispatch($0b6866794de633f9$var$fetchConversation({
                conversationId: conversationId
            }));
            return;
        }
        // IF chat already exist in conversation
        // switch to that convo -> and it will trigger refetch when ChatHistory is rendered
        if (getState().conversations[conversationId]) {
            // Keep the agent id from this `chat-new` event. When the new selected-agent
            // identity model is off, preserve the older hydration gate as the kill switch.
            const shouldStoreChatNewAgentId = !!agentId && ((0, $dh538.fg)('rovo_chat_agent_selection') || (0, $dh538.fg)('jira_ai_adding_agent_id_improving_agent_hydration'));
            if (shouldStoreChatNewAgentId) {
                const conversationAgentFromChatNew = (0, $dh538.fg)('rovo_chat_agent_selection') ? (0, $ce0ec8f0bfa0c691$export$fc6a9cdad8ea90e0)(agentId) : undefined;
                const conversationAgentFieldsFromChatNew = conversationAgentFromChatNew ? {
                    agent: conversationAgentFromChatNew
                } : {};
                dispatch($0b6866794de633f9$var$setConversationData({
                    conversationId: conversationId,
                    data: {
                        sourceAgentId: agentId,
                        ...conversationAgentFieldsFromChatNew
                    }
                }));
            }
            dispatch($0b6866794de633f9$var$setSelectedConversation({
                conversationId: conversationId
            }));
            return;
        }
        // IF chat does not exist yet
        // Create conversation optimistically, which will switch to that conversation
        // By switching conversation, it will render ChatHistory
        // ChatHistory will auto fetch the chat data
        // if not found during `sendMessage`, it will auto create one and retry when encountered `404`
        // Create conversation optimistically and store sourceAgentId
        const sourceAgentIdFromChatNew = agentId && ((0, $dh538.fg)('rovo_chat_agent_selection') || (0, $dh538.fg)('jira_ai_adding_agent_id_improving_agent_hydration')) ? agentId : undefined;
        dispatch($0b6866794de633f9$var$createConversationOptimistically({
            id: conversationId,
            sourceAgentId: sourceAgentIdFromChatNew
        }));
    });
const $0b6866794de633f9$var$createConversationOptimistically = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).createConversationOptimistically, (options)=>async ({ dispatch: dispatch }, { setMessages: setMessages })=>{
        const conversationId = options?.id ?? (0, $2CHXX.EMPTY_CONVERSATION_ID);
        const time = new Date().toISOString();
        // Seed `conversation.agent` from the known optimistic conversation identity.
        const agentForOptimisticConversation = $0b6866794de633f9$var$resolveConversationSeedAgent({
            backendAgent: options?.agent,
            agentId: options?.sourceAgentId,
            legacyAgent: options?.agent
        });
        // Under the selected-agent gate the header derives the displayed agent
        // solely from `conversation.agent`. When this optimistic creation re-uses an
        // existing conversation slot (e.g. EMPTY_CONVERSATION_ID) the data is
        // shallow-merged, so omitting the `agent` key would leave a previously-seeded
        // specialist agent in place. Selecting "Chat with Rovo" (no agent id) must
        // therefore explicitly clear `conversation.agent` back to the default Rovo
        // agent rather than silently preserving the stale one.
        const optimisticConversationAgentData = agentForOptimisticConversation ? {
            agent: agentForOptimisticConversation
        } : (0, $dh538.fg)('rovo_chat_agent_selection') ? {
            agent: undefined
        } // explicit clear so "Chat with Rovo" resets a stale specialist
         : {};
        dispatch($0b6866794de633f9$var$initializeConversationData({
            conversationId: conversationId,
            data: {
                id: conversationId,
                lastMessageTimestamp: options.lastMessageTimestamp ?? time,
                name: options.name ?? (0, $99vXA.generateConversationName)(),
                sourceAgentId: options.sourceAgentId,
                sourceId: options.sourceId ?? undefined,
                status: options?.status ?? (0, $bPHr8.CHAT_STORE_STATUS).idle,
                timeCreated: options?.timeCreated ?? time,
                traces: [],
                selectedAgentIds: options.selectedAgentIds ?? [],
                messages: [],
                lastMessageType: options?.lastMessageType ?? [],
                lastAgentMessageStatus: options?.lastAgentMessageStatus,
                // Explicitly set rovoSpaceId (including undefined) so that re-initialising
                // EMPTY_CONVERSATION_ID without a space clears any stale rovoSpaceId left
                // from a previous space-scoped conversation.
                rovoSpaceId: options?.rovoSpaceId,
                ...optimisticConversationAgentData,
                ...options?.agentVersion ? {
                    agentVersion: options.agentVersion
                } : {},
                ...options?.scopes ? {
                    scopes: options.scopes
                } : {}
            }
        }));
        setMessages(conversationId, []);
        dispatch($0b6866794de633f9$var$setSelectedConversation({
            conversationId: conversationId
        }));
    });
const $0b6866794de633f9$var$createSeededConversation = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).createSeededConversation, (options)=>async ({ dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, setMessages: setMessages, getChatInitiator: getChatInitiator, onNewConversationStartingWithSendMessage: onNewConversationStartingWithSendMessage })=>{
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL,
            id: (0, $16lEl.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL
        });
        const createdConversation = await assistanceService.createConversationChannel(options);
        const humanMessage = createdConversation.messages?.find((message)=>(0, $ljUdP.isHumanMessage)(message));
        const assistantMessage = createdConversation.messages?.find((message)=>(0, $ljUdP.isAssistantMessage)(message));
        const humanMessageId = humanMessage ? humanMessage.id : '';
        const assistantMessageId = assistantMessage ? assistantMessage.id : '';
        const conversationTags = createdConversation.tags ?? options.tags;
        // The header reads the displayed agent only from `conversation.agent.agent_id`,
        // so the chat-new/seeded flow must seed it from the known agent id (preferring a
        // backend-returned agent). Without this, a seeded conversation opened with a
        // specific agent shows default Rovo.
        const seededConversationAgent = $0b6866794de633f9$var$resolveConversationSeedAgent({
            backendAgent: createdConversation.agent,
            agentId: options.agentId,
            legacyAgent: createdConversation.agent
        });
        const seededConversationAgentFields = seededConversationAgent ? {
            agent: seededConversationAgent
        } : {};
        dispatch($0b6866794de633f9$var$initializeConversationData({
            conversationId: createdConversation.id,
            data: {
                id: createdConversation.id,
                name: createdConversation.name,
                timeCreated: createdConversation.time_created,
                status: (0, $bPHr8.CHAT_STORE_STATUS).idle,
                traces: [],
                selectedAgentIds: [],
                sourceId: options.sourceId ?? undefined,
                sourceAgentId: options.agentId,
                agentVersion: options.agentVersion,
                messages: [],
                ...seededConversationAgentFields,
                ...conversationTags !== undefined ? {
                    tags: conversationTags
                } : {},
                ...options.skipNextFetch ? {
                    skipNextFetch: true
                } : {},
                // Scope the seeded conversation to a Rovo Space when applicable so the
                // nav can immediately render it under the correct space and exclude it
                // from the regular conversation list (see ChatListMenuItems filter).
                ...options.rovoSpaceId && (0, $dh538.fg)('rovo_chat_spaces_fe') ? {
                    rovoSpaceId: options.rovoSpaceId
                } : {}
            }
        }));
        const chatInitiator = getChatInitiator();
        // Build synthetic ChatMessage[] from the seeded dialogues and pass directly to
        // processConversationMessages, which handles all boundary content extraction
        // (lumina, chart, expand, sculptor) consistently with fetchConversation —
        // without an extra getChat network call.
        const syntheticMessages = options.dialogues.flatMap((dialogue)=>{
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'sent',
                actionSubject: 'message',
                attributes: {
                    messageId: humanMessageId,
                    interactionSource: 'movedOver',
                    followUpSource: options.followUpSource,
                    timestamp: new Date().toISOString(),
                    initiator: chatInitiator
                }
            });
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'received',
                actionSubject: 'agentMessage',
                attributes: {
                    messageId: assistantMessageId,
                    humanMessageId: humanMessageId,
                    pluginsInvoked: [],
                    hasSources: false,
                    timestamp: new Date().toISOString(),
                    initiator: chatInitiator
                }
            });
            // When mimeType is 'text/adf', parse the ADF JSON string into a DocNode
            // so encodeAdf's isAdfContent check can pass it through natively.
            let agentContent = dialogue.agent_message.content;
            if (dialogue.agent_message.mimeType === 'text/adf') try {
                agentContent = JSON.parse(dialogue.agent_message.content);
            } catch  {
            // If parsing fails, fall back to raw string content
            }
            // Use raw ChatMessage types (not createStoreHuman/createStoreAssistant) so that
            // processConversationMessages can apply all boundary content extraction
            // (lumina, chart, expand, sculptor) before producing the final StoreChatItem[].
            const humanMessage = {
                role: 'HUMAN',
                id: (0, $cteoa.generateId)(),
                content: dialogue.human_message.content,
                time_created: new Date().toISOString(),
                user_ari: 'unknown',
                plugin_invocations: [],
                isFromSeededConversation: true
            };
            const assistantStreamResponse = {
                type: 'FINAL_RESPONSE',
                message: {
                    message: {
                        role: 'ASSISTANT',
                        id: (0, $cteoa.generateId)(),
                        conversation_channel_id: createdConversation.id,
                        content: agentContent,
                        time_created: new Date().toISOString(),
                        user_ari: 'unknown',
                        plugin_invocations: [],
                        author: {
                            named_id: 'ai_mate_agent',
                            name: 'unknown',
                            actor_type: 'AGENT',
                            ari: null,
                            id: 'unknown'
                        }
                    }
                }
            };
            return [
                humanMessage,
                assistantStreamResponse
            ];
        });
        const processedMessages = $0b6866794de633f9$export$31bb5ed5e2cc3184({
            latestMessages: syntheticMessages,
            conversationId: createdConversation.id,
            sendAnalyticsEvent: sendAnalyticsEvent
        });
        setMessages(createdConversation.id, processedMessages);
        dispatch($0b6866794de633f9$var$setSelectedConversation({
            conversationId: createdConversation.id
        }));
        if (options.mode && onNewConversationStartingWithSendMessage) onNewConversationStartingWithSendMessage(createdConversation.id, options.mode);
        experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL
        });
        return createdConversation.id;
    }, {
    experienceName: ()=>(0, $16lEl.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL
});
/** Side-nav list items may attach UI-only fields; the chat store `Conversation` type must not persist them. */ const $0b6866794de633f9$var$conversationMetadataForStore = (conversation)=>{
    const { isEmpty: _isEmpty, currentTask: _currentTask, ...storeConversation } = conversation;
    return storeConversation;
};
const $0b6866794de633f9$var$setSelectedConversation = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).setSelectedConversation, ({ conversationId: conversationId, sourceAgentId: sourceAgentId, conversationMetadata: conversationMetadata, targetMessageId: targetMessageId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { siteId: siteId })=>{
        let resolvedConversationId = conversationId;
        if (!getState().conversations[conversationId]) {
            if (conversationMetadata?.id === conversationId) dispatch($0b6866794de633f9$var$initializeConversationData({
                conversationId: conversationId,
                data: {
                    ...$0b6866794de633f9$var$conversationMetadataForStore(conversationMetadata),
                    ...targetMessageId ? {
                        targetTaskMessageId: targetMessageId
                    } : {}
                }
            }));
            else resolvedConversationId = (0, $2CHXX.EMPTY_CONVERSATION_ID);
        } else if (targetMessageId) dispatch($0b6866794de633f9$var$setConversationData({
            conversationId: conversationId,
            data: {
                targetTaskMessageId: targetMessageId
            }
        }));
        setState({
            currentConversationId: resolvedConversationId
        });
        // Keep the agent id provided when selecting this conversation; gate-on also seeds `conversation.agent` for the header.
        if (sourceAgentId) {
            const conversationAgentFromSource = (0, $dh538.fg)('rovo_chat_agent_selection') ? (0, $ce0ec8f0bfa0c691$export$fc6a9cdad8ea90e0)(sourceAgentId) : undefined;
            const conversationAgentSourceData = conversationAgentFromSource ? {
                agent: conversationAgentFromSource
            } : {};
            dispatch($0b6866794de633f9$var$setConversationData({
                conversationId: resolvedConversationId,
                data: {
                    sourceAgentId: sourceAgentId,
                    ...conversationAgentSourceData
                }
            }));
        }
        // Store preference.
        // For space-scoped conversations, store EMPTY_CONVERSATION_ID instead of the
        // client-generated UUID. The client UUID is never returned by the backend /conversations
        // API, so restoring it on refresh creates an orphaned optimistic entry that has no
        // rovoSpaceId and cannot be matched to any API channel — causing a ghost item to
        // appear in the regular conversation list. Starting fresh (empty chat) on refresh
        // is the correct behaviour for space conversations.
        const conversationForStorage = getState().conversations[resolvedConversationId];
        const localStorageConversationId = conversationForStorage?.rovoSpaceId && (0, $dh538.fg)('rovo_chat_spaces_fe') ? (0, $2CHXX.EMPTY_CONVERSATION_ID) : resolvedConversationId;
        localStorage?.setItem((0, $cBi7Q.getChatLoadPreferenceKey)(siteId), localStorageConversationId);
    });
const $0b6866794de633f9$var$updateActionInvocationStatus = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).updateActionInvocationStatus, ({ conversationId: conversationId, messageId: messageId, invocationId: invocationId, status: status })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const agentMessage = (0, $cteoa.getAgentMessageById)(messages, messageId);
        if (!agentMessage.result) return;
        const updatedMessages = [
            ...messages
        ];
        updatedMessages[agentMessage.index] = {
            ...agentMessage.result,
            invokedActions: {
                ...agentMessage.result.invokedActions,
                [invocationId]: status
            }
        };
        setMessages(conversationId, updatedMessages);
    });
const $0b6866794de633f9$var$updateConfirmedToolsActionStatuses = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).updateActionInvocationStatus, ({ conversationId: conversationId, messageId: messageId, tools: tools, status: status })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const agentMessage = (0, $cteoa.getAgentMessageById)(messages, messageId);
        if (!agentMessage.result) return;
        const updatedInvokedActions = {
            ...agentMessage.result.invokedActions
        };
        for (const tool of tools){
            const resolvedStatus = status === 'fromResolution' ? tool.resolution?.type === 'cancelled' ? 'cancelled' : 'finished' : status;
            updatedInvokedActions[tool.invocation_id] = resolvedStatus;
        }
        const updatedMessages = [
            ...messages
        ];
        updatedMessages[agentMessage.index] = {
            ...agentMessage.result,
            invokedActions: updatedInvokedActions
        };
        setMessages(conversationId, updatedMessages);
    });
const $0b6866794de633f9$var$updateActionData = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).updateActionData, ({ conversationId: conversationId, messageId: messageId, invocationId: invocationId, data: data })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const agentMessage = (0, $cteoa.getAgentMessageById)(messages, messageId);
        if (!agentMessage.result) return;
        const updatedMessages = [
            ...messages
        ];
        agentMessage.result.content.message.message.actions?.forEach((action)=>{
            if (action.invocationId === invocationId) action.data = {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                ...action.data,
                ...data
            };
        });
        updatedMessages[agentMessage.index] = agentMessage.result;
        setMessages(conversationId, updatedMessages);
    });
const $0b6866794de633f9$var$updateConversation = ({ conversationId: conversationId, data: data })=>async ({ dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker })=>{
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).UPDATE_CONVERSATION_CHANNEL,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        try {
            await assistanceService?.updateConversationChannel(conversationId, data);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).UPDATE_CONVERSATION_CHANNEL,
                error: error
            });
            throw error;
        }
        dispatch($0b6866794de633f9$var$setConversationData({
            conversationId: conversationId,
            data: data
        }));
        experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).UPDATE_CONVERSATION_CHANNEL
        });
    };
function $0b6866794de633f9$var$getScheduleRovoChatRuleIdUuidFromExecutionMessage(message) {
    const raw = message.message_metadata?.ruleIdUuid;
    if (raw === undefined || raw === null) return undefined;
    const s = typeof raw === 'string' ? raw.trim() : String(raw);
    return s.length > 0 ? s : undefined;
}
function $0b6866794de633f9$var$getScheduleRovoChatRRuleFromExecutionMessage(message) {
    const raw = message.message_metadata?.rRule;
    if (raw === undefined || raw === null) return undefined;
    const s = typeof raw === 'string' ? raw.trim() : String(raw);
    return s.length > 0 ? s : undefined;
}
const $0b6866794de633f9$var$resolveConversationAction = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).resolveConversationAction, ({ conversationId: conversationId, messageId: messageId, payload: payload, actionContentProcessor: actionContentProcessor, skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse = false, skipExperienceTracking: skipExperienceTracking = false })=>async ({ dispatch: dispatch, getState: getState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, trackAIMAUEvent: trackAIMAUEvent, sendAnalyticsEvent: sendAnalyticsEvent, getMessages: getMessages, broadcastConfirmedActions: broadcastConfirmedActions, chatContextStoreActions: chatContextStoreActions })=>{
        let actionCallbackData;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const humanMessageId = (0, $cteoa.getAssociatedHumanMessageId)(getMessages(conversationId), messageId);
        const featureArea = chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown';
        const attributes = {
            conversationId: conversationId,
            resolution: payload.context.resolution,
            actionKey: payload.context.key
        };
        if (!skipExperienceTracking) experienceTracker.start({
            name: (0, $16lEl.ExperienceName).RESOLVE_CONVERSATION_ACTION,
            id: conversationId,
            attributes: attributes
        });
        try {
            const { invocationId: invocationId } = payload.context;
            // Set actions loading state
            dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: invocationId,
                status: 'started'
            }));
            const response = await assistanceService.resolveConversationAction(conversationId, payload);
            const { message: message } = response;
            dispatch($0b6866794de633f9$var$updateActionData({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: invocationId,
                data: payload.context.data
            }));
            const ruleIdUuidFromExecution = payload.context.key === (0, $8IKbl.SCHEDULED_CHAT_KEY) && (0, $ljUdP.isAssistantMessage)(message) ? $0b6866794de633f9$var$getScheduleRovoChatRuleIdUuidFromExecutionMessage(message) : undefined;
            const rRuleFromExecution = payload.context.key === (0, $8IKbl.SCHEDULED_CHAT_KEY) && (0, $ljUdP.isAssistantMessage)(message) ? $0b6866794de633f9$var$getScheduleRovoChatRRuleFromExecutionMessage(message) : undefined;
            if (ruleIdUuidFromExecution || rRuleFromExecution) {
                const previousData = payload.context.data;
                const harvested = {
                    ...ruleIdUuidFromExecution ? {
                        ruleIdUuid: ruleIdUuidFromExecution
                    } : {},
                    ...rRuleFromExecution ? {
                        rRule: rRuleFromExecution
                    } : {}
                };
                dispatch($0b6866794de633f9$var$updateActionData({
                    conversationId: conversationId,
                    messageId: messageId,
                    invocationId: invocationId,
                    data: typeof previousData === 'object' && previousData !== null ? {
                        ...previousData,
                        ...harvested
                    } : harvested
                }));
            }
            const isMessageWithContent = !!message.content;
            // Display a new agent message from the response to reflect the change in chat history
            if ((0, $ljUdP.isAssistantMessage)(message) && (isMessageWithContent || (0, $ljUdP.isActionExecutedSuccessfully)(message))) {
                if (isMessageWithContent && !skipSuccessOptimisticAssistantResponse) dispatch($0b6866794de633f9$var$addAssistantMessage({
                    agentNamedId: message.author?.named_id,
                    content: message.content,
                    conversationId: conversationId,
                    id: message.id
                }));
                actionCallbackData = actionContentProcessor?.(message) ?? undefined;
                dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                    conversationId: conversationId,
                    messageId: messageId,
                    invocationId: invocationId,
                    status: (0, $cteoa.deriveInvocationStatus)(message, payload.context)
                }));
                if ((0, $ljUdP.isActionExecutedSuccessfully)(message)) broadcastConfirmedActions?.(conversationId, [
                    payload.context
                ]);
                sendAnalyticsEvent({
                    eventType: 'ui',
                    action: 'success',
                    actionSubject: 'rovoChatMessageAction',
                    attributes: {
                        recipientAgentNamedId: payload.context.recipient_agent_named_id,
                        actionKey: payload.context.key,
                        resolutionType: payload.context.resolution.type,
                        featureArea: featureArea,
                        humanMessageId: humanMessageId,
                        messageId: messageId
                    }
                });
            } else {
                dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                    conversationId: conversationId,
                    messageId: messageId,
                    invocationId: payload.context.invocationId,
                    status: 'errored'
                }));
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'error',
                    actionSubject: 'rovoChatMessageAction',
                    attributes: {
                        recipientAgentNamedId: payload.context.recipient_agent_named_id,
                        actionKey: payload.context.key,
                        resolutionType: payload.context.resolution.type,
                        featureArea: featureArea,
                        humanMessageId: humanMessageId,
                        messageId: messageId
                    }
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (!skipExperienceTracking) experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).RESOLVE_CONVERSATION_ACTION,
                error: error,
                attributes: attributes
            });
            trackAIMAUEvent({
                type: 'error',
                userGenerated: true,
                source: 'messageActionsResolver',
                subjectId: payload.context.resolution.type,
                singleInstrumentationID: messageId
            });
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'error',
                actionSubject: 'rovoChatMessageAction',
                attributes: {
                    recipientAgentNamedId: payload.context.recipient_agent_named_id,
                    actionKey: payload.context.key,
                    resolutionType: payload.context.resolution.type,
                    featureArea: featureArea,
                    humanMessageId: humanMessageId,
                    messageId: messageId
                }
            });
            dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: payload.context.invocationId,
                status: 'errored'
            }));
            throw new (0, $iEWar.MessageActionError)({
                message: `Message action error: ${error.message} for actionKey: ${payload.context.key}`,
                conversationId: conversationId,
                messageId: messageId,
                invocationId: payload.context.invocationId,
                actionKey: payload.context.key,
                cause: error
            });
        }
        if (!skipExperienceTracking) experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).RESOLVE_CONVERSATION_ACTION,
            attributes: attributes
        });
        return actionCallbackData;
    }, {
    actionErrorHandler: (context)=>{
        const { onError: onError, ...args } = context.args?.[0] ?? {};
        return onError ? onError({
            ...context,
            args: args
        }) : {
            proceedToDefaultHandling: true
        };
    }
});
const $0b6866794de633f9$var$bulkResolveConversationActions = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).bulkResolveConversationActions, ({ conversationId: conversationId, messageId: messageId, payloads: payloads, actionContentProcessor: actionContentProcessor, skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse = false })=>async ({ dispatch: dispatch, getState: getState }, { experienceTracker: experienceTracker })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return [];
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            id: conversationId,
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length
            }
        });
        // Execute all actions sequentially
        const actionCallbackResults = [];
        const successfulActions = [];
        let hasErrors = false;
        let successCount = 0;
        for (const payload of payloads){
            const result = await dispatch($0b6866794de633f9$var$resolveConversationAction({
                conversationId: conversationId,
                messageId: messageId,
                payload: payload,
                actionContentProcessor: actionContentProcessor,
                skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse,
                skipExperienceTracking: true
            }));
            actionCallbackResults.push(result);
            // Track success: result is defined means action succeeded
            if (result !== undefined) {
                successCount++;
                successfulActions.push(payload.context);
            } else if (!actionContentProcessor) // Action with no processor returns undefined on success
            successCount++;
            else // Action with processor returned undefined = failure
            hasErrors = true;
        }
        if (hasErrors) experienceTracker.fail({
            name: (0, $16lEl.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            error: new Error('Some bulk actions failed'),
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length,
                successCount: successCount,
                failureCount: payloads.length - successCount
            }
        });
        else experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length
            }
        });
        return actionCallbackResults;
    });
const $0b6866794de633f9$var$bulkResolveConversationUIActions = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).bulkResolveConversationUIActions, ({ conversationId: conversationId, messageId: messageId, payloads: payloads, actionContentProcessor: actionContentProcessor, skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse = false })=>async ({ dispatch: dispatch, getState: getState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, getMessages: getMessages, broadcastConfirmedActions: broadcastConfirmedActions, chatContextStoreActions: chatContextStoreActions })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return [];
        const humanMessageId = (0, $cteoa.getAssociatedHumanMessageId)(getMessages(conversationId), messageId);
        const featureArea = chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown';
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            id: conversationId,
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length
            }
        });
        // Set all invocation statuses to 'started'
        for (const payload of payloads)dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
            conversationId: conversationId,
            messageId: messageId,
            invocationId: payload.context.invocationId,
            status: 'started'
        }));
        try {
            const responses = await assistanceService.bulkResolveConversationUIActions(conversationId, messageId, {
                items: payloads
            });
            const actionCallbackResults = [];
            const successfulActions = [];
            let hasErrors = false;
            let successCount = 0;
            // Process each response paired with its corresponding payload
            for(let i = 0; i < payloads.length; i++){
                const payload = payloads[i];
                const response = responses[i];
                const { invocationId: invocationId } = payload.context;
                if (!response) {
                    // No response for this item - mark as errored
                    dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                        conversationId: conversationId,
                        messageId: messageId,
                        invocationId: invocationId,
                        status: 'errored'
                    }));
                    hasErrors = true;
                    actionCallbackResults.push(undefined);
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'error',
                        actionSubject: 'rovoChatMessageAction',
                        attributes: {
                            recipientAgentNamedId: payload.context.recipient_agent_named_id,
                            actionKey: payload.context.key,
                            resolutionType: payload.context.resolution.type,
                            featureArea: featureArea,
                            humanMessageId: humanMessageId,
                            messageId: messageId
                        }
                    });
                    continue;
                }
                const { message: message } = response;
                dispatch($0b6866794de633f9$var$updateActionData({
                    conversationId: conversationId,
                    messageId: messageId,
                    invocationId: invocationId,
                    data: payload.context.data
                }));
                const isMessageWithContent = !!message.content;
                if ((0, $ljUdP.isAssistantMessage)(message) && (isMessageWithContent || (0, $ljUdP.isActionExecutedSuccessfully)(message))) {
                    if (isMessageWithContent && !skipSuccessOptimisticAssistantResponse) dispatch($0b6866794de633f9$var$addAssistantMessage({
                        agentNamedId: message.author?.named_id,
                        content: message.content,
                        conversationId: conversationId,
                        id: message.id
                    }));
                    const callbackData = actionContentProcessor?.(message) ?? undefined;
                    actionCallbackResults.push(callbackData);
                    dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                        conversationId: conversationId,
                        messageId: messageId,
                        invocationId: invocationId,
                        status: (0, $cteoa.deriveInvocationStatus)(message, payload.context)
                    }));
                    if ((0, $ljUdP.isActionExecutedSuccessfully)(message)) successfulActions.push(payload.context);
                    successCount++;
                    sendAnalyticsEvent({
                        eventType: 'ui',
                        action: 'success',
                        actionSubject: 'rovoChatMessageAction',
                        attributes: {
                            recipientAgentNamedId: payload.context.recipient_agent_named_id,
                            actionKey: payload.context.key,
                            resolutionType: payload.context.resolution.type,
                            featureArea: featureArea,
                            humanMessageId: humanMessageId,
                            messageId: messageId
                        }
                    });
                } else {
                    dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                        conversationId: conversationId,
                        messageId: messageId,
                        invocationId: invocationId,
                        status: 'errored'
                    }));
                    hasErrors = true;
                    actionCallbackResults.push(undefined);
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'error',
                        actionSubject: 'rovoChatMessageAction',
                        attributes: {
                            recipientAgentNamedId: payload.context.recipient_agent_named_id,
                            actionKey: payload.context.key,
                            resolutionType: payload.context.resolution.type,
                            featureArea: featureArea,
                            humanMessageId: humanMessageId,
                            messageId: messageId
                        }
                    });
                }
            }
            // Broadcast all successful confirmed actions at once
            if (successfulActions.length > 0) broadcastConfirmedActions?.(conversationId, successfulActions);
            if (hasErrors) experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
                error: new Error('Some bulk actions failed'),
                attributes: {
                    conversationId: conversationId,
                    actionCount: payloads.length,
                    successCount: successCount,
                    failureCount: payloads.length - successCount
                }
            });
            else experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
                attributes: {
                    conversationId: conversationId,
                    actionCount: payloads.length
                }
            });
            return actionCallbackResults;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If the entire bulk request fails, mark all invocations as errored
            for (const payload of payloads)dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: payload.context.invocationId,
                status: 'errored'
            }));
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
                error: error instanceof Error ? error : new Error('Bulk resolve failed'),
                attributes: {
                    conversationId: conversationId,
                    actionCount: payloads.length,
                    successCount: 0,
                    failureCount: payloads.length
                }
            });
            throw error;
        }
    });
const $0b6866794de633f9$var$deleteConversation = ({ conversationId: conversationId })=>async ({ dispatch: dispatch, getState: getState }, { assistanceService: assistanceService, experienceTracker: experienceTracker })=>{
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).CLEAR_CHAT,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        await getState().conversations[conversationId]?.storeAbortController?.abort();
        try {
            await assistanceService.deleteChat(conversationId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).CLEAR_CHAT,
                error: error
            });
            throw error;
        }
        // Remove the deleted conversation from the local store prior to refetching channels.
        // fetchConversationChannelsData preserves any local conversation whose ID is missing
        // from the API response (to keep optimistic / in-flight conversations alive). Without
        // this explicit removal, the just-deleted conversation would be treated as
        // "optimistic" and re-added to the store, causing it to reappear in the UI.
        dispatch($0b6866794de633f9$var$removeConversationFromStore({
            conversationId: conversationId
        }));
        await dispatch($0b6866794de633f9$var$fetchConversationChannelsData());
        experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).CLEAR_CHAT
        });
    };
const $0b6866794de633f9$var$warmConversationCache = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).warmConversationCache, ({ conversation: conversationParams, forceRefresh: forceRefresh, onSuccess: onSuccess, onError: onError })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, setMessages: setMessages })=>{
        const conversationId = conversationParams.id;
        const existingConversation = getState().conversations[conversationId];
        // Skip if conversation is actively in-flight
        if (existingConversation?.status === (0, $bPHr8.CHAT_STORE_STATUS).loadingChat || existingConversation?.status === (0, $bPHr8.CHAT_STORE_STATUS).awaitingResponse || existingConversation?.status === (0, $bPHr8.CHAT_STORE_STATUS).typingResponse) return;
        // Skip if conversation is already loaded (idle with messages) unless forceRefresh
        if (existingConversation?.status === (0, $bPHr8.CHAT_STORE_STATUS).idle && !forceRefresh) return;
        try {
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).WARM_CONVERSATION_CACHE,
                id: conversationId,
                attributes: {
                    conversationId: conversationId,
                    forceRefresh: Boolean(forceRefresh)
                }
            });
            // Bootstrap conversation in store with provided metadata or client defaults.
            // rovo_chat_agent_selection cleanup: remove the gate when selected-agent identity
            // is fully launched. Preserve existing metadata during this loading reset,
            // or provisionally seed the agent id provided by the URL/pubsub flow so the header can hydrate it.
            const conversationAgentForWarmLoadingReset = (0, $dh538.fg)('rovo_chat_agent_selection') ? existingConversation?.agent ?? (0, $ce0ec8f0bfa0c691$export$fc6a9cdad8ea90e0)(conversationParams.agentId ?? existingConversation?.sourceAgentId) : undefined;
            const conversationAgentFieldsForWarmLoadingReset = conversationAgentForWarmLoadingReset ? {
                agent: conversationAgentForWarmLoadingReset
            } : {};
            dispatch($0b6866794de633f9$var$initializeConversationData({
                conversationId: conversationId,
                data: {
                    id: conversationId,
                    name: conversationParams.name ?? existingConversation?.name ?? '',
                    timeCreated: conversationParams.timeCreated ?? existingConversation?.timeCreated ?? new Date().toISOString(),
                    status: (0, $bPHr8.CHAT_STORE_STATUS).loadingChat,
                    traces: [],
                    selectedAgentIds: existingConversation?.selectedAgentIds ?? [],
                    sourceAgentId: conversationParams.agentId ?? existingConversation?.sourceAgentId ?? '',
                    ...conversationAgentFieldsForWarmLoadingReset,
                    messages: []
                }
            }));
            // If metadata params not fully provided, fetch from API in parallel (silent failure)
            const hasFullMetadata = conversationParams.name != null && conversationParams.timeCreated != null;
            const metadataPromise = hasFullMetadata ? Promise.resolve() : assistanceService.fetchConversationMetadata(conversationId).then((metadata)=>{
                // rovo_chat_agent_selection cleanup: remove the gate and always keep
                // backend conversation-agent metadata from fetched channels.
                const fetchedConversationAgentFields = metadata.agent && (0, $dh538.fg)('rovo_chat_agent_selection') ? {
                    agent: metadata.agent
                } : {};
                dispatch($0b6866794de633f9$var$setConversationData({
                    conversationId: conversationId,
                    data: {
                        name: metadata.name ?? conversationParams.name ?? '',
                        timeCreated: metadata.time_created ?? conversationParams.timeCreated ?? existingConversation?.timeCreated ?? new Date().toISOString(),
                        sourceAgentId: metadata.agent?.agent_named_id ?? conversationParams.agentId ?? existingConversation?.sourceAgentId ?? '',
                        ...fetchedConversationAgentFields,
                        ...metadata.tags !== undefined ? {
                            tags: metadata.tags
                        } : {}
                    }
                }));
            }).catch(()=>{
            // Silent failure — keep client defaults
            });
            // Run messages fetch and metadata fetch in parallel; wait for both
            const chatPromise = assistanceService.getChat(conversationId);
            const [chatResult] = await Promise.allSettled([
                chatPromise,
                metadataPromise
            ]);
            if (chatResult.status === 'rejected') {
                const normalizedError = chatResult.reason instanceof Error ? chatResult.reason : new Error(String(chatResult.reason));
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).WARM_CONVERSATION_CACHE,
                    error: normalizedError
                });
                dispatch($0b6866794de633f9$var$setConversationData({
                    conversationId: conversationId,
                    data: (0, $cteoa.clearStatus)({})
                }));
                onError?.(normalizedError);
                return;
            }
            const serviceChat = chatResult.value;
            const status = getState().conversations[conversationId]?.status;
            if (status !== (0, $bPHr8.CHAT_STORE_STATUS).loadingChat) return;
            const messages = $0b6866794de633f9$export$31bb5ed5e2cc3184({
                latestMessages: serviceChat,
                conversationId: conversationId,
                sendAnalyticsEvent: sendAnalyticsEvent,
                shouldPreprocessDetails: (0, $cteoa.shouldPreprocessDetailsForConversation)(getState(), conversationId)
            });
            const fetchedAgentVersion = $0b6866794de633f9$export$9c99f879b5701ba2(serviceChat);
            dispatch($0b6866794de633f9$var$setConversationData({
                conversationId: conversationId,
                data: {
                    ...(0, $cteoa.clearStatus)({
                        lastAgentMessageStatus: 'SUCCESSFUL'
                    }),
                    ...fetchedAgentVersion ? {
                        agentVersion: fetchedAgentVersion
                    } : {}
                }
            }));
            setMessages(conversationId, messages);
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).WARM_CONVERSATION_CACHE
            });
            onSuccess?.();
        } catch (e) {
            const normalizedError = e instanceof Error ? e : new Error(String(e));
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).WARM_CONVERSATION_CACHE,
                error: normalizedError
            });
            onError?.(normalizedError);
        }
    }, {
    experienceName: ()=>(0, $16lEl.ExperienceName).WARM_CONVERSATION_CACHE,
    actionErrorHandler: ()=>{
        // Suppress all default error handling for cache warming
        return;
    }
});
/**
 * Imperative warm-path messages prefetch
 */ const $0b6866794de633f9$var$prefetchConversationMessages = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).prefetchConversationMessages, ({ conversationId: conversationId, skipNextFetch: skipNextFetch = false, onStart: onStart, onSuccess: onSuccess, onError: onError })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, setMessages: setMessages, showFlag: showFlag })=>{
        const conversation = getState().conversations[conversationId];
        // Bail without emitting if the conversation isn't selectable, is
        // in flight, or is already loaded
        if ((0, $cteoa.isEmptyConversation)(conversationId) || !conversation || conversation.status !== (0, $bPHr8.CHAT_STORE_STATUS).idle || conversation.messages.length > 0) return;
        onStart?.();
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).PREFETCH_CHAT,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        dispatch($0b6866794de633f9$var$resetConversationForLoading({
            conversationId: conversationId,
            traces: [],
            sourceAgentId: conversation.sourceAgentId ?? ''
        }));
        try {
            const serviceChat = await assistanceService.getChat(conversationId);
            const status = getState().conversations[conversationId]?.status;
            if (status !== (0, $bPHr8.CHAT_STORE_STATUS).loadingChat) // Something else (e.g. a user-initiated send or an explicit
            // `fetchConversation`) raced ahead; surrender the response.
            return;
            const messages = $0b6866794de633f9$export$31bb5ed5e2cc3184({
                latestMessages: serviceChat,
                conversationId: conversationId,
                sendAnalyticsEvent: sendAnalyticsEvent,
                shouldPreprocessDetails: (0, $cteoa.shouldPreprocessDetailsForConversation)(getState(), conversationId)
            });
            const fetchedAgentVersion = $0b6866794de633f9$export$9c99f879b5701ba2(serviceChat);
            // Mirror fetchConversation's reconnect check.
            const lastMessage = serviceChat.at(-1);
            const isDeepResearch = lastMessage?.message?.message?.message_metadata?.deep_research;
            const shouldReconnect = (0, $ljUdP.isInProgressStreamResponse)(lastMessage) && (isDeepResearch || (0, $c6GJD.default).getExperimentValue('rovo_chat_reconnect_all_experiment', 'isEnabled', false));
            if (shouldReconnect) {
                const messageId = lastMessage.message.message.id;
                const updatedMessages = (0, $cteoa.clearStoreAssistantMessageContent)(messages, messageId);
                dispatch($0b6866794de633f9$var$setConversationData({
                    conversationId: conversationId,
                    data: {
                        ...(0, $cteoa.clearStatus)({
                            lastAgentMessageStatus: 'SUCCESSFUL'
                        }),
                        sourceAgentId: (0, $cteoa.getSourceAgentId)(messages, (0, $cteoa.getConversation)(getState(), conversationId)),
                        ...fetchedAgentVersion ? {
                            agentVersion: fetchedAgentVersion
                        } : {}
                    }
                }));
                setMessages(conversationId, updatedMessages);
                dispatch($0b6866794de633f9$var$restoreTaskModeForConversation({
                    conversationId: conversationId,
                    messages: messages
                }));
                dispatch($0b6866794de633f9$var$reconnectToInProgressStream({
                    conversationId: conversationId,
                    messageId: messageId,
                    isDeepResearch: isDeepResearch,
                    isAutoReconnect: true,
                    isReconnectToAll: (0, $c6GJD.default).getExperimentValue('rovo_chat_reconnect_all_experiment', 'isEnabled', false)
                }));
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).PREFETCH_CHAT
                });
                onSuccess?.();
                return;
            }
            dispatch($0b6866794de633f9$var$setConversationData({
                conversationId: conversationId,
                data: {
                    ...(0, $cteoa.clearStatus)({
                        lastAgentMessageStatus: 'SUCCESSFUL'
                    }),
                    sourceAgentId: (0, $cteoa.getSourceAgentId)(messages, (0, $cteoa.getConversation)(getState(), conversationId)),
                    ...fetchedAgentVersion ? {
                        agentVersion: fetchedAgentVersion
                    } : {},
                    ...skipNextFetch ? {
                        skipNextFetch: true
                    } : {}
                }
            }));
            setMessages(conversationId, messages);
            dispatch($0b6866794de633f9$var$restoreTaskModeForConversation({
                conversationId: conversationId,
                messages: messages
            }));
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).PREFETCH_CHAT
            });
            onSuccess?.();
        } catch (error) {
            const normalizedError = error instanceof Error ? error : new Error(String(error));
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).PREFETCH_CHAT,
                error: normalizedError
            });
            if ($0b6866794de633f9$var$isForbiddenConversationError(error) && (0, $dh538.fg)('rovo_chat_improved_conversation_403_handling')) {
                $0b6866794de633f9$var$handleForbiddenConversation({
                    conversationId: conversationId,
                    dispatch: dispatch,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    showFlag: showFlag
                });
                onError?.(normalizedError);
                return;
            }
            // Roll back warm loading state; do not set `skipNextFetch` on failure.
            dispatch($0b6866794de633f9$var$setConversationData({
                conversationId: conversationId,
                data: (0, $cteoa.clearStatus)({})
            }));
            onError?.(normalizedError);
        }
    }, {
    experienceName: ()=>(0, $16lEl.ExperienceName).PREFETCH_CHAT,
    actionErrorHandler: ()=>{
        // Errors are surfaced via `onError`; keep the silent warm path silent.
        return;
    }
});
/**
 * Seeds a conversation into the store without going through createSafeAction.
 *
 * This is used by the template-smartCreate flow where createConversationChannel
 * has already created a real backend conversation. We need to:
 *   1. Register it in state.conversations (so setSelectedConversation can find it)
 *   2. Set it as the active conversation
 *
 * Unlike createConversationOptimistically, this does NOT use createSafeAction,
 * so it works even when ChatStoreContainer is not mounted (e.g. template gallery page).
 */ const $0b6866794de633f9$var$seedConversation = ({ conversationId: conversationId, skipNextFetch: skipNextFetch })=>({ getState: getState, setState: setState })=>{
        const time = new Date().toISOString();
        // Register in conversations map
        setState({
            conversations: {
                ...getState().conversations,
                [conversationId]: {
                    ...getState().conversations[conversationId] ?? {},
                    id: conversationId,
                    name: (0, $99vXA.generateConversationName)(),
                    status: (0, $bPHr8.CHAT_STORE_STATUS).idle,
                    timeCreated: time,
                    lastMessageTimestamp: time,
                    traces: [],
                    messages: [],
                    lastMessageType: [],
                    ...skipNextFetch ? {
                        skipNextFetch: true
                    } : {}
                }
            },
            // Also set as active conversation
            currentConversationId: conversationId
        });
    };
const $0b6866794de633f9$var$stopTask = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).stopTask, ({ conversationId: conversationId })=>({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, unifiedTasksActions: unifiedTasksActions })=>{
        if (!(0, $dh538.fg)('rovo_chat_enable_tasks')) return;
        const conversation = getState().conversations[conversationId];
        if (conversation?.storeAbortController) {
            dispatch($0b6866794de633f9$var$abortRequests({
                conversationId: conversationId,
                taskModeEnabled: true
            }));
            return;
        }
        if (!unifiedTasksActions) return;
        const task = unifiedTasksActions.getActiveTaskForConversation(conversationId);
        if (!task?.taskId || (0, $bPHr8.isTerminalTaskState)(task.progressState)) return;
        unifiedTasksActions.setTaskProgressState({
            taskId: task.taskId,
            progressState: 'Cancelled',
            updatedAt: new Date().toISOString()
        });
        assistanceService.cancelTask(task.taskId).catch((err)=>{
            (0, $1yaYZ.logException)({
                name: 'rovoCancelTaskFromStopTask',
                exception: err,
                tags: {
                    taskId: task.taskId
                }
            });
        });
    });
const $0b6866794de633f9$var$clearTargetTaskMessageId = ({ conversationId: conversationId })=>({ dispatch: dispatch })=>{
        dispatch($0b6866794de633f9$var$setConversationData({
            conversationId: conversationId,
            data: {
                targetTaskMessageId: null
            }
        }));
    };
/**
 * Wholesale replace of the conversation's selected-agent history. Use this
 * only for bulk-seeding / bootstrap paths (e.g. hydrating a brand-new
 * conversation from a channel response). For individual user selections from
 * the @-mention picker, use `addSelectedAgentId` so the order-preserving
 * move-to-end semantics are applied. To remove a single id, use
 * `removeSelectedAgentId`.
 */ const $0b6866794de633f9$var$setSelectedAgentIds = ({ conversationId: conversationId, agentIds: agentIds })=>({ dispatch: dispatch })=>{
        dispatch($0b6866794de633f9$var$setConversationData({
            conversationId: conversationId,
            data: {
                selectedAgentIds: agentIds
            }
        }));
    };
/**
 * Append an agent id onto the conversation's selected-agent history.
 *
 * The array is an append-only, duplicate-preserving log of every chip the
 * user has inserted in this conversation. The last entry is the active
 * agent (read via `selectedAgentIds.at(-1)`); earlier entries (including
 * earlier occurrences of the same id) reflect older picks that are no
 * longer active but whose chips may still exist in the chat input.
 *
 * This is the action the @-mention picker fires when the user selects an
 * agent. Re-picking an already-active agent still appends (and re-emits)
 * so subscribers (e.g. mention chip disabled-state) refresh.
 */ const $0b6866794de633f9$var$addSelectedAgentId = ({ conversationId: conversationId, agentId: agentId })=>({ dispatch: dispatch, getState: getState })=>{
        const conversation = getState().conversations[conversationId];
        if (!conversation) return;
        const current = conversation.selectedAgentIds ?? [];
        const next = [
            ...current,
            agentId
        ];
        dispatch($0b6866794de633f9$var$setConversationData({
            conversationId: conversationId,
            data: {
                selectedAgentIds: next
            }
        }));
    };
/**
 * Remove the rightmost occurrence of `agentId` from the conversation's
 * selected-agent history. Used when an agent-mention chip is deleted from
 * the chat input: only one chip's worth of state is removed, so duplicate chips
 * for the same agent each get one chance at being the active entry before
 * the id fully drops off the history. The new last entry (if any)
 * automatically becomes the active agent.
 */ const $0b6866794de633f9$var$removeSelectedAgentId = ({ conversationId: conversationId, agentId: agentId })=>({ dispatch: dispatch, getState: getState })=>{
        const current = getState().conversations[conversationId]?.selectedAgentIds ?? [];
        const lastIndex = current.lastIndexOf(agentId);
        if (lastIndex === -1) return;
        const next = [
            ...current.slice(0, lastIndex),
            ...current.slice(lastIndex + 1)
        ];
        dispatch($0b6866794de633f9$var$setConversationData({
            conversationId: conversationId,
            data: {
                selectedAgentIds: next
            }
        }));
    };
/**
 * Checks the selected conversation's unified task after conversations are loaded.
 * If the active task is not in a terminal state (Completed/Cancelled/Failed),
 * restores the chat mode to 'task' so the user resumes in task mode.
 */ const $0b6866794de633f9$var$restoreTaskModeIfNeeded = ()=>({ getState: getState }, { setReasoningMode: setReasoningMode, unifiedTasksActions: unifiedTasksActions })=>{
        if (!unifiedTasksActions || !(0, $dh538.fg)('rovo_chat_enable_tasks')) return;
        const { currentConversationId: currentConversationId } = getState();
        const task = unifiedTasksActions.getActiveTaskForConversation(currentConversationId);
        if (task && !(0, $bPHr8.isTerminalTaskState)(task.progressState)) setReasoningMode(currentConversationId, 'task');
    };
const $0b6866794de633f9$var$actions = {
    abortRequests: $0b6866794de633f9$var$abortRequests,
    addAgentMessage: $0b6866794de633f9$var$addAgentMessage,
    addErrorMessage: $0b6866794de633f9$var$addErrorMessage,
    answerNow: $0b6866794de633f9$var$answerNow,
    bulkResolveConversationActions: $0b6866794de633f9$var$bulkResolveConversationActions,
    bulkResolveConversationUIActions: $0b6866794de633f9$var$bulkResolveConversationUIActions,
    clearFollowUpMessages: $0b6866794de633f9$var$clearFollowUpMessages,
    stopTask: $0b6866794de633f9$var$stopTask,
    clearTargetTaskMessageId: $0b6866794de633f9$var$clearTargetTaskMessageId,
    setSelectedAgentIds: $0b6866794de633f9$var$setSelectedAgentIds,
    addSelectedAgentId: $0b6866794de633f9$var$addSelectedAgentId,
    removeSelectedAgentId: $0b6866794de633f9$var$removeSelectedAgentId,
    createConversationOptimistically: $0b6866794de633f9$var$createConversationOptimistically,
    createSeededConversation: $0b6866794de633f9$var$createSeededConversation,
    deleteConversation: $0b6866794de633f9$var$deleteConversation,
    getChat: $0b6866794de633f9$var$fetchConversation,
    handleChatOpenPubsubAction: $0b6866794de633f9$var$handleChatOpenPubsubAction,
    hydrateConversationWithExternalParams: $0b6866794de633f9$var$hydrateConversationWithExternalParams,
    fetchConversationChannelsData: $0b6866794de633f9$var$fetchConversationChannelsData,
    setConversationData: $0b6866794de633f9$var$setConversationData,
    removeMessage: $0b6866794de633f9$var$removeMessage,
    truncateFromLastHumanMessage: $0b6866794de633f9$var$truncateFromLastHumanMessage,
    resolveConversationAction: $0b6866794de633f9$var$resolveConversationAction,
    sendMessage: $0b6866794de633f9$var$sendMessage,
    sendMessageConfirmedTools: $0b6866794de633f9$var$sendMessageConfirmedTools,
    setSelectedConversation: $0b6866794de633f9$var$setSelectedConversation,
    updateConversation: $0b6866794de633f9$var$updateConversation,
    removeConversationFromStore: $0b6866794de633f9$var$removeConversationFromStore,
    reconnectToInProgressStream: $0b6866794de633f9$var$reconnectToInProgressStream,
    restoreTaskModeIfNeeded: $0b6866794de633f9$var$restoreTaskModeIfNeeded,
    warmConversationCache: $0b6866794de633f9$var$warmConversationCache,
    prefetchConversationMessages: $0b6866794de633f9$var$prefetchConversationMessages,
    seedConversation: $0b6866794de633f9$var$seedConversation
};
const $0b6866794de633f9$var$chatStore = (0, $2CHXX.createChatStore)($0b6866794de633f9$var$actions);
/**
 * ************************************************************
 * Container
 * ************************************************************
 */ const $0b6866794de633f9$var$storeInit = ()=>async ({ dispatch: dispatch }, { setChatStatus: setChatStatus, skipAutoConversationSelection: skipAutoConversationSelection })=>{
        (0, $1yaYZ.addSentryBreadcrumb)('ChatStoreContainer: storeInit');
        setChatStatus('launching');
        // Init conversation hydrates the chat store with conversation from URL or Storage
        // and fetches conversations list (however, fetching conversations list is performed "in the background")
        // conversations list is fetched to be later on displayed in the sidebar/conversation list to remove/minimize
        // visual delay when user opens the side-navigation; or in full-screen mode to fetch conversations as early as possible;
        const initConversation = async ()=>{
            dispatch($0b6866794de633f9$var$hydrateConversationWithExternalParams({
                autoSelectConversation: !skipAutoConversationSelection
            }));
            (0, $1K4cm.interactionMetrics).initializeChannels.start();
            await dispatch($0b6866794de633f9$var$fetchConversationChannelsData({
                isInitialLoad: true
            }));
            (0, $1K4cm.interactionMetrics).initializeChannels.stop();
        };
        initConversation();
        (0, $1yaYZ.addSentryBreadcrumb)('ChatStoreContainer: storeInit completed');
    };
const $0b6866794de633f9$var$storeInitOnUpdate = ()=>{
    return ()=>{};
};
const $0b6866794de633f9$var$chatStoreContainerOptions = {
    onInit: $0b6866794de633f9$var$storeInit,
    onUpdate: $0b6866794de633f9$var$storeInitOnUpdate
};
const $0b6866794de633f9$export$9b7b433b0520b82b = (0, $FOT9i.createContainer)($0b6866794de633f9$var$chatStore, $0b6866794de633f9$var$chatStoreContainerOptions);
/**
 * ************************************************************
 * Main Hook
 * ************************************************************
 */ const $0b6866794de633f9$var$publicStateSelector = (state)=>{
    return {
        ...state,
        checkActiveConversationMatchesSource: (id)=>{
            return (0, $cteoa.checkActiveConversationMatchesSource)(state, id);
        }
    };
};
const $0b6866794de633f9$export$e5fca4e502afbbf1 = (0, $9zUhf.createStateHook)($0b6866794de633f9$var$chatStore, {
    selector: (state)=>state.currentConversationId
});
const $0b6866794de633f9$export$69f8a6521b059b65 = (0, $9zUhf.createStateHook)($0b6866794de633f9$var$chatStore, {
    selector: (state)=>state.conversations[state.currentConversationId]
});
const $0b6866794de633f9$export$409e508fe0e24613 = (0, $9zUhf.createStateHook)($0b6866794de633f9$var$chatStore, {
    selector: (state, { conversationId: conversationId })=>state.conversations[conversationId]
});
const $0b6866794de633f9$export$32ab7ff538e75ef1 = (0, $9zUhf.createStateHook)($0b6866794de633f9$var$chatStore, {
    selector: (state)=>state.conversations
});
const $0b6866794de633f9$export$ec4a3a5c0e5ad91e = (0, $9zUhf.createStateHook)($0b6866794de633f9$var$chatStore, {
    selector: (state)=>state.isConversationsInitialized
});
const $0b6866794de633f9$export$c96a1629e6c55001 = (0, $9zUhf.createStateHook)($0b6866794de633f9$var$chatStore, {
    selector: (state, { conversationId: conversationId })=>state.conversations[conversationId]?.selectedAgentIds?.at(-1)
});
const $0b6866794de633f9$export$8d30245ae42b8baf = (0, $9zUhf.createStateHook)($0b6866794de633f9$var$chatStore, {
    selector: (state, { conversationId: conversationId })=>state.conversations[conversationId]?.selectedAgentIds ?? []
});
const $0b6866794de633f9$export$655699269aa75afd = ()=>(0, $c6GJD.default).getExperimentValue('rovo_chat_store_selector_optimization', 'isEnabled', false);
const $0b6866794de633f9$export$5ca9bbfceeb3b458 = (0, $9zUhf.createHook)($0b6866794de633f9$var$chatStore, {
    selector: $0b6866794de633f9$var$publicStateSelector
});
const $0b6866794de633f9$export$b8d7540a5f22fede = (0, $9zUhf.createActionsHook)($0b6866794de633f9$var$chatStore);
module.exports["processConversationMessages"] = $0b6866794de633f9$export$31bb5ed5e2cc3184;
module.exports["ChatStoreContainer"] = $0b6866794de633f9$export$9b7b433b0520b82b;
module.exports["useCurrentConversationId"] = $0b6866794de633f9$export$e5fca4e502afbbf1;
module.exports["useCurrentConversation"] = $0b6866794de633f9$export$69f8a6521b059b65;
module.exports["useConversationById"] = $0b6866794de633f9$export$409e508fe0e24613;
module.exports["useActiveSelectedAgentId"] = $0b6866794de633f9$export$c96a1629e6c55001;
module.exports["isStoreSelectorOptimizationEnabled"] = $0b6866794de633f9$export$655699269aa75afd;
module.exports["useChatStore"] = $0b6866794de633f9$export$5ca9bbfceeb3b458;
module.exports["useChatStoreActions"] = $0b6866794de633f9$export$b8d7540a5f22fede;

});

parcelRegister("8IKbl", function(module, exports) {
const $e66d55c2753a8f61$export$d48e9af4e05f2a7 = 'google-calendar-event-create';
const $e66d55c2753a8f61$export$a43abf6a24956d01 = 'google-doc-create';
const $e66d55c2753a8f61$export$21d5a0caed6ec45a = 'slack-send-channel-message';
const $e66d55c2753a8f61$export$ca1dbd7b2bdea0b9 = 'github-pull-request-comment';
const $e66d55c2753a8f61$export$5265054aab70a085 = 'sharepoint-document-create';
const $e66d55c2753a8f61$export$51cf89863fa35443 = {
    'google-calendar-event-create': {
        stg: '57a5a90f-ab9c-4f1c-b661-3267fb23b5f2',
        prod: '57a5a90f-ab9c-4f1c-b661-3267fb23b5f2'
    },
    'google-doc-create': {
        stg: 'ari:cloud:ecosystem::extension/2357cbb7-bf5c-4fe4-a9c6-c8e172ccb5b1/3b53863d-a6bb-4818-91da-4de04f975f48/static/create-gdrive-document',
        prod: 'ari:cloud:ecosystem::extension/ff32b4a9-0056-4c40-bb6e-eebf3b1d82f7/c50f3d56-68fc-4c3c-8191-6717f173dc54/static/create-gdrive-document'
    },
    'slack-send-channel-message': {
        stg: '698c49a4-8c14-448d-a7c6-766298a5f22e',
        prod: '698c49a4-8c14-448d-a7c6-766298a5f22e'
    },
    'github-pull-request-comment': {
        stg: '88344c12-d3a8-4f9b-85ca-9c905de23570',
        prod: '88344c12-d3a8-4f9b-85ca-9c905de23570'
    },
    'sharepoint-document-create': {
        stg: 'c910d167-3796-4b72-b144-0a9a0c4ef8cc',
        prod: 'c910d167-3796-4b72-b144-0a9a0c4ef8cc'
    }
};
const $e66d55c2753a8f61$export$9036027f2f20417a = (actionKey)=>{
    return actionKey in $e66d55c2753a8f61$export$51cf89863fa35443;
};
const $e66d55c2753a8f61$export$709b8cb02beb8ef9 = (actionKey)=>{
    switch(actionKey){
        case $e66d55c2753a8f61$export$d48e9af4e05f2a7:
            return 'google-calendar';
        case $e66d55c2753a8f61$export$a43abf6a24956d01:
            return 'google-doc';
        case $e66d55c2753a8f61$export$21d5a0caed6ec45a:
            return 'slack';
        case $e66d55c2753a8f61$export$ca1dbd7b2bdea0b9:
            return 'github';
        case $e66d55c2753a8f61$export$5265054aab70a085:
            return 'sharepoint';
    }
};
const $e66d55c2753a8f61$export$4081752c8da17394 = {
    // Atlassian Projects
    CreateProjectProgressUpdate: 'atlassian-project-atlassian-atlassian-project-create-progress-up',
    // Jira
    UpdateWorkItemFields: 'jira-atlassian-work-item-update-single-field',
    UpdateWorkItemAllFieldTypes: 'jira-atlassian-work-item-update-all-field-types-bulk',
    JiraFindIssues: 'jira-find-issues',
    JiraSmartIssueCreateAllField: 'jira-atlassian-work-item-create-all-field-types',
    JiraIssueTransition: 'jira-issue-transition-bulk',
    JiraEpicsSuggest: 'jira-epics-suggest',
    JiraIssueDelete: 'jira-issue-delete',
    JiraIssueMove: 'jira-issue-move',
    JiraIssueAssign: 'jira-issue-assign-bulk',
    JiraVersionCreate: 'jira-version-create',
    // Work organizer sprint actions
    JiraCreateSprint: 'jira-atlassian-work-item-create-sprint',
    JiraStartSprint: 'jira-atlassian-board-start-sprint',
    JiraMoveToSprint: 'jira-atlassian-workspace-move-to-sprint-work-item',
    JiraWorkflowEditor: 'jira-workflow-operations',
    // Confluence
    ConfluencePageCreate: 'confluence-page-create',
    ConfluencePageComment: 'confluence-page-comment',
    ConfluencePageAddLabel: 'confluence-label-create',
    ConfluencePageRename: 'confluence-page-rename',
    ConfluencePageMove: 'confluence-page-move',
    // JSM
    JsmJourneyBuilder: 'jsm-invoke-orchestrator-agent',
    JsmCreateRequest: 'jsm-create-request',
    JsmCreateRequestV2: 'jsm-create-request-v2',
    CreateRequest: 'create-request',
    JsmCreateEmbeddedRequest: 'help-form-submit',
    JsmCreateSurvey: 'jsm-create-survey',
    JsmLivechat: 'jsm-livechat',
    JsmSolutionComposerPlanSummary: 'jsm-solution-composer-plan-summary',
    // Deep Research
    DeepResearchCreatePageAction: 'deep-research-report-confluence-export',
    // Studio
    StudioTriggerSolutionPlan: 'studio-trigger-solution-plan',
    StudioUpdateAgentDraft: 'studio-atlassian-studio-update-agent-draft',
    StudioWorkspaceUpdateAgentDraft: 'studio-atlassian-workspace-update-draft-agent',
    StudioAutomationTriggerRuleBuild: 'studio-automation-trigger-rule-build',
    UpdateAgentConfigurationTool: 'UpdateAgentConfigurationTool',
    StudioCreateAgent: 'CreateAgentTool',
    StudioLandingPageRedirect: 'studio-landing-page-redirect',
    // Plans
    JiraPlansUpdateWorkSource: 'jira-atlassian-plan-update-work-sources',
    JiraPlansCreateProgramBoard: 'jira-plan-add-program-board-plugin',
    JiraPlansDeleteProgramBoard: 'Jira-Plan-Delete-Program-Board-Plugin',
    JiraPlansCreateWorkItem: 'jira-atlassian-plan-create-work-item',
    JiraPlansCreateRelease: 'Jira-Plan-Create-Release-Plugin',
    JiraPlansManageFeatures: 'jira-atlassian-plan-set-release-enabled',
    JiraPlansAddDependency: 'jira-atlassian-plan-add-work-item-dependencies',
    JiraPlansRemoveDependency: 'jira-atlassian-plan-remove-work-item-dependencies',
    // Capacity Planning
    ManageCapacityPlan: 'capacity-plan-update-single-action',
    // Atlassian Teams
    AtlassianTeamUpdateArchive: 'atlassian-team-atlassian-team-update-archive',
    // Focus Asks
    FocusCreateAsk: 'passionfruit-atlassian-workspace-create-asks',
    // Bitbucket
    BitbucketPullRequestComment: 'bitbucket-pull-request-comment',
    // Others
    StoreRecommendationCard: 'store-recommendation-card',
    RequireInformationTool: 'RequireInformationTool',
    HiringManagerTool: 'HiringManagerTool',
    JsmSuggestAndAddFieldsToRequestType: 'SuggestAndAddFieldsToRequestType',
    JsmAtlassianProjectCreateJsmRequestTypeWithFields: 'jsm-atlassian-project-create-jsm-request-type-with-fields',
    // Convo AI agent tools
    ExecutePython: 'execute_python',
    PlanComplete: 'plan_complete',
    AskQuestion: 'ask_question',
    JsmAtlassianProjectCreateJsmQueue: 'jsm-atlassian-project-create-jsm-queue',
    JsmAtlassianProjectCreateJsmQueueGroup: 'jsm-atlassian-project-create-jsm-queue-group',
    JsmAtlassianProjectUpdateJsmQueue: 'jsm-atlassian-project-update-jsm-queue',
    JsmAtlassianProjectUpdateJsmQueueGroup: 'jsm-atlassian-project-update-jsm-queue-group',
    JsmCreateSlaPlugin: 'jsm-create-sla-plugin',
    JsmUpdateSlaPlugin: 'jsm-update-sla-plugin',
    // Confluence AIFC
    AifcAdfUpdate: 'aifc-adf-update',
    // Add other keys here as needed
    ScheduledChat: 'ScheduleRovoChatTool',
    MultipleChoiceQuestionsTool: 'MultipleChoiceQuestionsTool',
    AgenticPlanTool: 'AgenticPlanTool',
    CreateKBCard: 'jsm-atlassian-jsm-kb-bulk-create-draft-topics',
    CreateKbArticlesCard: 'jsm-atlassian-project-create-jsm-kb-articles',
    // Custom Skills
    CreateCustomSkillTool: 'CreateCustomSkillTool',
    UpdateCustomSkillTool: 'UpdateCustomSkillTool'
};
const $e66d55c2753a8f61$export$c5959ebd02278fb3 = $e66d55c2753a8f61$export$4081752c8da17394.FocusCreateAsk;
const $e66d55c2753a8f61$export$98251f227f05fc03 = 'execute_python';
const $e66d55c2753a8f61$export$2cf48170a90af7e3 = 'plan_complete';
const $e66d55c2753a8f61$export$52c76e2fb6c72799 = 'ask_question';
const $e66d55c2753a8f61$export$d3fc7569bcc4e4e7 = new Set([
    $e66d55c2753a8f61$export$52c76e2fb6c72799
]);
const $e66d55c2753a8f61$export$f4709e6eb43898ae = {
    DynamicAction: 'dynamicAction',
    Resumption: 'resumption'
};
const $e66d55c2753a8f61$export$dc0b7ce6d28cc1a4 = Object.values($e66d55c2753a8f61$export$4081752c8da17394);
const $e66d55c2753a8f61$export$a70752a3aa5d7b44 = 'generic-external-action-error';
const $e66d55c2753a8f61$export$4017c867f2f7bb4 = 'jira-find-issues';
const $e66d55c2753a8f61$export$d94c92560b8e6d9 = 'jira-atlassian-work-item-create-all-field-types';
const $e66d55c2753a8f61$export$ae7170c1349b8d03 = 'jsm-create-request';
const $e66d55c2753a8f61$export$bd97f2d43b42e54b = 'jsm-create-request-v2';
const $e66d55c2753a8f61$export$ce5ab65c94ba90a5 = 'create-request';
const $e66d55c2753a8f61$export$d8b6e8d910775d71 = 'help-form-submit';
const $e66d55c2753a8f61$export$63066a4ea024d6dc = 'jsm-livechat';
const $e66d55c2753a8f61$export$12df73851574d597 = 'jira-issue-transition-bulk';
const $e66d55c2753a8f61$export$3409cf7709732f7a = 'jira-epics-suggest';
const $e66d55c2753a8f61$export$28eab0a47cd4bdb7 = 'jira-issue-delete';
const $e66d55c2753a8f61$export$7814024c83fb6ff0 = 'jira-issue-move';
const $e66d55c2753a8f61$export$1621b7bb3a34aaf8 = 'jira-issue-assign-bulk';
const $e66d55c2753a8f61$export$5d140de35a141589 = 'jira-version-create';
const $e66d55c2753a8f61$export$9c43c5b52e38bd7b = 'capacity-plan-update-single-action';
const $e66d55c2753a8f61$export$7daabf9beae1e394 = 'jira-workflow-operations';
const $e66d55c2753a8f61$export$b34d7535a3731e6 = 'confluence-page-create';
const $e66d55c2753a8f61$export$5eead95dddb4d85e = 'confluence-page-comment';
const $e66d55c2753a8f61$export$dd1d4f1078af0323 = 'confluence-page-rename';
const $e66d55c2753a8f61$export$ea076e5315cd0441 = 'confluence-label-create';
const $e66d55c2753a8f61$export$2d6387634f79866d = 'confluence-page-move';
const $e66d55c2753a8f61$export$c35e156d5b3ba839 = 'deep-research-report-confluence-export';
const $e66d55c2753a8f61$export$6509c2efb7cf2a1a = 'RequireInformationTool';
const $e66d55c2753a8f61$export$32fdd722a8ead9f4 = 'HiringManagerTool';
const $e66d55c2753a8f61$export$1b06fd861ab5ff79 = 'studio-trigger-solution-plan';
const $e66d55c2753a8f61$export$7f87d37407a70a70 = 'studio-atlassian-studio-update-agent-draft';
const $e66d55c2753a8f61$export$e118b34b65e65120 = 'studio-atlassian-workspace-update-draft-agent';
const $e66d55c2753a8f61$export$1d1c24f8fb60d008 = 'UpdateAgentConfigurationTool';
const $e66d55c2753a8f61$export$5f46fda2a8a95615 = 'jsm-invoke-orchestrator-agent';
const $e66d55c2753a8f61$export$a1766d72cd6b3386 = 'jsm-atlassian-project-create-jsm-survey';
const $e66d55c2753a8f61$export$97632a370497b953 = 'jsm-atlassian-project-create-jsm-queue';
const $e66d55c2753a8f61$export$d1d21bf838e2f79 = 'jsm-atlassian-project-create-jsm-queue-group';
const $e66d55c2753a8f61$export$7343cca51c2f764f = 'jsm-atlassian-project-update-jsm-queue';
const $e66d55c2753a8f61$export$263c9dbbd6f9736b = 'jsm-atlassian-project-update-jsm-queue-group';
const $e66d55c2753a8f61$export$b26feecb387f3cdd = 'jsm-create-sla-plugin';
const $e66d55c2753a8f61$export$2ebc939020585965 = 'jsm-update-sla-plugin';
const $e66d55c2753a8f61$export$85f4644ed1882358 = 'jsm-atlassian-project-create-jsm-request-type-with-fields';
const $e66d55c2753a8f61$export$a95d95d149961c0e = 'SuggestAndAddFieldsToRequestType';
const $e66d55c2753a8f61$export$20f16b1101429bc = 'jsm-atlassian-jsm-kb-bulk-create-draft-topics';
const $e66d55c2753a8f61$export$4c4ea6fd8cbe01a5 = 'jsm-atlassian-project-create-jsm-kb-articles';
const $e66d55c2753a8f61$export$459b808fe2e5243c = 'studio-automation-trigger-rule-build';
const $e66d55c2753a8f61$export$7ec0908a542c881f = 'CreateAgentTool';
const $e66d55c2753a8f61$export$5b672baa753f5e11 = 'jira-atlassian-plan-update-work-sources';
const $e66d55c2753a8f61$export$cbc8657dfb60324e = 'jira-plan-add-program-board-plugin';
const $e66d55c2753a8f61$export$5eaeb9a94b1424d1 = 'Jira-Plan-Delete-Program-Board-Plugin';
const $e66d55c2753a8f61$export$aa0b02e94003e760 = 'jira-atlassian-plan-create-work-item';
const $e66d55c2753a8f61$export$fc48d7aa308f4ddd = 'jira-atlassian-plan-set-release-enabled';
const $e66d55c2753a8f61$export$82a76d32e0a5ed52 = 'jira-atlassian-plan-add-work-item-dependencies';
const $e66d55c2753a8f61$export$a27ffbabb22373cc = 'jira-atlassian-plan-remove-work-item-dependencies';
const $e66d55c2753a8f61$export$17ce344f9afefd3f = 'Jira-Plan-Create-Release-Plugin';
const $e66d55c2753a8f61$export$b392dc810180e703 = 'store-recommendation-card';
const $e66d55c2753a8f61$export$1d10a8f57c7c69ae = 'jira-ham-ai-insights-preview';
const $e66d55c2753a8f61$export$37572672766b68ab = 'atlassian-team-atlassian-team-update-archive';
const $e66d55c2753a8f61$export$88c32cc437966d51 = 'ScheduleRovoChatTool';
const $e66d55c2753a8f61$export$a60c2f7f22cc5a42 = 'MultipleChoiceQuestionsTool';
const $e66d55c2753a8f61$export$d4c7224b1c4ad942 = 'AgenticPlanTool';
const $e66d55c2753a8f61$export$ef8aa45067b257a9 = [
    $e66d55c2753a8f61$export$4017c867f2f7bb4,
    $e66d55c2753a8f61$export$3409cf7709732f7a,
    $e66d55c2753a8f61$export$28eab0a47cd4bdb7,
    $e66d55c2753a8f61$export$7814024c83fb6ff0
];
module.exports["actionKeyToActionId"] = $e66d55c2753a8f61$export$51cf89863fa35443;
module.exports["isDynamicAction"] = $e66d55c2753a8f61$export$9036027f2f20417a;
module.exports["mapActionToProduct"] = $e66d55c2753a8f61$export$709b8cb02beb8ef9;
module.exports["ActionKeys"] = $e66d55c2753a8f61$export$4081752c8da17394;
module.exports["FOCUS_CREATE_ASK_KEY"] = $e66d55c2753a8f61$export$c5959ebd02278fb3;
module.exports["ACTIONS_HIDING_FOOTER_BUTTONS"] = $e66d55c2753a8f61$export$d3fc7569bcc4e4e7;
module.exports["ActionPredicateKeys"] = $e66d55c2753a8f61$export$f4709e6eb43898ae;
module.exports["JIRA_FIND_ISSUES_KEY"] = $e66d55c2753a8f61$export$4017c867f2f7bb4;
module.exports["JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY"] = $e66d55c2753a8f61$export$d94c92560b8e6d9;
module.exports["JSM_CREATE_REQUEST_KEY"] = $e66d55c2753a8f61$export$ae7170c1349b8d03;
module.exports["JSM_CREATE_REQUEST_V2_KEY"] = $e66d55c2753a8f61$export$bd97f2d43b42e54b;
module.exports["CREATE_REQUEST_KEY"] = $e66d55c2753a8f61$export$ce5ab65c94ba90a5;
module.exports["JSM_CREATE_EMBEDDED_REQUEST_KEY"] = $e66d55c2753a8f61$export$d8b6e8d910775d71;
module.exports["JSM_LIVECHAT_KEY"] = $e66d55c2753a8f61$export$63066a4ea024d6dc;
module.exports["JIRA_ISSUE_TRANSITION_KEY"] = $e66d55c2753a8f61$export$12df73851574d597;
module.exports["JIRA_EPICS_SUGGEST_KEY"] = $e66d55c2753a8f61$export$3409cf7709732f7a;
module.exports["JIRA_ISSUE_DELETE_KEY"] = $e66d55c2753a8f61$export$28eab0a47cd4bdb7;
module.exports["JIRA_ISSUE_MOVE_KEY"] = $e66d55c2753a8f61$export$7814024c83fb6ff0;
module.exports["JIRA_ISSUE_ASSIGN_KEY"] = $e66d55c2753a8f61$export$1621b7bb3a34aaf8;
module.exports["JIRA_VERSION_CREATE_KEY"] = $e66d55c2753a8f61$export$5d140de35a141589;
module.exports["JIRA_WORKFLOW_EDITOR"] = $e66d55c2753a8f61$export$7daabf9beae1e394;
module.exports["CONFLUENCE_PAGE_CREATE_KEY"] = $e66d55c2753a8f61$export$b34d7535a3731e6;
module.exports["CONFLUENCE_PAGE_COMMENT_KEY"] = $e66d55c2753a8f61$export$5eead95dddb4d85e;
module.exports["CONFLUENCE_PAGE_RENAME_KEY"] = $e66d55c2753a8f61$export$dd1d4f1078af0323;
module.exports["CONFLUENCE_PAGE_ADD_LABEL_KEY"] = $e66d55c2753a8f61$export$ea076e5315cd0441;
module.exports["CONFLUENCE_PAGE_MOVE_KEY"] = $e66d55c2753a8f61$export$2d6387634f79866d;
module.exports["DEEP_RESEARCH_CREATE_PAGE_ACTION_KEY"] = $e66d55c2753a8f61$export$c35e156d5b3ba839;
module.exports["REQUIRE_INFORMATION_TOOL"] = $e66d55c2753a8f61$export$6509c2efb7cf2a1a;
module.exports["STUDIO_TRIGGER_SOLUTION_PLAN_KEY"] = $e66d55c2753a8f61$export$1b06fd861ab5ff79;
module.exports["JSM_JOURNEY_BUILDER_KEY"] = $e66d55c2753a8f61$export$5f46fda2a8a95615;
module.exports["JSM_CREATE_SURVEY_KEY"] = $e66d55c2753a8f61$export$a1766d72cd6b3386;
module.exports["JSM_QUEUE_CREATE_KEY"] = $e66d55c2753a8f61$export$97632a370497b953;
module.exports["JSM_QUEUE_UPDATE_KEY"] = $e66d55c2753a8f61$export$7343cca51c2f764f;
module.exports["JSM_SLA_CREATE_KEY"] = $e66d55c2753a8f61$export$b26feecb387f3cdd;
module.exports["JSM_SLA_UPDATE_KEY"] = $e66d55c2753a8f61$export$2ebc939020585965;
module.exports["JSM_REQUEST_TYPE_UPDATED_KEY"] = $e66d55c2753a8f61$export$85f4644ed1882358;
module.exports["JSM_SUGGEST_AND_ADD_FIELDS_TO_REQUEST_TYPE_KEY"] = $e66d55c2753a8f61$export$a95d95d149961c0e;
module.exports["JSM_CREATE_KB_TOPICS_KEY"] = $e66d55c2753a8f61$export$20f16b1101429bc;
module.exports["JSM_CREATE_KB_ARTICLES_KEY"] = $e66d55c2753a8f61$export$4c4ea6fd8cbe01a5;
module.exports["STUDIO_AUTOMATION_TRIGGER_RULE_BUILD_KEY"] = $e66d55c2753a8f61$export$459b808fe2e5243c;
module.exports["JIRA_PLANS_UPDATE_WORK_SOURCE_KEY"] = $e66d55c2753a8f61$export$5b672baa753f5e11;
module.exports["JIRA_PLANS_ADD_PROGRAM_BOARD_KEY"] = $e66d55c2753a8f61$export$cbc8657dfb60324e;
module.exports["JIRA_PLANS_DELETE_PROGRAM_BOARD_KEY"] = $e66d55c2753a8f61$export$5eaeb9a94b1424d1;
module.exports["JIRA_PLANS_CREATE_WORK_ITEM_KEY"] = $e66d55c2753a8f61$export$aa0b02e94003e760;
module.exports["JIRA_PLANS_MANAGE_FEATURES_KEY"] = $e66d55c2753a8f61$export$fc48d7aa308f4ddd;
module.exports["JIRA_PLANS_ADD_DEPENDENCY_KEY"] = $e66d55c2753a8f61$export$82a76d32e0a5ed52;
module.exports["JIRA_PLANS_REMOVE_DEPENDENCY_KEY"] = $e66d55c2753a8f61$export$a27ffbabb22373cc;
module.exports["JIRA_PLANS_CREATE_RELEASE_KEY"] = $e66d55c2753a8f61$export$17ce344f9afefd3f;
module.exports["STORE_RECOMMENDATION_ACTION_KEY"] = $e66d55c2753a8f61$export$b392dc810180e703;
module.exports["JIRA_HAM_AI_INSIGHTS_PREVIEW_KEY"] = $e66d55c2753a8f61$export$1d10a8f57c7c69ae;
module.exports["ATLASSIAN_TEAM_UPDATE_ARCHIVE_KEY"] = $e66d55c2753a8f61$export$37572672766b68ab;
module.exports["SCHEDULED_CHAT_KEY"] = $e66d55c2753a8f61$export$88c32cc437966d51;

});

parcelRegister("5MDfE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dpPtd = parcelRequire("dpPtd");


var $a3fRD = parcelRequire("a3fRD");


var $2Nizw = parcelRequire("2Nizw");

var $2a2a91121a59b721$export$33c7ec07de4be904 = /*#__PURE__*/ function(StoreErrorFlagId) {
    StoreErrorFlagId["CONVERSATION_FORBIDDEN"] = "conversationForbidden";
    return StoreErrorFlagId;
}({});
const $2a2a91121a59b721$export$4610738c067a7645 = ()=>{
    const { showFlag: showFlagFromFlags } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const showFlag = (0, $42omo.useCallback)((flagId)=>{
        switch(flagId){
            case "conversationForbidden":
                showFlagFromFlags({
                    id: 'conversation-assistant.conversation-forbidden',
                    title: formatMessage((0, $2Nizw.default).conversationForbiddenTitle),
                    description: formatMessage((0, $2Nizw.default).conversationForbiddenDescription),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                        color: "var(--ds-icon-danger, #C9372C)",
                        label: ""
                    }),
                    isAutoDismiss: true
                });
                break;
        }
    }, [
        showFlagFromFlags,
        formatMessage
    ]);
    return showFlag;
};
module.exports["StoreErrorFlagId"] = $2a2a91121a59b721$export$33c7ec07de4be904;
module.exports["useShowStoreErrorFlag"] = $2a2a91121a59b721$export$4610738c067a7645;

});

parcelRegister("2Nizw", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $92b5895e6b5aadfd$var$message = (0, $aXWIB.defineMessages)({
    conversationForbiddenTitle: {
        id: "ai-mate.conversation-assistant.flag.conversation-forbidden.title",
        defaultMessage: "This conversation is not available"
    },
    conversationForbiddenDescription: {
        id: "ai-mate.conversation-assistant.flag.conversation-forbidden.description",
        defaultMessage: "The conversation you tried to open may belong to another user or you may not have permission to view it."
    },
    autoConversationPrompt: {
        id: "ai-mate.conversation-assistant.auto-conversation.prompt",
        defaultMessage: "Hey Rovo, list three things you can do with my work that will make me more effective this week."
    }
});
var $92b5895e6b5aadfd$export$2e2bcd8739ae039 = $92b5895e6b5aadfd$var$message;
module.exports["default"] = $92b5895e6b5aadfd$export$2e2bcd8739ae039;

});

parcelRegister("1K4cm", function(module, exports) {

var $kyiqo = parcelRequire("kyiqo");

const $bbc0ec2f964cbf02$var$SEND_MESSAGE_METRICS_KEY = 'ai-mate.send-message';
const $bbc0ec2f964cbf02$var$TIME_TO_FIRST_ANSWER_PART_METRICS_KEY = 'ai-mate.time-to-first-answer-part';
const $bbc0ec2f964cbf02$var$TIME_TO_FIRST_ACTION_PART_METRICS_KEY = 'ai-mate.time-to-first-action-part';
const $bbc0ec2f964cbf02$var$TIME_TO_ACTION_COMPLETION_METRICS_KEY = 'ai-mate.time-to-action-completion';
// Reconnection metrics
const $bbc0ec2f964cbf02$var$TIME_TO_CONNECT_TO_STREAM_METRICS_KEY = 'ai-mate.reconnect.time-to-connect-to-stream';
const $bbc0ec2f964cbf02$var$TIME_TO_FIRST_CHUNK_RECEIVED_METRICS_KEY = 'ai-mate.reconnect.time-to-first-chunk-received';
const $bbc0ec2f964cbf02$export$86db56030b57ba34 = {
    initializeChannels: (0, $kyiqo.metrics).interaction({
        key: 'ai-mate.initialize-channels'
    }),
    timeToRenderMessageContent: (0, $kyiqo.metrics).interaction({
        key: 'ai-mate.time-to-render-message-content'
    }),
    timeToRenderFinalResponse: (0, $kyiqo.metrics).interaction({
        key: 'ai-mate.time-to-render-final-response'
    }),
    sendConfirmedToolsTimeToFinishStream: (0, $kyiqo.metrics).interaction({
        key: 'ai-mate.send-confirmed-tools.time-to-finish-stream'
    }),
    sendConfirmedToolsTimeToFirstAnswerPart: (0, $kyiqo.metrics).interaction({
        key: 'ai-mate.send-confirmed-tools.time-to-first-answer-part'
    }),
    messageCompositionTime: (0, $kyiqo.metrics).interaction({
        key: 'ai-mate.message-composition-time'
    })
};
const $bbc0ec2f964cbf02$export$72bdd99dfc759d06 = (baseName, { deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, isRovoCustomAgent: isRovoCustomAgent })=>{
    if (isRovoCustomAgent) return `${baseName}.rovo-custom-agent`;
    if (deepResearchEnabled) return `${baseName}.deep-research`;
    if (thinkDeeperEnabled) return `${baseName}.think-deeper`;
    return baseName;
};
const $bbc0ec2f964cbf02$export$1e4d1659c4209dbf = {
    createSendMessageMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: $bbc0ec2f964cbf02$export$72bdd99dfc759d06($bbc0ec2f964cbf02$var$SEND_MESSAGE_METRICS_KEY, params)
        });
    },
    createTimeToFirstAnswerPartMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: $bbc0ec2f964cbf02$export$72bdd99dfc759d06($bbc0ec2f964cbf02$var$TIME_TO_FIRST_ANSWER_PART_METRICS_KEY, params)
        });
    },
    createTimeToFirstActionPartMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: $bbc0ec2f964cbf02$export$72bdd99dfc759d06($bbc0ec2f964cbf02$var$TIME_TO_FIRST_ACTION_PART_METRICS_KEY, params)
        });
    },
    createTimeToActionCompletionMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: $bbc0ec2f964cbf02$export$72bdd99dfc759d06($bbc0ec2f964cbf02$var$TIME_TO_ACTION_COMPLETION_METRICS_KEY, params)
        });
    }
};
const $bbc0ec2f964cbf02$export$924cdb4a6542ccd = {
    createTimeToConnectToStreamMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: $bbc0ec2f964cbf02$export$72bdd99dfc759d06($bbc0ec2f964cbf02$var$TIME_TO_CONNECT_TO_STREAM_METRICS_KEY, params)
        });
    },
    createTimeToResumeStreamMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: $bbc0ec2f964cbf02$export$72bdd99dfc759d06($bbc0ec2f964cbf02$var$TIME_TO_FIRST_CHUNK_RECEIVED_METRICS_KEY, params)
        });
    }
};
const $bbc0ec2f964cbf02$export$4841ee9a7190fdf6 = {
    createDeadAirIntervalMetrics: ()=>{
        return (0, $kyiqo.metrics).interaction({
            key: 'ai-mate.dead-air-interval'
        });
    },
    createDeadAirMaxMetrics: ()=>{
        return (0, $kyiqo.metrics).interaction({
            key: 'ai-mate.dead-air-max'
        });
    }
};
const $bbc0ec2f964cbf02$export$d077ccae10682bac = {
    createViewDeadAirMetrics: ()=>{
        return (0, $kyiqo.metrics).interaction({
            key: 'ai-mate.view-dead-air'
        });
    }
};
module.exports["interactionMetrics"] = $bbc0ec2f964cbf02$export$86db56030b57ba34;
module.exports["messageLatencyMetrics"] = $bbc0ec2f964cbf02$export$1e4d1659c4209dbf;
module.exports["reconnectionMetrics"] = $bbc0ec2f964cbf02$export$924cdb4a6542ccd;
module.exports["deadAirMetrics"] = $bbc0ec2f964cbf02$export$4841ee9a7190fdf6;
module.exports["viewDeadAirMetrics"] = $bbc0ec2f964cbf02$export$d077ccae10682bac;

});

parcelRegister("9likX", function(module, exports) {
const $e89354fc9dc00005$export$9f198c0729e6b053 = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, taskModeEnabled: taskModeEnabled, fastModeEnabled: fastModeEnabled })=>{
    if (deepResearchEnabled) return 'deep_research';
    if (thinkDeeperEnabled || alphaExtendedThinkingMode) return 'think_deeper';
    if (taskModeEnabled) return 'max';
    if (fastModeEnabled) return 'fast';
    return 'auto';
};
const $e89354fc9dc00005$export$3ac8b179c5bae1cb = (metadata)=>metadata?.interaction_mode_executed ?? undefined;
const $e89354fc9dc00005$export$41ee2caec24cebc0 = (message)=>$e89354fc9dc00005$export$3ac8b179c5bae1cb(message?.message_metadata);
const $e89354fc9dc00005$export$c13c17c66364de2d = (streamResponse)=>$e89354fc9dc00005$export$41ee2caec24cebc0(streamResponse?.message?.message);
const $e89354fc9dc00005$export$bab8a3e4fa0b7d89 = (storeAssistant)=>$e89354fc9dc00005$export$c13c17c66364de2d(storeAssistant?.content);
const $e89354fc9dc00005$export$2f438a4a7bbfabc = (interactionModeRequested)=>interactionModeRequested ? {
        interactionModeRequested: interactionModeRequested
    } : {};
const $e89354fc9dc00005$export$420f5414c6aecb85 = (interactionModeExecuted)=>interactionModeExecuted ? {
        interactionModeExecuted: interactionModeExecuted
    } : {};
module.exports["getInteractionModeRequested"] = $e89354fc9dc00005$export$9f198c0729e6b053;
module.exports["getInteractionModeExecutedFromStreamResponse"] = $e89354fc9dc00005$export$c13c17c66364de2d;
module.exports["getInteractionModeExecutedFromStoreAssistant"] = $e89354fc9dc00005$export$bab8a3e4fa0b7d89;
module.exports["interactionModeRequestedAttributes"] = $e89354fc9dc00005$export$2f438a4a7bbfabc;
module.exports["interactionModeExecutedAttributes"] = $e89354fc9dc00005$export$420f5414c6aecb85;

});

parcelRegister("deF0K", function(module, exports) {
// ============================================================================
// ACTIONS that are shared between Confluence and Jira
// ============================================================================

var $dh538 = parcelRequire("dh538");


var $8IKbl = parcelRequire("8IKbl");


var $bPHr8 = parcelRequire("bPHr8");


var $cBrev = parcelRequire("cBrev");


var $3vCSA = parcelRequire("3vCSA");


var $htiKQ = parcelRequire("htiKQ");


var $9bF5n = parcelRequire("9bF5n");

const $665803f9684f4c9f$export$992a8e659d5a1252 = (action)=>typeof action === 'object' && action !== null && 'key' in action;
const $665803f9684f4c9f$export$74f7c5137689c9a9 = (action)=>(0, $3vCSA.isConfluenceCreateNewAction)(action) || (0, $htiKQ.isJiraCreatableAction)(action) || (0, $9bF5n.isJsmCreatableAction)(action) || (0, $3vCSA.isDynamicUiCreatableAction)(action) || (0, $3vCSA.isImageCreatableAction)(action) || (0, $cBrev.isAvpPreviewCardAction)(action);
const $665803f9684f4c9f$export$8244c8e5412f2a57 = (message)=>(0, $3vCSA.isDynamicUiCreatableAction)(message) && !(0, $3vCSA.isDynamicUiUpdateActionData)(message.data) || (0, $3vCSA.isImageCreatableAction)(message) && !(0, $3vCSA.isImageUpdateActionData)(message.data);
const $665803f9684f4c9f$export$95acec44a3c80403 = (action)=>(0, $3vCSA.isConfluenceUpdatableAction)(action) || (0, $htiKQ.isJiraUpdatableAction)(action) || (0, $9bF5n.isJsmUpdatableAction)(action);
const $665803f9684f4c9f$export$473ed8cdfdfcd6f4 = (action)=>$665803f9684f4c9f$export$74f7c5137689c9a9(action) || $665803f9684f4c9f$export$95acec44a3c80403(action);
const $665803f9684f4c9f$export$a4e95791cb217646 = (action)=>{
    return (0, $3vCSA.getConfluenceContentType)(action) ?? (0, $htiKQ.getJiraContentType)(action) ?? (0, $9bF5n.getJsmContentType)(action) ?? 'unknown';
};
const $665803f9684f4c9f$export$29736db3162547c8 = (action)=>(0, $8IKbl.ACTIONS_HIDING_FOOTER_BUTTONS).has(action.key);
const $665803f9684f4c9f$export$154eb84770532af2 = (action)=>(0, $3vCSA.isConfluenceStreamAction)(action) || (0, $htiKQ.isJiraStreamAction)(action) || (0, $9bF5n.isJsmStreamAction)(action) || (0, $cBrev.isAvpStreamAction)(action);
const $665803f9684f4c9f$export$1382aef9948f8fc7 = (action)=>(0, $3vCSA.isConfluencePreviewCardAction)(action) || (0, $htiKQ.isJiraPreviewCardAction)(action) || (0, $9bF5n.isJsmPreviewCardAction)(action) || (0, $3vCSA.isDynamicUiCreatableAction)(action) || (0, $3vCSA.isImageCreatableAction)(action) || (0, $cBrev.isAvpPreviewCardAction)(action);
const $665803f9684f4c9f$export$681cf9ea58de88fd = (action, identifier)=>{
    if (!(0, $dh538.fg)('jira_aifc_enabled')) return (0, $3vCSA.generateRovoReceiverId)(action, identifier ?? '');
    if (!$665803f9684f4c9f$export$992a8e659d5a1252(action)) return undefined;
    if ((0, $htiKQ.isJiraAction)(action)) return (0, $htiKQ.generateJiraReceiverId)(action);
    if ((0, $9bF5n.isJsmAction)(action) && (0, $dh538.fg)('surveys-aifc')) return (0, $9bF5n.generateJsmReceiverId)(action);
    return (0, $3vCSA.generateRovoReceiverId)(action, identifier ?? '');
};
const $665803f9684f4c9f$export$ea699f0d7930d4d4 = ({ action: action, isContentPreviewSupported: isContentPreviewSupported })=>{
    if ((0, $dh538.fg)('aifc_create_enabled')) return !$665803f9684f4c9f$export$154eb84770532af2({
        key: action.key
    }) && !(0, $htiKQ.isJiraCreatableAction)({
        key: action.key
    }) && !(0, $9bF5n.isJsmCreatableAction)({
        key: action.key
    }) && !(0, $cBrev.isAvpPreviewCardAction)({
        key: action.key
    });
    if (!isContentPreviewSupported && !(0, $dh538.fg)('aifc_create_enabled')) return !$665803f9684f4c9f$export$1382aef9948f8fc7(action);
    return true;
};
function $665803f9684f4c9f$export$d94ea083820ef679(messages, invocationId) {
    return messages.find((msg)=>(0, $bPHr8.isStoreAssistant)(msg) && !!msg.content.message.message.actions?.some((action)=>action.invocationId === invocationId));
}
module.exports["isCreatableAction"] = $665803f9684f4c9f$export$74f7c5137689c9a9;
module.exports["isEphemeralCreateAction"] = $665803f9684f4c9f$export$8244c8e5412f2a57;
module.exports["isUpdatableAction"] = $665803f9684f4c9f$export$95acec44a3c80403;
module.exports["isAIFCAction"] = $665803f9684f4c9f$export$473ed8cdfdfcd6f4;
module.exports["getAIFCContentType"] = $665803f9684f4c9f$export$a4e95791cb217646;
module.exports["isActionHidingFooterButtons"] = $665803f9684f4c9f$export$29736db3162547c8;
module.exports["isSupportedStreamAction"] = $665803f9684f4c9f$export$154eb84770532af2;
module.exports["isPreviewCardAction"] = $665803f9684f4c9f$export$1382aef9948f8fc7;
module.exports["generateRovoReceiverId"] = $665803f9684f4c9f$export$681cf9ea58de88fd;
module.exports["findMessageByInvocationId"] = $665803f9684f4c9f$export$d94ea083820ef679;

});

parcelRegister("cBrev", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $a881abcb3d17fd39$export$3e0063b4c9eccd95 = 'avp_chart_create';
function $a881abcb3d17fd39$export$144269edab6271d9(data) {
    if (typeof data !== 'object' || data === null) return false;
    const d = data;
    const chartData = d.chartData;
    if (typeof chartData !== 'object' || chartData === null) return false;
    const cd = chartData;
    return typeof d.dashboardAri === 'string' && typeof cd.chart === 'object' && cd.chart !== null && typeof cd.canvasLayout === 'object' && cd.canvasLayout !== null;
}
const $a881abcb3d17fd39$export$2faa8f3a24d96e39 = 'avp_chart_delete';
function $a881abcb3d17fd39$export$9f17310825a1a178(data) {
    if (typeof data !== 'object' || data === null || !(0, $dh538.fg)('platform_avp_aifc_enabled')) return false;
    const d = data;
    return typeof d.dashboardAri === 'string' && typeof d.chartId === 'string' && typeof d.canvasLayout === 'object' && d.canvasLayout !== null;
}
const $a881abcb3d17fd39$export$a01e31e7aead77c1 = 'avp_chart_update';
function $a881abcb3d17fd39$export$db13f09592330b3b(data) {
    if (typeof data !== 'object' || data === null || !(0, $dh538.fg)('platform_avp_aifc_enabled')) return false;
    const d = data;
    if (typeof d.dashboardAri !== 'string' || typeof d.chartId !== 'string') return false;
    const chartData = d.chartData;
    if (typeof chartData !== 'object' || chartData === null) return false;
    const cd = chartData;
    return typeof cd.chart === 'object' && cd.chart !== null;
}
const $a881abcb3d17fd39$var$isStringArray = (value)=>Array.isArray(value) && value.every((item)=>typeof item === 'string');
const $a881abcb3d17fd39$var$isAvpFilterExpressionPayload = (data)=>{
    if (typeof data !== 'object' || data === null || !(0, $dh538.fg)('platform_avp_aifc_enabled')) return false;
    const d = data;
    return typeof d.dashboardAri === 'string' && (d.filterExpression === null || typeof d.filterExpression === 'object' && d.filterExpression !== null);
};
const $a881abcb3d17fd39$export$37d8bc8514392efa = 'avp_dashboard_create_filter';
function $a881abcb3d17fd39$export$a21637e45432b3cd(data) {
    if (!$a881abcb3d17fd39$var$isAvpFilterExpressionPayload(data)) return false;
    const d = data;
    return d.expressionIds === undefined || $a881abcb3d17fd39$var$isStringArray(d.expressionIds);
}
const $a881abcb3d17fd39$export$1e6353bd95c91843 = 'avp_dashboard_delete_filter';
function $a881abcb3d17fd39$export$9a3f223399a3708c(data) {
    if (!$a881abcb3d17fd39$var$isAvpFilterExpressionPayload(data)) return false;
    const d = data;
    return $a881abcb3d17fd39$var$isStringArray(d.expressionIds);
}
const $a881abcb3d17fd39$export$72caf49a260f725e = 'avp_dashboard_update_filter';
function $a881abcb3d17fd39$export$c6efee5e04349169(data) {
    if (!$a881abcb3d17fd39$var$isAvpFilterExpressionPayload(data)) return false;
    const d = data;
    return typeof d.expressionId === 'string';
}
const $a881abcb3d17fd39$export$e36a63f9bc6ec9d9 = 'avp_dashboard_remove_row';
function $a881abcb3d17fd39$export$b8981fb8c2b2ceae(data) {
    if (typeof data !== 'object' || data === null || !(0, $dh538.fg)('platform_avp_aifc_enabled')) return false;
    const d = data;
    return typeof d.dashboardAri === 'string' && typeof d.rowId === 'string' && typeof d.canvasLayout === 'object' && d.canvasLayout !== null;
}
const $a881abcb3d17fd39$export$e21300173aaa5a75 = 'avp_dashboard_remove_element';
function $a881abcb3d17fd39$export$393c0a783fee1203(data) {
    if (typeof data !== 'object' || data === null || !(0, $dh538.fg)('platform_avp_aifc_enabled')) return false;
    const d = data;
    return typeof d.dashboardAri === 'string' && typeof d.elementId === 'string' && typeof d.canvasLayout === 'object' && d.canvasLayout !== null;
}
const $a881abcb3d17fd39$export$5860e19fc7aa5d00 = 'avp_dashboard_create';
function $a881abcb3d17fd39$export$eca0d9c93fb8ccc3(data) {
    if (typeof data !== 'object' || data === null) return false;
    const d = data;
    return typeof d.dashboardUrl === 'string' && typeof d.dashboardAri === 'string';
}
// ============================================================================
// AVP ACTION CLASSIFICATION
// ============================================================================
const $a881abcb3d17fd39$var$AVP_CREATABLE_ACTION_KEYS = new Set([
    $a881abcb3d17fd39$export$3e0063b4c9eccd95,
    $a881abcb3d17fd39$export$5860e19fc7aa5d00,
    $a881abcb3d17fd39$export$37d8bc8514392efa
]);
const $a881abcb3d17fd39$var$AVP_PREVIEW_CARD_ACTION_KEYS = new Set([
    $a881abcb3d17fd39$export$5860e19fc7aa5d00
]);
const $a881abcb3d17fd39$export$6b9e1da20a0f005c = (action)=>$a881abcb3d17fd39$var$AVP_PREVIEW_CARD_ACTION_KEYS.has(action.key);
const $a881abcb3d17fd39$var$AVP_DELETABLE_ACTION_KEYS = new Set([
    $a881abcb3d17fd39$export$2faa8f3a24d96e39,
    $a881abcb3d17fd39$export$e21300173aaa5a75,
    $a881abcb3d17fd39$export$e36a63f9bc6ec9d9,
    $a881abcb3d17fd39$export$1e6353bd95c91843
]);
const $a881abcb3d17fd39$var$AVP_UPDATABLE_ACTION_KEYS = new Set([
    $a881abcb3d17fd39$export$a01e31e7aead77c1,
    $a881abcb3d17fd39$export$72caf49a260f725e
]);
const $a881abcb3d17fd39$export$d69ccc6d462afdf8 = (action)=>$a881abcb3d17fd39$var$AVP_CREATABLE_ACTION_KEYS.has(action.key);
const $a881abcb3d17fd39$export$edc9f9dece97635 = (action)=>$a881abcb3d17fd39$var$AVP_DELETABLE_ACTION_KEYS.has(action.key);
const $a881abcb3d17fd39$export$a2d39e4b08e0e68d = (action)=>$a881abcb3d17fd39$var$AVP_UPDATABLE_ACTION_KEYS.has(action.key);
const $a881abcb3d17fd39$export$ebb904732b24f004 = (action)=>$a881abcb3d17fd39$export$d69ccc6d462afdf8(action) || $a881abcb3d17fd39$export$edc9f9dece97635(action) || $a881abcb3d17fd39$export$a2d39e4b08e0e68d(action);
module.exports["AVP_CHART_CREATE_KEY"] = $a881abcb3d17fd39$export$3e0063b4c9eccd95;
module.exports["isAvpChartCreateActionData"] = $a881abcb3d17fd39$export$144269edab6271d9;
module.exports["AVP_CHART_DELETE_KEY"] = $a881abcb3d17fd39$export$2faa8f3a24d96e39;
module.exports["isAvpChartDeleteActionData"] = $a881abcb3d17fd39$export$9f17310825a1a178;
module.exports["AVP_CHART_UPDATE_KEY"] = $a881abcb3d17fd39$export$a01e31e7aead77c1;
module.exports["isAvpChartUpdateActionData"] = $a881abcb3d17fd39$export$db13f09592330b3b;
module.exports["AVP_FILTER_EXPRESSION_CREATE_KEY"] = $a881abcb3d17fd39$export$37d8bc8514392efa;
module.exports["isAvpFilterExpressionCreateActionData"] = $a881abcb3d17fd39$export$a21637e45432b3cd;
module.exports["AVP_FILTER_EXPRESSION_DELETE_KEY"] = $a881abcb3d17fd39$export$1e6353bd95c91843;
module.exports["isAvpFilterExpressionDeleteActionData"] = $a881abcb3d17fd39$export$9a3f223399a3708c;
module.exports["AVP_FILTER_EXPRESSION_UPDATE_KEY"] = $a881abcb3d17fd39$export$72caf49a260f725e;
module.exports["isAvpFilterExpressionUpdateActionData"] = $a881abcb3d17fd39$export$c6efee5e04349169;
module.exports["AVP_DASHBOARD_REMOVE_ROW_KEY"] = $a881abcb3d17fd39$export$e36a63f9bc6ec9d9;
module.exports["isAvpDashboardRemoveRowActionData"] = $a881abcb3d17fd39$export$b8981fb8c2b2ceae;
module.exports["AVP_DASHBOARD_REMOVE_ELEMENT_KEY"] = $a881abcb3d17fd39$export$e21300173aaa5a75;
module.exports["isAvpDashboardRemoveElementActionData"] = $a881abcb3d17fd39$export$393c0a783fee1203;
module.exports["AVP_DASHBOARD_CREATE_KEY"] = $a881abcb3d17fd39$export$5860e19fc7aa5d00;
module.exports["isAvpDashboardCreateActionData"] = $a881abcb3d17fd39$export$eca0d9c93fb8ccc3;
module.exports["isAvpPreviewCardAction"] = $a881abcb3d17fd39$export$6b9e1da20a0f005c;
module.exports["isAvpStreamAction"] = $a881abcb3d17fd39$export$ebb904732b24f004;

});

parcelRegister("htiKQ", function(module, exports) {
// ============================================================================
// JIRA SMART ISSUE CREATE
// ============================================================================

var $8IKbl = parcelRequire("8IKbl");


var $eX3ET = parcelRequire("eX3ET");

const $97b023c268fae936$export$5f099b7754a7652a = [
    (0, $8IKbl.JIRA_FIND_ISSUES_KEY),
    (0, $8IKbl.JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY),
    (0, $8IKbl.JSM_CREATE_REQUEST_KEY),
    (0, $8IKbl.JSM_CREATE_REQUEST_V2_KEY),
    (0, $8IKbl.JSM_CREATE_EMBEDDED_REQUEST_KEY),
    (0, $8IKbl.JIRA_ISSUE_TRANSITION_KEY),
    (0, $8IKbl.JIRA_EPICS_SUGGEST_KEY),
    (0, $8IKbl.JIRA_ISSUE_DELETE_KEY),
    (0, $8IKbl.JIRA_ISSUE_MOVE_KEY),
    (0, $8IKbl.JIRA_ISSUE_ASSIGN_KEY),
    (0, $8IKbl.JIRA_VERSION_CREATE_KEY),
    (0, $8IKbl.JIRA_HAM_AI_INSIGHTS_PREVIEW_KEY)
];
const $97b023c268fae936$export$29b82f3d15178d30 = new Set($97b023c268fae936$export$5f099b7754a7652a);
const $97b023c268fae936$export$211f4719f56285e9 = new Set([
    (0, $8IKbl.JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY)
]);
const $97b023c268fae936$export$d75519ce8257cbe3 = new Set([
    (0, $8IKbl.JIRA_HAM_AI_INSIGHTS_PREVIEW_KEY)
]);
const $97b023c268fae936$export$530aa0daf5811c30 = (action)=>{
    return typeof action === 'object' && action !== null && 'key' in action && $97b023c268fae936$export$29b82f3d15178d30.has(action?.['key']);
};
const $97b023c268fae936$export$b4d5023312147fc4 = (action)=>$97b023c268fae936$export$530aa0daf5811c30(action) && $97b023c268fae936$export$211f4719f56285e9.has(action.key);
const $97b023c268fae936$export$69c28e373f39b349 = (action)=>$97b023c268fae936$export$530aa0daf5811c30(action) && $97b023c268fae936$export$d75519ce8257cbe3.has(action.key);
const $97b023c268fae936$export$b5050b797265a8be = (action)=>false;
const $97b023c268fae936$export$a1a30289a72c78b1 = (action)=>false;
const $97b023c268fae936$export$6fe601f4a243e8f4 = (action)=>{
    if (!$97b023c268fae936$export$530aa0daf5811c30(action)) return undefined;
    if ($97b023c268fae936$export$b4d5023312147fc4(action)) return 0, $eX3ET.JIRA_SMART_CREATE_TABLE_CLIENT_ID;
    return undefined;
};
const $97b023c268fae936$export$1643c639e4c073b8 = (action)=>{
    const actionKey = action.key;
    if ($97b023c268fae936$export$211f4719f56285e9.has(actionKey)) return 'jira-issue-table';
    return undefined;
};
// ============================================================================
// JIRA PREVIEW CARDS
// ============================================================================
const $97b023c268fae936$var$PREVIEW_CARD_ACTION_KEYS = new Set([
    (0, $8IKbl.JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY)
]);
const $97b023c268fae936$export$4a1398b92436f797 = (action)=>$97b023c268fae936$var$PREVIEW_CARD_ACTION_KEYS.has(action.key);
module.exports["isJiraAction"] = $97b023c268fae936$export$530aa0daf5811c30;
module.exports["isJiraCreatableAction"] = $97b023c268fae936$export$b4d5023312147fc4;
module.exports["isJiraPreviewableAction"] = $97b023c268fae936$export$69c28e373f39b349;
module.exports["isJiraUpdatableAction"] = $97b023c268fae936$export$b5050b797265a8be;
module.exports["isJiraStreamAction"] = $97b023c268fae936$export$a1a30289a72c78b1;
module.exports["generateJiraReceiverId"] = $97b023c268fae936$export$6fe601f4a243e8f4;
module.exports["getJiraContentType"] = $97b023c268fae936$export$1643c639e4c073b8;
module.exports["isJiraPreviewCardAction"] = $97b023c268fae936$export$4a1398b92436f797;

});

parcelRegister("9bF5n", function(module, exports) {
// ============================================================================
// JSM CREATE SURVEY
// ============================================================================

var $dh538 = parcelRequire("dh538");


var $8IKbl = parcelRequire("8IKbl");


var $62lkj = parcelRequire("62lkj");


var $b9NdB = parcelRequire("b9NdB");

const $b06f6240a2781a94$export$4d5c499af23159fb = (0, $b9NdB.client)('jsm-queue-settings');





const $53c66121daab2d4a$export$c1a656e72d7a4bcc = (0, $b9NdB.client)('jsm-request-type-settings');





const $35e6ac4d589373ac$export$bd769f5be4601367 = (0, $b9NdB.client)('jsm-sla-settings');



var $3OJcK = parcelRequire("3OJcK");

const $7fdb7cabde039026$var$JSM_EMBED_VIEW_MAP = {
    [(0, $8IKbl.JSM_QUEUE_CREATE_KEY)]: {
        clientId: (0, $b06f6240a2781a94$export$4d5c499af23159fb),
        contentType: 'jsm-queue-updated'
    },
    [(0, $8IKbl.JSM_QUEUE_UPDATE_KEY)]: {
        clientId: (0, $b06f6240a2781a94$export$4d5c499af23159fb),
        contentType: 'jsm-queue-updated'
    },
    [(0, $8IKbl.JSM_REQUEST_TYPE_UPDATED_KEY)]: {
        clientId: (0, $53c66121daab2d4a$export$c1a656e72d7a4bcc),
        contentType: 'jsm-request-type-updated'
    },
    [(0, $8IKbl.JSM_SLA_CREATE_KEY)]: {
        clientId: (0, $35e6ac4d589373ac$export$bd769f5be4601367),
        contentType: 'jsm-sla-updated'
    },
    [(0, $8IKbl.JSM_SLA_UPDATE_KEY)]: {
        clientId: (0, $35e6ac4d589373ac$export$bd769f5be4601367),
        contentType: 'jsm-sla-updated'
    },
    [(0, $8IKbl.JSM_SUGGEST_AND_ADD_FIELDS_TO_REQUEST_TYPE_KEY)]: {
        clientId: (0, $53c66121daab2d4a$export$c1a656e72d7a4bcc),
        contentType: 'jsm-request-type-updated'
    }
};
const $7fdb7cabde039026$export$fd2af7ce2e351879 = [
    (0, $8IKbl.JSM_CREATE_EMBEDDED_REQUEST_KEY),
    (0, $8IKbl.JSM_CREATE_REQUEST_KEY),
    (0, $8IKbl.JSM_CREATE_REQUEST_V2_KEY),
    (0, $8IKbl.JSM_CREATE_SURVEY_KEY),
    (0, $8IKbl.JSM_QUEUE_CREATE_KEY),
    (0, $8IKbl.JSM_QUEUE_UPDATE_KEY),
    (0, $8IKbl.JSM_REQUEST_TYPE_UPDATED_KEY),
    (0, $8IKbl.JSM_SLA_CREATE_KEY),
    (0, $8IKbl.JSM_SLA_UPDATE_KEY),
    (0, $8IKbl.JSM_SUGGEST_AND_ADD_FIELDS_TO_REQUEST_TYPE_KEY)
];
const $7fdb7cabde039026$export$7b875f28b9805c0c = new Set($7fdb7cabde039026$export$fd2af7ce2e351879);
const $7fdb7cabde039026$export$3fcc5475955435c4 = new Set([
    (0, $8IKbl.JSM_CREATE_SURVEY_KEY),
    (0, $8IKbl.JSM_QUEUE_CREATE_KEY),
    (0, $8IKbl.JSM_QUEUE_UPDATE_KEY),
    (0, $8IKbl.JSM_REQUEST_TYPE_UPDATED_KEY),
    (0, $8IKbl.JSM_SUGGEST_AND_ADD_FIELDS_TO_REQUEST_TYPE_KEY)
]);
const $7fdb7cabde039026$var$isKbFromScratchActionKey = (actionKey)=>(actionKey === (0, $8IKbl.JSM_CREATE_KB_TOPICS_KEY) || actionKey === (0, $8IKbl.JSM_CREATE_KB_ARTICLES_KEY)) && (0, $dh538.fg)('jsm_kb_from_scratch');
const $7fdb7cabde039026$export$98885adfb17a807b = (action)=>{
    return typeof action === 'object' && action !== null && 'key' in action && ($7fdb7cabde039026$export$7b875f28b9805c0c.has(action?.['key']) || $7fdb7cabde039026$var$isKbFromScratchActionKey(action?.['key']));
};
const $7fdb7cabde039026$export$29f39e9429d6b955 = (action)=>$7fdb7cabde039026$export$98885adfb17a807b(action) && ($7fdb7cabde039026$export$3fcc5475955435c4.has(action.key) || $7fdb7cabde039026$var$isKbFromScratchActionKey(action.key));
const $7fdb7cabde039026$export$ae7904ebe7bd5bb0 = (action)=>false;
const $7fdb7cabde039026$export$f4d25026329e5a91 = (action)=>false;
const $7fdb7cabde039026$export$af2b121ccb8f1449 = (action)=>{
    if (!$7fdb7cabde039026$export$98885adfb17a807b(action)) return undefined;
    if ((0, $dh538.fg)('solution_composer_master')) {
        // Embed view actions — driven by lookup map
        const embedView = $7fdb7cabde039026$var$JSM_EMBED_VIEW_MAP[action.key];
        if (embedView) return embedView.clientId;
    }
    if ($7fdb7cabde039026$var$isKbFromScratchActionKey(action.key)) return 0, $62lkj.JSM_CREATE_KB_STAGING_AREA_CLIENT_ID;
    if ($7fdb7cabde039026$export$29f39e9429d6b955(action)) return 0, $3OJcK.JSM_CREATE_SURVEY_CLIENT_ID;
    return undefined;
};
const $7fdb7cabde039026$export$292f03726a3f6528 = (action)=>{
    const actionKey = action.key;
    if ((0, $dh538.fg)('solution_composer_master')) {
        // Embed view actions — driven by lookup map
        const embedView = $7fdb7cabde039026$var$JSM_EMBED_VIEW_MAP[actionKey];
        if (embedView) return embedView.contentType;
    }
    if ($7fdb7cabde039026$export$3fcc5475955435c4.has(actionKey) || $7fdb7cabde039026$var$isKbFromScratchActionKey(actionKey)) return 'jsm-create-survey';
    return undefined;
};
// ============================================================================
// JSM PREVIEW CARDS
// ============================================================================
const $7fdb7cabde039026$var$PREVIEW_CARD_ACTION_KEYS = new Set([
    (0, $8IKbl.JSM_CREATE_SURVEY_KEY)
]);
const $7fdb7cabde039026$export$c8683ba29b03d037 = (action)=>$7fdb7cabde039026$var$PREVIEW_CARD_ACTION_KEYS.has(action.key);
module.exports["isJsmAction"] = $7fdb7cabde039026$export$98885adfb17a807b;
module.exports["isJsmCreatableAction"] = $7fdb7cabde039026$export$29f39e9429d6b955;
module.exports["isJsmUpdatableAction"] = $7fdb7cabde039026$export$ae7904ebe7bd5bb0;
module.exports["isJsmStreamAction"] = $7fdb7cabde039026$export$f4d25026329e5a91;
module.exports["generateJsmReceiverId"] = $7fdb7cabde039026$export$af2b121ccb8f1449;
module.exports["getJsmContentType"] = $7fdb7cabde039026$export$292f03726a3f6528;
module.exports["isJsmPreviewCardAction"] = $7fdb7cabde039026$export$c8683ba29b03d037;

});

parcelRegister("62lkj", function(module, exports) {

var $b9NdB = parcelRequire("b9NdB");

const $2517e7f57717d029$export$91e704c2411cb3f5 = (0, $b9NdB.client)('jsm-create-kb');
const $2517e7f57717d029$export$ee04bc09e7068b43 = (0, $b9NdB.client)('jsm-create-kb-staging-area');
const $2517e7f57717d029$export$c608186adcac93ad = (0, $b9NdB.client)('jsm-create-kb-card');
module.exports["JSM_CREATE_KB_CLIENT_ID"] = $2517e7f57717d029$export$91e704c2411cb3f5;
module.exports["JSM_CREATE_KB_STAGING_AREA_CLIENT_ID"] = $2517e7f57717d029$export$ee04bc09e7068b43;
module.exports["JSM_KB_CARD_CLIENT_ID"] = $2517e7f57717d029$export$c608186adcac93ad;

});

parcelRegister("4eSde", function(module, exports) {

var $16lEl = parcelRequire("16lEl");


var $dgaTK = parcelRequire("dgaTK");

const $487e3aa6cdc75eb3$export$24a03a39abc3110e = ()=>{
    const additionalAttributes = {
        isInitialDataReceived: null
    };
    const subExperienceCollect = (0, $dgaTK.collectAllWithSubExperienceAttributes)([
        (0, $16lEl.ExperienceName).AIFC_MESSAGE,
        (0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED
    ], additionalAttributes);
    return (events, experience)=>{
        for (const event of events)if (event.name === (0, $16lEl.ExperienceName).AIFC_INITIAL_DATA_RECEIVED) {
            if (event.action === 'taskSuccess') additionalAttributes.isInitialDataReceived = true;
            else if (event.action === 'taskFail') additionalAttributes.isInitialDataReceived = false;
        }
        // If AIFC_INITIAL_DATA_RECEIVED fails, fail AIFC_GENERATE_CONTENT
        (0, $dgaTK.failExperienceOnSubExperienceFail)((0, $16lEl.ExperienceName).AIFC_INITIAL_DATA_RECEIVED, experience, events, additionalAttributes);
        subExperienceCollect(events, experience);
    };
};
module.exports["createAifcExperienceCollect"] = $487e3aa6cdc75eb3$export$24a03a39abc3110e;

});

parcelRegister("1cjt9", function(module, exports) {
const $5f7f03ab221db6a4$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC',
    actor_type: 'AGENT',
    user_defined_conversation_starters: [],
    favourite: false,
    deactivated: false
};
module.exports["DEFAULT_AGENT"] = $5f7f03ab221db6a4$export$48783720d93c2d26;

});

parcelRegister("eWKku", function(module, exports) {

var $1yaYZ = parcelRequire("1yaYZ");


var $fgOJ7 = parcelRequire("fgOJ7");


var $l30d8 = parcelRequire("l30d8");


var $eL1ct = parcelRequire("eL1ct");


var $6nGJw = parcelRequire("6nGJw");


var $hHa70 = parcelRequire("hHa70");


var $gdg5T = parcelRequire("gdg5T");


var $15h8H = parcelRequire("15h8H");

var $75cf7fb40a3fb800$export$680ab500cb1105eb = /*#__PURE__*/ function(StreamLifecycleState) {
    StreamLifecycleState["COMPLETED"] = "completed";
    StreamLifecycleState["ERRORED"] = "errored";
    StreamLifecycleState["ABORTED"] = "aborted";
    return StreamLifecycleState;
}({});
const $75cf7fb40a3fb800$export$ff6a2981a5436d75 = (status, streamId, content)=>{
    if (!content) return;
    const api = (0, $15h8H.getBrowserBridgeAPI)();
    const id = String(content.id);
    const receiverId = (()=>{
        switch(content.type){
            case 'page':
                return (0, $eL1ct.getConfluenceEditorClientId)(id);
            case 'database':
                return (0, $fgOJ7.getConfluenceDatabaseClientId)(id);
            case 'whiteboard':
                return (0, $6nGJw.getConfluenceWhiteboardClientId)(id);
            case 'slide':
                return (0, $l30d8.getConfluenceSlidesClientId)(id);
            default:
                return undefined;
        }
    })();
    try {
        if (!receiverId) return;
        switch(status){
            case "completed":
                api.send((0, $gdg5T.RovoStreamCompletedCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $hHa70.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId
                });
                break;
            case "errored":
                api.send((0, $gdg5T.RovoStreamErroredCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $hHa70.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId
                });
                break;
            case "aborted":
                api.send((0, $gdg5T.RovoStreamAbortedCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $hHa70.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId
                });
                break;
            default:
                (0, $1yaYZ.logException)({
                    exception: new Error(`Unknown stream lifecycle state: ${status}`),
                    name: 'UnknownStreamLifecycleState'
                });
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $1yaYZ.logException)({
            exception: error,
            name: 'SendStreamLifecycleCommandError'
        });
    }
};
module.exports["StreamLifecycleState"] = $75cf7fb40a3fb800$export$680ab500cb1105eb;
module.exports["broadcastStreamStatus"] = $75cf7fb40a3fb800$export$ff6a2981a5436d75;

});

parcelRegister("ceMRi", function(module, exports) {
/**
 * Minimum interval threshold in milliseconds.
 * Intervals at or below this threshold are excluded from dead air tracking.
 */ const $c9147b3ca7c52e0c$export$a47f8ff651baafd3 = 20;
const $c9147b3ca7c52e0c$export$1dad78007a379433 = (intervalMs)=>{
    return intervalMs <= $c9147b3ca7c52e0c$export$a47f8ff651baafd3;
};
module.exports["shouldExcludeInterval"] = $c9147b3ca7c52e0c$export$1dad78007a379433;

});

parcelRegister("cteoa", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $bOrYy = parcelRequire("bOrYy");


var $1oCLl = parcelRequire("1oCLl");


var $deF0K = parcelRequire("deF0K");


var $3vCSA = parcelRequire("3vCSA");


var $4pEXC = parcelRequire("4pEXC");

/**
 * Rewrites HTML `<details>` / `<summary>` collapsed sections embedded in
 * markdown into the Rovo-native boundary format that the rest of the stream
 * pipeline already understands.
 *
 *   <details><summary>Title</summary>Body</details>  →  ▞Title\nBody▚
 *
 * Downstream, the existing `expand` streamable component (see
 * `getStreamableComponents` in `chat-store/utils.ts`) picks up `▞…▚`, swaps
 * in the `[^expand^]` placeholder, and renders the body out-of-band through
 * `markdownData`.
 *
 * Spec reference: the HTML `<details>` element (rendered as a disclosure
 * widget) and its `<summary>` child, as documented by MDN and supported by
 * common markdown renderers.
 *
 * Known limitations (V1):
 *  - Code-fence aware rewriting is not implemented. A `<details>` block
 *    embedded inside a ``` code fence will still be rewritten. Agents
 *    producing collapsed sections generally don't do this, but if it becomes
 *    a real problem the fence-tracking state machine from
 *    `sanitize-markdown.ts` can be ported here.
 *  - Nested `<details>` are passed through unchanged.
 */ const $534f3b959a2e27b2$var$DETAILS_OPEN_BOUNDARY = "\u259E";
const $534f3b959a2e27b2$var$DETAILS_CLOSE_BOUNDARY = "\u259A";
const $534f3b959a2e27b2$var$DEFAULT_TITLE = 'Details';
// Complete-tag matchers. Case-insensitive, allow attributes on open tags.
const $534f3b959a2e27b2$var$DETAILS_OPEN_RE = /^<details(?:\s[^>]*)?>$/i;
const $534f3b959a2e27b2$var$SUMMARY_OPEN_RE = /^<summary(?:\s[^>]*)?>$/i;
const $534f3b959a2e27b2$var$SUMMARY_CLOSE_RE = /^<\/summary\s*>$/i;
const $534f3b959a2e27b2$var$DETAILS_CLOSE_RE = /^<\/details\s*>$/i;
// Fast-path probe: if the text cannot possibly contain a relevant tag, skip
// the scan entirely.
const $534f3b959a2e27b2$var$HAS_RELEVANT_TAG_RE = /<\/?(?:details|summary)\b/i;
/**
 * Shared scan used by both the streaming and one-shot paths.
 *
 * When `allowBuffer` is `true`, a trailing incomplete tag (i.e. a `<` with
 * no subsequent `>`) is stashed on `state.buffer` for the next call instead
 * of being emitted. When `false` (flush / one-shot), the partial text is
 * emitted as literal.
 */ const $534f3b959a2e27b2$var$scan = (input, state, allowBuffer)=>{
    let out = '';
    let i = 0;
    const emitText = (text)=>{
        if (state.mode === 'IN_DETAILS_PRE_SUMMARY') // Silently discard text between `<details>` and `<summary>` (in
        // practice this is whitespace / newlines the agent formats for
        // readability).
        return;
        if (state.mode === 'IN_SUMMARY') {
            // Collapse newlines inside the summary so the downstream
            // `splitHeaderAndContent` (first-newline split) still sees a
            // single-line title.
            out += text.replace(/\r?\n/g, ' ');
            return;
        }
        out += text;
    };
    while(i < input.length){
        const lt = input.indexOf('<', i);
        if (lt === -1) {
            emitText(input.slice(i));
            break;
        }
        if (lt > i) emitText(input.slice(i, lt));
        const gt = input.indexOf('>', lt);
        if (gt === -1) {
            if (allowBuffer) {
                state.buffer = input.slice(lt);
                return out;
            }
            // One-shot path: emit the dangling partial tag as literal.
            emitText(input.slice(lt));
            break;
        }
        const tag = input.slice(lt, gt + 1);
        if ($534f3b959a2e27b2$var$DETAILS_OPEN_RE.test(tag)) {
            if (state.mode === 'NORMAL') state.mode = 'IN_DETAILS_PRE_SUMMARY';
            else // Nested or unexpected — pass through so we don't eat user text.
            emitText(tag);
        } else if ($534f3b959a2e27b2$var$SUMMARY_OPEN_RE.test(tag)) {
            if (state.mode === 'IN_DETAILS_PRE_SUMMARY') {
                state.mode = 'IN_SUMMARY';
                out += $534f3b959a2e27b2$var$DETAILS_OPEN_BOUNDARY;
            } else emitText(tag);
        } else if ($534f3b959a2e27b2$var$SUMMARY_CLOSE_RE.test(tag)) {
            if (state.mode === 'IN_SUMMARY') {
                state.mode = 'IN_DETAILS_BODY';
                out += '\n';
            } else emitText(tag);
        } else if ($534f3b959a2e27b2$var$DETAILS_CLOSE_RE.test(tag)) {
            if (state.mode === 'IN_DETAILS_BODY') {
                state.mode = 'NORMAL';
                out += $534f3b959a2e27b2$var$DETAILS_CLOSE_BOUNDARY;
            } else if (state.mode === 'IN_DETAILS_PRE_SUMMARY') {
                // `<details>…</details>` with no `<summary>`. Synthesise a
                // default header so the renderer has something to show.
                state.mode = 'NORMAL';
                out += `${$534f3b959a2e27b2$var$DETAILS_OPEN_BOUNDARY}${$534f3b959a2e27b2$var$DEFAULT_TITLE}\n${$534f3b959a2e27b2$var$DETAILS_CLOSE_BOUNDARY}`;
            } else if (state.mode === 'IN_SUMMARY') {
                // Malformed: `</details>` while still inside `<summary>`. Close
                // the summary implicitly and close the details.
                state.mode = 'NORMAL';
                out += `\n${$534f3b959a2e27b2$var$DETAILS_CLOSE_BOUNDARY}`;
            } else emitText(tag);
        } else // Unrelated tag (e.g. `<span>`, `<a href=…>`) — pass through.
        emitText(tag);
        i = gt + 1;
    }
    state.buffer = '';
    return out;
};
const $534f3b959a2e27b2$var$synthesiseClosers = (state)=>{
    let out = '';
    if (state.mode === 'IN_DETAILS_PRE_SUMMARY') out += `${$534f3b959a2e27b2$var$DETAILS_OPEN_BOUNDARY}${$534f3b959a2e27b2$var$DEFAULT_TITLE}\n${$534f3b959a2e27b2$var$DETAILS_CLOSE_BOUNDARY}`;
    else if (state.mode === 'IN_SUMMARY') out += `\n${$534f3b959a2e27b2$var$DETAILS_CLOSE_BOUNDARY}`;
    else if (state.mode === 'IN_DETAILS_BODY') out += $534f3b959a2e27b2$var$DETAILS_CLOSE_BOUNDARY;
    state.mode = 'NORMAL';
    return out;
};
const $534f3b959a2e27b2$export$c00e46a308694bc9 = (text)=>{
    if (!text || !$534f3b959a2e27b2$var$HAS_RELEVANT_TAG_RE.test(text)) return text;
    const state = {
        mode: 'NORMAL',
        buffer: ''
    };
    let out = $534f3b959a2e27b2$var$scan(text, state, /* allowBuffer */ false);
    out += $534f3b959a2e27b2$var$synthesiseClosers(state);
    return out;
};
const $534f3b959a2e27b2$export$88c7624283baadd3 = ()=>{
    const state = {
        mode: 'NORMAL',
        buffer: ''
    };
    return {
        process (chunk) {
            const combined = state.buffer + (chunk ?? '');
            state.buffer = '';
            // Fast-path: when we are not inside a details block and the combined
            // text contains no `<` at all, a tag is impossible — skip the scan.
            // We deliberately do NOT use a name-level regex here: a partial tag
            // like `<det` spanning a chunk boundary must still be buffered for
            // the next chunk to complete it.
            if (!combined || state.mode === 'NORMAL' && !combined.includes('<')) return combined;
            return $534f3b959a2e27b2$var$scan(combined, state, /* allowBuffer */ true);
        },
        flush () {
            let out = '';
            if (state.buffer) {
                const leftover = state.buffer;
                state.buffer = '';
                out += $534f3b959a2e27b2$var$scan(leftover, state, /* allowBuffer */ false);
            }
            out += $534f3b959a2e27b2$var$synthesiseClosers(state);
            return out;
        }
    };
};



var $7yZ5y = parcelRequire("7yZ5y");


var $16lEl = parcelRequire("16lEl");


var $8IKbl = parcelRequire("8IKbl");


var $ljUdP = parcelRequire("ljUdP");


var $flpNp = parcelRequire("flpNp");


var $aclUh = parcelRequire("aclUh");


var $2CHXX = parcelRequire("2CHXX");


var $bPHr8 = parcelRequire("bPHr8");


var $9vgbT = parcelRequire("9vgbT");


var $52Fo2 = parcelRequire("52Fo2");

const $6bf7a89ae376c5c9$export$ed5572b558d71438 = (ari)=>{
    if (!ari) return null;
    // see go/ari for possible values
    // Example:
    // ari:third-party:amplitude.amplitude::remote-link/org/{orgId}/chart/{chartId}
    // -> amplitude
    const ariParts = ari.split(':');
    if (ariParts.length < 3) return null;
    return ariParts[2];
};



var $iEWar = parcelRequire("iEWar");

// Only these classifications get the softer "no content" hint screen.
// Everything else (including missing or unknown) falls through to the error screen.
const $658a05ad0cb6a20b$var$ABORT_CLASSIFICATIONS = new Set([
    'BAD_USER_PROMPT',
    'GOOD_REPLY_NO_CREATE',
    'EXTERNAL_ERROR'
]);
const $658a05ad0cb6a20b$export$567fc7097e064344 = ()=>String(Math.floor(Math.random() * 1000000));
const $658a05ad0cb6a20b$export$b043b11900276452 = ({ broadcastStreamStatus: broadcastStreamStatus, chatContextStoreActions: chatContextStoreActions, contentContextValue: contentContextValue, targetId: targetId, assistantMessageId: assistantMessageId })=>{
    return (status)=>{
        let contentTarget;
        if ((0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true)) {
            // Use targetId from sendMessage if provided, otherwise fall back to currentTargetId
            const activeTargetId = targetId ?? chatContextStoreActions.getCurrentTargetId();
            contentTarget = chatContextStoreActions.getTarget(contentContextValue, activeTargetId);
        } else contentTarget = chatContextStoreActions.getTarget(contentContextValue, targetId);
        broadcastStreamStatus?.(status, assistantMessageId, contentTarget ? {
            id: contentTarget.id,
            type: contentTarget.type
        } : undefined);
    };
};
const $658a05ad0cb6a20b$export$9c657fdfae6b2020 = (messages, messageId)=>{
    const assistantMessage = messages.find((chatItem)=>(0, $bPHr8.isStoreAssistant)(chatItem) && (0, $aclUh.getId)(chatItem.content) === messageId);
    if (!assistantMessage) return '';
    const content = assistantMessage.content.message.message.content;
    return typeof content === 'string' ? content : '';
};
const $658a05ad0cb6a20b$export$bb0ca99caffb8502 = (messages, messageId)=>{
    return messages.map((chatItem)=>{
        if ((0, $bPHr8.isStoreAssistant)(chatItem) && $658a05ad0cb6a20b$var$getStoreMessageId(chatItem) === messageId) return {
            ...chatItem,
            content: {
                ...chatItem.content,
                message: {
                    ...chatItem.content.message,
                    message: {
                        ...chatItem.content.message.message,
                        content: ''
                    }
                },
                streamingComplete: false
            }
        };
        return chatItem;
    });
};
const $658a05ad0cb6a20b$export$d812e3ec408e3b14 = (messages, messageId, answerGenerationType)=>{
    return messages.map((chatItem)=>{
        if ((0, $bPHr8.isStoreAssistant)(chatItem) && $658a05ad0cb6a20b$var$getStoreMessageId(chatItem) === messageId) return {
            ...chatItem,
            content: {
                ...chatItem.content,
                message: {
                    ...chatItem.content.message,
                    message: {
                        ...chatItem.content.message.message
                    }
                },
                streamingComplete: false
            },
            answerGenerationType: answerGenerationType
        };
        return chatItem;
    });
};
const $658a05ad0cb6a20b$export$14aeb537f795ee1a = (messages, messageId, answerNowStatus)=>{
    return messages.map((chatItem)=>{
        if ((0, $bPHr8.isStoreAssistant)(chatItem) && $658a05ad0cb6a20b$var$getStoreMessageId(chatItem) === messageId) return {
            ...chatItem,
            answerNowStatus: answerNowStatus
        };
        return chatItem;
    });
};
const $658a05ad0cb6a20b$export$ed23852026f99b3a = (conversationId, messageId, getMessages, setMessages)=>{
    const currentMessages = getMessages(conversationId);
    const assistantMessage = currentMessages.find((msg)=>(0, $bPHr8.isStoreAssistant)(msg) && $658a05ad0cb6a20b$var$getStoreMessageId(msg) === messageId);
    if (assistantMessage && 'answerNowStatus' in assistantMessage && assistantMessage.answerNowStatus) setMessages(conversationId, $658a05ad0cb6a20b$export$14aeb537f795ee1a(currentMessages, messageId, undefined));
};
const $658a05ad0cb6a20b$export$f9095c96f8c4be7e = (messages, messageId, subAgentMessage)=>{
    return messages.map((chatItem)=>{
        if ((0, $bPHr8.isStoreAssistant)(chatItem) && $658a05ad0cb6a20b$var$getStoreMessageId(chatItem) === messageId) return {
            ...chatItem,
            content: {
                ...chatItem.content,
                message: {
                    ...chatItem.content.message,
                    message: {
                        ...chatItem.content.message.message
                    }
                },
                streamingComplete: false
            },
            dynamicLayoutSubAgentMessages: [
                ...chatItem.dynamicLayoutSubAgentMessages || [],
                subAgentMessage
            ]
        };
        return chatItem;
    });
};
const $658a05ad0cb6a20b$export$a89606c68db527fb = (streamMessage)=>{
    return {
        messageContent: streamMessage.message?.content,
        messageTemplate: streamMessage.message?.message_template
    };
};
const $658a05ad0cb6a20b$export$5782d74d68fa92c6 = (error, prefix = '', actionLoggableNameIfActionExecutionFailed)=>{
    let status_code, message_template, timeout;
    const message = error instanceof Error ? error.message : typeof error === 'string' ? error : 'Unknown error';
    let prefixedMessage = prefix ? `${prefix}: ${message}` : message;
    let errorType;
    let traceId;
    if (error instanceof (0, $iEWar.StreamErrorException)) {
        status_code = error.detail.message.status_code;
        message_template = error.detail.message.message_template;
        timeout = error.detail.metadata?.timeout;
        errorType = 'StreamErrorException';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $flpNp.ApiError)) {
        status_code = error.errorAttributes.statusCode;
        message_template = error.errorAttributes.errorCode;
        errorType = 'ApiError';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $iEWar.MessageActionError)) {
        // Prefer showing only the raw API error message (without codes) to end users
        const rawErrorMessage = error.cause && 'errorAttributes' in error.cause && typeof error.cause.errorAttributes === 'object' && error.cause.errorAttributes !== null && 'rawErrorMessage' in error.cause.errorAttributes ? error.cause.errorAttributes.rawErrorMessage : undefined;
        if (typeof rawErrorMessage === 'string') prefixedMessage = prefix ? `${prefix}: ${rawErrorMessage}` : rawErrorMessage;
    }
    if (error instanceof (0, $iEWar.StreamGeneratorError)) {
        errorType = 'StreamGeneratorError';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $iEWar.DeepResearchError)) {
        message_template = error.message_template;
        errorType = 'DeepResearchError';
        traceId = error.errorAttributes.traceId;
    }
    return {
        type: 'ERROR',
        content: prefixedMessage,
        time_created: new Date().toLocaleString(),
        status_code: status_code,
        message_template: message_template,
        timeout: timeout,
        id: $658a05ad0cb6a20b$export$567fc7097e064344(),
        errorType: errorType,
        traceId: traceId,
        storeActionExecutionError: actionLoggableNameIfActionExecutionFailed ? {
            actionLoggableName: actionLoggableNameIfActionExecutionFailed
        } : undefined
    };
};
const $658a05ad0cb6a20b$export$fa05b63813f8a225 = (content)=>({
        type: 'HUMAN',
        content: content
    });
const $658a05ad0cb6a20b$export$2250e3c2fe6e53e5 = (...args)=>({
        type: 'HUMAN',
        content: (0, $aclUh.createHumanMessage)(...args)
    });
const $658a05ad0cb6a20b$export$bd3c429f5e3d2c3e = (content)=>({
        type: 'ASSISTANT',
        content: content
    });
const $658a05ad0cb6a20b$export$f509fd4645870a6e = (args)=>({
        type: 'ASSISTANT',
        content: {
            type: 'FINAL_RESPONSE',
            message: {
                message: {
                    role: 'ASSISTANT',
                    id: args.id,
                    conversation_channel_id: args.conversationId,
                    content: args.content,
                    time_created: new Date().toISOString(),
                    user_ari: 'unknown',
                    plugin_invocations: [],
                    author: {
                        named_id: args.agentNamedId || 'ai_mate_agent',
                        name: 'unknown',
                        actor_type: 'AGENT',
                        ari: null,
                        id: 'unknown'
                    }
                }
            }
        }
    });
const $658a05ad0cb6a20b$var$getStoreMessageId = (storeMessage)=>{
    if ((0, $bPHr8.isStoreAssistant)(storeMessage)) return (0, $aclUh.getId)(storeMessage.content);
    return storeMessage.content.id;
};
const $658a05ad0cb6a20b$export$64b557ae352795d6 = (chat, messageId)=>chat.findIndex((storeMessage)=>(0, $bPHr8.isStoreMessage)(storeMessage) && (messageId ? $658a05ad0cb6a20b$var$getStoreMessageId(storeMessage) === messageId : true));
const $658a05ad0cb6a20b$var$updateStoreMessage = ({ chat: chat, messageId: messageId, updateFunction: updateFunction, updateType: updateType, useIndex: useIndex })=>{
    // If the chat is empty, return it as is - prevents the 'in' of 'undefined' errors we were seeing
    // TODO: Take this into account with upcoming refactor
    if (!chat.length) return chat;
    const targetIndex = useIndex || $658a05ad0cb6a20b$export$64b557ae352795d6(chat, messageId);
    const targetStoreMessage = chat[targetIndex];
    if (targetIndex < 0 || !(0, $bPHr8.isStoreMessage)(targetStoreMessage)) throw new Error(`Attempting to update a non StoreMessage (${updateType})`);
    if ($658a05ad0cb6a20b$var$getStoreMessageId(targetStoreMessage) !== messageId) throw new Error(`Attempting to update a store message at the wrong index (${updateType})`);
    const newStoreMessage = updateFunction(targetStoreMessage);
    const newChat = [
        ...chat
    ];
    newChat.splice(targetIndex, 1, newStoreMessage);
    return newChat;
};
const $658a05ad0cb6a20b$var$updateStoreAssistant = ({ chat: chat, promptId: promptId, updateFunction: updateFunction, updateType: updateType, useIndex: useIndex })=>$658a05ad0cb6a20b$var$updateStoreMessage({
        chat: chat,
        messageId: promptId,
        updateFunction: (storeMessage)=>{
            if (!(0, $bPHr8.isStoreAssistant)(storeMessage)) throw new Error(`Attempting to update a non StoreAssistant (${updateType})`);
            return updateFunction(storeMessage);
        },
        updateType: updateType,
        useIndex: useIndex
    });
const $658a05ad0cb6a20b$export$6e5609c05ab74cc7 = ({ chat: chat, answerId: answerId, answerPart: answerPart, useIndex: useIndex })=>$658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...(0, $aclUh.addAnswerPart)(storeAssistant.content, answerPart),
                    streamingComplete: false
                }
            }),
        updateType: 'Add Answer Part',
        useIndex: useIndex
    });
const $658a05ad0cb6a20b$export$4287833726c64095 = ({ chat: chat, answerId: answerId, answerPart: answerPart, markdownData: markdownData, useIndex: useIndex })=>{
    const { key: key, content: content, loading: loading } = markdownData;
    const loadingKey = `${key}-loading`;
    return $658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...(0, $aclUh.addAnswerPart)(storeAssistant.content, answerPart),
                    streamingComplete: false
                },
                markdownData: {
                    ...storeAssistant.markdownData,
                    [key]: (storeAssistant.markdownData?.[key] || '') + content,
                    [loadingKey]: loading ? 'true' : 'false'
                }
            }),
        updateType: 'Add Answer Part With Markdown Data',
        useIndex: useIndex
    });
};
const $658a05ad0cb6a20b$export$679615d953ba31c3 = ({ chat: chat, answerId: answerId, answerPart: answerPart, markdownData: markdownData, useIndex: useIndex })=>{
    return $658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>{
            const updatedMarkdownData = Object.entries(markdownData).reduce((acc, [key, { content: content, loading: loading }])=>{
                const loadingKey = `${key}-loading`;
                return {
                    ...acc,
                    [key]: (acc[key] || '') + content,
                    [loadingKey]: loading ? 'true' : 'false'
                };
            }, {
                ...storeAssistant.markdownData
            });
            return {
                ...storeAssistant,
                content: {
                    ...(0, $aclUh.addAnswerPart)(storeAssistant.content, answerPart),
                    streamingComplete: false
                },
                markdownData: updatedMarkdownData
            };
        },
        updateType: 'Add Answer Part With Markdown Data',
        useIndex: useIndex
    });
};
const $658a05ad0cb6a20b$export$13b6a4e4e3704011 = ({ chat: chat, messageId: messageId, actionPart: actionPart, useIndex: useIndex, actionUpdaterOverride: actionUpdaterOverride })=>{
    const findMessage = chat.findIndex((message)=>(0, $bPHr8.isStoreAssistant)(message) && (0, $aclUh.getId)(message.content) === messageId);
    const actionIndex = findMessage > 0 ? findMessage : chat.length - 1;
    const index = useIndex || actionIndex;
    return $658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: messageId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...(0, $aclUh.addActionPart)(storeAssistant.content, actionPart, actionUpdaterOverride)
                }
            }),
        updateType: 'Add Action Part',
        useIndex: index
    });
};
const $658a05ad0cb6a20b$export$1c0805bd5fc59c20 = (content)=>{
    if (content == null || typeof content !== 'object' || !('structured' in content)) return null;
    const { text_parts: text_parts, data_parts: data_parts } = content;
    const textContent = text_parts?.map((part)=>part.text ?? '').join('').trim() || '';
    const a2uiMessages = data_parts?.filter((part)=>part?.metadata?.mimeType === 'application/json+a2ui' && part?.data != null).map((part)=>part.data);
    return {
        textContent: textContent,
        a2uiMessages: a2uiMessages && a2uiMessages.length > 0 ? a2uiMessages : undefined
    };
};
const $658a05ad0cb6a20b$export$3a4ed3ae96502e9e = (messages, messageId, agenticUiMessage)=>{
    return messages.map((chatItem)=>{
        if ((0, $bPHr8.isStoreAssistant)(chatItem) && $658a05ad0cb6a20b$var$getStoreMessageId(chatItem) === messageId) return {
            ...chatItem,
            agenticUiMessages: [
                ...chatItem.agenticUiMessages || [],
                ...agenticUiMessage.message.content
            ]
        };
        return chatItem;
    });
};
const $658a05ad0cb6a20b$export$41f43752e3744795 = (messages, messageId, text)=>{
    return messages.map((chatItem)=>{
        if ((0, $bPHr8.isStoreAssistant)(chatItem) && $658a05ad0cb6a20b$var$getStoreMessageId(chatItem) === messageId) {
            const currentContent = chatItem.content?.message?.message?.content ?? '';
            return {
                ...chatItem,
                content: {
                    ...chatItem.content,
                    message: {
                        ...chatItem.content.message,
                        message: {
                            ...chatItem.content.message.message,
                            content: currentContent + text
                        }
                    }
                }
            };
        }
        return chatItem;
    });
};
const $658a05ad0cb6a20b$export$4499bf045ea6bd06 = ({ markdownData: markdownData, type: type, index: index })=>{
    return markdownData?.[`${type}-${index}`];
};
const $658a05ad0cb6a20b$export$60e170089d1b35dd = ({ chat: chat, answerId: answerId, content: content, useIndex: useIndex, humanMessageId: humanMessageId, markdownData: markdownData, onMessageIdChanged: onMessageIdChanged })=>$658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeMessage)=>{
            const oldId = $658a05ad0cb6a20b$var$getStoreMessageId(storeMessage);
            const newId = content.message.message.id;
            if (oldId !== newId) onMessageIdChanged?.(oldId, newId);
            return {
                ...storeMessage,
                content: {
                    ...content,
                    streamingComplete: false
                },
                humanMessageId: humanMessageId,
                markdownData: markdownData
            };
        },
        updateType: 'Replace Answer Data',
        useIndex: useIndex
    });
const $658a05ad0cb6a20b$export$ba29913b663b084c = ({ chat: chat, oldId: oldId, newId: newId, parentMessageId: parentMessageId })=>chat.map((message)=>{
        if ((0, $bPHr8.isStoreHuman)(message) && message.content.id === oldId) return {
            ...message,
            content: {
                ...message.content,
                id: newId,
                ...parentMessageId && {
                    parent_message_id: parentMessageId
                }
            }
        };
        return message;
    });
const $658a05ad0cb6a20b$export$f279e50afd80e7d8 = ({ chat: chat, oldId: oldId, newId: newId })=>$658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: oldId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...storeAssistant.content,
                    message: {
                        ...storeAssistant.content.message,
                        message: {
                            ...storeAssistant.content.message.message,
                            id: newId
                        }
                    }
                }
            }),
        updateType: 'Update Store Assistant Message ID'
    });
const $658a05ad0cb6a20b$export$680d2bb5b9579c57 = (chat)=>chat.map((message)=>{
        if ((0, $bPHr8.isStoreAssistant)(message) && !message.content.streamingComplete) return {
            ...message,
            content: {
                ...message.content,
                streamingComplete: true
            },
            // Clear answerNowStatus when streaming completes (success, error, or abort)
            answerNowStatus: undefined
        };
        return message;
    });
const $658a05ad0cb6a20b$export$304863f72794c019 = (chat)=>{
    const isInFlight = (action)=>{
        const lower = action.status?.toLowerCase();
        return lower === 'streaming' || lower === 'preparing';
    };
    const hasInFlightAction = chat.some((message)=>(0, $bPHr8.isStoreAssistant)(message) && message.content.message.message.actions?.some(isInFlight));
    if (!hasInFlightAction) return chat;
    return chat.map((message)=>{
        if (!(0, $bPHr8.isStoreAssistant)(message) || !message.content.message.message.actions?.some(isInFlight)) return message;
        return {
            ...message,
            content: {
                ...message.content,
                message: {
                    ...message.content.message,
                    message: {
                        ...message.content.message.message,
                        actions: message.content.message.message.actions.map((action)=>isInFlight(action) ? {
                                ...action,
                                status: 'cancelled'
                            } : action)
                    }
                }
            }
        };
    });
};
const $658a05ad0cb6a20b$export$24d2e7dc410ce2e5 = (chat, startFromMessageId, messageCount = 1)=>{
    const messageIndex = $658a05ad0cb6a20b$export$64b557ae352795d6(chat, startFromMessageId);
    if (messageIndex < 0) return [];
    const messageHistory = chat.slice(Math.max(0, messageIndex - messageCount), messageIndex + 1);
    return messageHistory;
};
const $658a05ad0cb6a20b$export$b53f205a52449551 = ({ lastAgentMessageStatus: lastAgentMessageStatus })=>({
        status: (0, $bPHr8.CHAT_STORE_STATUS).idle,
        traces: [],
        storeAbortController: undefined,
        ...lastAgentMessageStatus !== undefined && {
            lastAgentMessageStatus: lastAgentMessageStatus
        }
    });
const $658a05ad0cb6a20b$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        content: (0, $aclUh.removeSensitiveData)(message.content)
    });
const $658a05ad0cb6a20b$export$a2ff1144002a6147 = (state, id)=>{
    return state.conversations[id];
};
const $658a05ad0cb6a20b$export$de552dcf26f1e520 = (state, conversationId)=>{
    const creatorType = $658a05ad0cb6a20b$export$a2ff1144002a6147(state, conversationId)?.agent?.creator_type;
    return !!creatorType && (0, $bOrYy.isForgeAgentByCreatorType)(creatorType);
};
const $658a05ad0cb6a20b$export$80b847bfebcaa3fd = (state, id)=>{
    return !!id && state.conversations[state.currentConversationId]?.sourceId === id;
};
const $658a05ad0cb6a20b$export$d9047a7a8ec8ea5c = (messages)=>{
    return $658a05ad0cb6a20b$export$296de88ccac4bedb(messages, (0, $bPHr8.isStoreHuman));
};
const $658a05ad0cb6a20b$export$2813a13604911e2d = (messages)=>{
    try {
        const last = $658a05ad0cb6a20b$export$296de88ccac4bedb(messages, (0, $bPHr8.isStoreAssistant));
        return last?.content.message.message.id;
    } catch  {
        return undefined;
    }
};
const $658a05ad0cb6a20b$export$1ba374c59efc126c = (messages)=>{
    return $658a05ad0cb6a20b$export$d9047a7a8ec8ea5c(messages)?.content.requestId;
};
const $658a05ad0cb6a20b$export$7fd69d5cdd838542 = (messages, messageId)=>{
    let index = -1;
    const result = messages.find((item, i)=>{
        index = i;
        return (0, $bPHr8.isStoreAssistant)(item) && (0, $aclUh.getId)(item.content) === messageId;
    });
    return result ? {
        result: result,
        index: index
    } : {
        result: false,
        index: index
    };
};
const $658a05ad0cb6a20b$export$3dfca8d0ecaaf31f = ({ messages: messages, messageId: messageId, searchType: searchType })=>{
    const startIndex = messages.findIndex((item)=>{
        switch(item.type){
            case 'HUMAN':
                return item.content.id === messageId;
            case 'ASSISTANT':
                return item.content.message.message.id === messageId;
            case 'FOLLOW_UP':
                return String(item.id) === messageId;
            default:
                return false;
        }
    });
    for(let i = startIndex; i >= 0; i--){
        if (messages[i].type === searchType) return messages[i];
    }
    return undefined;
};
const $658a05ad0cb6a20b$export$1a288f9aecfed8b4 = (messages, agentMessageId)=>{
    try {
        const agentMessage = $658a05ad0cb6a20b$export$7fd69d5cdd838542(messages, agentMessageId).result;
        if (agentMessage && (0, $bPHr8.isStoreAssistant)(agentMessage)) {
            const foundId = $658a05ad0cb6a20b$export$3dfca8d0ecaaf31f({
                messages: messages,
                messageId: agentMessageId,
                searchType: 'HUMAN'
            })?.content.id;
            return foundId ? String(foundId) : undefined;
        }
    } catch  {
        return undefined;
    }
};
const $658a05ad0cb6a20b$export$1cdaa2c4089128bd = (chat, requestId)=>{
    const lastHumanMessage = $658a05ad0cb6a20b$export$296de88ccac4bedb(chat, (0, $bPHr8.isStoreHuman));
    // Skip if there is no last human message or if the requestId is already set
    if (!lastHumanMessage || !requestId || !!lastHumanMessage.content.requestId) return chat;
    const newHumanMessage = {
        ...lastHumanMessage,
        content: {
            ...lastHumanMessage.content,
            requestId: requestId
        }
    };
    const newChat = [
        ...chat
    ];
    newChat[newChat.lastIndexOf(lastHumanMessage)] = newHumanMessage;
    return newChat;
};
const $658a05ad0cb6a20b$export$b178621992ef9541 = (conversationId)=>conversationId === (0, $2CHXX.EMPTY_CONVERSATION_ID) || conversationId === undefined;
const $658a05ad0cb6a20b$export$3902b208060a7183 = (chatStatus, conversationStatus)=>{
    return chatStatus === 'launching' || conversationStatus === (0, $bPHr8.CHAT_STORE_STATUS).loadingChat;
};
const $658a05ad0cb6a20b$export$2126c56dcace27e4 = ({ chat: chat, type: type, index: index })=>{
    for(let currentIndex = chat.length - 1; currentIndex >= 0; currentIndex--){
        if (chat[currentIndex].type === type) return currentIndex === index;
    }
    return false;
};
const $658a05ad0cb6a20b$export$d669251a312339ff = (chat, type)=>{
    const lastIndex = chat.map((item)=>item.type).indexOf(type);
    if (lastIndex >= 0) return chat[lastIndex];
};
const $658a05ad0cb6a20b$export$adcb9a09d2b33fd = (chat, type)=>$658a05ad0cb6a20b$export$296de88ccac4bedb(chat, (item)=>item.type === type);
function $658a05ad0cb6a20b$export$296de88ccac4bedb(array, predicate) {
    for(let i = array.length - 1; i >= 0; i--){
        if (predicate(array[i])) return array[i];
    }
    return undefined;
}
const $658a05ad0cb6a20b$export$8855a8be7bd3e9f8 = (array, predicate)=>{
    for(let i = array.length - 1; i >= 0; i--){
        if (predicate(array[i])) return i;
    }
    return -1;
};
const $658a05ad0cb6a20b$export$ab93cd1ecacda8ec = (messages, conversation)=>{
    const assistantMessage = messages.find((message)=>(0, $bPHr8.isStoreAssistant)(message));
    if ((0, $dh538.fg)('rovo_chat_fix_agent_selection_after_cancel')) // fixing the fallback to correctly select an agent if a user cancels a session
    return conversation?.sourceAgentId ?? assistantMessage?.content.message.message.author_id ?? conversation?.agent?.agent_id;
    return conversation?.sourceAgentId ?? assistantMessage?.content.message.message.author_id;
};
const $658a05ad0cb6a20b$export$25a2389a84d1a0a0 = (timeStamp, conversationId)=>{
    // More detail on djb2 hash function https://theartincode.stanis.me/008-djb2/
    let hash = 5381;
    if (!timeStamp || !conversationId) return hash;
    const concat = conversationId + timeStamp;
    for(let i = 0; i < concat.length; i++)// Update the hash value
    hash = (hash << 5) + hash + concat.charCodeAt(i); // hash * 33 + c
    // Ensure the hash is a positive integer
    return hash >>> 0;
};
const $658a05ad0cb6a20b$export$eca740b13a7a3080 = (conversationId)=>String($658a05ad0cb6a20b$export$25a2389a84d1a0a0(new Date().toISOString(), conversationId));
const $658a05ad0cb6a20b$export$9de2c1973de15b05 = (sources)=>{
    if (!sources) return {};
    const citedProductList = {};
    sources.forEach((source)=>{
        const productName = (0, $6bf7a89ae376c5c9$export$ed5572b558d71438)(source.ari);
        if (productName) citedProductList[productName] = (citedProductList[productName] ?? 0) + 1;
    });
    return citedProductList;
};
const $658a05ad0cb6a20b$export$823ed9c8e3d751f5 = (streamMessage)=>{
    const content = streamMessage.message.message.content;
    if (typeof content !== 'string') return streamMessage;
    return {
        ...streamMessage,
        message: {
            ...streamMessage.message,
            message: {
                ...streamMessage.message.message,
                content: (0, $534f3b959a2e27b2$export$c00e46a308694bc9)(content)
            }
        }
    };
};
const $658a05ad0cb6a20b$export$66fc5003b23b7a8c = (sources)=>{
    if (!sources) return {};
    const products = {};
    sources.forEach((source)=>{
        const productName = source.product;
        if (productName) products[productName] = (products[productName] ?? 0) + 1;
    });
    return products;
};
const $658a05ad0cb6a20b$export$bb73d89e7217c465 = ({ streamMessage: streamMessage, boundaryStart: boundaryStart, boundaryEnd: boundaryEnd, replacementContent: replacementContent })=>{
    const messageContent = (0, $ljUdP.isStreamResponse)(streamMessage) ? streamMessage.message.message.content : streamMessage.message.content;
    if (!messageContent || typeof messageContent !== 'string') return {
        processedStreamMessage: streamMessage,
        boundaryContents: []
    };
    const { processedText: processedText, boundaryContents: boundaryContents } = (0, $7yZ5y.extractMarkdownText)(messageContent, boundaryStart, boundaryEnd, replacementContent);
    if (boundaryContents.length > 0) {
        if ((0, $ljUdP.isStreamResponse)(streamMessage)) streamMessage.message.message.content = processedText;
        else streamMessage.message.content = processedText;
    }
    return {
        processedStreamMessage: streamMessage,
        boundaryContents: boundaryContents
    };
};
const $658a05ad0cb6a20b$export$b77ba8e4ec693266 = (jsonString)=>{
    try {
        const parsed = JSON.parse(jsonString);
        if ((0, $4pEXC.isAdfContent)(parsed)) return true;
        return false;
    } catch  {
        return false;
    }
};
const $658a05ad0cb6a20b$var$serviceDeskSourceRegex = /https:\/\/[a-zA-Z0-9_.-]+\/servicedesk\/customer\//g;
const $658a05ad0cb6a20b$export$b9ac6250c4aba7c6 = (pluginOutput)=>{
    return $658a05ad0cb6a20b$var$serviceDeskSourceRegex.test(pluginOutput);
};
const $658a05ad0cb6a20b$export$c37d58cb6fcaff84 = ()=>[
        {
            key: 'expand',
            startTag: "\u259E",
            endTag: "\u259A",
            placeholderTag: '[^expand^]',
            isEnabled: true
        },
        {
            key: 'chart',
            startTag: "\u25F4",
            endTag: "\u25F6",
            placeholderTag: '[^chart^]',
            isEnabled: true
        },
        {
            key: 'lumina',
            startTag: "\u25D0",
            endTag: "\u25D1",
            placeholderTag: '\n\n[^lumina^]\n\n',
            isEnabled: (0, $dh538.fg)('rovo_chat_enable_inline_lumina')
        }
    ];
const $658a05ad0cb6a20b$export$11d94ded1c502e7b = ({ streamMessage: streamMessage, currentLoadingKey: currentLoadingKey, previousKey: previousKey, componentType: componentType })=>{
    const componentConfig = $658a05ad0cb6a20b$export$c37d58cb6fcaff84().find((c)=>c.key === componentType);
    if (!componentConfig) return {
        processedStreamMessage: streamMessage,
        currentLoadingKey: currentLoadingKey,
        previousKey: previousKey,
        markdownData: null
    };
    const messageContent = streamMessage.message.content;
    if (typeof messageContent !== 'string') return {
        processedStreamMessage: streamMessage,
        currentLoadingKey: currentLoadingKey,
        previousKey: previousKey,
        markdownData: null
    };
    const result = (0, $7yZ5y.processMarkdownComponent)(messageContent, currentLoadingKey, previousKey, componentConfig);
    streamMessage.message.content = result.processedText;
    return {
        processedStreamMessage: streamMessage,
        currentLoadingKey: result.currentLoadingKey,
        previousKey: result.previousKey,
        markdownData: result.markdownData
    };
};
const $658a05ad0cb6a20b$export$f0a9473b2d3b8f30 = (options)=>{
    // We pass a lazy supplier so the processor reads current feature flag values on each call.
    // createMarkdownProcessor keeps state (currentLoadingKeys / previousKeys) across calls,
    // while components are re-evaluated every invocation to reflect live flag values.
    const processor = (0, $7yZ5y.createMarkdownProcessor)($658a05ad0cb6a20b$export$c37d58cb6fcaff84);
    // Per-message preprocessor that rewrites HTML `<details><summary>` blocks
    // into the Rovo-native `▞…▚` boundary before they reach the component
    // extractor. Maintains its own cross-chunk buffer so partial tags spanning
    // chunk boundaries resolve correctly. The caller decides whether to enable
    // it (typically gated on 3P agents via
    // `shouldPreprocessDetailsForConversation`).
    const detailsPreprocessor = options?.shouldPreprocessDetails ? (0, $534f3b959a2e27b2$export$88c7624283baadd3)() : null;
    return (streamMessage)=>{
        const messageContent = streamMessage.message.content;
        const text = typeof messageContent === 'string' ? messageContent : '';
        const preprocessedText = detailsPreprocessor ? detailsPreprocessor.process(text) : text;
        const { processedText: processedText, markdownData: markdownData, processedComponentType: processedComponentType } = processor(preprocessedText);
        streamMessage.message.content = processedText;
        return {
            processedStreamMessage: streamMessage,
            markdownData: markdownData,
            processedComponentType: processedComponentType
        };
    };
};
const $658a05ad0cb6a20b$export$95c0abd604a2cca2 = (options)=>{
    // handles multiple tags in a single chunk (e.g. close tag + new open tag)
    // Returns markdownData as a MarkdownDataMap (keyed by component instance).
    const processor = (0, $7yZ5y.createMarkdownProcessorMultiTags)($658a05ad0cb6a20b$export$c37d58cb6fcaff84);
    // Optional <details>/<summary> rewriter that runs upstream of the
    // multi-tag extractor so the existing `▞…▚` boundary-driven `expand`
    // component picks them up. See createStreamMarkdownProcessor.
    const detailsPreprocessor = options?.shouldPreprocessDetails ? (0, $534f3b959a2e27b2$export$88c7624283baadd3)() : null;
    return (streamMessage)=>{
        const messageContent = streamMessage.message.content;
        const text = typeof messageContent === 'string' ? messageContent : '';
        const preprocessedText = detailsPreprocessor ? detailsPreprocessor.process(text) : text;
        const { processedText: processedText, markdownData: markdownData } = processor(preprocessedText);
        streamMessage.message.content = processedText;
        return {
            processedStreamMessage: streamMessage,
            markdownData: markdownData
        };
    };
};
function $658a05ad0cb6a20b$export$5ab2d78f2e4dba11(message, context) {
    if (!(0, $ljUdP.isActionExecutedSuccessfully)(message)) return 'errored';
    return (0, $ljUdP.isActionResolutionCancelled)(context) ? 'cancelled' : 'finished';
}
const $658a05ad0cb6a20b$export$886a0387c1c465f5 = (error)=>{
    if (!error) return false;
    // Server-sent error chunks are wrapped as StreamErrorException and should be excluded
    if (error instanceof (0, $iEWar.StreamErrorException)) return false;
    // Any ApiError (or object exposing errorAttributes.statusCode) comes from the HTTP layer, so exclude
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (error instanceof (0, $flpNp.ApiError) || error?.errorAttributes?.statusCode) return false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const message = error?.message;
    // When the backend terminates the stream abruptly we get a JSON parsing error, so we treat it as server-side
    // See onversation-assistant-service/src/services/assistance-service/read-json-stream/index.ts
    if (typeof message === 'string' && message.startsWith('Error Processing Stream Data')) return false;
    // Whatever remains is considered a client/network error
    return true;
};
const $658a05ad0cb6a20b$export$24c718731d9a7b6a = (messages, predicate)=>{
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $bPHr8.isStoreAssistant)(msg)) {
            const actionParts = msg.content.message?.message?.actions ?? [];
            const action = $658a05ad0cb6a20b$export$296de88ccac4bedb(actionParts, predicate);
            if (action) return action;
        }
    }
    return undefined;
};
const $658a05ad0cb6a20b$export$acbf6433e9af643f = (allMessages, conversationId, traceId, chatContextStoreActions, experienceTracker, getMessages, setMessages, sendMessageLatencyMetrics, cancelStreamingMetrics, commonExperienceAttributes, productKey, minionOutputs)=>{
    // Some products do not require first response to be an action,
    // so exit early when we're not within Confluence
    if (productKey !== 'confluence') return true;
    const humanMessageCount = allMessages.filter((0, $bPHr8.isStoreHuman)).length;
    // Only execute on the first human message within the staging area
    if (chatContextStoreActions.getIsStagingArea() && humanMessageCount === 1) {
        const firstAssistantResponse = allMessages.find((0, $bPHr8.isStoreAssistant));
        const firstAction = firstAssistantResponse?.content?.message?.message?.actions?.[0];
        const hasCreatableAction = firstAction ? (0, $deF0K.isCreatableAction)(firstAction) : false;
        const authUrl = (0, $9vgbT.extractOutboundAuthLink)(firstAssistantResponse?.content?.message?.message?.content ?? '');
        // Experience handling for the scenario where there
        // should be an action returned but there was not
        if (!hasCreatableAction) {
            // If authUrl is present, abort the experience
            if (authUrl) {
                experienceTracker.abort({
                    name: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT,
                    reason: 'authentication-required',
                    attributes: commonExperienceAttributes
                });
                (0, $52Fo2.abortGenerateContentChildExperiences)(experienceTracker, 'AIFC_GENERATE_CONTENT aborted - authentication required', commonExperienceAttributes);
            } else {
                // This error should have a user-friendly message, as it will be shown to the user.
                const noActionError = new (0, $iEWar.NoActionInvokedError)("Something went wrong on Rovo's end. Please try sending your message again.", {
                    traceId: traceId
                });
                const hasConfluenceCreationTool = minionOutputs?.flat().some((output)=>output.minion_id === 'ConfluenceCreationTool');
                const messageMetadata = firstAssistantResponse?.content?.message?.message?.message_metadata;
                const orchestratorDepthLimitReached = messageMetadata?.orchestrator_depth_limit_reached ?? false;
                const orchestratorContextWindowUsage = messageMetadata?.orchestrator_context_window_usage;
                if ((0, $dh538.fg)('aifc_rovo_better_no_content_created')) {
                    const classification = messageMetadata?.aifc_no_create_classification;
                    const noContentCreatedAttributes = {
                        orchestratorContextWindowUsage: orchestratorContextWindowUsage,
                        orchestratorDepthLimitReached: orchestratorDepthLimitReached,
                        hasConfluenceCreationTool: hasConfluenceCreationTool,
                        noContentCreatedClassification: classification ?? 'NO_CLASSIFICATION_PROVIDED'
                    };
                    if (!classification || !$658a05ad0cb6a20b$var$ABORT_CLASSIFICATIONS.has(classification)) {
                        experienceTracker.fail({
                            name: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT,
                            error: noActionError,
                            attributes: {
                                ...commonExperienceAttributes,
                                ...noContentCreatedAttributes
                            }
                        });
                        (0, $52Fo2.abortGenerateContentChildExperiences)(experienceTracker, classification ?? 'NO_CLASSIFICATION_PROVIDED', commonExperienceAttributes);
                        const messages = getMessages(conversationId);
                        setMessages(conversationId, [
                            ...messages,
                            $658a05ad0cb6a20b$export$5782d74d68fa92c6(noActionError)
                        ]);
                        sendMessageLatencyMetrics.cancel();
                        cancelStreamingMetrics();
                        return false;
                    }
                    // Abort: user prompt or external issue — nudge user to fix the problem
                    experienceTracker.abort({
                        name: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT,
                        reason: classification,
                        attributes: {
                            ...commonExperienceAttributes,
                            ...noContentCreatedAttributes
                        }
                    });
                    (0, $52Fo2.abortGenerateContentChildExperiences)(experienceTracker, classification, commonExperienceAttributes);
                    // GOOD_REPLY_NO_CREATE is symptomatic of the user prompting non-creation, which we can also treat as a bad prompt
                    const hintVariant = classification === 'EXTERNAL_ERROR' ? 'EXTERNAL_ERROR' : 'BAD_USER_INPUT';
                    const messages = getMessages(conversationId);
                    setMessages(conversationId, [
                        ...messages,
                        {
                            type: 'USAGE_HINT',
                            topic: 'NoActionInvokedError',
                            variant: hintVariant
                        }
                    ]);
                    return true;
                }
                let errorToTrack;
                let reason;
                if (!hasConfluenceCreationTool && orchestratorDepthLimitReached) {
                    errorToTrack = new (0, $iEWar.NoActionInvokedError)('The orchestrator reached its depth limit and the ConfluenceCreationTool was not invoked.', {
                        traceId: traceId
                    });
                    reason = 'orchestrator-depth-limit-reached-no-cct';
                } else if (hasConfluenceCreationTool) {
                    errorToTrack = new (0, $iEWar.NoActionInvokedError)('The ConfluenceCreationTool was invoked, but valid content was not created for action key: ' + firstAction?.key + '. Please try again', {
                        traceId: traceId
                    });
                    reason = 'confluence-creation-tool-invoked-no-action';
                } else {
                    errorToTrack = noActionError;
                    reason = 'no-action-invoked';
                }
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT,
                    error: errorToTrack,
                    attributes: {
                        ...commonExperienceAttributes,
                        reason: reason,
                        orchestratorContextWindowUsage: orchestratorContextWindowUsage
                    }
                });
                (0, $52Fo2.abortGenerateContentChildExperiences)(experienceTracker, reason, commonExperienceAttributes);
                const messages = getMessages(conversationId);
                // This is to show the error in the UI
                setMessages(conversationId, [
                    ...messages,
                    $658a05ad0cb6a20b$export$5782d74d68fa92c6(noActionError)
                ]);
                // Stop metrics before returning
                sendMessageLatencyMetrics.cancel();
                cancelStreamingMetrics();
                return false;
            }
        }
    }
    return true;
};
const $658a05ad0cb6a20b$export$82b32799d0ea512c = ({ streamMessage: streamMessage, messageId: messageId, conversationId: conversationId, sendAnalyticsEvent: sendAnalyticsEvent, shouldPreprocessDetails: shouldPreprocessDetails = false })=>{
    let processedStreamMessage = streamMessage;
    const markdownData = {};
    // Applies to the final-response path (non-streaming) and to reconnect replay.
    if (shouldPreprocessDetails) processedStreamMessage = $658a05ad0cb6a20b$export$823ed9c8e3d751f5(processedStreamMessage);
    if ((0, $dh538.fg)('rovo_enable_data_sculptor')) {
        const dataSculptorMsg = $658a05ad0cb6a20b$export$bb73d89e7217c465({
            streamMessage: processedStreamMessage,
            boundaryStart: '[^sculptor:start^]',
            boundaryEnd: '[^sculptor:end^]',
            replacementContent: '[^sculptor^]'
        });
        processedStreamMessage = dataSculptorMsg.processedStreamMessage;
        dataSculptorMsg.boundaryContents.forEach((content, index)=>{
            markdownData[`sculptor-${index}`] = content;
        });
    }
    const expandOpenTag = "\u259E";
    const expandCloseTag = "\u259A";
    const expandPlaceholder = '[^expand^]';
    const expandMsg = $658a05ad0cb6a20b$export$bb73d89e7217c465({
        streamMessage: processedStreamMessage,
        boundaryStart: expandOpenTag,
        boundaryEnd: expandCloseTag,
        replacementContent: expandPlaceholder
    });
    processedStreamMessage = expandMsg.processedStreamMessage;
    expandMsg.boundaryContents.forEach((content, index)=>{
        markdownData[`expand-${index}`] = content;
    });
    if (expandMsg?.boundaryContents && expandMsg.boundaryContents.length > 0) sendAnalyticsEvent({
        eventType: 'track',
        action: 'viewed',
        actionSubject: 'expandComponent',
        attributes: {
            messageId: messageId,
            conversationId: conversationId,
            expandCount: expandMsg.boundaryContents.length,
            timestamp: new Date().toISOString(),
            isFinalResponse: true
        }
    });
    const chartOpenTag = "\u25F4";
    const chartCloseTag = "\u25F6";
    const chartPlaceholder = '[^chart^]';
    const chartMsg = $658a05ad0cb6a20b$export$bb73d89e7217c465({
        streamMessage: processedStreamMessage,
        boundaryStart: chartOpenTag,
        boundaryEnd: chartCloseTag,
        replacementContent: chartPlaceholder
    });
    processedStreamMessage = chartMsg.processedStreamMessage;
    chartMsg.boundaryContents.forEach((content, index)=>{
        markdownData[`chart-${index}`] = content;
    });
    if (chartMsg?.boundaryContents && chartMsg.boundaryContents.length > 0) sendAnalyticsEvent({
        eventType: 'track',
        action: 'extracted',
        actionSubject: 'vizPluginChart',
        attributes: {
            messageId: messageId,
            conversationId: conversationId,
            chartCount: chartMsg.boundaryContents.length,
            timestamp: new Date().toISOString()
        }
    });
    if ((0, $dh538.fg)('rovo_chat_enable_inline_lumina')) {
        const luminaMsg = $658a05ad0cb6a20b$export$bb73d89e7217c465({
            streamMessage: processedStreamMessage,
            boundaryStart: "\u25D0",
            boundaryEnd: "\u25D1",
            replacementContent: '\n\n[^lumina^]\n\n'
        });
        processedStreamMessage = luminaMsg.processedStreamMessage;
        luminaMsg.boundaryContents.forEach((content, index)=>{
            markdownData[`lumina-${index}`] = content;
        });
    }
    return {
        processedStreamMessage: processedStreamMessage,
        markdownData: markdownData
    };
};
const $658a05ad0cb6a20b$export$e3f334fc6effa531 = ({ chat: chat, answerId: answerId, useIndex: useIndex, memory: memory })=>$658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                memory: memory
            }),
        updateType: 'Add memory',
        useIndex: useIndex
    });
const $658a05ad0cb6a20b$export$2244b7838be162ca = (response, skillSelectionSource, includeDynamicUIData)=>{
    const sources = response.message?.message?.sources;
    const pluginInvocations = response.message?.message?.plugin_invocations;
    const minionOutputs = response.message?.message?.minion_outputs;
    const actions = response.message?.message?.actions;
    const humanMessageId = response.message?.human_message?.id.toString();
    const pluginsInvoked = [];
    const skillsInvoked = [];
    let usesJsm = false;
    pluginInvocations?.forEach((pi)=>{
        if (pi.plugin_name) pluginsInvoked.push(pi.plugin_name);
        if (pi.plugin_output && $658a05ad0cb6a20b$export$b9ac6250c4aba7c6(pi.plugin_output) && (0, $dh538.fg)('rovo_chat_analytics_source_extended')) usesJsm = true;
    });
    const flatMinionOutputs = minionOutputs?.flat() ?? [];
    const executedStratusSkill = flatMinionOutputs.some((output)=>output.skill_type === 'STRATUS') ?? false;
    flatMinionOutputs.forEach((output)=>{
        pluginsInvoked.push(output.minion_id);
        const isExplicit = output.directly_invoked;
        skillsInvoked.push({
            minionId: output.minion_id,
            skillName: output.skill_alias,
            skillType: output.skill_type,
            invocationType: isExplicit ? 'explicit' : 'implicit',
            internalTools: output.internal_tools?.map((tool)=>({
                    name: tool.name,
                    isConsequential: tool.is_consequential
                })) ?? [],
            skillSelectionSource: isExplicit ? skillSelectionSource : undefined
        });
        if (output.minion_output && $658a05ad0cb6a20b$export$b9ac6250c4aba7c6(output.minion_output) && (0, $dh538.fg)('rovo_chat_analytics_source_extended')) usesJsm = true;
    });
    return {
        humanMessageId: humanMessageId,
        citedProductList: $658a05ad0cb6a20b$export$9de2c1973de15b05(sources),
        sourceProducts: $658a05ad0cb6a20b$export$66fc5003b23b7a8c(sources),
        hasSources: !!sources?.length,
        pluginsInvoked: pluginsInvoked,
        skillsInvoked: skillsInvoked,
        executedStratusSkill: executedStratusSkill,
        messageActions: actions?.map((action)=>action.key),
        messageDynamicUIData: includeDynamicUIData ? actions?.map((action)=>({
                subtype: action.data?.dynamicUiSubtype
            })) : undefined,
        invokedFrom: $658a05ad0cb6a20b$export$a0e3245ee56765fd({
            messageActionKey: actions?.[0]?.key,
            messageActionData: actions?.[0]?.data
        }),
        responseSources: (0, $dh538.fg)('rovo_chat_analytics_source_extended') ? sources?.map((x)=>x.ari).filter(Boolean) : undefined,
        usesJsm: (0, $dh538.fg)('rovo_chat_analytics_source_extended') ? usesJsm : undefined,
        scenarioId: response.message?.message?.scenario?.id,
        interactionModeExecuted: response.message?.message?.message_metadata?.interaction_mode_executed
    };
};
const $658a05ad0cb6a20b$var$WHITEBOARD_ACTION_KEYS = new Set([
    (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY),
    (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY)
]);
const $658a05ad0cb6a20b$var$DIAGRAM_UI_SUBTYPES = new Set([
    'flowchart',
    'mindmap'
]);
const $658a05ad0cb6a20b$export$f3b7160b60840213 = (actionKey, source, dynamicUiSubtype)=>{
    if (actionKey && $658a05ad0cb6a20b$var$WHITEBOARD_ACTION_KEYS.has(actionKey)) {
        if (source === 'remix') return `${actionKey}-maui`;
        if (dynamicUiSubtype && $658a05ad0cb6a20b$var$DIAGRAM_UI_SUBTYPES.has(dynamicUiSubtype)) return `${actionKey}-diagram`;
    }
    return actionKey;
};
const $658a05ad0cb6a20b$export$43489e04a87de7d0 = 'Create a Confluence page from this response';
function $658a05ad0cb6a20b$export$12e85b2979bdbb52(messages) {
    const lastAssistant = $658a05ad0cb6a20b$export$296de88ccac4bedb(messages, (0, $bPHr8.isStoreAssistant));
    const actions = lastAssistant?.content?.message?.message?.actions;
    if (!actions || actions.length === 0) return false;
    return actions.some((action)=>(0, $3vCSA.isConfluenceCreatableAction)({
            key: action.key
        }) || (0, $3vCSA.isConfluenceUpdatableAction)({
            key: action.key
        }) || action.key === (0, $8IKbl.CONFLUENCE_PAGE_CREATE_KEY));
}
function $658a05ad0cb6a20b$export$a5165b6c5017830(messages, productKey) {
    if (productKey !== 'confluence' || !(0, $1oCLl.expValEquals)('confluence_fe_create_page_suggestion', 'isEnabled', true)) return false;
    return !$658a05ad0cb6a20b$export$12e85b2979bdbb52(messages);
}
function $658a05ad0cb6a20b$export$c2722b1ddbddcce5(messages, streamFollowUp, productKey) {
    if (!$658a05ad0cb6a20b$export$a5165b6c5017830(messages, productKey)) return streamFollowUp;
    const existingFollowUps = streamFollowUp.message.follow_ups ?? [];
    if (existingFollowUps.some((f)=>f.text === $658a05ad0cb6a20b$export$43489e04a87de7d0)) return streamFollowUp;
    return {
        ...streamFollowUp,
        message: {
            ...streamFollowUp.message,
            follow_ups: [
                ...existingFollowUps,
                {
                    type: 'SYNTHETIC',
                    text: $658a05ad0cb6a20b$export$43489e04a87de7d0
                }
            ]
        }
    };
}
function $658a05ad0cb6a20b$export$b323db724925d16f() {
    return {
        type: 'FOLLOW_UP_QUERIES',
        message: {
            follow_ups: [
                {
                    type: 'SYNTHETIC',
                    text: $658a05ad0cb6a20b$export$43489e04a87de7d0
                }
            ]
        },
        millisOffset: 0
    };
}
const $658a05ad0cb6a20b$export$a0e3245ee56765fd = ({ messageActionKey: messageActionKey, messageActionData: messageActionData })=>{
    // WARNING: Changing the logic here can affect AIFC MAU and other AI metrics.
    // Please consult with the Create with Rovo team before making any changes.
    if (!messageActionKey) return undefined;
    if ((0, $3vCSA.isDynamicUiCreatableAction)({
        key: messageActionKey
    }) || (0, $3vCSA.isImageCreatableAction)({
        key: messageActionKey
    }) || (0, $3vCSA.isRemixGeneratedAction)(messageActionData)) return 'remix';
    if ((0, $3vCSA.isConfluenceCreatableAction)({
        key: messageActionKey
    })) // TODO All creatable actions should be as AIFC MAU here,
    // but we are temporarily changing this to Confluence only due to HOT-122605
    return 'AIFC';
    else if ((0, $3vCSA.isConfluencePageUpdateAction)({
        key: messageActionKey
    })) return 'Editor AI';
    else if ((0, $3vCSA.isConfluenceWhiteboardUpdateAction)({
        key: messageActionKey
    })) return 'Whiteboard AI';
    else if ((0, $3vCSA.isConfluenceSlidesUpdateAction)({
        key: messageActionKey
    })) return 'Slide AI';
    else if ((0, $3vCSA.isConfluenceDatabaseUpdateAction)({
        key: messageActionKey
    })) return 'Database AI';
    return undefined;
};
const $658a05ad0cb6a20b$export$9ac25e0768639c5d = (traces)=>{
    const messages = traces.map((trace)=>trace.messageContent);
    return traces.filter((trace, i)=>messages.lastIndexOf(trace.messageContent) === i);
};
const $658a05ad0cb6a20b$export$8567b8b6b4d41b2f = (state, conversationId)=>state.conversations[conversationId]?.traces ?? [];
const $658a05ad0cb6a20b$export$d30a5acf6cceb893 = (getState, conversationId, updateCurrentConversation)=>{
    const currentTraces = $658a05ad0cb6a20b$export$8567b8b6b4d41b2f(getState(), conversationId);
    if (currentTraces.length > 0) updateCurrentConversation({
        traces: []
    });
};
module.exports["generateId"] = $658a05ad0cb6a20b$export$567fc7097e064344;
module.exports["createBroadcastStreamLifecycle"] = $658a05ad0cb6a20b$export$b043b11900276452;
module.exports["getStoreAssistantMessageContent"] = $658a05ad0cb6a20b$export$9c657fdfae6b2020;
module.exports["clearStoreAssistantMessageContent"] = $658a05ad0cb6a20b$export$bb0ca99caffb8502;
module.exports["updateStoreAssistantMessageAnswerGenerationType"] = $658a05ad0cb6a20b$export$d812e3ec408e3b14;
module.exports["updateStoreAssistantMessageAnswerNowStatus"] = $658a05ad0cb6a20b$export$14aeb537f795ee1a;
module.exports["clearAnswerNowStatusForMessageIfSet"] = $658a05ad0cb6a20b$export$ed23852026f99b3a;
module.exports["addSubAgentMessageToStoreAssistantMessage"] = $658a05ad0cb6a20b$export$f9095c96f8c4be7e;
module.exports["getTraceFromStreamMessage"] = $658a05ad0cb6a20b$export$a89606c68db527fb;
module.exports["createStoreError"] = $658a05ad0cb6a20b$export$5782d74d68fa92c6;
module.exports["createStoreHumanWithContent"] = $658a05ad0cb6a20b$export$fa05b63813f8a225;
module.exports["createStoreHuman"] = $658a05ad0cb6a20b$export$2250e3c2fe6e53e5;
module.exports["createStoreAssistantWithContent"] = $658a05ad0cb6a20b$export$bd3c429f5e3d2c3e;
module.exports["createStoreAssistant"] = $658a05ad0cb6a20b$export$f509fd4645870a6e;
module.exports["findStoreMessageIndex"] = $658a05ad0cb6a20b$export$64b557ae352795d6;
module.exports["addAnswerPart"] = $658a05ad0cb6a20b$export$6e5609c05ab74cc7;
module.exports["addAnswerPartWithMarkdownData"] = $658a05ad0cb6a20b$export$4287833726c64095;
module.exports["addAnswerPartWithMarkdownDataMap"] = $658a05ad0cb6a20b$export$679615d953ba31c3;
module.exports["addActionPart"] = $658a05ad0cb6a20b$export$13b6a4e4e3704011;
module.exports["extractA2UIFromStructuredContent"] = $658a05ad0cb6a20b$export$1c0805bd5fc59c20;
module.exports["addAgenticUiMessage"] = $658a05ad0cb6a20b$export$3a4ed3ae96502e9e;
module.exports["appendTextToAssistantMessage"] = $658a05ad0cb6a20b$export$41f43752e3744795;
module.exports["getMarkdownDataByType"] = $658a05ad0cb6a20b$export$4499bf045ea6bd06;
module.exports["replaceAnswerData"] = $658a05ad0cb6a20b$export$60e170089d1b35dd;
module.exports["updateHumanMessageId"] = $658a05ad0cb6a20b$export$ba29913b663b084c;
module.exports["updateStoreAssistantMessageId"] = $658a05ad0cb6a20b$export$f279e50afd80e7d8;
module.exports["markStreamingMessagesAsComplete"] = $658a05ad0cb6a20b$export$680d2bb5b9579c57;
module.exports["markInFlightActionsAsCancelled"] = $658a05ad0cb6a20b$export$304863f72794c019;
module.exports["getMessageHistory"] = $658a05ad0cb6a20b$export$24d2e7dc410ce2e5;
module.exports["clearStatus"] = $658a05ad0cb6a20b$export$b53f205a52449551;
module.exports["removeSensitiveData"] = $658a05ad0cb6a20b$export$efd4f6b5d168b654;
module.exports["getConversation"] = $658a05ad0cb6a20b$export$a2ff1144002a6147;
module.exports["shouldPreprocessDetailsForConversation"] = $658a05ad0cb6a20b$export$de552dcf26f1e520;
module.exports["checkActiveConversationMatchesSource"] = $658a05ad0cb6a20b$export$80b847bfebcaa3fd;
module.exports["getLastHumanMessageFromConversation"] = $658a05ad0cb6a20b$export$d9047a7a8ec8ea5c;
module.exports["findLast"] = $658a05ad0cb6a20b$export$296de88ccac4bedb;
module.exports["getLastAgentMessageID"] = $658a05ad0cb6a20b$export$2813a13604911e2d;
module.exports["getAgentMessageById"] = $658a05ad0cb6a20b$export$7fd69d5cdd838542;
module.exports["getAssociatedHumanMessageId"] = $658a05ad0cb6a20b$export$1a288f9aecfed8b4;
module.exports["addRequestIdToLatestHumanMessage"] = $658a05ad0cb6a20b$export$1cdaa2c4089128bd;
module.exports["isEmptyConversation"] = $658a05ad0cb6a20b$export$b178621992ef9541;
module.exports["isChatLoading"] = $658a05ad0cb6a20b$export$3902b208060a7183;
module.exports["getFirstMessageOfType"] = $658a05ad0cb6a20b$export$d669251a312339ff;
module.exports["findLastIndex"] = $658a05ad0cb6a20b$export$8855a8be7bd3e9f8;
module.exports["getSourceAgentId"] = $658a05ad0cb6a20b$export$ab93cd1ecacda8ec;
module.exports["generateTmpMessageId"] = $658a05ad0cb6a20b$export$eca740b13a7a3080;
module.exports["preprocessStreamResponseDetails"] = $658a05ad0cb6a20b$export$823ed9c8e3d751f5;
module.exports["extractMarkdownContent"] = $658a05ad0cb6a20b$export$bb73d89e7217c465;
module.exports["isValidAdfJsonString"] = $658a05ad0cb6a20b$export$b77ba8e4ec693266;
module.exports["createStreamMarkdownProcessor"] = $658a05ad0cb6a20b$export$f0a9473b2d3b8f30;
module.exports["createStreamMarkdownMultiTagProcessor"] = $658a05ad0cb6a20b$export$95c0abd604a2cca2;
module.exports["deriveInvocationStatus"] = $658a05ad0cb6a20b$export$5ab2d78f2e4dba11;
module.exports["isClientSideStreamingError"] = $658a05ad0cb6a20b$export$886a0387c1c465f5;
module.exports["findLastAssistantAction"] = $658a05ad0cb6a20b$export$24c718731d9a7b6a;
module.exports["handleStagingAreaActionValidation"] = $658a05ad0cb6a20b$export$acbf6433e9af643f;
module.exports["processStreamResponseMarkdown"] = $658a05ad0cb6a20b$export$82b32799d0ea512c;
module.exports["addMemorytoLatestAssistantMessage"] = $658a05ad0cb6a20b$export$e3f334fc6effa531;
module.exports["extractStreamMeta"] = $658a05ad0cb6a20b$export$2244b7838be162ca;
module.exports["getInvokedFrom"] = $658a05ad0cb6a20b$export$a0e3245ee56765fd;
module.exports["getActionPartKeyForMetrics"] = $658a05ad0cb6a20b$export$f3b7160b60840213;
module.exports["CREATE_CONFLUENCE_PAGE_FOLLOWUP_TEXT"] = $658a05ad0cb6a20b$export$43489e04a87de7d0;
module.exports["shouldAppendCreatePageFollowUp"] = $658a05ad0cb6a20b$export$a5165b6c5017830;
module.exports["appendCreatePageFollowUpIfNeeded"] = $658a05ad0cb6a20b$export$c2722b1ddbddcce5;
module.exports["createSyntheticCreatePageFollowUp"] = $658a05ad0cb6a20b$export$b323db724925d16f;
module.exports["dedupeTraceMessagesWithLatest"] = $658a05ad0cb6a20b$export$9ac25e0768639c5d;
module.exports["getConversationTraces"] = $658a05ad0cb6a20b$export$8567b8b6b4d41b2f;
module.exports["clearTracesIfNotEmpty"] = $658a05ad0cb6a20b$export$d30a5acf6cceb893;

});

parcelRegister("7yZ5y", function(module, exports) {
/**
 * Generic, dependency-free markdown stream parsing utilities.
 *
 * These utilities handle the extraction and processing of special-tag content
 * from streaming markdown text (e.g., `<lumina>...</lumina>`, `◴...◶`).
 * They operate on plain strings only — no conversation-assistant-specific
 * types or store dependencies.
 */ function $1baacd3a3b5cccce$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
const $1baacd3a3b5cccce$export$1edc769cb607aa0f = (text, boundaryStart, boundaryEnd, replacementContent = '')=>{
    const boundaryContents = [];
    if (!text) return {
        processedText: text,
        boundaryContents: boundaryContents
    };
    const regex = new RegExp(`${$1baacd3a3b5cccce$var$escapeRegExp(boundaryStart)}(.*?)${$1baacd3a3b5cccce$var$escapeRegExp(boundaryEnd)}`, 'gs');
    let newText = text;
    let match;
    let found = false;
    while((match = regex.exec(text)) !== null){
        boundaryContents.push(match[1]);
        newText = newText.replace(match[0], replacementContent);
        found = true;
    }
    return {
        processedText: found ? newText : text,
        boundaryContents: boundaryContents
    };
};
const $1baacd3a3b5cccce$export$c6f5269a29d1a6df = (text, currentLoadingKey, previousKey, componentConfig)=>{
    const { startTag: startTag, endTag: endTag, placeholderTag: placeholderTag, key: key } = componentConfig;
    let streamingMarkdownContent = '';
    let newLoadingKey = currentLoadingKey;
    let newPreviousKey = previousKey;
    let markdownData = null;
    let processedText = text;
    if (typeof text === 'string') {
        const hasCloseTag = text.includes(endTag);
        if (hasCloseTag && currentLoadingKey && currentLoadingKey.startsWith(`${key}-`)) {
            const [contentBeforeCloseTag, contentAfterCloseTag] = text.split(endTag);
            streamingMarkdownContent = contentBeforeCloseTag;
            processedText = contentAfterCloseTag;
            markdownData = {
                key: currentLoadingKey,
                content: streamingMarkdownContent,
                loading: false
            };
            newPreviousKey = currentLoadingKey;
            newLoadingKey = null;
        } else if (text.includes(startTag) && !currentLoadingKey) {
            const currentCount = previousKey == null ? -1 : parseInt(previousKey.substring(`${key}-`.length), 10);
            newLoadingKey = `${key}-${currentCount + 1}`;
            const [contentBeforeOpenTag, contentAfterOpenTag] = text.split(startTag);
            processedText = contentBeforeOpenTag + placeholderTag;
            streamingMarkdownContent = contentAfterOpenTag;
            markdownData = {
                key: newLoadingKey,
                content: streamingMarkdownContent,
                loading: true
            };
            newPreviousKey = newLoadingKey;
        } else if (currentLoadingKey) {
            streamingMarkdownContent = text;
            processedText = '';
            markdownData = {
                key: currentLoadingKey,
                content: streamingMarkdownContent,
                loading: true
            };
            newPreviousKey = currentLoadingKey;
        }
    }
    return {
        processedText: processedText,
        currentLoadingKey: newLoadingKey,
        previousKey: newPreviousKey,
        markdownData: markdownData
    };
};
const $1baacd3a3b5cccce$export$1fc44797755f1907 = (getComponents)=>{
    let currentLoadingKeys = {};
    let previousKeys = {};
    return (text)=>{
        let processedText = text;
        let newCurrentLoadingKeys = {
            ...currentLoadingKeys
        };
        let newPreviousKeys = {
            ...previousKeys
        };
        let markdownData = null;
        let processedComponentType = null;
        for (const component of getComponents()){
            if (!component.isEnabled) continue;
            const currentLoadingKey = currentLoadingKeys[component.key] || null;
            const previousKey = previousKeys[component.key] || null;
            const result = $1baacd3a3b5cccce$export$c6f5269a29d1a6df(processedText, currentLoadingKey, previousKey, component);
            if (result.markdownData) {
                processedText = result.processedText;
                newCurrentLoadingKeys[component.key] = result.currentLoadingKey;
                newPreviousKeys[component.key] = result.previousKey;
                markdownData = result.markdownData;
                processedComponentType = component.key;
                break; // Only process one component type per call
            }
        }
        currentLoadingKeys = newCurrentLoadingKeys;
        previousKeys = newPreviousKeys;
        return {
            processedText: processedText,
            markdownData: markdownData,
            processedComponentType: processedComponentType
        };
    };
};
const $1baacd3a3b5cccce$export$87723f8a010c233f = (text, currentLoadingKey, previousKey, componentConfig)=>{
    const { startTag: startTag, endTag: endTag, placeholderTag: placeholderTag, key: key } = componentConfig;
    let newLoadingKey = currentLoadingKey;
    let newPreviousKey = previousKey;
    let markdownData = null;
    let processedText = text;
    let unprocessedText = '';
    if (typeof text === 'string') {
        const closeTagIndex = text.indexOf(endTag);
        if (closeTagIndex !== -1 && currentLoadingKey && currentLoadingKey.startsWith(`${key}-`)) {
            const contentBeforeCloseTag = text.substring(0, closeTagIndex);
            const contentAfterCloseTag = text.substring(closeTagIndex + endTag.length);
            processedText = '';
            unprocessedText = contentAfterCloseTag;
            markdownData = {
                key: currentLoadingKey,
                content: contentBeforeCloseTag,
                loading: false
            };
            newPreviousKey = currentLoadingKey;
            newLoadingKey = null;
        } else if (text.includes(startTag) && !currentLoadingKey) {
            const currentCount = previousKey == null ? -1 : parseInt(previousKey.substring(`${key}-`.length), 10);
            newLoadingKey = `${key}-${currentCount + 1}`;
            const openTagIndex = text.indexOf(startTag);
            const contentBeforeOpenTag = text.substring(0, openTagIndex);
            const contentAfterOpenTag = text.substring(openTagIndex + startTag.length);
            processedText = contentBeforeOpenTag + placeholderTag;
            unprocessedText = contentAfterOpenTag;
            markdownData = {
                key: newLoadingKey,
                content: '',
                loading: true
            };
            newPreviousKey = newLoadingKey;
        } else if (currentLoadingKey) {
            // Mid-stream branch: no boundary in this chunk; the whole text is
            // streamed content for the active component.
            processedText = '';
            unprocessedText = '';
            markdownData = {
                key: currentLoadingKey,
                content: text,
                loading: true
            };
            newPreviousKey = currentLoadingKey;
        }
    }
    return {
        processedText: processedText,
        unprocessedText: unprocessedText,
        currentLoadingKey: newLoadingKey,
        previousKey: newPreviousKey,
        markdownData: markdownData
    };
};
const $1baacd3a3b5cccce$export$e234f678a7b6108d = (getComponents)=>{
    let currentLoadingKeys = {};
    let previousKeys = {};
    const processRecursive = (text, markdownData)=>{
        for (const component of getComponents()){
            if (!component.isEnabled) continue;
            const currentLoadingKey = currentLoadingKeys[component.key] ?? null;
            const prevKey = previousKeys[component.key] ?? null;
            const result = $1baacd3a3b5cccce$export$87723f8a010c233f(text, currentLoadingKey, prevKey, component);
            if (!result.markdownData) continue;
            const { key: key, content: content, loading: loading } = result.markdownData;
            currentLoadingKeys[component.key] = result.currentLoadingKey;
            previousKeys[component.key] = result.previousKey;
            const existing = markdownData[key];
            markdownData[key] = {
                content: (existing?.content ?? '') + content,
                loading: loading
            };
            if (result.unprocessedText) {
                const inner = processRecursive(result.unprocessedText, markdownData);
                return {
                    ...inner,
                    processedText: result.processedText + inner.processedText
                };
            }
            return {
                processedText: result.processedText,
                markdownData: markdownData
            };
        }
        // No component matched — return text unchanged.
        return {
            processedText: text,
            markdownData: markdownData
        };
    };
    return (text)=>{
        return processRecursive(text, {});
    };
};
module.exports["extractMarkdownText"] = $1baacd3a3b5cccce$export$1edc769cb607aa0f;
module.exports["processMarkdownComponent"] = $1baacd3a3b5cccce$export$c6f5269a29d1a6df;
module.exports["createMarkdownProcessor"] = $1baacd3a3b5cccce$export$1fc44797755f1907;
module.exports["createMarkdownProcessorMultiTags"] = $1baacd3a3b5cccce$export$e234f678a7b6108d;

});

parcelRegister("9vgbT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $jEzab = parcelRequire("jEzab");


var $72hrp = parcelRequire("72hrp");

const $842f00fe6a20cb59$export$4124b3cbf6d26820 = ({ useSmartCreationChatStoreApi: useSmartCreationChatStoreApi })=>{
    const { activeConversation: activeConversation } = useSmartCreationChatStoreApi();
    const [chatMessages] = (0, $jEzab.useChatMessages)({
        conversationId: activeConversation?.id
    });
    return (0, $42omo.useMemo)(()=>{
        if (!(0, $dh538.fg)('aifc_show_connected_apps_auth_login_screen')) return null;
        if (chatMessages.length === 0) return null;
        const lastAssistantMessage = (0, $72hrp.findLastAssistantMessage)(chatMessages);
        if (!lastAssistantMessage) return null;
        return $842f00fe6a20cb59$export$74c2c8fe0412025(lastAssistantMessage?.content?.message?.message?.content ?? '');
    }, [
        chatMessages
    ]);
};
function $842f00fe6a20cb59$export$74c2c8fe0412025(content) {
    if (!content) return null;
    let textContent;
    if (typeof content === 'object') textContent = JSON.stringify(content);
    else textContent = content;
    const regex = /https:\/\/id\.(stg\.internal\.)?atlassian\.com\/outboundAuth\/start[^\s)"]*/g;
    const matches = textContent.match(regex);
    return matches ? matches[0] : null;
}
module.exports["useLastAssistantMessageAuthLink"] = $842f00fe6a20cb59$export$4124b3cbf6d26820;
module.exports["extractOutboundAuthLink"] = $842f00fe6a20cb59$export$74c2c8fe0412025;

});

parcelRegister("72hrp", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $3wgAM = parcelRequire("3wgAM");


var $dh538 = parcelRequire("dh538");


var $deF0K = parcelRequire("deF0K");


var $htiKQ = parcelRequire("htiKQ");


var $bPHr8 = parcelRequire("bPHr8");

function $f56e0f5c5904b36b$export$17828fb10c7c5928(messages, messageId) {
    return messages.find((msg)=>(0, $bPHr8.isStoreAssistant)(msg) && msg.content.message.message.id === messageId);
}
function $f56e0f5c5904b36b$export$c5f84c389beb0191(messages) {
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $bPHr8.isStoreAssistant)(msg) && (msg.content.message.message.actions || []).some((action)=>(0, $deF0K.isCreatableAction)(action) || (0, $htiKQ.isJiraPreviewableAction)(action) && (0, $dh538.fg)('ham-ai-insights'))) return msg;
    }
    return undefined;
}
function $f56e0f5c5904b36b$export$551dda091e9d40ca(messages) {
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $bPHr8.isStoreAssistant)(msg) && (msg.content.message.message.actions || []).some((0, $deF0K.isAIFCAction))) return msg;
    }
    return undefined;
}
function $f56e0f5c5904b36b$export$6f9d326b409b8a89(messages) {
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $bPHr8.isStoreAssistant)(msg)) return msg;
    }
    return undefined;
}
function $f56e0f5c5904b36b$export$e839ab847bfd35fb(message) {
    const action = message.content.message.message.actions?.find((0, $deF0K.isCreatableAction));
    const contentId = action?.data?.contentId;
    // always make it a string since the final response sometimes returns a number and re-renders the iframe.
    return contentId === undefined ? undefined : String(contentId);
}
function $f56e0f5c5904b36b$export$460905b2c4dc18c9(message) {
    return message?.content?.message?.message?.actions?.[0];
}
function $f56e0f5c5904b36b$export$b05803156e5015b6(message) {
    const action = message?.content?.message?.message?.actions?.find((0, $deF0K.isCreatableAction));
    return action?.data?.title;
}
function $f56e0f5c5904b36b$export$4382776317fc294f(message) {
    if (!message) return undefined;
    const aifcAction = message?.content?.message?.message?.actions?.find((0, $deF0K.isAIFCAction));
    if (aifcAction) {
        const status = aifcAction?.status?.toLowerCase();
        if (status === 'preparing' || status === 'streaming') return status;
        // 'Planned' is the same as a final response. If we see it, assume streaming is complete.
        if (status === 'planned' || status === 'finished' || status === 'cancelled' || message.content.streamingComplete) return 'complete';
    }
    return undefined;
}
function $f56e0f5c5904b36b$var$getStableMessageParts(message) {
    const action = message.content.message.message.actions?.find((0, $deF0K.isCreatableAction));
    const actionData = action?.data;
    // We just pick the parts we care about directly from the message
    // We avoid ADF since that is streamed and changes all the time.
    return {
        messageId: message.content.message.message.id,
        streamingComplete: message.content.streamingComplete,
        action: actionData ? (0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(actionData, [
            'contentId',
            'title',
            'mediaFileId'
        ]) : undefined,
        status: action?.status
    };
}
function $f56e0f5c5904b36b$export$c90c71e0e0065a6(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    return (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))($f56e0f5c5904b36b$var$getStableMessageParts(a), $f56e0f5c5904b36b$var$getStableMessageParts(b));
}
module.exports["findMessageById"] = $f56e0f5c5904b36b$export$17828fb10c7c5928;
module.exports["findLastMessageWithCreateAction"] = $f56e0f5c5904b36b$export$c5f84c389beb0191;
module.exports["findLastMessageWithAIFCAction"] = $f56e0f5c5904b36b$export$551dda091e9d40ca;
module.exports["findLastAssistantMessage"] = $f56e0f5c5904b36b$export$6f9d326b409b8a89;
module.exports["extractContentId"] = $f56e0f5c5904b36b$export$e839ab847bfd35fb;
module.exports["getFirstMessageAction"] = $f56e0f5c5904b36b$export$460905b2c4dc18c9;
module.exports["extractTitle"] = $f56e0f5c5904b36b$export$b05803156e5015b6;
module.exports["getAIFCActionStatus"] = $f56e0f5c5904b36b$export$4382776317fc294f;
module.exports["areMessagesEqual"] = $f56e0f5c5904b36b$export$c90c71e0e0065a6;

});

parcelRegister("bd943", function(module, exports) {
const $3b4ff3e4ad90548c$export$53fd140c96bc558 = 'https://media.staging.atl-paas.net';
module.exports["MEDIA_BASE_URL_STAGING"] = $3b4ff3e4ad90548c$export$53fd140c96bc558;

});

parcelRegister("dgaTK", function(module, exports) {
const $c70599da8b0bb884$export$51ee55de82fed0a0 = (subExperienceNameToCheck, mainExperienceToFail, events, additionalAttributes)=>{
    const subExperienceFailEvent = events.find((event)=>event.action === 'taskFail' && event.name === subExperienceNameToCheck);
    if (subExperienceFailEvent) mainExperienceToFail.fail({
        error: subExperienceFailEvent.error,
        attributes: {
            ...additionalAttributes,
            ...subExperienceFailEvent.attributes
        }
    });
};
const $c70599da8b0bb884$export$da415d22ae15cf08 = (subExperiences, additionalAttributes)=>{
    const subExperienceNameSet = new Set(subExperiences);
    const mergedAttributes = {};
    return (events, experience)=>{
        // all subExperiences must succeed for the parent experience to succeed
        // a failure/abort to any subExperience will fail/abort the parent experience
        events.forEach((event)=>{
            if (subExperienceNameSet.has(event.name)) switch(event.action){
                case 'taskSuccess':
                    if (subExperienceNameSet.delete(event.name)) Object.assign(mergedAttributes, event.attributes ?? {});
                    break;
                case 'taskFail':
                    if ('error' in event) experience.fail({
                        error: event.error,
                        attributes: {
                            ...additionalAttributes,
                            ...event.attributes
                        }
                    });
                    break;
                case 'taskAbort':
                    experience.abort({
                        reason: `${event.name} aborted`,
                        attributes: {
                            ...additionalAttributes,
                            ...event.attributes,
                            childAbortReason: event.reason
                        }
                    });
                    break;
            }
        });
        if (subExperienceNameSet.size === 0) experience.succeed({
            ...additionalAttributes,
            ...mergedAttributes
        });
    };
};
module.exports["failExperienceOnSubExperienceFail"] = $c70599da8b0bb884$export$51ee55de82fed0a0;
module.exports["collectAllWithSubExperienceAttributes"] = $c70599da8b0bb884$export$da415d22ae15cf08;

});

parcelRegister("52Fo2", function(module, exports) {

var $16lEl = parcelRequire("16lEl");

const $fed287a888253e80$export$a9ffe3cc687b4144 = (experienceTracker, reason, attributes)=>{
    [
        (0, $16lEl.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
        (0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED,
        (0, $16lEl.ExperienceName).AIFC_MESSAGE
    ].forEach((experienceName)=>{
        experienceTracker.abort({
            name: experienceName,
            reason: reason,
            attributes: attributes
        });
    });
};
module.exports["abortGenerateContentChildExperiences"] = $fed287a888253e80$export$a9ffe3cc687b4144;

});

parcelRegister("iEWar", function(module, exports) {
const $39527fcfea4df9b6$var$generateTraceId = ()=>`${Date.now().toString(16)}-${Math.floor(Math.random() * 1e4).toString(16)}`;
class $39527fcfea4df9b6$export$7ed16f132715a198 extends Error {
    constructor(message, params){
        const { detail: detail, traceId: traceId } = params;
        super(message);
        this.detail = void 0;
        this.errorAttributes = void 0;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        this.detail = detail;
        this.errorAttributes = {
            errorCode: this.detail.message.message_template,
            statusCode: this.detail.message.status_code,
            rawErrorMessage: this.detail.message.content,
            // in case there is no traceId, we generate one in FE
            // and make it distinguishable from BE generated traceId
            // appended by random 5 digit number
            traceId: traceId ?? `StreamError-${$39527fcfea4df9b6$var$generateTraceId()}`,
            requestId: this.detail.metadata?.request_id,
            latestStreamMessageType: this.detail.type,
            latestStreamMessageMillisOffset: this.detail.millisOffset
        };
    }
}
class $39527fcfea4df9b6$export$7a01d8a5a5a1ae0a extends Error {
    constructor(message, params, cause){
        super(message);
        this.errorAttributes = void 0;
        this.cause = void 0;
        this.name = this.constructor.name;
        this.cause = cause;
        this.errorAttributes = {
            traceId: params.traceId ?? `StreamGenerator-${$39527fcfea4df9b6$var$generateTraceId()}`,
            latestStreamMessageType: params.detail?.type,
            latestStreamMessageMillisOffset: params.detail?.millisOffset
        };
    }
}
class $39527fcfea4df9b6$export$cdcaebd3b25a3ac3 extends Error {
    constructor(message, params){
        super(message);
        this.errorAttributes = void 0;
        this.name = this.constructor.name;
        this.errorAttributes = {
            traceId: params.traceId ?? `NoFinalResponse-${$39527fcfea4df9b6$var$generateTraceId()}`
        };
    }
}
class $39527fcfea4df9b6$export$a4ff042cd5c23500 extends Error {
    constructor(params){
        super(params.message);
        this.errorAttributes = void 0;
        this.cause = void 0;
        this.name = this.constructor.name;
        this.errorAttributes = {
            conversationId: params.conversationId,
            messageId: params.messageId,
            invocationId: params.invocationId,
            actionKey: params.actionKey
        };
        if (params.cause) this.cause = params.cause;
    }
}
class $39527fcfea4df9b6$export$17fb3253ebc25334 extends Error {
    constructor(message, params){
        super(message);
        this.errorAttributes = void 0;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        this.errorAttributes = {
            traceId: params.traceId ?? `NoActionInvoked-${$39527fcfea4df9b6$var$generateTraceId()}`
        };
    }
}
class $39527fcfea4df9b6$export$f2869f2905168ef1 extends Error {
    constructor(message, params = {}){
        super(message);
        this.errorAttributes = void 0;
        this.message_template = void 0;
        this.name = this.constructor.name;
        this.message_template = 'DEEP_RESEARCH_ERROR';
        this.errorAttributes = {
            errorCode: 'DEEP_RESEARCH_ERROR',
            traceId: params.traceId ?? `DeepResearch-${$39527fcfea4df9b6$var$generateTraceId()}`,
            requestId: params.requestId
        };
    }
}
class $39527fcfea4df9b6$export$83cef568563975a4 extends Error {
    constructor(message, params){
        super(message);
        this.errorAttributes = void 0;
        this.agentMessageId = void 0;
        this.conversationId = void 0;
        this.answerIndex = void 0;
        this.lastEventId = void 0;
        this.name = this.constructor.name;
        this.agentMessageId = params.agentMessageId;
        this.conversationId = params.conversationId;
        this.answerIndex = params.answerIndex;
        this.lastEventId = params.lastEventId;
        this.errorAttributes = {
            traceId: params.traceId ?? `StreamReconnection-${$39527fcfea4df9b6$var$generateTraceId()}`,
            errorCode: 'STREAM_RECONNECTION_NEEDED',
            originalError: params.originalError.message,
            latestStreamMessageType: params.detail?.type,
            latestStreamMessageMillisOffset: params.detail?.millisOffset
        };
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
    }
}
module.exports["StreamErrorException"] = $39527fcfea4df9b6$export$7ed16f132715a198;
module.exports["StreamGeneratorError"] = $39527fcfea4df9b6$export$7a01d8a5a5a1ae0a;
module.exports["NoFinalResponseError"] = $39527fcfea4df9b6$export$cdcaebd3b25a3ac3;
module.exports["MessageActionError"] = $39527fcfea4df9b6$export$a4ff042cd5c23500;
module.exports["NoActionInvokedError"] = $39527fcfea4df9b6$export$17fb3253ebc25334;
module.exports["DeepResearchError"] = $39527fcfea4df9b6$export$f2869f2905168ef1;
module.exports["StreamDisconnectedError"] = $39527fcfea4df9b6$export$83cef568563975a4;

});


//# sourceMappingURL=FullPageEditorComponent.8ab3daba.js.map
